/** @license Guesty v1.0.40
 *
 * This source code is licensed under the ISC license found in the
 * LICENSE file in the root directory of this source tree.
 */
import React from "react";

var BtnExport = function BtnExport(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.88 5.145A.496.496 0 0 0 10.475 5l-.01.002-.008-.002c-.16 0-.296.08-.388.197L6.126 9.141a.5.5 0 0 0 .004.71.508.508 0 0 0 .71.004l3.117-3.154v8.8a.5.5 0 0 0 1 0v-8.8l3.206 3.154a.5.5 0 0 0 .71-.003.508.508 0 0 0 .004-.71L10.88 5.144z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.71 0 0 4.71 0 10.5S4.71 21 10.5 21 21 16.29 21 10.5 16.29 0 10.5 0zm0 20C5.262 20 1 15.738 1 10.5S5.262 1 10.5 1 20 5.262 20 10.5 15.738 20 10.5 20z"
  }));
};

BtnExport.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
};

var BtnImport = function BtnImport(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.12 15.855c.11.112.26.159.405.144l.01-.002.008.002c.16 0 .296-.08.388-.197l3.943-3.943a.5.5 0 0 0-.004-.71.508.508 0 0 0-.71-.004l-3.117 3.154v-8.8a.5.5 0 0 0-1 0v8.8l-3.206-3.154a.5.5 0 0 0-.71.003.508.508 0 0 0-.004.71l3.997 3.997z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.71 0 0 4.71 0 10.5S4.71 21 10.5 21 21 16.29 21 10.5 16.29 0 10.5 0zm0 20C5.262 20 1 15.738 1 10.5S5.262 1 10.5 1 20 5.262 20 10.5 15.738 20 10.5 20z"
  }));
};

BtnImport.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
};

var BtnAccount = function BtnAccount(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.6 0C5.7 0 0 5.7 0 12.6c0 6.9 5.7 12.6 12.6 12.6 6.9 0 12.6-5.7 12.6-12.6C25.2 5.7 19.5 0 12.6 0zM6.2 22h.1c.2-1.2.3-2.1.4-2.5.1-.5 1.4-1.3 3.7-1.6 0 .5.2 1.2.6 1.7.4.5 1 .7 1.7.7.9 0 1.4-.4 1.7-.7.4-.5.6-1.2.6-1.7 2.3.3 3.6 1.1 3.7 1.6.1.4.2 1.2.4 2.3-1.9 1.4-4.2 2.2-6.7 2.2-2.2 0-4.4-.7-6.2-2zm7.6-13.4l2.4 1.7c0 1.1-.2 2-.6 2.8-.8 1.7-2.2 2.2-2.7 2.2s-1.9-.5-2.7-2.2c-.4-.8-.6-1.7-.6-2.7l4.2-1.8zm-4.3.5c.2-3.1 1.7-3.6 3.3-3.6 1.6 0 3 .4 3.3 3.3L14 7.3 9.5 9.1zm3.3 7.4c.3 0 .6-.1.9-.2 0 .4.1.7.3 1h-.1c0 .3 0 1.1-.3 1.5-.3.4-1.2.4-1.6 0-.3-.3-.4-.9-.3-1.3.2-.2.5-.6.5-1.1.2.1.4.1.6.1zm7.5 4.4c-.1-.8-.2-1.4-.3-1.7-.4-1.4-2.7-2.2-4.9-2.5-.1-.1-.3-.4 0-1H15c.6-.5 1.2-1.1 1.7-2 0-.1 0-.1.1-.2.9 0 1.1-.9 1.3-1.8.1-.7.1-1.2 0-1.5-.1-.3-.4-.5-.6-.6-.1-3.6-1.6-5.3-4.6-5.3-3 0-4.5 1.8-4.6 5.4-.2.1-.4.2-.6.5-.2.3-.2.8 0 1.5.1.9.4 1.8 1.3 1.8 0 .1 0 .1.1.2.5 1 1.2 1.8 1.9 2.2.2.4.1.7-.1.8-2.3.3-4.8 1-5.2 2.6-.1.4-.2 1.1-.4 2.1-2.5-2.1-4-5.2-4-8.7 0-6.3 5.1-11.4 11.4-11.4S24 6.3 24 12.6c0 3.3-1.4 6.3-3.7 8.3z"
  }));
};

BtnAccount.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25.2 25.2"
};

var BtnAdd = function BtnAdd(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11 0C4.925 0 0 4.925 0 11s4.925 11 11 11 11-4.925 11-11S17.075 0 11 0zm0 21C5.477 21 1 16.523 1 11S5.477 1 11 1s10 4.477 10 10-4.477 10-10 10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5h-1v5.5H5v1h5.5V17h1v-5.5H17v-1h-5.5z"
  }));
};

BtnAdd.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22"
};

var BtnApprove = function BtnApprove(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.745 11.282L.935 6.933a.546.546 0 0 0-.766 0 .557.557 0 0 0 0 .799l5.191 4.881c.097.095.237.15.385.15a.543.543 0 0 0 .35-.122L15.468.944a.559.559 0 0 0 0-.8.587.587 0 0 0-.727-.034L5.745 11.282z"
  }));
};

BtnApprove.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15.636672 12.7622719"
};

var BtnArchive = function BtnArchive(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.02 11.086c.027.032.06.055.034.025l.192.115c.03.01.06.017.108.023l.071.001.022-.003a.472.472 0 0 0 .074-.012l.097-.035c.033-.015.066-.035.058-.035a.29.29 0 0 0 .078-.055l2.408-3.559a.513.513 0 1 0-.85-.575L9.338 9.914l-.7-.764a.507.507 0 0 0-.356-.165.579.579 0 0 0-.368.137.518.518 0 0 0-.03.726l1.136 1.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 0H2C.897 0 0 .897 0 2v2h1v9.367C1 14.844 2.096 16 3.495 16h12.939C17.849 16 19 14.819 19 13.367V4h1V2c0-1.103-.897-2-2-2zm0 13c0 1.103-.897 2-2 2H4c-1.103 0-2-.897-2-2V4h16v9zm1-10H1V2c0-.551.449-1 1-1h16c.552 0 1 .449 1 1v1z"
  }));
};

BtnArchive.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 16"
};

var BtnArrowDown = function BtnArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.533 4.997c.13.006.26-.039.357-.136L8.925.826a.488.488 0 0 0-.69-.69L4.532 3.843.826.137a.488.488 0 0 0-.69.69L4.172 4.86c.097.097.23.143.362.136z"
  }));
};

BtnArrowDown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9.0618038 4.9977479"
};

var BtnArrowUp = function BtnArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.529 0a.474.474 0 0 0-.357.137L.137 4.172a.488.488 0 0 0 .69.689L4.53 1.156l3.705 3.705a.488.488 0 0 0 .69-.69L4.89.138A.477.477 0 0 0 4.53 0z"
  }));
};

BtnArrowUp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9.0618038 4.9977479"
};

var BtnAssign = function BtnAssign(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18.173 8.43l3.548 3.667 1.537-4.753-.957-.292c-.299.936-.527 1.659-.704 2.233a10.76 10.76 0 0 0-3.052-6.104A10.917 10.917 0 0 0 10.809 0l-.003.002C4.85.04.03 4.913.016 10.863H0c0 2.902 1.13 5.63 3.18 7.681a10.784 10.784 0 0 0 7.677 3.18h.018c2.779 0 5.42-1.057 7.45-2.974l.063-.006-.009-.04.008-.007-.011-.012c-.149-1.19-1.292-2.667-3.482-3.262l-1.216-1.186c.336-.367.65-.81.91-1.356.32-.676.524-1.447.625-2.29l.04-.377c.02-.263.036-.53.036-.806 0-3.672-1.385-5.457-4.233-5.457S6.822 5.736 6.822 9.408c0 .155.015.301.021.452l.01.228c.069 1.045.288 1.986.671 2.794.258.541.57.982.903 1.348L7.01 15.486c-1.607.495-2.615 1.467-3.043 2.424-.026-.025-.055-.047-.08-.073a9.796 9.796 0 0 1-2.886-6.942C1 5.462 5.423 1.005 10.865 1l.003.003c2.614.016 5.122 1.036 6.97 2.885a9.775 9.775 0 0 1 2.798 5.65l-1.743-1.803-.72.696zm-7.117-3.48c1.547 0 3.124.506 3.223 4.102l-4.156-3.028-1.596 2.089-.689.705c.16-3.387 1.703-3.867 3.218-3.867zM7.859 10.23l1.423-1.462 1.045-1.365 3.444 2.473.48.375v.003c-.075.826-.265 1.563-.566 2.2-.779 1.634-2.107 2.164-2.63 2.164-.52 0-1.85-.53-2.627-2.164-.305-.643-.495-1.389-.57-2.224zm5.098 4.652l-1.905 2.388-1.995-2.462c.735.565 1.492.81 1.999.81.484 0 1.197-.224 1.901-.736zM7.67 16.328l.733-.74 2.647 3.224 2.605-3.202.823.728c1.617.391 2.467 1.295 2.774 2.022a9.8 9.8 0 0 1-6.377 2.363h-.018a9.779 9.779 0 0 1-6.086-2.11c.202-.76 1.062-1.853 2.9-2.285z"
  }));
};

BtnAssign.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23.2578144 21.7231445"
};

var BtnAttachment = function BtnAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.94 4.145l-.046.046-.147.149-.528.531-1.6 1.614L4.292 8.83c-1.022 1.033-.888 2.158-.074 2.983.96.971 2.127.727 3.025-.182l6.978-7.057A2.647 2.647 0 0 0 15 2.648 2.548 2.548 0 0 0 14.2.84c-.98-.99-2.638-1.208-3.743-.09l-9.32 9.425c-1.443 1.46-1.518 3.219-.187 4.686 1.58 1.516 3.335 1.515 4.815.02l2.173-2.209 5.01-5.08-.692-.698-5.01 5.08-2.172 2.208c-1.101 1.112-2.252 1.113-3.428-.013-.947-1.046-.897-2.204.182-3.295l9.32-9.425c.678-.687 1.73-.549 2.376.105.312.29.49.691.5 1.117.01.445-.164.872-.493 1.205l-6.978 7.057c-.562.57-1.14.69-1.643.182-.464-.47-.525-.98.073-1.584l2.327-2.346 1.6-1.614.527-.531.148-.15.039-.038-.683-.707z"
  }));
};

BtnAttachment.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 16"
};

var BtnBulkArticles = function BtnBulkArticles(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.963 0h-7.51C6.65 0 6 .648 6 1.445V3H4.452C3.652 3 3 3.648 3 4.445V6H1.452C.652 6 0 6.648 0 7.445v15.11A1.45 1.45 0 0 0 1.452 24h10.941c.8 0 1.452-.647 1.452-1.444L13.846 21h1.547c.8 0 1.452-.647 1.452-1.444L16.846 18h1.547c.8 0 1.452-.647 1.452-1.444l.007-11.896L14.963 0zm3.882 16.556a.449.449 0 0 1-.452.444H7.452c-.25 0-.452-.2-.452-.444V1.445C7 1.2 7.203 1 7.452 1h6.811v2.93a1.45 1.45 0 0 0 1.452 1.444h3.137l-.007 11.182zm-3 3a.449.449 0 0 1-.452.444H4.452c-.25 0-.452-.2-.452-.444V4.445C4 4.2 4.203 4 4.452 4H6v12.556A1.45 1.45 0 0 0 7.452 18h8.394v1.556zm-3 3a.449.449 0 0 1-.452.444H1.453c-.25 0-.453-.2-.453-.444V7.445C1 7.2 1.203 7 1.452 7H3v12.556A1.45 1.45 0 0 0 4.452 21h8.394v1.556zm5.258-18.182h-2.388a.449.449 0 0 1-.452-.445V1.667l2.84 2.707z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.35 13H8.425v1h9v-1h-.577zM16.351 10H8.426v1h9v-1h-.575zM14.711 7H8.426v1h9V7h-1.99z"
  }));
};

BtnBulkArticles.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19.8520508 24"
};

var BtnCabs = function BtnCabs(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 0h-20C1.57 0 0 1.57 0 3.5v8C0 13.43 1.57 15 3.5 15h20c1.93 0 3.5-1.57 3.5-3.5v-8C27 1.57 25.43 0 23.5 0zm-3.763 1.085c.007-.032.017-.055.025-.085h2.473c.008.03.018.053.025.085.077.343.115.777.115 1.3s-.038.957-.115 1.3-.18.617-.307.82c-.129.203-.276.346-.443.427s-.34.123-.52.123c-.177 0-.347-.04-.513-.123a1.112 1.112 0 0 1-.437-.427c-.127-.203-.227-.477-.303-.82s-.112-.777-.112-1.3.037-.957.112-1.3zM26 11.5c0 1.379-1.121 2.5-2.5 2.5h-2.044l1.969-4.06c.033-.067.067-.15.103-.247.035-.099.052-.228.052-.388V8.77h-5v.835c0 .077.028.143.085.2a.274.274 0 0 0 .2.085h3.46a2.881 2.881 0 0 0-.39.585L20.149 14H3.5A2.503 2.503 0 0 1 1 11.5v-8C1 2.122 2.122 1 3.5 1h14.999c-.092.408-.149.86-.149 1.385 0 .63.067 1.177.2 1.643.133.464.318.849.555 1.152.237.303.516.53.838.677.321.149.67.223 1.047.223s.727-.074 1.052-.223c.325-.148.607-.374.846-.677s.424-.688.56-1.152c.135-.465.202-1.013.202-1.643 0-.525-.058-.977-.15-1.385C24.879 1 26 2.122 26 3.5v8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.888 4.59a2.265 2.265 0 0 0-.846-.678 2.504 2.504 0 0 0-1.052-.222c-.377 0-.726.074-1.047.222-.322.149-.601.375-.838.678-.237.303-.422.687-.555 1.15-.133.463-.2 1.012-.2 1.645 0 .63.067 1.177.2 1.643.133.464.318.849.555 1.152.237.303.516.53.838.677.321.149.67.223 1.047.223.377 0 .728-.074 1.052-.223.325-.148.607-.374.846-.677s.424-.688.56-1.152c.135-.466.202-1.013.202-1.643 0-.633-.067-1.182-.202-1.645s-.322-.847-.56-1.15zm-.628 4.095c-.077.343-.18.617-.307.82-.129.203-.276.346-.443.427s-.34.123-.52.123c-.177 0-.347-.04-.513-.123a1.112 1.112 0 0 1-.437-.427c-.127-.203-.227-.477-.303-.82s-.112-.777-.112-1.3.037-.957.112-1.3c.075-.343.176-.617.303-.82.127-.203.273-.346.437-.427a1.142 1.142 0 0 1 1.033 0c.167.081.314.224.443.427.128.203.23.477.307.82.077.343.115.777.115 1.3s-.038.957-.115 1.3zM7.888 4.59a2.265 2.265 0 0 0-.846-.678A2.505 2.505 0 0 0 5.99 3.69c-.377 0-.726.074-1.047.222-.322.149-.601.375-.838.678-.237.303-.422.687-.555 1.15-.133.463-.2 1.012-.2 1.645 0 .63.067 1.177.2 1.643.133.464.318.849.555 1.152.237.303.516.53.838.677.321.149.67.223 1.047.223.377 0 .727-.074 1.052-.223.325-.148.607-.374.846-.677s.424-.688.56-1.152c.135-.466.202-1.013.202-1.643 0-.633-.067-1.182-.202-1.645s-.322-.847-.56-1.15zM7.26 8.685c-.077.343-.18.617-.307.82-.129.203-.276.346-.443.427s-.34.123-.52.123c-.177 0-.347-.04-.513-.123a1.112 1.112 0 0 1-.437-.427c-.127-.203-.228-.477-.303-.82s-.112-.777-.112-1.3.037-.957.112-1.3c.075-.343.176-.617.303-.82.127-.203.272-.346.437-.427a1.142 1.142 0 0 1 1.033 0c.167.081.314.224.443.427.128.203.23.477.307.82.077.343.115.777.115 1.3s-.038.957-.115 1.3z"
  }));
};

BtnCabs.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27 15"
};

var BtnCalendar = function BtnCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 2h-4V0h-1v2h-6V0h-1v2h-4A2.503 2.503 0 0 0 0 4.5v12C0 17.879 1.122 19 2.5 19h16c1.379 0 2.5-1.121 2.5-2.5v-12C21 3.122 19.879 2 18.5 2zm-16 1h4v.667h1V3h6v.667h1V3h4c.827 0 1.5.673 1.5 1.5V7H1V4.5C1 3.673 1.673 3 2.5 3zm16 15h-16c-.827 0-1.5-.673-1.5-1.5V8h19v8.5c0 .827-.673 1.5-1.5 1.5z"
  }));
};

BtnCalendar.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 19"
};

var BtnCheckboxOff = function BtnCheckboxOff(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15h-10A2.503 2.503 0 0 1 0 12.5v-10C0 1.122 1.122 0 2.5 0h10C13.879 0 15 1.122 15 2.5v10c0 1.379-1.121 2.5-2.5 2.5zM2.5 1C1.673 1 1 1.673 1 2.5v10c0 .827.673 1.5 1.5 1.5h10c.827 0 1.5-.673 1.5-1.5v-10c0-.827-.673-1.5-1.5-1.5h-10z"
  }));
};

BtnCheckboxOff.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 15"
};

var BtnCheckboxOn = function BtnCheckboxOn(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "16",
    height: "16",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.71 4.803L6.757 9.879 5.281 8.474a1.045 1.045 0 0 0-1.462.005 1.057 1.057 0 0 0 0 1.513l2.26 2.216c.193.189.46.292.735.292.248 0 .485-.082.671-.237l.072-.075 4.668-5.935c.381-.37.381-1.049-.043-1.465a1.086 1.086 0 0 0-1.392-.068l-.08.083z",
    fill: "#fff",
    fillRule: "nonzero"
  })));
};

BtnCheckboxOn.defaultProps = {
  viewBox: "0 0 16 16",
  xmlns: "http://www.w3.org/2000/svg"
};

var BtnCheckboxIndeterminate = function BtnCheckboxIndeterminate(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "15",
    height: "15",
    rx: "2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "9",
    height: "1.5",
    x: "3",
    y: "6.75",
    fill: "#FFF",
    rx: ".75"
  })));
};

BtnCheckboxIndeterminate.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "15",
  height: "15",
  viewBox: "0 0 15 15"
};

var BtnColumns = function BtnColumns(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13 0H0v18h19V0h-6zm-1 1v3H7V1h5zM1 1h5v3H1V1zm0 16V5h5v12H1zm6 0V5h5v12H7zm11 0h-5V5h5v12zM13 4V1h5v3h-5z"
  }));
};

BtnColumns.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19 18"
};

var BtnCopy = function BtnCopy(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4 0v4H0v14h11v-4h4V0H4zm6 17H1V5h9v12zm4-4h-3V4H5V1h9v12z"
  }));
};

BtnCopy.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 18"
};

var BtnDelete = function BtnDelete(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.485.707L7.778 0 4.243 3.536.707 0 0 .707l3.536 3.536L0 7.778l.707.707L4.243 4.95l3.535 3.535.707-.707L4.95 4.243z"
  }));
};

BtnDelete.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8.4854 8.4854"
};

var BtnDeleteMobile = function BtnDeleteMobile(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10 10.7L5.4 6.1.7 10.7 0 10l4.6-4.6L0 .7.7 0l4.7 4.6L10 0l.7.7-4.6 4.7 4.6 4.6z"
  }));
};

BtnDeleteMobile.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10.7 10.7"
};

var BtnDetails = function BtnDetails(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h9.182v1H0zM0 3h7.364v1H0zM0 6h8.273v1H0zM0 9h6.455v1H0z"
  }));
};

BtnDetails.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9.1821289 10"
};

var BtnDetailsOnOff = function BtnDetailsOnOff(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h15v1H0zM0 3h9.915v1H0zM0 6h9.915v1H0z"
  }));
};

BtnDetailsOnOff.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 7"
};

var BtnDragDrop = function BtnDragDrop(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.2 0L0 4.2h8.5zM4.3 11.5l4.2-4.2H0z"
  }));
};

BtnDragDrop.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8.5 11.5"
};

var BtnEdit = function BtnEdit(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 3.044c.002-.59-.391-1.336-1.05-1.996C13.08.182 11.864-.36 11.221.28L1.589 9.917c-.296.294-.763 1.73-1.388 4.27L0 15l.814-.202c2.539-.629 3.976-1.096 4.271-1.388l9.633-9.638c.128-.127.282-.357.282-.728zm-3.093-2.027c.127-.043.69.111 1.328.747.634.635.791 1.194.77 1.291l-.285.284-2.066-2.067.253-.255zm-.966.972l2.063 2.065-7.58 7.585L3.36 9.574l7.58-7.585zM1.39 13.607c.358-1.37.762-2.725.929-2.99l.326-.326 2.065 2.066-.311.312c-.236.16-1.617.572-3.009.938z"
  }));
};

BtnEdit.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 15"
};

var BtnExpand = function BtnExpand(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.65 5.206v2.795c0 .282.224.497.5.497.268 0 .5-.223.5-.497V3.999a.49.49 0 0 0-.307-.46.483.483 0 0 0-.19-.039H12.15a.494.494 0 0 0-.497.5c0 .268.222.5.497.5h2.792L11.84 7.603a.5.5 0 0 0 .707.707l3.103-3.104zM4.5 14.948v-2.796a.494.494 0 0 0-.5-.497c-.268 0-.5.222-.5.497v4.005a.493.493 0 0 0 .498.498h4.004a.494.494 0 0 0 .498-.5c0-.268-.223-.5-.498-.5H5.207l3.103-3.103a.5.5 0 0 0-.707-.707L4.5 14.948z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20h-15A2.503 2.503 0 0 1 0 17.5v-15C0 1.122 1.122 0 2.5 0h15C18.879 0 20 1.122 20 2.5v15c0 1.379-1.121 2.5-2.5 2.5zM2.5 1C1.673 1 1 1.673 1 2.5v15c0 .827.673 1.5 1.5 1.5h15c.827 0 1.5-.673 1.5-1.5v-15c0-.827-.673-1.5-1.5-1.5h-15z"
  }));
};

BtnExpand.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};

var BtnFilters = function BtnFilters(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.95 2.5C14.71 1.084 13.482 0 12 0S9.29 1.084 9.05 2.5H0v1h9.05C9.29 4.916 10.518 6 12 6s2.71-1.084 2.95-2.5H18v-1h-3.05zm-1.021 1c-.224.86-1 1.5-1.929 1.5s-1.705-.64-1.929-1.5C10.029 3.34 10 3.174 10 3s.03-.34.071-.5c.224-.86 1-1.5 1.929-1.5s1.705.64 1.929 1.5c.042.16.071.326.071.5s-.03.34-.071.5zM0 9.5v1h3.05C3.29 11.916 4.518 13 6 13s2.71-1.084 2.95-2.5H18v-1H8.95C8.71 8.084 7.482 7 6 7S3.29 8.084 3.05 9.5H0zm4 .5c0-.174.03-.34.071-.5C4.295 8.64 5.071 8 6 8s1.705.64 1.929 1.5c.042.16.071.326.071.5s-.03.34-.071.5c-.224.86-1 1.5-1.929 1.5s-1.705-.64-1.929-1.5A1.977 1.977 0 0 1 4 10z"
  }));
};

BtnFilters.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 13"
};

var BtnGoTo = function BtnGoTo(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.059 9.47v5.118c0 .26-.21.47-.47.47H1.411a.47.47 0 0 1-.47-.47V1.412c0-.26.21-.47.47-.47h5.117a.47.47 0 0 0 0-.942H1.412C.632 0 0 .632 0 1.412v13.176C0 15.368.632 16 1.412 16h13.176c.78 0 1.412-.632 1.412-1.412V9.471a.47.47 0 0 0-.941 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.99.382c-.002-.014-.007-.026-.01-.039l-.016-.05c-.006-.015-.015-.028-.022-.041-.007-.014-.013-.028-.022-.041a.482.482 0 0 0-.048-.06c-.015-.016-.019-.018-.023-.022a.465.465 0 0 0-.06-.049c-.013-.009-.027-.015-.04-.022-.014-.007-.028-.016-.042-.022-.017-.007-.034-.01-.05-.015l-.039-.012A.47.47 0 0 0 15.525 0h-4.73a.475.475 0 0 0 0 .95h3.585L8.61 6.72a.474.474 0 0 0 .67.67l5.77-5.77v3.584a.475.475 0 0 0 .95 0V.474a.528.528 0 0 0-.01-.092z"
  }));
};

BtnGoTo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};

var BtnGuests = function BtnGuests(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22.01 24.537c0 .815-.666 1.478-1.484 1.478H9.389a1.483 1.483 0 0 1-1.484-1.478v-5.913c0-.054.01-.106.016-.159a1.48 1.48 0 0 1 1.468-1.319h1.413l-.001 3.033c0 .23.187.417.418.417h.153a.418.418 0 0 0 .418-.417v-3.026c0-.002.124-.004.371-.007H18.423l-.002 3.033c0 .23.188.417.419.417h.152a.418.418 0 0 0 .419-.417v-3.026c0-.002.372-.004 1.115-.007.818 0 1.484.663 1.484 1.478v5.913zM6.951 18.33h-1.69v7.005c0 .375-.306.68-.683.68h-.231a.683.683 0 0 1-.684-.68v-7.226a59.843 59.843 0 0 1-.016-1.122v-6.004h-.99v5.155h-.183A1.483 1.483 0 0 1 .989 14.66l.99-5.347c0-.687.475-1.261 1.114-1.426.119-.031.242-.052.371-.052h6.234c.129 0 .252.021.371.052a1.478 1.478 0 0 1 1.114 1.426l.99 5.347c0 .051-.011.099-.016.148-.003.035-.02.064-.02.1v.066a1.485 1.485 0 0 1-1.449 1.164h-.184v-5.155h-.989v5.155l-.126.023a2.465 2.465 0 0 0-2.438 2.169zM3.885 3.671c0-.137.02-.27.04-.403A2.69 2.69 0 0 1 6.581.986c1.348 0 2.458.994 2.656 2.282.02.133.041.266.041.403 0 .201-.026.395-.069.583a2.695 2.695 0 0 1-5.324-.583zm9.277 11.581c.009-.12.036-.234.072-.344h3.851v1.253h-3.923v-.909zm4.913.909v-1.253c0-.46-.325-.83-.753-.938-.078-.019-.153-.048-.237-.048h-3.958l-.954-4.609a2.45 2.45 0 0 0-.99-1.958 2.454 2.454 0 0 0-1.485-.505H8.39a3.66 3.66 0 0 0 1.818-2.596 3.61 3.61 0 0 0 .059-.583c0-.137-.026-.268-.041-.403C10.022 1.436 8.475 0 6.581 0S3.14 1.436 2.936 3.268c-.015.135-.041.266-.041.403 0 .2.028.392.059.583A3.66 3.66 0 0 0 4.772 6.85H3.464c-.559 0-1.07.192-1.485.505a2.45 2.45 0 0 0-.99 1.958L0 14.66c0 .801.392 1.508.989 1.958.415.313.926.505 1.485.505h.197l.003 1.207V25.335c0 .918.751 1.665 1.673 1.665h.231c.922 0 1.673-.747 1.673-1.665v-6.019h.665v5.221A2.471 2.471 0 0 0 9.389 27h11.137A2.471 2.471 0 0 0 23 24.537v-5.913a2.471 2.471 0 0 0-2.474-2.463h-2.451z"
  }));
};

BtnGuests.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23 27"
};

var BtnGuestyLogo = function BtnGuestyLogo(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M57.389 17.23L33.53.583C33.09.263 32.622 0 32.094 0h-.234c-.528.03-.997.262-1.436.583L6.565 17.23a2.169 2.169 0 0 0-.938 1.895v31.108a2.22 2.22 0 0 0 2.228 2.216H43.73a2.22 2.22 0 0 0 2.228-2.216V25.335c0-.904-.264-1.4-.938-1.895L33.5 15.452c-.41-.292-.909-.583-1.436-.583h-.235c-.527.029-1.055.32-1.436.583l-11.49 8.017a2.153 2.153 0 0 0-.937 1.866V37.93a2.22 2.22 0 0 0 2.227 2.216 2.22 2.22 0 0 0 2.228-2.216V26.443l9.526-6.647 9.525 6.647v21.574h-31.45V20.204L31.919 4.927l21.895 15.277v30.03a2.22 2.22 0 0 0 2.227 2.215 2.22 2.22 0 0 0 2.228-2.216V19.125c.03-.729-.235-1.457-.88-1.895zM11.167 69.62h-3.78c-.323 0-.5.147-.558.263-.117.146-.146.35-.146.642v.32c0 .263.058.496.146.642a.675.675 0 0 0 .557.262h2.228v3.528a7.397 7.397 0 0 1-.938.116c-.499.059-1.026.059-1.554.059-1.67 0-2.872-.467-3.517-1.429-.674-.962-1.026-2.303-1.026-3.965 0-1.75.381-3.09 1.114-3.965.703-.874 1.964-1.312 3.693-1.312.645 0 1.172.059 1.612.205s.88.32 1.29.524c.293.146.38.175.469.175.176 0 .351-.116.527-.32.117-.176.235-.35.323-.555.117-.233.146-.408.146-.583 0-.408-.44-.67-.762-.816-.41-.204-.967-.38-1.641-.525a9.417 9.417 0 0 0-2.052-.204C2.462 62.682 0 65.218 0 70.262c0 2.42.616 4.257 1.788 5.481 1.202 1.225 2.93 1.837 5.188 1.837 1.436 0 2.638-.117 3.546-.35 1.055-.262 1.583-.729 1.583-1.4v-5.335c0-.291-.088-.525-.264-.67-.146-.146-.38-.204-.674-.204M23.506 74.198v-7.143c0-.32-.205-.729-1.172-.729h-.088c-.967 0-1.143.409-1.143.73v7.23c-.322.379-.703.67-1.114.874-.44.233-.879.35-1.319.35-.615 0-1.113-.146-1.436-.437-.322-.292-.469-.7-.469-1.225v-6.793c0-.32-.205-.729-1.143-.729h-.088c-.967 0-1.172.409-1.172.73v6.967c0 1.108.352 1.983 1.026 2.595s1.612.933 2.784.933c.645 0 1.29-.146 1.934-.408a4.595 4.595 0 0 0 1.29-.817c.059.204.117.438.205.642.147.32.41.495.704.495.263 0 .527-.029.82-.116.528-.146.616-.467.616-.642 0-.029 0-.087-.117-.7-.059-.35-.117-.962-.117-1.807M30.863 68.28c1.495 0 2.228.816 2.286 2.594h-5.012c.235-1.749 1.114-2.594 2.726-2.594m.059-2.041c-1.73 0-3.078.496-3.986 1.487-.909.962-1.349 2.39-1.349 4.256s.47 3.265 1.407 4.199c.938.933 2.345 1.399 4.22 1.399.704 0 1.379-.087 1.994-.233.616-.146 1.114-.32 1.495-.554.293-.175.674-.437.674-.817 0-.116-.059-.291-.147-.495a1.908 1.908 0 0 0-.351-.496c-.176-.204-.352-.291-.528-.291a.66.66 0 0 0-.293.087l-.176.088c-.38.175-.791.35-1.23.496-.411.116-.91.204-1.466.204-.997 0-1.73-.234-2.199-.7-.44-.408-.703-1.08-.82-1.954h6.507c.146 0 .322-.087.498-.233a1.53 1.53 0 0 0 .352-.408c.117-.175.175-.32.175-.466 0-1.779-.41-3.149-1.201-4.082-.82-.991-2.023-1.487-3.576-1.487M43.408 71.487c-.498-.263-1.231-.554-2.169-.816-.557-.146-.938-.35-1.172-.584-.206-.204-.323-.495-.323-.874 0-.292.117-.496.41-.671.323-.204.733-.291 1.202-.291.323 0 .616.029.88.116.263.088.498.146.644.234.323.145.352.175.44.175.176 0 .351-.088.527-.292.117-.146.235-.32.323-.525.088-.204.146-.379.146-.525 0-.408-.44-.612-.586-.67-.293-.146-.674-.263-1.143-.35a7.738 7.738 0 0 0-1.436-.117c-.733 0-1.407.146-1.964.409a3.377 3.377 0 0 0-1.407 1.137 2.993 2.993 0 0 0-.498 1.661c0 .554.088 1.05.293 1.458.205.408.557.787 1.026 1.078.469.292 1.084.555 1.905.759.527.146.938.291 1.231.437.264.146.44.292.557.467.117.174.146.378.146.612 0 .583-.175 1.34-1.817 1.34-.47 0-.88-.057-1.202-.174a4.934 4.934 0 0 1-.967-.467c-.205-.116-.293-.145-.38-.145-.177 0-.352.087-.529.291-.146.146-.263.32-.351.496a1.001 1.001 0 0 0-.146.495c0 .35.35.613.586.788.351.233.79.408 1.348.553a6.976 6.976 0 0 0 1.788.233c.732 0 1.436-.145 2.051-.437.616-.291 1.143-.7 1.495-1.224.381-.525.557-1.108.557-1.779 0-.67-.117-1.224-.351-1.632-.176-.496-.587-.875-1.114-1.166M51.85 75.452c-.06 0-.118 0-.353.058-.117.03-.322.03-.586.03a.968.968 0 0 1-.645-.234c-.117-.116-.234-.379-.234-.962v-5.948h1.524c.322 0 .469-.145.557-.262.117-.146.146-.35.146-.641v-.263c0-.262-.058-.495-.146-.64a.673.673 0 0 0-.557-.264h-1.524V64.52c0-.32-.147-.496-.293-.583-.147-.117-.381-.146-.674-.146h-.205c-.85 0-.968.496-.997.7l-.234 1.836h-.821c-.323 0-.498.146-.557.263-.117.146-.147.35-.147.641v.262c0 .263.059.496.147.642a.676.676 0 0 0 .557.262h.791v6.123c0 1.137.323 1.924.967 2.39.616.438 1.32.671 2.11.671.47 0 1.876 0 1.876-.875 0-.175-.058-.408-.146-.67-.117-.496-.381-.583-.557-.583M62.752 66.326h-.088c-.234 0-.996 0-1.172.496l-2.14 5.452a9.147 9.147 0 0 0-.264.7l-.205.554a50.07 50.07 0 0 0-.44-1.254l-2.197-5.452c-.206-.496-.91-.496-1.143-.496h-.176c-.352 0-.616.03-.821.117-.352.146-.41.38-.41.525 0 .058 0 .116.029.204l.03.116 3.751 9.3-1.759 3.995c-.117.262-.117.35-.117.437 0 .292.176.613.997.613h.322c.674 0 1.114-.205 1.29-.613l5.569-13.702c.058-.175.088-.263.088-.35 0-.437-.382-.642-1.144-.642z"
  }));
};

BtnGuestyLogo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 82"
};

var BtnGuestyName = function BtnGuestyName(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.167 6.939H7.386c-.322 0-.498.146-.557.262-.117.146-.146.35-.146.642v.32c0 .263.058.496.146.642a.675.675 0 0 0 .557.262h2.228v3.528a7.397 7.397 0 0 1-.938.116c-.499.059-1.026.059-1.554.059-1.67 0-2.872-.467-3.517-1.429-.674-.962-1.026-2.303-1.026-3.965 0-1.75.381-3.09 1.114-3.965C4.396 2.537 5.657 2.1 7.386 2.1c.645 0 1.172.059 1.612.204s.88.32 1.29.525c.293.146.38.175.469.175.176 0 .351-.116.527-.32.117-.176.235-.35.323-.555.117-.233.146-.408.146-.583 0-.408-.44-.67-.762-.816-.41-.204-.967-.38-1.641-.525A9.417 9.417 0 0 0 7.298 0C2.462 0 0 2.536 0 7.58c0 2.42.616 4.257 1.788 5.481 1.202 1.225 2.93 1.837 5.188 1.837 1.436 0 2.638-.117 3.546-.35 1.055-.262 1.583-.729 1.583-1.4V7.814c0-.291-.088-.524-.264-.67-.146-.146-.38-.204-.674-.204M23.506 11.516V4.373c0-.32-.205-.729-1.172-.729h-.088c-.967 0-1.143.408-1.143.73v7.23c-.322.379-.703.67-1.114.874-.44.233-.879.35-1.319.35-.615 0-1.113-.146-1.436-.437s-.469-.7-.469-1.225V4.373c0-.32-.205-.729-1.143-.729h-.088c-.967 0-1.172.408-1.172.73v6.967c0 1.108.351 1.983 1.026 2.595s1.612.933 2.784.933c.645 0 1.29-.146 1.934-.408a4.595 4.595 0 0 0 1.29-.817c.059.204.117.437.205.642.147.32.41.495.704.495.263 0 .527-.029.82-.116.528-.146.616-.467.616-.642 0-.029 0-.087-.117-.7-.059-.35-.117-.962-.117-1.807M30.863 5.598c1.495 0 2.228.816 2.286 2.594h-5.012c.235-1.749 1.114-2.594 2.726-2.594m.059-2.041c-1.73 0-3.078.496-3.986 1.487-.909.962-1.349 2.39-1.349 4.256s.47 3.265 1.407 4.199c.938.932 2.345 1.399 4.22 1.399.704 0 1.378-.087 1.994-.233.616-.146 1.114-.32 1.495-.554.293-.175.674-.437.674-.817 0-.116-.059-.291-.147-.495a1.908 1.908 0 0 0-.351-.496c-.176-.204-.352-.291-.528-.291a.66.66 0 0 0-.293.087l-.176.088c-.381.175-.791.35-1.23.496-.411.116-.91.204-1.467.204-.996 0-1.729-.234-2.198-.7-.44-.408-.703-1.08-.82-1.954h6.506c.147 0 .323-.087.499-.233a1.53 1.53 0 0 0 .351-.408c.118-.175.176-.32.176-.466 0-1.779-.41-3.149-1.201-4.082-.82-.991-2.023-1.487-3.576-1.487M43.408 8.805c-.498-.263-1.231-.554-2.169-.816-.557-.146-.938-.35-1.172-.584-.206-.204-.323-.495-.323-.874 0-.292.117-.496.41-.671.323-.204.733-.291 1.202-.291.323 0 .616.029.88.116.263.088.498.146.644.234.323.145.352.175.44.175.176 0 .351-.088.527-.292.117-.146.235-.32.323-.525.088-.204.146-.379.146-.525 0-.408-.44-.612-.586-.67-.293-.146-.674-.263-1.143-.35a7.738 7.738 0 0 0-1.436-.117c-.733 0-1.407.146-1.964.409A3.377 3.377 0 0 0 37.78 5.16a2.993 2.993 0 0 0-.498 1.661c0 .554.088 1.05.293 1.458.205.408.557.787 1.026 1.079.469.291 1.084.554 1.905.758.527.146.938.291 1.23.437.264.146.44.292.558.467.117.175.146.378.146.612 0 .583-.176 1.34-1.817 1.34-.47 0-.88-.057-1.202-.174a4.934 4.934 0 0 1-.967-.466c-.205-.117-.293-.146-.38-.146-.177 0-.352.087-.529.291-.146.146-.263.32-.351.496a1.001 1.001 0 0 0-.147.495c0 .35.352.613.587.788.351.233.79.408 1.348.554a6.976 6.976 0 0 0 1.788.232c.732 0 1.436-.145 2.051-.437.616-.291 1.143-.7 1.495-1.224.381-.525.557-1.108.557-1.778 0-.671-.117-1.225-.351-1.633-.176-.496-.587-.875-1.114-1.166M51.85 12.77c-.06 0-.118 0-.353.058-.117.03-.322.03-.586.03a.968.968 0 0 1-.645-.234c-.117-.116-.234-.38-.234-.962V5.714h1.524c.322 0 .469-.146.557-.262.117-.146.146-.35.146-.642v-.262c0-.262-.058-.495-.146-.641a.673.673 0 0 0-.557-.263h-1.524V1.837c0-.321-.147-.496-.293-.583-.147-.117-.381-.146-.674-.146h-.205c-.85 0-.968.495-.997.7l-.234 1.836h-.821c-.323 0-.498.146-.557.263-.117.146-.147.35-.147.641v.262c0 .263.059.496.147.642a.676.676 0 0 0 .557.262h.791v6.123c0 1.137.323 1.924.967 2.39.616.438 1.32.67 2.11.67.47 0 1.876 0 1.876-.874 0-.175-.058-.408-.146-.67-.117-.496-.381-.583-.557-.583M62.752 3.644h-.088c-.234 0-.996 0-1.172.496l-2.14 5.452a9.147 9.147 0 0 0-.264.7l-.205.554a50.07 50.07 0 0 0-.44-1.254L56.247 4.14c-.206-.495-.91-.495-1.143-.495h-.176c-.352 0-.616.028-.821.116-.352.146-.41.38-.41.525 0 .058 0 .116.029.204l.03.116 3.75 9.3-1.758 3.995c-.117.262-.117.35-.117.437 0 .292.176.613.997.613h.322c.674 0 1.114-.205 1.29-.613l5.569-13.702c.058-.175.087-.263.087-.35 0-.437-.38-.641-1.143-.641z"
  }));
};

BtnGuestyName.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 63.8954 18.9506"
};

var BtnGuestySymbol = function BtnGuestySymbol(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M52.642 19.125c.03-.729-.234-1.457-.88-1.895L27.906.583C27.465.263 26.996 0 26.469 0h-.235c-.527.03-.996.262-1.436.583L.94 17.23a2.169 2.169 0 0 0-.938 1.895v31.108a2.22 2.22 0 0 0 2.227 2.216h35.875a2.22 2.22 0 0 0 2.228-2.216V25.335c0-.904-.264-1.4-.938-1.895l-11.519-7.988c-.41-.292-.908-.583-1.436-.583h-.234c-.528.029-1.055.32-1.436.583l-11.49 8.017a2.153 2.153 0 0 0-.938 1.866V37.93c0 1.225.997 2.216 2.228 2.216s2.227-.992 2.227-2.216V26.443l9.526-6.647 9.526 6.647v21.574H4.398V20.204L26.293 4.927l21.894 15.277v30.03c0 1.224.997 2.215 2.228 2.215s2.227-.991 2.227-2.216v-31.05c.059-.029.059-.029.059-.058"
  }));
};

BtnGuestySymbol.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 52.7027 52.4489"
};

var BtnHelp = function BtnHelp(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13C2.916 13 0 10.084 0 6.5S2.916 0 6.5 0 13 2.916 13 6.5 10.084 13 6.5 13zm0-12A5.506 5.506 0 0 0 1 6.5C1 9.532 3.467 12 6.5 12 9.532 12 12 9.532 12 6.5 12 3.467 9.532 1 6.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 3.735c.113-.1.237-.195.372-.285a2.674 2.674 0 0 1 .948-.393C6.003 3.02 6.202 3 6.415 3c.29 0 .554.04.792.12s.443.194.613.343c.17.148.302.327.395.537s.14.445.14.705c0 .253-.037.472-.11.658s-.166.345-.277.482a2.205 2.205 0 0 1-.363.355l-.37.283a2.924 2.924 0 0 0-.303.26.513.513 0 0 0-.152.287l-.115.73H5.82l-.085-.815a.222.222 0 0 1-.005-.042V6.86c0-.147.037-.274.11-.383s.165-.21.275-.304c.11-.096.228-.188.355-.278.127-.09.245-.187.355-.292.11-.106.202-.225.275-.358a.96.96 0 0 0 .11-.47.73.73 0 0 0-.255-.568c-.08-.068-.176-.12-.287-.157s-.233-.055-.363-.055a1.615 1.615 0 0 0-.817.202c-.092.052-.17.099-.233.14a.32.32 0 0 1-.17.063.273.273 0 0 1-.26-.15L4.5 3.735zm.945 5.62c0-.103.02-.202.058-.295a.705.705 0 0 1 .16-.24.79.79 0 0 1 .545-.22.76.76 0 0 1 .537.22.756.756 0 0 1 .22.535.764.764 0 0 1-.22.535.774.774 0 0 1-.537.215.787.787 0 0 1-.545-.215.71.71 0 0 1-.16-.237.761.761 0 0 1-.058-.298z"
  }));
};

BtnHelp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13 13"
};

var BtnHelpCenter = function BtnHelpCenter(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17.92 3.07c-4.091-4.09-10.748-4.09-14.84 0-4.097 4.097-4.1 10.759-.01 14.85 4.097 4.097 10.763 4.097 14.86 0 4.09-4.092 4.087-10.753-.01-14.85zm-.367 13.776l-2.828-2.828a5.504 5.504 0 0 0 0-7.035l2.828-2.829c3.242 3.605 3.243 9.095 0 12.692zm-10.236-3.17a4.498 4.498 0 1 1 6.361-6.361c1.757 1.756 1.761 4.61.01 6.36a4.51 4.51 0 0 1-6.371 0zm9.53-10.23l-2.83 2.83a5.498 5.498 0 0 0-7.035-.001L4.154 3.447a9.49 9.49 0 0 1 12.692 0zm-13.4.708l2.829 2.829a5.506 5.506 0 0 0 .002 7.032l-2.831 2.831C.204 13.25.205 7.76 3.447 4.154zm.707 13.399l2.831-2.831a5.511 5.511 0 0 0 7.032.002l2.829 2.829c-3.602 3.239-9.09 3.239-12.692 0z"
  }));
};

BtnHelpCenter.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
};

var BtnInbox = function BtnInbox(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22 .4H3C1.6.4.4 1.6.4 3v14c0 1.4 1.2 2.6 2.6 2.6h19c1.4 0 2.6-1.2 2.6-2.6V3c0-1.4-1.2-2.6-2.6-2.6zM3 1.6h19c.4 0 .8.2 1 .4l-10.5 9L2 2.1c.2-.3.6-.5 1-.5zm19 16.8H3c-.8 0-1.4-.6-1.4-1.4V3.3l10.9 9.3 10.9-9.3V17c0 .8-.6 1.4-1.4 1.4z"
  }));
};

BtnInbox.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 20"
};

var BtnInboxExpand = function BtnInboxExpand(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4 11.294V9.503a.492.492 0 0 0-.5-.49.5.5 0 0 0-.5.49v3.02a.488.488 0 0 0 .492.49h3.02c.275 0 .49-.224.49-.5a.5.5 0 0 0-.49-.5H4.684l2.667-2.667c.2-.2.195-.51 0-.703a.503.503 0 0 0-.703.001L4 11.294zM12 4.719v1.79c0 .276.224.491.5.491a.5.5 0 0 0 .5-.49V3.49a.488.488 0 0 0-.492-.49h-3.02a.492.492 0 0 0-.49.5c0 .268.22.5.49.5h1.827L8.648 6.666c-.2.2-.195.51 0 .704a.503.503 0 0 0 .703-.002L12 4.718z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16h-11A2.503 2.503 0 0 1 0 13.5v-11C0 1.122 1.122 0 2.5 0h11C14.879 0 16 1.122 16 2.5v11c0 1.379-1.121 2.5-2.5 2.5zM2.5 1C1.673 1 1 1.673 1 2.5v11c0 .827.673 1.5 1.5 1.5h11c.827 0 1.5-.673 1.5-1.5v-11c0-.827-.673-1.5-1.5-1.5h-11z"
  }));
};

BtnInboxExpand.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};

var BtnInboxOpen = function BtnInboxOpen(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23.628 8.087c0-.016-.008-.03-.01-.045a.478.478 0 0 0-.017-.089.484.484 0 0 0-.04-.102c-.006-.011-.007-.024-.014-.035L18.659.229A.5.5 0 0 0 18.24 0H5.39a.501.501 0 0 0-.421.229L.08 7.816c-.009.013-.01.027-.016.04a.481.481 0 0 0-.036.091.489.489 0 0 0-.02.1C.007 8.06 0 8.073 0 8.087V15.164c0 1.718 1.35 3.115 3.01 3.115h17.607c1.66 0 3.01-1.397 3.01-3.115v-.542-6.535zM5.66 1h12.306l4.244 6.587h-2.707c-1.661 0-3.012 1.375-3.012 3.064v.939c0 .25-.178.44-.413.44H7.546c-.233 0-.41-.19-.41-.44V10.65c0-1.69-1.35-3.064-3.011-3.064H1.417L5.66 1zm16.966 14.164c0 1.166-.901 2.115-2.01 2.115H3.01C1.9 17.28 1 16.33 1 15.164V8.587h3.125c1.128 0 2.011.907 2.011 2.064v.939l.001.004c.003.806.62 1.436 1.41 1.436h8.532c.792 0 1.413-.633 1.413-1.44v-.939c0-1.157.884-2.064 2.012-2.064h3.124v4.981l-.001.005v1.591z"
  }));
};

BtnInboxOpen.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23.6279297 18.2792969"
};

var BtnLeft = function BtnLeft(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.854.146a.497.497 0 0 1 0 .703L1.201 5.503l4.653 4.654a.497.497 0 1 1-.703.703L.146 5.854a.497.497 0 0 1 0-.703L5.15.146a.497.497 0 0 1 .703 0z"
  }));
};

BtnLeft.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 6 11.0054388"
};

var BtnLinks = function BtnLinks(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.1 0l-.024.001C4.52.013 0 4.544 0 10.101c0 5.555 4.52 10.085 10.07 10.098h.03c5.57 0 10.1-4.53 10.1-10.099S15.67 0 10.1 0zm3.14 15.365c-.638 1.96-1.635 3.368-2.64 3.735v-4.086c.89.032 1.776.15 2.64.35zm3.253 1.204a9.092 9.092 0 0 1-3.953 2.296c.67-.79 1.244-1.899 1.67-3.237.789.246 1.555.562 2.283.94zM10.6 14.015V10.6h3.398a17.728 17.728 0 0 1-.485 3.803c-.95-.225-1.93-.356-2.913-.388zM13.998 9.6H10.6V6.182a14.845 14.845 0 0 0 2.912-.388c.29 1.17.452 2.449.486 3.806zm.21-5.032c-.425-1.336-.998-2.444-1.668-3.234a9.093 9.093 0 0 1 3.95 2.294c-.734.381-1.5.697-2.282.94zm-3.608.613v-4.08c1.005.366 2.002 1.772 2.64 3.73-.86.2-1.748.318-2.64.35zm8.585 5.42a8.998 8.998 0 0 1-2 5.203 14.848 14.848 0 0 0-2.705-1.14 18.87 18.87 0 0 0 .522-4.064h4.183zm0-1h-4.183a18.95 18.95 0 0 0-.522-4.069c.933-.289 1.84-.672 2.702-1.14A8.997 8.997 0 0 1 19.185 9.6zM5.696 14.671c-.926.288-1.827.67-2.68 1.133a9.006 9.006 0 0 1-2-5.205h4.157c.034 1.433.21 2.802.523 4.072zm1.242-9.846C7.582 2.849 8.588 1.44 9.6 1.089V5.18c-.9-.032-1.794-.151-2.662-.355zM3.711 3.628a9.089 9.089 0 0 1 3.917-2.285c-.666.788-1.235 1.891-1.659 3.218a13.833 13.833 0 0 1-2.258-.933zM9.6 6.181V9.6H6.177a17.76 17.76 0 0 1 .486-3.811c.959.227 1.945.358 2.936.39zM6.177 10.6H9.6v3.414c-.99.032-1.977.164-2.937.393a17.78 17.78 0 0 1-.485-3.808zm1.45 8.256a9.1 9.1 0 0 1-3.92-2.288c.722-.377 1.481-.69 2.26-.934.424 1.33.994 2.434 1.66 3.222zM9.6 15.014v4.098c-1.013-.354-2.02-1.764-2.663-3.742a13.806 13.806 0 0 1 2.663-.356zM1.015 9.6a9.008 9.008 0 0 1 2.001-5.205c.857.465 1.757.846 2.68 1.132A18.9 18.9 0 0 0 5.173 9.6H1.015z"
  }));
};

BtnLinks.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20.199707 20.199707"
};

var BtnLogout = function BtnLogout(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1.375 18.625V1.375h8.938a.688.688 0 0 0 0-1.375H.687A.688.688 0 0 0 0 .687v18.625c0 .38.308.688.688.688h9.624a.688.688 0 0 0 0-1.375H1.376z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.803 10.01L17.11 5.203a.67.67 0 0 0-.96 0 .701.701 0 0 0 0 .98l3.535 3.623H5.68c-.375 0-.68.31-.68.694s.305.694.68.694h14.005l-3.536 3.622a.701.701 0 0 0 0 .98.67.67 0 0 0 .961 0l4.692-4.806a.707.707 0 0 0 0-.98"
  }));
};

BtnLogout.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 20"
};

var BtnMap = function BtnMap(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.986 0l-8.71 2.679L0 .76v16.43l7.544 1.92 8.497-2.689 4.955.99V1l-5.01-1zm-.723 15.62L7.93 17.941l-.25-14.34 7.335-2.256.25 14.273zM1 2.06l5.677 1.495.252 14.368L1 16.413V2.06zm18.996 14.133l-3.735-.747-.252-14.406.03-.01 3.957.79v14.373z"
  }));
};

BtnMap.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20.9960938 19.1118164"
};

var BtnMarkRead = function BtnMarkRead(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 0a4.002 4.002 0 0 0-3.703 2.5H2.5A2.503 2.503 0 0 0 0 5v10c0 1.379 1.122 2.5 2.5 2.5h15c1.379 0 2.5-1.121 2.5-2.5V7.703A4.002 4.002 0 0 0 22.5 4c0-2.206-1.794-4-4-4zm-16 3.5h12.05c-.02.166-.05.329-.05.5 0 .93.332 1.774.866 2.453l-5.353 4.322L1.452 3.93c.27-.265.64-.43 1.048-.43zM19 15c0 .827-.673 1.5-1.5 1.5h-15c-.827 0-1.5-.673-1.5-1.5V5c0-.048.01-.093.014-.14l9.001 7.197 6.07-4.888-.002-.004.003.003A3.96 3.96 0 0 0 18.5 8c.171 0 .334-.03.5-.05V15zm1-8.417c-.305.177-.64.305-1 .366-.163.028-.329.051-.5.051a2.975 2.975 0 0 1-2.354-1.163A2.97 2.97 0 0 1 15.5 4c0-.171.023-.337.05-.5.062-.36.19-.695.367-1A2.99 2.99 0 0 1 18.5 1c1.654 0 3 1.346 3 3A2.99 2.99 0 0 1 20 6.583z"
  }));
};

BtnMarkRead.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22.5 17.5"
};

var BtnMessage = function BtnMessage(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 22c-.1 0-.3 0-.4-.1l-4.1-4H3.9C1.8 17.8 0 16.1 0 14V3.9C0 1.7 1.8 0 3.9 0H18c2.2 0 4 1.7 4 3.9V14c0 2.1-1.7 3.8-3.9 3.8H16v3.7c0 .2-.1.4-.3.5h-.2zM3.9 1C2.3 1 1 2.3 1 3.9V14c0 1.6 1.3 2.8 2.9 2.8h7.3c.1 0 .3.1.4.1l3.4 3.3v-3c0-.3.2-.5.5-.5h2.6c1.6 0 2.9-1.2 2.9-2.8v-10C21 2.3 19.7 1 18.1 1H3.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.2 5.5h6.7v1H6.2zM6.2 8.4h10.2v1H6.2zM6.2 11.2h9.5v1H6.2z"
  }));
};

BtnMessage.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22"
};

var BtnNights = function BtnNights(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.6 22C4.8 22 0 17.1 0 11S4.8 0 10.6 0c1.4 0 2.8.3 4.1.9l.9.4-.8.5C11.6 3.6 9.6 7.2 9.6 11c0 3.8 2 7.4 5.2 9.3l.8.5-.9.4c-1.3.5-2.7.8-4.1.8zm0-21C5.3 1 1 5.5 1 11s4.3 10 9.6 10c1 0 1.9-.1 2.8-.4-3-2.2-4.8-5.7-4.8-9.6s1.8-7.4 4.8-9.6c-.9-.3-1.8-.4-2.8-.4z"
  }));
};

BtnNights.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15.6 22"
};

var BtnNotifications = function BtnNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1.791 20.472c1.32-.267 3.549-.699 5.646-.934-.011.094-.034.187-.034.281 0 1.405 1.165 2.548 2.596 2.548s2.596-1.143 2.596-2.548c0-.095-.024-.188-.035-.282 2.057.231 4.245.652 5.574.921-1.532.935-4.649 2.502-8.351 2.502-3.686 0-6.586-1.557-7.992-2.488m8.208.887c-.868 0-1.573-.691-1.573-1.539 0-.129.019-.257.052-.38.516-.04 1.013-.066 1.47-.066h.112c.453 0 .948.025 1.462.065.032.124.051.251.051.381 0 .848-.706 1.539-1.574 1.539zm-7.258-6.407c.259-.228.401-.353.452-.556.251-.966.413-2.006.571-3.012.618-3.943 1.151-7.349 6.275-7.349 5.044 0 5.577 3.406 6.195 7.348.158 1.007.32 2.047.57 3.009.052.207.195.332.454.56.353.312.945.833 1.293 1.567.349.732.422 2.259.416 3.079-1.656-.341-6.003-1.233-8.908-1.233h-.12c-2.906 0-7.253.893-8.89 1.229-.025-.816.049-2.342.397-3.075.349-.734.941-1.255 1.295-1.567zM8.255 2.716c0-.941.782-1.707 1.743-1.707.963 0 1.745.766 1.745 1.707 0 .158-.027.312-.07.46a9.845 9.845 0 0 0-3.353-.008 1.714 1.714 0 0 1-.065-.452M17.94 14.2a5.762 5.762 0 0 1-.167-.147c-.225-.894-.38-1.874-.528-2.824-.495-3.164-1.053-6.67-4.578-7.814.062-.228.099-.462.099-.699C12.767 1.219 11.525 0 9.998 0 8.473 0 7.232 1.219 7.232 2.716c0 .233.034.463.094.688-3.514 1.13-4.075 4.649-4.572 7.826-.149.948-.302 1.928-.527 2.823-.042.039-.1.087-.167.147-.385.339-1.103.971-1.54 1.891-.553 1.164-.629 4.022-.397 4.382l.254.235c.847.677 4.408 3.26 9.408 3.26 5.033 0 8.934-2.617 9.819-3.261l.273-.234c.232-.36.157-3.218-.397-4.382-.438-.92-1.155-1.551-1.54-1.891z"
  }));
};

BtnNotifications.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 24"
};

var BtnNotificationsBadge = function BtnNotificationsBadge(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F5F",
    d: "M15.5 13.749a3.833 3.833 0 1 0 0-7.666 3.833 3.833 0 0 0 0 7.666z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.94 14.2a5.762 5.762 0 0 1-.167-.147c-.02-.079-.033-.166-.052-.247C19.075 13.03 20 11.586 20 9.917c0-2.481-2.019-4.5-4.5-4.5-.022 0-.043.006-.065.007-.634-.887-1.51-1.6-2.768-2.008.062-.228.099-.462.099-.699C12.767 1.219 11.525 0 9.998 0 8.473 0 7.232 1.219 7.232 2.716c0 .233.034.463.094.688-3.514 1.13-4.075 4.649-4.572 7.826-.149.948-.302 1.928-.527 2.823-.042.039-.1.087-.167.147-.385.339-1.103.971-1.54 1.891-.553 1.164-.629 4.022-.397 4.382l.254.235c.847.677 4.408 3.26 9.408 3.26 5.033 0 8.934-2.617 9.819-3.261l.273-.234c.232-.36.157-3.218-.397-4.382-.438-.92-1.155-1.551-1.54-1.891zM15.5 6.417c.187 0 .367.027.546.055A3.496 3.496 0 0 1 19 9.917a3.494 3.494 0 0 1-1.496 2.861c-.287.201-.608.35-.949.458a3.45 3.45 0 0 1-1.056.181c-1.93 0-3.5-1.57-3.5-3.5a3.497 3.497 0 0 1 2.931-3.442c.187-.032.375-.058.57-.058zM9.998 1.009c.963 0 1.745.766 1.745 1.707 0 .158-.027.312-.07.46a9.845 9.845 0 0 0-3.353-.008 1.714 1.714 0 0 1-.065-.452c0-.941.782-1.707 1.743-1.707zM9.783 22.96c-3.686 0-6.586-1.557-7.992-2.488 1.32-.267 3.549-.699 5.646-.934-.011.094-.034.187-.034.281 0 1.405 1.165 2.548 2.596 2.548s2.596-1.143 2.596-2.548c0-.095-.024-.188-.035-.282 2.057.231 4.245.652 5.574.921-1.532.935-4.649 2.502-8.351 2.502zm-1.357-3.14c0-.129.019-.257.052-.38.516-.04 1.013-.066 1.47-.066h.112c.453 0 .948.025 1.462.065.032.124.051.251.051.381 0 .848-.706 1.539-1.574 1.539-.868 0-1.573-.691-1.573-1.539zm1.633-1.455h-.12c-2.906 0-7.253.893-8.89 1.229-.025-.816.049-2.342.397-3.075.349-.734.941-1.255 1.295-1.567.259-.228.401-.353.452-.556.251-.966.413-2.006.571-3.012.618-3.943 1.151-7.349 6.275-7.349 2.094 0 3.403.593 4.271 1.561C12.408 6.122 11 7.85 11 9.917c0 2.481 2.019 4.5 4.5 4.5.442 0 .861-.084 1.266-.203.014.059.023.121.039.179.052.207.195.332.454.56.353.312.945.833 1.293 1.567.349.732.422 2.259.416 3.079-1.657-.342-6.004-1.234-8.909-1.234z"
  }));
};

BtnNotificationsBadge.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 24"
};

var BtnParking = function BtnParking(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17.025 0H0v1h.025v16.025h1V1h16v16.025h1V0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.427 10.98V15H5.98V4.253h3.172c.68 0 1.271.078 1.774.235.503.158.92.382 1.25.672s.575.64.738 1.05.244.867.244 1.372c0 .501-.088.958-.263 1.373s-.43.773-.769 1.072-.756.535-1.255.702c-.501.167-1.074.251-1.72.251H7.428zm0-1.155h1.725c.416 0 .781-.054 1.1-.165.317-.11.583-.264.798-.46.215-.199.377-.435.488-.71a2.42 2.42 0 0 0 .165-.908c0-.685-.211-1.22-.634-1.604S10.007 5.4 9.152 5.4H7.427v4.425z"
  }));
};

BtnParking.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18.0249023 17.0253906"
};

var BtnPayment = function BtnPayment(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22.58 13.636c.262-.362.42-.768.42-1.211 0-1.555-1.78-2.728-4.14-2.728-1.466 0-2.707.453-3.438 1.17.13-.272.218-.56.218-.867 0-.443-.158-.85-.42-1.212.262-.363.42-.769.42-1.212 0-1.555-1.78-2.727-4.14-2.727-1.466 0-2.707.453-3.438 1.169.13-.272.218-.559.218-.867 0-.443-.158-.849-.42-1.212.262-.362.42-.769.42-1.212C8.28 1.172 6.5 0 4.14 0 1.78 0 0 1.172 0 2.727c0 .443.158.85.42 1.212-.262.363-.42.77-.42 1.212 0 .444.158.85.42 1.213-.262.362-.42.769-.42 1.212 0 .443.158.85.42 1.212C.157 9.15 0 9.557 0 10s.158.85.42 1.212c-.262.363-.42.77-.42 1.213 0 .443.158.849.42 1.211-.262.363-.42.77-.42 1.212 0 .443.158.85.42 1.212-.262.363-.42.77-.42 1.213C0 18.827 1.78 20 4.14 20c1.655 0 3.01-.584 3.68-1.465C8.49 19.416 9.845 20 11.5 20c1.655 0 3.01-.584 3.68-1.465.67.881 2.025 1.465 3.68 1.465 2.36 0 4.14-1.173 4.14-2.727 0-.443-.158-.85-.42-1.213.262-.362.42-.769.42-1.212 0-.443-.158-.849-.42-1.212zM4.186 19.088l-.045.003c-1.775 0-3.22-.816-3.22-1.818 0-.195.069-.379.17-.555.745.53 1.814.857 3.05.857 1.237 0 2.305-.327 3.05-.857.101.176.17.36.17.555 0 .993-1.42 1.802-3.175 1.815zm3.005-3.685c-.14.246-.367.469-.667.657-.59.37-1.435.606-2.383.606-.947 0-1.792-.236-2.382-.606h-.001c-.3-.188-.526-.41-.667-.657a1.12 1.12 0 0 1-.17-.555c0-.026.012-.05.013-.075a1.13 1.13 0 0 1 .156-.479c.32.228.704.413 1.134.555.57.188 1.212.303 1.917.303.705 0 1.348-.115 1.917-.303.43-.142.813-.327 1.134-.555.087.153.143.312.156.48.001.025.013.048.013.074 0 .195-.069.379-.17.555zm.154-2.889a1.134 1.134 0 0 1-.153.465c-.141.246-.367.469-.667.657h-.001c-.373.234-.848.409-1.389.509a5.444 5.444 0 0 1-.994.097c-.298 0-.581-.03-.856-.073-.597-.094-1.122-.28-1.527-.533-.3-.188-.527-.411-.668-.657a1.133 1.133 0 0 1-.153-.465c-.003-.03-.016-.059-.016-.09 0-.194.069-.378.17-.554.32.228.704.412 1.133.554.57.188 1.212.303 1.917.303.705 0 1.348-.115 1.917-.303.43-.142.813-.326 1.134-.554.1.176.169.36.169.554 0 .031-.013.06-.016.09zm-.153-1.96c-.141.247-.367.47-.668.657v.001c-.58.363-1.409.596-2.338.604l-.045.002c-.948 0-1.792-.237-2.382-.606h-.001c-.3-.189-.527-.411-.668-.658A1.12 1.12 0 0 1 .92 10c0-.195.069-.378.17-.554.32.228.703.412 1.133.554.57.188 1.212.303 1.917.303.705 0 1.348-.115 1.917-.303.43-.142.813-.326 1.134-.554.1.175.169.36.169.554s-.069.379-.17.554zm.158-2.915c-.011.172-.069.335-.158.491-.141.247-.367.47-.667.657h-.001c-.441.277-1.022.479-1.687.562a5.598 5.598 0 0 1-1.344.008c-.685-.08-1.283-.286-1.735-.57-.3-.188-.527-.41-.668-.657a1.13 1.13 0 0 1-.158-.49C.93 7.617.92 7.597.92 7.575c0-.195.069-.379.17-.555.32.228.704.413 1.134.555.569.188 1.212.303 1.916.303.705 0 1.348-.115 1.917-.303A4.26 4.26 0 0 0 7.19 7.02c.1.176.169.36.169.555 0 .022-.01.042-.011.063zm.011-2.488c0 .195-.069.38-.169.555-.14.247-.367.47-.667.657h-.002c-.59.37-1.434.607-2.382.607-.948 0-1.792-.237-2.382-.606l-.001-.001h-.001c-.3-.188-.526-.41-.667-.657-.1-.176-.169-.36-.169-.554 0-.018.008-.035.01-.052a1.13 1.13 0 0 1 .159-.503c.321.228.705.413 1.135.555.569.188 1.212.303 1.916.303.705 0 1.348-.115 1.917-.303.43-.142.813-.327 1.134-.555-.038-.066-.097-.125-.146-.187.05.062.109.121.146.187.091.16.15.327.16.503 0 .017.009.034.009.051zm-.169-1.87c-.14.247-.367.47-.667.658.098.062.176.132.258.2H6.78c-.082-.067-.159-.138-.257-.2-.58.364-1.407.597-2.338.604l-.045.002c-.95 0-1.794-.236-2.383-.605h-.001c-.3-.189-.526-.412-.667-.658-.1-.176-.169-.36-.169-.555C.92 1.723 2.362.91 4.14.91l.028.002c1.765.008 3.192.817 3.192 1.816 0 .195-.069.379-.169.555zm4.35 15.808l-.04.002c-1.776 0-3.221-.816-3.221-1.818 0-.195.069-.379.17-.555.745.53 1.814.857 3.05.857 1.237 0 2.305-.327 3.05-.857.101.176.17.36.17.555 0 .994-1.423 1.803-3.178 1.816zm3.01-3.686c-.142.246-.368.469-.668.657h-.001c-.59.37-1.434.606-2.382.606-.947 0-1.792-.236-2.382-.606h-.001c-.3-.188-.526-.41-.667-.657a1.12 1.12 0 0 1-.17-.555c0-.026.012-.05.013-.075a1.13 1.13 0 0 1 .156-.479c.32.228.704.413 1.134.555.57.188 1.212.303 1.917.303.705 0 1.348-.115 1.917-.303.43-.142.813-.327 1.134-.555.087.153.143.312.156.48.001.025.013.048.013.074 0 .195-.069.379-.17.555zm.153-2.889a1.134 1.134 0 0 1-.153.465c-.141.246-.367.469-.667.657h-.001c-.391.245-.895.426-1.468.523-.292.049-.595.083-.915.083-.298 0-.581-.03-.856-.073-.597-.094-1.122-.28-1.527-.533-.3-.188-.527-.411-.668-.657a1.133 1.133 0 0 1-.153-.465c-.003-.03-.016-.059-.016-.09 0-.194.069-.378.17-.554.32.228.704.412 1.133.554.57.188 1.212.303 1.917.303.705 0 1.348-.115 1.917-.303.43-.142.813-.326 1.134-.554.1.176.169.36.169.554 0 .031-.013.06-.016.09zm-.153-1.96c-.141.247-.368.47-.668.657v.001c-.581.364-1.41.597-2.341.604l-.042.002c-.948 0-1.792-.237-2.382-.606h-.001c-.3-.189-.527-.411-.668-.658A1.12 1.12 0 0 1 8.28 10c0-.195.069-.378.17-.554.32.228.703.412 1.133.554.57.188 1.212.303 1.917.303.705 0 1.348-.115 1.917-.303.43-.142.813-.326 1.134-.554.1.176.169.36.169.554s-.069.379-.17.554zm.158-2.915c-.011.172-.069.335-.158.491-.141.247-.367.47-.667.657h-.001c-.452.284-1.05.49-1.734.57a5.649 5.649 0 0 1-1.297 0c-.685-.08-1.283-.286-1.735-.57-.3-.188-.527-.41-.668-.657a1.13 1.13 0 0 1-.158-.49c-.001-.022-.011-.042-.011-.064 0-1.003 1.445-1.818 3.22-1.818 1.775 0 3.22.815 3.22 1.818 0 .022-.01.042-.011.063zm4.151 11.452c-.04 0-.077-.006-.117-.007-1.72-.035-3.103-.831-3.103-1.811 0-.195.069-.379.17-.555.745.53 1.813.857 3.05.857s2.305-.327 3.05-.857c.101.176.17.36.17.555 0 1.002-1.445 1.818-3.22 1.818zm3.05-3.688c-.14.246-.367.469-.667.657h-.001c-.59.37-1.434.606-2.382.606s-1.792-.236-2.382-.606h-.001c-.3-.188-.526-.41-.667-.657a1.12 1.12 0 0 1-.17-.555c0-.026.012-.05.013-.075.013-.167.069-.326.156-.479.32.228.704.413 1.134.555.57.188 1.212.303 1.917.303.705 0 1.348-.115 1.917-.303.43-.142.813-.327 1.134-.555.087.153.143.312.156.48.001.025.013.048.013.074 0 .195-.069.379-.17.555zm.154-2.889a1.134 1.134 0 0 1-.153.465c-.141.246-.367.469-.667.657h-.001c-.422.264-.974.457-1.604.547-.25.035-.509.06-.779.06-.338 0-.658-.038-.965-.093-.552-.099-1.038-.276-1.418-.514-.3-.188-.527-.411-.668-.657a1.134 1.134 0 0 1-.153-.465c-.003-.03-.016-.059-.016-.09 0-.877 1.106-1.611 2.572-1.781a5.66 5.66 0 0 1 1.287 0c1.47.167 2.58.902 2.581 1.781 0 .031-.013.06-.016.09z"
  }));
};

BtnPayment.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23 20"
};

var BtnPhone = function BtnPhone(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16.048 21.514c-3.516 0-7.11-2.965-9.762-5.83-3.68-3.411-7.551-8.428-4.952-12.809.022-.049 1.028-2.08 2.88-2.346 1.19-.172 2.397.413 3.599 1.735.793.872 2.271 2.496.826 4.45C7.46 8.31 6.107 8.503 6.05 8.51l-.105.009c.013.004-.258.803 3.067 4.503 3.654 3.286 4.455 3.018 4.486 3.004-.01-.137.18-1.49 1.774-2.67 2.032-1.505 3.73.135 4.458.834 1.335 1.287 1.92 2.538 1.739 3.72-.238 1.545-1.727 2.439-2.356 2.752l-.005.002a5.89 5.89 0 0 1-3.06.85zM4.613 1.5c-.086 0-.172.006-.256.018-1.312.19-2.134 1.814-2.143 1.831-2.398 4.044 1.966 9.02 4.778 11.629 2.574 2.777 7.377 7.013 11.33 4.978l-.002-.016.347-.173c.49-.243 1.645-.927 1.812-2.01.13-.84-.356-1.799-1.444-2.846-1.326-1.277-2.187-1.48-3.169-.752-1.231.912-1.39 1.88-1.396 1.92.018.149-.08.626-.54.848-.627.305-1.833.215-5.626-3.2-3.449-3.833-3.538-5.041-3.235-5.67.222-.458.703-.556.946-.542-.047-.004.914-.17 1.82-1.395.805-1.088.353-1.958-.762-3.183C6.205 1.982 5.38 1.5 4.613 1.5z"
  }));
};

BtnPhone.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 22"
};

var BtnPrinter = function BtnPrinter(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M21.873 4.793h-3.34v-1.8c0-1.082.912-1.995 1.99-1.995a.499.499 0 1 0 0-.998H7.843C6.182 0 4.83 1.343 4.83 2.993v1.8H2.127C.954 4.793 0 5.78 0 6.99v8.82c0 1.23.934 2.196 2.127 2.196H4.83v2.996c0 1.121-.886 2-2.017 2a.499.499 0 1 0 0 .998h12.743c1.64 0 2.975-1.345 2.975-2.998v-2.996h3.34c1.193 0 2.128-.965 2.128-2.197V6.99c0-1.211-.954-2.197-2.127-2.197zm-16.044 0v-1.8c0-1.119.884-1.995 2.013-1.995h10.455a2.983 2.983 0 0 0-.763 1.994v1.829H5.829v-.027zM17.534 17.01v3.993c0 1.121-.869 2-1.977 2H5.059c.48-.53.771-1.232.771-2V10.278h11.705l-.001 6.73zm5.467-1.2c0 .684-.485 1.2-1.128 1.2h-3.34v-7.23a.499.499 0 0 0-.499-.499H5.331c-.276 0-.5.223-.5.499v7.23H2.127c-.633 0-1.128-.528-1.128-1.2V6.99c0-.661.506-1.199 1.128-1.199h19.746c.622 0 1.128.538 1.128 1.199v8.82z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.545 6.474h-.768c-.287 0-.487.26-.487.512v.776c0 .286.2.512.487.512h.768a.528.528 0 0 0 .504-.512v-.775c0-.252-.259-.513-.504-.513zM8.275 12.399h6.853v.998H8.275zM8.275 15.891h6.853v.998H8.275zM8.275 19.383h3.594v.998H8.275z"
  }));
};

BtnPrinter.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var BtnProperty = function BtnProperty(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13 2V0H3v2H0v18h16V2h-3zM4 1h8v1H4V1zm2 18v-2h4v2H6zm9 0h-4v-3H5v3H1V3h14v16z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8h3V5h-3v3zm1-2h1v1h-1V6zM11 8h3V5h-3v3zm1-2h1v1h-1V6zM2 8h3V5H2v3zm1-2h1v1H3V6zM6.5 12h3V9h-3v3zm1-2h1v1h-1v-1zM11 12h3V9h-3v3zm1-2h1v1h-1v-1zM2 12h3V9H2v3zm1-2h1v1H3v-1z"
  }));
};

BtnProperty.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 20"
};

var BtnRadioOff = function BtnRadioOff(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 1c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5m0-1a6 6 0 1 0 0 12A6 6 0 0 0 6 0z"
  }));
};

BtnRadioOff.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12"
};

var BtnRadioOn = function BtnRadioOn(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6 0a6 6 0 1 0 0 12A6 6 0 0 0 6 0zm0 8a2 2 0 1 1 0-4 2 2 0 0 1 0 4z"
  }));
};

BtnRadioOn.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 12"
};

var BtnReservation = function BtnReservation(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M24 0c-2.035 0-3.7 1.532-3.95 3.5H7.95C7.7 1.532 6.035 0 4 0 1.794 0 0 1.794 0 4s1.794 4 4 4c2.035 0 3.7-1.532 3.95-3.5h12.1C20.3 6.468 21.966 8 24 8c2.206 0 4-1.794 4-4s-1.794-4-4-4zM4 7C2.346 7 1 5.654 1 4s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm20 0c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3z"
  }));
};

BtnReservation.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28 8"
};

var BtnReservationMobile = function BtnReservationMobile(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0c-2.3 0-4.2 1.8-4.4 4H8.9c-.2-2.2-2.1-4-4.4-4C2 0 0 2 0 4.5S2 9 4.5 9c2.3 0 4.2-1.8 4.4-4H23c.3 2.2 2.1 4 4.4 4C30 9 32 7 32 4.5S30 0 27.5 0zm-23 8C2.6 8 1 6.4 1 4.5S2.6 1 4.5 1 8 2.6 8 4.5 6.4 8 4.5 8zm23 0C25.6 8 24 6.4 24 4.5S25.6 1 27.5 1 31 2.6 31 4.5 29.4 8 27.5 8z"
  }));
};

BtnReservationMobile.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 9"
};

var BtnReset = function BtnReset(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.272 4.242a8.461 8.461 0 0 0-2.277-1.55V0l-.746.423c-1.218.69-3.92 2.506-4.033 2.583l-.63.424.638.41c.113.074 2.796 1.805 4.038 2.46l.733.387V3.819c.57.31 1.104.688 1.588 1.147 3.044 2.894 3.23 7.792.413 10.92-1.363 1.513-3.217 2.389-5.219 2.466-2.006.078-3.904-.648-5.37-2.043C.363 13.416.178 8.518 2.994 5.39l-.743-.668c-3.175 3.526-2.966 9.05.466 12.313 1.585 1.506 3.622 2.324 5.77 2.324.11 0 .219-.002.329-.007 2.275-.088 4.378-1.081 5.922-2.796 3.176-3.526 2.967-9.05-.466-12.313zm-3.277.761a91.787 91.787 0 0 1-2.586-1.591c.67-.444 1.741-1.149 2.586-1.672v3.263z"
  }));
};

BtnReset.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16.9898434 19.3579102"
};

var BtnRichAlign = function BtnRichAlign(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14 1H0V0h14v1zm0 4H0V4h14v1zm0 4H0V8h14v1zm-4-6H0V2h10v1zm0 4H0V6h10v1zm0 4H0v-1h10v1z"
  }));
};

BtnRichAlign.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 11"
};

var BtnRichBold = function BtnRichBold(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.293 7.105c0 .457-.092.866-.276 1.225-.184.36-.437.658-.76.896-.371.279-.78.478-1.227.596S5.018 10 4.332 10H.206V.549h3.669c.762 0 1.32.025 1.673.076.352.05.703.162 1.05.336.36.182.628.427.803.733.175.307.263.658.263 1.05 0 .457-.12.86-.361 1.21-.241.349-.582.621-1.022.816v.05c.617.123 1.108.377 1.469.762.362.385.543.893.543 1.523zM5.17 3.221c0-.157-.04-.314-.117-.47a.733.733 0 0 0-.416-.349 1.985 1.985 0 0 0-.663-.111c-.265-.007-.637-.01-1.115-.01h-.228v2h.38c.386 0 .714-.007.985-.02s.484-.054.64-.126c.22-.098.364-.224.432-.378s.102-.333.102-.536zm.59 3.846c0-.3-.058-.532-.174-.695s-.314-.284-.592-.364c-.19-.056-.452-.085-.786-.09a89.315 89.315 0 0 0-1.045-.006h-.532v2.356h.177c.684 0 1.174-.003 1.47-.007s.568-.06.818-.165c.253-.106.427-.246.521-.422.096-.176.143-.378.143-.607z"
  }));
};

BtnRichBold.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9 10"
};

var BtnRichBullets = function BtnRichBullets(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4 2h7v1H4V2zm0 4h7v1H4V6zm0 2h7v1H4V8zM0 6h2v2H0V6zm4-6h7v1H4V0zM0 0h2v2H0V0z"
  }));
};

BtnRichBullets.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 11 9"
};

var BtnRichDirection = function BtnRichDirection(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.694 1H5v7H4V5.892a.139.139 0 0 1-.05.007A2.95 2.95 0 0 1 1 2.949C1 1.463 1.987.233 3.5.03V0h6v1H4.694zM7 1h1v7H7V1zm3.013 9v1.29H2.642v1.994L0 10.642 2.642 8v2h7.37z"
  }));
};

BtnRichDirection.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10.0126038 13.2840004"
};

var BtnRichFont = function BtnRichFont(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.633h11v1H0zM10.852 11.633h-1.57L8.89 8.359H3.875l-1.906 3.274H.336L7.258 0h2.047l1.547 11.633zm-2.133-4.54l-.727-5.741-3.375 5.742H8.72z"
  }));
};

BtnRichFont.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 11 13.6328125"
};

var BtnRichItali = function BtnRichItali(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3.746 9.451H0l.21-.92h1.237L3.21.92H1.973l.21-.92h3.745l-.21.92H4.481L2.718 8.53h1.238l-.21.92z"
  }));
};

BtnRichItali.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 5.9282227 9.4511719"
};

var BtnRichLink = function BtnRichLink(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.101 5.29a.5.5 0 1 1 0-1h3.613a1.647 1.647 0 0 0 1.165-2.808c-.308-.31-.7-.465-1.163-.477H9.098c-.9 0-1.635.737-1.639 1.645a.5.5 0 0 1-.5.498h-.002a.5.5 0 0 1-.498-.503A2.65 2.65 0 0 1 9.104.005h3.61c.69.033 1.375.271 1.873.77.499.499.772 1.164.77 1.873.004 1.448-1.18 2.635-2.64 2.642H9.101z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.634 5.285a2.616 2.616 0 0 1-1.863-.77A2.616 2.616 0 0 1 0 2.64C-.006 1.19 1.178.006 2.64 0h3.614a.5.5 0 1 1 0 1H2.643A1.645 1.645 0 0 0 1 2.64a1.627 1.627 0 0 0 1.641 1.645H6.261A1.645 1.645 0 0 0 7.897 2.64a.5.5 0 1 1 1 .004 2.641 2.641 0 0 1-.777 1.87 2.607 2.607 0 0 1-1.856.77H2.633z"
  }));
};

BtnRichLink.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15.3569622 5.2905273"
};

var BtnRichNumbers = function BtnRichNumbers(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 0h7v1H5zM5 6h7v1H5zM5 2h7v1H5zM5 8h7v1H5zM1 9H0v1h3V9H2V8H1zM0 7h2v1h1V6H0zM1 1h1v3h1V0H1z"
  }));
};

BtnRichNumbers.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 10"
};

var BtnRichRemoveStyle = function BtnRichRemoveStyle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1.117 1.066h3.371L2.552 9.451h1.27L5.76 1.066h3.369L9.369 0H1.36zM0 10.213h8.271v.762H0zM14.37 11.113l-1.663-1.662 1.5-1.5-.707-.707-1.5 1.5-1.5-1.5-.707.707 1.5 1.5-1.662 1.662.707.707L12 10.158l1.662 1.662z"
  }));
};

BtnRichRemoveStyle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14.3691406 11.8203125"
};

var BtnRichTextColor = function BtnRichTextColor(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("style", null, ".st0", "{", "enable-background:new", "}"), /*#__PURE__*/React.createElement("path", {
    d: "M10.778 9.451H9.44l-.927-2.635H4.425l-.927 2.635H2.222L5.662 0h1.676l3.44 9.451zM8.125 5.738l-1.656-4.64-1.664 4.64h3.32z",
    className: "st0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M0 11.451h13v1H0z"
  }));
};

BtnRichTextColor.defaultProps = {
  id: "icon_2_",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13 12.4510498"
};

var BtnRichTextSize = function BtnRichTextSize(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 1.5H12V0H4v1.5h3.25v6.25h1.5V1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 4.5H5V3H0v1.5h1.75v3.25h1.5V4.5z"
  }));
};

BtnRichTextSize.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12 7.75"
};

var BtnRichUnderline = function BtnRichUnderline(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.255 5.655c0 .686-.074 1.283-.225 1.793a2.899 2.899 0 0 1-1.883 1.978c-.435.148-.943.222-1.522.222-.593 0-1.11-.079-1.55-.235s-.81-.388-1.11-.692a3.006 3.006 0 0 1-.74-1.256C.076 6.974 0 6.37 0 5.655V0h1.257v5.719c0 .511.035.916.104 1.213.07.296.188.564.353.805.186.276.439.483.759.622.319.14.703.21 1.152.21.452 0 .837-.069 1.155-.207a1.75 1.75 0 0 0 .762-.625 2.38 2.38 0 0 0 .352-.828c.07-.311.105-.697.105-1.159V0h1.256v5.655z"
  }));
};

BtnRichUnderline.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 7.2548828 9.6484375"
};

var BtnSavedReply = function BtnSavedReply(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.757 18.182a.5.5 0 0 1-.35-.144l-3.315-3.254H3.305C1.483 14.784 0 13.34 0 11.562v-8.32C0 1.453 1.483 0 3.305 0h11.572c1.822 0 3.305 1.454 3.305 3.241v8.322c0 1.806-1.452 3.221-3.305 3.221h-1.62v2.898a.5.5 0 0 1-.5.5zM3.305 1C2.035 1 1 2.005 1 3.241v8.322c0 1.224 1.034 2.221 2.305 2.221h5.991a.5.5 0 0 1 .35.144l2.61 2.562v-2.206a.5.5 0 0 1 .5-.5h2.121c1.292 0 2.305-.975 2.305-2.222v-8.32C17.182 1.983 16.169 1 14.877 1H3.305z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.09 4.526h5.646v1H5.09zM5.09 6.849h8.549v1H5.09zM5.09 9.171h7.968v1H5.09z"
  }));
};

BtnSavedReply.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18.1816406 18.1816406"
};

var BtnSearch = function BtnSearch(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.96 20.243l-5.995-5.995c.049-.046.1-.086.149-.134A8.269 8.269 0 0 0 2.422 2.422a8.267 8.267 0 0 0 0 11.692c2.939 2.939 7.538 3.193 10.775.779l6.057 6.057.707-.707zM3.13 13.407A7.268 7.268 0 1 1 13.408 3.129a7.268 7.268 0 0 1-10.28 10.278z"
  }));
};

BtnSearch.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19.9607 20.9498"
};

var BtnSearchMobile = function BtnSearchMobile(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 22.6l-5.8-5.8c1.5-1.7 2.5-4 2.5-6.5 0-5.5-4.5-9.9-9.9-9.9C4.8.4.4 4.9.4 10.3c0 5.5 4.5 9.9 9.9 9.9 2.5 0 4.8-.9 6.5-2.5l5.8 5.8.9-.9zm-13.2-3.7c-4.8 0-8.6-3.9-8.6-8.6 0-4.8 3.9-8.6 8.6-8.6 4.8 0 8.6 3.9 8.6 8.6 0 4.7-3.9 8.6-8.6 8.6z"
  }));
};

BtnSearchMobile.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};

var BtnServices = function BtnServices(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.09 1v3.79H3.91V1h-1v3.79H1.543V1h-1v4.289h.006v.005c.016 1.662.258 3.24 1.808 3.693l-.373 9.544c0 .562.592.969 1.408.969.817 0 1.409-.407 1.408-.988L4.426 8.96c1.476-.497 1.645-2.115 1.663-3.666V1h-1zM3.828 8.081l-.436.072.402 10.27c-.145.07-.66.071-.808 0L3.39 8.15l-.451-.06c-.794-.108-1.285-.535-1.376-2.3h3.57C5.044 7.525 4.58 7.957 3.83 8.08zM30.157 4.995C30.157 2.514 28.658.5 27.68.5h-.48l-.02.48c-.001.026-.102 2.595-.102 4.83 0 2.233.1 5.307.102 5.306-.004.133-.305 7.415-.305 7.436 0 .55.575.948 1.368.948s1.37-.398 1.37-.969l-.339-8.396c.58-1.381.883-3.61.883-5.14zm-1.55 13.44c-.14.062-.586.061-.727 0 .213-5.157.278-6.766.25-7.318l-.052-5.307c0-1.4.04-2.935.07-3.88.457.577 1.01 1.687 1.01 3.065 0 1.466-.29 3.6-.845 4.843l-.046.107.34 8.49zM16.105 1.447c-4.977 0-9.026 4.05-9.026 9.027 0 4.977 4.05 9.026 9.026 9.026 4.978 0 9.027-4.049 9.027-9.026 0-4.977-4.049-9.027-9.027-9.027zm0 17.053c-4.425 0-8.026-3.6-8.026-8.026s3.6-8.027 8.026-8.027 8.027 3.6 8.027 8.027-3.6 8.026-8.027 8.026z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.105 4.29a6.192 6.192 0 0 0-6.184 6.184 6.192 6.192 0 0 0 6.184 6.184 6.191 6.191 0 0 0 6.184-6.184 6.191 6.191 0 0 0-6.184-6.184zm0 11.368c-2.858 0-5.184-2.326-5.184-5.184s2.326-5.184 5.184-5.184c2.859 0 5.184 2.325 5.184 5.184s-2.325 5.184-5.184 5.184z"
  }));
};

BtnServices.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 31 20"
};

var BtnSettings = function BtnSettings(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.074 21H8.927l-.737-2.348a8.359 8.359 0 0 1-1.82-.754l-2.182 1.14-2.225-2.226 1.143-2.19a8.407 8.407 0 0 1-.745-1.808L0 12.074V8.925l2.37-.744a8.394 8.394 0 0 1 .745-1.788L1.962 4.188l2.225-2.224 2.215 1.155a8.454 8.454 0 0 1 1.776-.735L8.928 0h3.145l.75 2.383a8.418 8.418 0 0 1 1.775.735l2.214-1.155 2.225 2.224-1.152 2.208a8.38 8.38 0 0 1 .744 1.787L21 8.926v3.147l-2.36.741a8.46 8.46 0 0 1-.746 1.81l1.143 2.189-2.224 2.224-2.183-1.139a8.374 8.374 0 0 1-1.818.754L12.074 21zm-2.413-1h1.679l.684-2.178.273-.067a7.384 7.384 0 0 0 2.06-.856l.24-.145 2.028 1.057 1.185-1.186-1.06-2.032.145-.24c.385-.64.67-1.33.847-2.052l.067-.274L20 11.34V9.66l-2.2-.69-.068-.272a7.41 7.41 0 0 0-.845-2.032l-.146-.241 1.07-2.05-1.186-1.187-2.056 1.072-.24-.144a7.42 7.42 0 0 0-2.022-.836l-.272-.068L11.34 1H9.661l-.696 2.213-.272.068a7.431 7.431 0 0 0-2.023.837l-.24.143L4.376 3.19 3.188 4.376l1.07 2.05-.146.24A7.412 7.412 0 0 0 3.267 8.7L3.2 8.97 1 9.66v1.679l2.192.688.067.274c.178.721.462 1.412.846 2.052l.144.24-1.06 2.032 1.187 1.185 2.027-1.056.241.145c.636.387 1.33.675 2.06.856l.273.067L9.66 20zm.839-5.07a4.418 4.418 0 0 1-4.413-4.413c0-2.434 1.98-4.413 4.413-4.413s4.413 1.98 4.413 4.413a4.418 4.418 0 0 1-4.413 4.414zm0-7.826a3.417 3.417 0 0 0-3.413 3.413c0 1.882 1.531 3.414 3.413 3.414s3.413-1.531 3.413-3.414A3.417 3.417 0 0 0 10.5 7.104z"
  }));
};

BtnSettings.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
};

var BtnShare = function BtnShare(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.852 4.813l3.124-3.128V13.49a.5.5 0 1 0 1 0V1.685l3.125 3.128a.496.496 0 0 0 .704-.003c.19-.19.197-.511.004-.705L9.852.145A.49.49 0 0 0 9.45.003a.49.49 0 0 0-.35.142l-3.956 3.96a.497.497 0 0 0 .003.705c.19.19.51.197.704.003z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5 7.984h-5a.5.5 0 0 0 0 1.001H18V23H1V8.985h4.5a.5.5 0 0 0 0-1h-5a.5.5 0 0 0-.5.5v15.014A.5.5 0 0 0 .5 24h18a.5.5 0 0 0 .5-.5V8.485a.5.5 0 0 0-.5-.5z"
  }));
};

BtnShare.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19 24"
};

var BtnSnooze = function BtnSnooze(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17.277 6.795a4.01 4.01 0 0 0 1.18-2.909 3.984 3.984 0 0 0-1.17-2.77A3.775 3.775 0 0 0 14.54 0c-1.096.02-2.103.525-2.82 1.369A8.522 8.522 0 0 0 9.23 1c-.858 0-1.695.127-2.493.37C6.022.527 5.014.02 3.917 0a3.78 3.78 0 0 0-2.703 1.072A3.977 3.977 0 0 0 .001 3.887a4.012 4.012 0 0 0 1.177 2.905A8.503 8.503 0 0 0 .73 9.5c0 1.816.574 3.54 1.622 4.981l-1.33 2.364.87.49 1.143-2.028c.062.067.119.138.184.203a8.474 8.474 0 0 0 6.011 2.486 8.473 8.473 0 0 0 6.01-2.486c.036-.035.065-.074.1-.11l1.09 1.936.87-.49-1.271-2.26a8.508 8.508 0 0 0 1.248-7.791zM14.557 1a2.75 2.75 0 0 1 2.024.823 3.017 3.017 0 0 1 .272 3.934 8.448 8.448 0 0 0-1.613-2.269 8.488 8.488 0 0 0-2.518-1.734 2.77 2.77 0 0 1 1.836-.754zM1.002 3.904a2.98 2.98 0 0 1 .908-2.112C2.45 1.268 3.143.972 3.899 1c.69.012 1.332.288 1.837.755A8.486 8.486 0 0 0 3.22 3.49a8.495 8.495 0 0 0-1.616 2.268A3.018 3.018 0 0 1 1 3.904zm13.532 10.9c-2.924 2.924-7.682 2.923-10.607 0C2.51 13.385 1.73 11.503 1.73 9.5s.78-3.887 2.197-5.303C5.344 2.78 7.227 2 9.23 2s3.886.78 5.303 2.196c2.924 2.925 2.924 7.684 0 10.607z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.73 5.455h-1V10h4.636V9H9.73z"
  }));
};

BtnSnooze.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18.4577122 17.9958057"
};

var BtnSort = function BtnSort(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h8L4 4z"
  }));
};

BtnSort.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8 4"
};

var BtnStarOff = function BtnStarOff(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M2.864 14l.886-5.065L0 5.347l5.183-.74L7.5 0l2.318 4.608 5.182.74-3.75 3.587.887 5.065-4.638-2.393L2.864 14zM7.5 10.482l3.305 1.706-.631-3.607 2.648-2.535-3.662-.522L7.5 2.225 5.84 5.524l-3.662.522 2.649 2.535-.63 3.606L7.5 10.482z"
  }));
};

BtnStarOff.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 14"
};

var BtnStarOn = function BtnStarOn(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 0l2.319 4.608L15 5.347l-3.75 3.588.887 5.065-4.638-2.393L2.864 14l.886-5.065L0 5.347l5.183-.74z"
  }));
};

BtnStarOn.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 14"
};

var btnSummary = function btnSummary(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.002 18h-.16c-2.403-.042-4.646-1.018-6.316-2.747S-.041 11.247 0 8.843s1.017-4.646 2.747-6.316C4.477.857 6.725-.053 9.158.002a8.943 8.943 0 0 1 6.317 2.747 8.941 8.941 0 0 1 2.524 6.41C17.913 14.066 13.893 18 9.002 18zM8.996 1c-2.083 0-4.05.795-5.553 2.246A7.945 7.945 0 0 0 1 8.861a7.948 7.948 0 0 0 2.244 5.698A7.947 7.947 0 0 0 8.86 17c4.392.098 8.062-3.45 8.139-7.86a7.948 7.948 0 0 0-2.244-5.696A7.945 7.945 0 0 0 9.14 1.002a6.892 6.892 0 0 0-.144-.001z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "translate(5.493 13)",
    fontFamily: "'LucidaGrande-Bold'",
    fontSize: "11"
  }, "\u03A3"));
};

btnSummary.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18.0004 18.0009"
};

var BtnSupport = function BtnSupport(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "6.398",
    cy: "10.21",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "9.859",
    cy: "10.21",
    r: "1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.247 8.4C16.072 3.925 12.309 0 8.194 0 4.236 0 .776 3.431.122 7.993c-.144.37-.128.731-.112 1.082.005.108.01.22.01.338 0 1.661.962 2.962 2.19 2.962l.02-.001c1.166 2.2 3.447 3.614 5.924 3.614.079 0 .155-.014.233-.017-.476.363-.708.833-.572 1.282a.96.96 0 0 0 .497.572c.223.117.501.176.806.176.275 0 .572-.049.868-.145h.001a2.267 2.267 0 0 0 1.237-.991c1.103-.174 4.859-1.146 4.859-6.3h-.013c.242-.923.186-2.022.177-2.165zM8.194 1c2.8 0 5.169 2.056 6.316 4.527-1.533-2.275-3.879-3.675-6.316-3.675-2.442 0-4.811 1.424-6.346 3.728C3.074 2.847 5.506 1 8.194 1zm-5.43 9.031c0 .73-.082 1.22-.411 1.317a.232.232 0 0 1-.083.024h-.02c-.013.001-.026.003-.04.003a.76.76 0 0 1-.375-.114c-.035-.015-.064-.023-.102-.042C.628 10.64.886 8.476.886 8.476c.166-.882.683-1.026 1.325-1.026.068 0 .132.006.19.06.447.277.363 1.576.363 2.521zm-.299-3.559c1.341-2.227 3.507-3.62 5.73-3.62 2.474 0 4.532 1.688 5.717 3.608-.311.037-.708.207-.962.7l-2.926-2.673-.315.52c-.01.015-.875 1.414-3.1 2.437-1.043.48-2.127.768-2.994.945a4.27 4.27 0 0 0-.116-.865c-.198-.747-.663-.986-1.034-1.052zm5.689 8.516c-2.082 0-4-1.176-5.005-3.014.144-.158.27-.37.35-.673.132-.497.132-1.114.132-1.83v-.067c.95-.184 2.192-.498 3.396-1.051 1.703-.783 2.7-1.767 3.182-2.345l2.483 2.27c-.022.33-.028.687-.028 1.08v.11c0 .716 0 1.334.132 1.832.081.309.21.524.357.683-1.005 1.833-2.919 3.005-5 3.005zm1.523 1.917c-.436.14-.766.097-.87.098-.015 0-.026 0-.031.004.02-.089.274-.365.787-.527.222-.07.476-.03.69.036-.126.148-.311.302-.576.39zm1.518-1.043a2.354 2.354 0 0 0-.71-.317 6.777 6.777 0 0 0 3.592-3.17l.008.001c.295 0 .577-.09.84-.237-.611 2.913-2.873 3.577-3.73 3.723zm3.379-4.643c-.87.454-1.032-.125-1.032-1.188s-.11-2.58.554-2.58c.642 0 1.158.143 1.324 1.025 0 0 .26 2.165-.846 2.743z"
  }));
};

BtnSupport.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16.2587585 18.0009766"
};

var BtnTime = function BtnTime(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.71 0 0 4.71 0 10.5S4.71 21 10.5 21 21 16.29 21 10.5 16.29 0 10.5 0zm0 20C5.262 20 1 15.738 1 10.5S5.262 1 10.5 1 20 5.262 20 10.5 15.738 20 10.5 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 5H9v7h7v-1h-6z"
  }));
};

BtnTime.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
};

var BtnToCsv = function BtnToCsv(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.554 17.44h.977a.408.408 0 0 1 .405.274l1.53 3.957c.05.128.099.27.145.424.047.154.092.316.133.487.07-.345.155-.647.257-.911l1.525-3.957a.47.47 0 0 1 .145-.189.39.39 0 0 1 .256-.085h.976l-2.628 6.488h-1.093l-2.628-6.487zM11.044 18.62a.338.338 0 0 1-.115.14c-.043.026-.095.04-.155.04s-.127-.024-.202-.07a6.184 6.184 0 0 0-.266-.154 2.092 2.092 0 0 0-.357-.155 1.5 1.5 0 0 0-.484-.07c-.168 0-.315.02-.439.06a.955.955 0 0 0-.315.169.675.675 0 0 0-.191.258.848.848 0 0 0-.063.33c0 .153.042.28.128.382.085.1.198.187.34.26a3.1 3.1 0 0 0 .481.192c.18.057.364.118.552.182a5.2 5.2 0 0 1 .55.224c.181.086.341.193.482.324.141.13.254.289.34.478.085.188.128.416.128.686 0 .293-.05.567-.15.823a1.904 1.904 0 0 1-.442.669c-.193.19-.429.338-.708.448-.28.11-.599.164-.959.164a3.135 3.135 0 0 1-1.19-.234 3.068 3.068 0 0 1-.518-.268 2.568 2.568 0 0 1-.43-.35l.352-.58a.462.462 0 0 1 .119-.105.294.294 0 0 1 .155-.042.43.43 0 0 1 .243.091c.087.062.19.13.308.205.119.075.258.143.419.204.16.062.353.092.578.092.345 0 .612-.082.802-.245.188-.163.283-.397.283-.702 0-.17-.043-.31-.128-.417a1.054 1.054 0 0 0-.34-.272c-.141-.073-.302-.135-.482-.186s-.363-.106-.549-.165a4.876 4.876 0 0 1-.549-.216c-.18-.084-.34-.193-.481-.328s-.254-.302-.34-.504a1.918 1.918 0 0 1-.128-.748c0-.235.047-.466.141-.69a1.76 1.76 0 0 1 .414-.597c.182-.173.405-.312.669-.417a2.45 2.45 0 0 1 .904-.157c.384 0 .738.06 1.062.179.325.12.6.287.828.503l-.297.57zM5.203 22.398c.066 0 .123.026.171.076l.477.516a2.612 2.612 0 0 1-.974.749c-.385.174-.848.261-1.388.261-.483 0-.918-.083-1.303-.247A2.871 2.871 0 0 1 .57 22.017a3.934 3.934 0 0 1-.218-1.333c0-.487.081-.934.243-1.339a3.07 3.07 0 0 1 .684-1.047c.294-.294.646-.521 1.055-.685.41-.163.862-.244 1.357-.244.483 0 .905.077 1.267.23.361.155.671.359.93.613l-.406.56a.357.357 0 0 1-.092.095.259.259 0 0 1-.155.04.357.357 0 0 1-.212-.08 2.265 2.265 0 0 0-.695-.35 2.178 2.178 0 0 0-.646-.081c-.306 0-.587.053-.844.16a1.87 1.87 0 0 0-.661.455 2.09 2.09 0 0 0-.432.72c-.103.283-.155.6-.155.953 0 .365.052.69.155.973.104.285.244.524.42.719.178.194.386.343.626.446.24.103.498.155.774.155.165 0 .314-.01.448-.028.133-.017.256-.046.369-.084.113-.04.219-.09.32-.15.1-.062.2-.138.299-.227a.42.42 0 0 1 .094-.065.239.239 0 0 1 .108-.025zM13.852 6.153a.504.504 0 0 0-.704-.004l-3.125 3.116V.498a.5.5 0 0 0-1 0v8.767L5.9 6.149a.5.5 0 0 0-.707.705L9.147 10.8c.11.11.258.157.401.142a.49.49 0 0 0 .35-.142l3.956-3.944a.493.493 0 0 0-.003-.702zM.5 11.964h18a.5.5 0 0 1 0 .997H.5a.5.5 0 0 1 0-.997z"
  }));
};

BtnToCsv.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19 24"
};

var BtnToggleOff = function BtnToggleOff(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21h12C28.29 21 33 16.29 33 10.5S28.29 0 22.5 0h-12C4.701 0 0 4.701 0 10.5S4.701 21 10.5 21zm12-19c4.687 0 8.5 3.813 8.5 8.5 0 4.687-3.813 8.5-8.5 8.5S14 15.187 14 10.5C14 5.814 17.813 2 22.5 2z"
  }));
};

BtnToggleOff.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 33 21"
};

var BtnToggleOn = function BtnToggleOn(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 0h-12C4.71 0 0 4.71 0 10.5S4.71 21 10.5 21h12C28.299 21 33 16.299 33 10.5S28.299 0 22.5 0zm-12 19C5.813 19 2 15.187 2 10.5 2 5.813 5.813 2 10.5 2S19 5.813 19 10.5c0 4.687-3.813 8.5-8.5 8.5z"
  }));
};

BtnToggleOn.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 33 21"
};

var BtnTrash = function BtnTrash(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.773 18h-8.5c-1.224 0-2.22-.923-2.22-2.057L1 5.503A.501.501 0 0 1 1.5 5h11.946a.5.5 0 0 1 .5.498L14 15.94c0 1.137-.999 2.06-2.227 2.06zM2.003 6l.05 9.94v.002c0 .574.558 1.058 1.22 1.058h8.5C12.44 17 13 16.516 13 15.942L12.95 6H2.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 6H.5a.5.5 0 0 1-.5-.5v-3A.5.5 0 0 1 .5 2h14a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5zM1 5h13V3H1v2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3h-6a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5zM5 2h5V1H5v1zM10.5 15a.5.5 0 0 1-.5-.5v-6a.5.5 0 1 1 1 0v6a.5.5 0 0 1-.5.5zM7.5 15a.5.5 0 0 1-.5-.5v-6a.5.5 0 1 1 1 0v6a.5.5 0 0 1-.5.5zM4.5 15a.5.5 0 0 1-.5-.5v-6a.5.5 0 1 1 1 0v6a.5.5 0 0 1-.5.5z"
  }));
};

BtnTrash.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 18"
};

var BtnUnexpand = function BtnUnexpand(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.654 6.792V3.997a.494.494 0 0 0-.5-.497c-.268 0-.5.223-.5.497V8a.49.49 0 0 0 .307.46.483.483 0 0 0 .19.04h4.002a.494.494 0 0 0 .497-.5c0-.269-.222-.5-.497-.5h-2.792l3.103-3.103a.5.5 0 0 0-.707-.708l-3.103 3.104zM7.5 13.362v2.795c0 .283.224.498.5.498.268 0 .5-.223.5-.498v-4.005a.493.493 0 0 0-.498-.497H3.998a.494.494 0 0 0-.498.5c0 .268.223.5.498.5h2.795L3.69 15.757a.5.5 0 0 0 .707.707L7.5 13.362z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 20h-15A2.503 2.503 0 0 1 0 17.5v-15C0 1.122 1.122 0 2.5 0h15C18.879 0 20 1.122 20 2.5v15c0 1.379-1.121 2.5-2.5 2.5zM2.5 1C1.673 1 1 1.673 1 2.5v15c0 .827.673 1.5 1.5 1.5h15c.827 0 1.5-.673 1.5-1.5v-15c0-.827-.673-1.5-1.5-1.5h-15z"
  }));
};

BtnUnexpand.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
};

var BtnWeather = function BtnWeather(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M21.943 10.284c-.213-2.44-2.278-4.569-4.65-4.824C16.786 2.32 13.981 0 10.59 0 6.847 0 3.802 2.894 3.802 6.45c0 .174.008.349.023.524C1.612 7.474 0 9.491 0 11.861c0 2.76 2.192 5.003 4.886 5.003h16.078c2.035 0 3.691-1.502 3.691-3.348 0-1.537-1.118-2.841-2.712-3.232zm-.98 5.58H4.887C2.743 15.864 1 14.068 1 11.861c0-2.037 1.478-3.747 3.438-3.979a.501.501 0 0 0 .435-.578 5.268 5.268 0 0 1-.07-.854C4.802 3.445 7.398 1 10.59 1c2.85 0 5.193 1.91 5.675 4.5a4.859 4.859 0 0 0-2.984 1.763.5.5 0 1 0 .784.62c.695-.879 1.72-1.416 2.787-1.474 2.15 0 4.11 2.045 4.11 4.29a.5.5 0 0 0 .43.496c1.29.18 2.263 1.177 2.263 2.32 0 1.296-1.207 2.35-2.691 2.35zM6.771 21.238a.499.499 0 0 0-.653.27L5.252 23.6a.5.5 0 0 0 .924.382l.866-2.09a.5.5 0 0 0-.27-.654zM10.79 18.271a.499.499 0 0 0-.654.271L9.134 20.96a.5.5 0 0 0 .924.383l1.002-2.418a.5.5 0 0 0-.27-.654zM12.602 20.629a.499.499 0 0 0-.654.27l-.866 2.092a.5.5 0 0 0 .924.383l.866-2.092a.5.5 0 0 0-.27-.653zM15.549 23.661a.5.5 0 0 0-.653.27l-.622 1.499a.5.5 0 0 0 .924.382l.621-1.498a.5.5 0 0 0-.27-.653zM17.361 18.284a.499.499 0 0 0-.653.27l-.78 1.885a.5.5 0 0 0 .924.383l.78-1.884a.5.5 0 0 0-.27-.654z"
  }));
};

BtnWeather.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24.6552734 26.1210938"
};

var IcoArrowDown = function IcoArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M.178 9.293l3.342 3.515a.597.597 0 0 0 .491.19c.17.01.342-.06.466-.19L7.82 9.293a.648.648 0 0 0 .083-.79l.009-.008-.085-.09a.004.004 0 0 1-.002-.002l-.01.009a.579.579 0 0 0-.33-.102.597.597 0 0 0-.434.19l-2.512 2.642V.539a.54.54 0 0 0-1.082 0v10.603L.945 8.5a.596.596 0 0 0-.434-.192.573.573 0 0 0-.328.104l-.01-.01-.001.001-.001.001-.086.091.01.01a.657.657 0 0 0 .083.788z"
  }));
};

IcoArrowDown.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8 13"
};

var IcoArrowUp = function IcoArrowUp(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.822 3.707L4.48.192a.597.597 0 0 0-.491-.19.599.599 0 0 0-.466.19L.18 3.707a.648.648 0 0 0-.083.79l-.009.008.085.09.002.002.01-.009c.097.067.21.102.33.102a.597.597 0 0 0 .434-.19l2.512-2.642v10.603a.54.54 0 0 0 1.082 0V1.858L7.055 4.5a.596.596 0 0 0 .434.192.573.573 0 0 0 .328-.104l.01.01.001-.001.001-.001.086-.091-.01-.01a.657.657 0 0 0-.083-.788z"
  }));
};

IcoArrowUp.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 8 13"
};

var IcoAddress = function IcoAddress(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M6.947 17.917C5.9 17.917 0 11.437 0 6.765 0 3.035 3.035 0 6.766 0s6.767 3.035 6.767 6.765c0 4.079-5.553 11.152-6.586 11.152zm-.158-.967zM6.766 1A5.772 5.772 0 0 0 1 6.765c0 4.004 4.813 9.25 5.934 10.082 1.131-.93 5.6-6.615 5.6-10.082A5.773 5.773 0 0 0 6.765 1zm-.03 8.36c-1.631 0-2.958-1.298-2.958-2.893 0-1.595 1.327-2.893 2.958-2.893 1.632 0 2.96 1.298 2.96 2.893 0 1.595-1.328 2.892-2.96 2.892zm0-4.786c-1.08 0-1.958.849-1.958 1.893 0 1.043.878 1.892 1.958 1.892s1.96-.849 1.96-1.892c0-1.044-.88-1.893-1.96-1.893z"
  }));
};

IcoAddress.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13.5331421 17.9169846"
};

var IcoAirbnb = function IcoAirbnb(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.948 13.075a2.403 2.403 0 0 1-1.47 1.891c-.39.161-.81.21-1.23.161a3.204 3.204 0 0 1-1.228-.42c-.581-.324-1.162-.825-1.841-1.569 1.066-1.308 1.712-2.505 1.955-3.57.113-.502.13-.953.081-1.375a2.63 2.63 0 0 0-.436-1.098C9.277 6.367 8.436 5.947 7.5 5.947c-.938 0-1.779.436-2.279 1.148a2.614 2.614 0 0 0-.436 1.098c-.065.422-.049.89.08 1.374.243 1.066.905 2.279 1.955 3.588-.661.743-1.26 1.245-1.841 1.567a3.143 3.143 0 0 1-1.229.42 2.575 2.575 0 0 1-1.229-.161 2.4 2.4 0 0 1-1.47-1.89 2.68 2.68 0 0 1 .147-1.261c.047-.161.128-.323.21-.517.112-.258.242-.533.37-.808l.017-.033A176.46 176.46 0 0 1 5.35 3.216l.049-.096c.13-.243.259-.502.387-.744.13-.259.275-.501.453-.711.34-.388.792-.598 1.294-.598s.952.21 1.292.598c.178.211.322.452.452.711.13.242.26.501.388.744l.049.096a214.387 214.387 0 0 1 3.539 7.274v.015c.13.258.242.55.372.808.08.194.161.356.21.517.129.42.178.824.113 1.245m-6.448-.76c-.872-1.099-1.439-2.133-1.633-3.006-.08-.372-.097-.694-.048-.985.032-.26.13-.485.259-.68.307-.435.823-.71 1.422-.71.598 0 1.131.257 1.421.71.13.195.228.42.26.68.048.29.031.63-.048.985-.195.857-.76 1.89-1.633 3.006m7.288-.84c-.08-.195-.162-.405-.242-.583-.13-.291-.26-.565-.372-.824l-.016-.016a169.892 169.892 0 0 0-3.572-7.305l-.048-.096a31.004 31.004 0 0 1-.388-.76c-.161-.291-.322-.597-.581-.889A2.613 2.613 0 0 0 7.516 0C6.707 0 5.98.356 5.448.97c-.243.29-.42.597-.583.888-.125.256-.255.51-.387.76l-.048.097A189.639 189.639 0 0 0 .858 10.02l-.017.032c-.112.259-.242.534-.371.824-.081.179-.161.371-.242.581-.21.599-.275 1.165-.194 1.746a3.435 3.435 0 0 0 2.101 2.683 3.3 3.3 0 0 0 1.309.259 4.27 4.27 0 0 0 2.036-.583c.662-.371 1.292-.903 2.004-1.68.711.777 1.357 1.309 2.003 1.68a4.27 4.27 0 0 0 2.038.583c.451 0 .904-.08 1.307-.259a3.424 3.424 0 0 0 2.102-2.683c.129-.566.063-1.13-.146-1.728"
  }));
};

IcoAirbnb.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 17"
};

var IcoWhatsapp = function IcoWhatsapp(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "whatsapp"), /*#__PURE__*/React.createElement("g", {
    fill: "#AEB6BA",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.394 10.698L12.01 9.642a1.193 1.193 0 0 0-1.562.103l-.54.54a2.796 2.796 0 0 1-1.124-.57l-.047-.04a2.96 2.96 0 0 1-.363-.363l-.038-.046a2.785 2.785 0 0 1-.572-1.121l.54-.54c.42-.42.464-1.085.105-1.558L7.35 4.667a1.243 1.243 0 0 0-1.488-.382l-.157.07a2.598 2.598 0 0 0-1.552 2.318 6.883 6.883 0 0 0 1.616 4.574l.07.081c.268.318.563.612.88.88l.083.07a6.922 6.922 0 0 0 4.44 1.614h.145a2.602 2.602 0 0 0 2.321-1.552l.07-.157a1.239 1.239 0 0 0-.384-1.485zm-.456 1.12v-.001l-.07.157a1.684 1.684 0 0 1-1.502 1.002h-.126a6.004 6.004 0 0 1-3.85-1.399l-.082-.07a6.296 6.296 0 0 1-.77-.768l-.07-.082a5.97 5.97 0 0 1-1.401-3.97 1.68 1.68 0 0 1 1.004-1.5l.157-.07a.329.329 0 0 1 .394.105l1.058 1.38a.272.272 0 0 1-.024.357l-.714.713a.456.456 0 0 0-.128.397 3.7 3.7 0 0 0 .82 1.786l.04.045c.143.171.302.33.474.474l.047.04c.511.428 1.13.71 1.788.818a.458.458 0 0 0 .398-.128l.714-.714a.274.274 0 0 1 .359-.023l1.383 1.059c.12.091.162.253.101.391z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.392 2.672A8.966 8.966 0 0 0 9.017.035C4.447.035.6 3.446.062 7.975a9.04 9.04 0 0 0 1.104 5.49l-.76 2.614a1.25 1.25 0 0 0 1.553 1.55l2.62-.758a9.082 9.082 0 0 0 4.449 1.164c4.98-.007 9.01-4.042 9.004-9.012a8.992 8.992 0 0 0-2.64-6.351zm-.647 12.081a8.022 8.022 0 0 1-4.774 2.312 8.157 8.157 0 0 1-5.098-1.08.459.459 0 0 0-.363-.046l-2.807.814a.338.338 0 0 1-.418-.418l.815-2.802a.456.456 0 0 0-.046-.362A8.118 8.118 0 0 1 .972 8.082 8.095 8.095 0 0 1 9.017.95c4.474 0 8.1 3.62 8.1 8.086a8.078 8.078 0 0 1-2.372 5.718z"
  })));
};

IcoWhatsapp.defaultProps = {
  width: "19",
  height: "19",
  viewBox: "0 0 19 19",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoApproved = function IcoApproved(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.701 0 0 4.701 0 10.5S4.701 21 10.5 21 21 16.299 21 10.5 16.299 0 10.5 0zm4.633 6.752l-5.537 8.202c-.018.026-.044.04-.065.063-.012.014-.018.032-.032.045-.01.01-.024.013-.035.021a.597.597 0 0 1-.123.075.595.595 0 0 1-.096.04.608.608 0 0 1-.121.018.617.617 0 0 1-.12 0 .602.602 0 0 1-.103-.025.596.596 0 0 1-.13-.054c-.013-.007-.027-.008-.04-.016-.016-.01-.024-.028-.04-.04-.023-.019-.051-.03-.072-.052l-2.693-2.931c-.233-.252-.218-.648.034-.88s.647-.219.88.033l2.163 2.354 5.098-7.55a.625.625 0 0 1 .864-.168c.284.192.36.581.168.865z"
  }));
};

IcoApproved.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
};

var IcoAvatarAutoMessage = function IcoAvatarAutoMessage(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.963 22.831l.713 1.985h6.616l.71-1.985a.5.5 0 0 1 .472-.331H28.5v-6h-17v6h3.992a.5.5 0 0 1 .47.331zM12.5 13.188h15v2.313h-15zM14.5 10.5h11v1.688h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0zm11 30a.5.5 0 0 1-.5.5h-21A.5.5 0 0 1 9 30v-7a.5.5 0 0 1 .5-.5h1V16a.5.5 0 0 1 .5-.5h.5v-2.813a.5.5 0 0 1 .5-.5h1.5V10a.5.5 0 0 1 .5-.5h12a.5.5 0 0 1 .5.5v2.188H28a.5.5 0 0 1 .5.5V15.5h.5a.5.5 0 0 1 .5.5v6.5h1a.5.5 0 0 1 .5.5v7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.114 25.485a.5.5 0 0 1-.47.331h-7.32a.5.5 0 0 1-.47-.33l-.713-1.986H10v6h20v-6h-5.175l-.71 1.985z"
  }));
};

IcoAvatarAutoMessage.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
};

var IcoAvatarNoName = function IcoAvatarNoName(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M30 0C13.4 0 0 13.4 0 30s13.4 30 30 30 30-13.4 30-30S46.6 0 30 0zm-2.8 31H16.5v-2.5h10.7V31zm16 0H32.4v-2.5h10.7V31z"
  }));
};

IcoAvatarNoName.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 60 60"
};

var IcoAvatarProperty = function IcoAvatarProperty(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.8 43.1c2.1 2 4.6 3.7 7.4 4.9V29.8H7.8v13.3zM31.5 19.8H18.1c-.8 0-1.4.6-1.4 1.3H33c-.1-.8-.8-1.3-1.5-1.3zM16.6 48.6c2.6.9 5.4 1.4 8.4 1.4 2.8 0 5.4-.5 7.9-1.3V22.5H16.6v26.1zM29 26.2h1.5v2.2H29v-2.2zm0 6.1h1.5v2.2H29v-2.2zm0 6.7h1.5v2.2H29V39zm0 6.1h1.5v2.2H29v-2.2zm-2.2-18.9h1.5v2.2h-1.5v-2.2zm0 6.1h1.5v2.2h-1.5v-2.2zm0 6.7h1.5v2.2h-1.5V39zm0 6.1h1.5v2.2h-1.5v-2.2zm-5.7-18.9h1.5v2.2h-1.5v-2.2zm0 6.1h1.5v2.2h-1.5v-2.2zm0 6.7h1.5v2.2h-1.5V39zm0 6.1h1.5v2.2h-1.5v-2.2zm-2.2-18.9h1.5v2.2h-1.5v-2.2zm0 6.1h1.5v2.2h-1.5v-2.2zm0 6.7h1.5v2.2h-1.5V39zm0 6.1h1.5v2.2h-1.5v-2.2zM34.4 48.2c2.7-1.1 5.2-2.7 7.4-4.7V29.8h-7.4v18.4zM40.9 26.2h-6.5v2h7.4V27c0-.4-.4-.8-.9-.8zM7.8 27.1v1.2h7.4v-2H8.6c-.5-.1-.8.3-.8.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 25C50 11.2 38.8 0 25 0S0 11.2 0 25c0 6.3 2.4 12.1 6.2 16.5V27.1c0-1.3 1.1-2.3 2.4-2.3h6.5v-3.6c0-1.6 1.3-2.9 2.9-2.9h13.4c1.6 0 2.9 1.3 2.9 2.9v3.6h6.5c1.3 0 2.4 1 2.4 2.3V42c4.3-4.4 6.8-10.4 6.8-17z"
  }));
};

IcoAvatarProperty.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 50 50"
};

var IcoBackCircle = function IcoBackCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "10.5",
    cy: "10.5",
    r: "10.5",
    transform: "rotate(-180 10.5 10.5)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.704 8.042a.6.6 0 0 0 .631.567l2.12-.115a.6.6 0 0 0-.064-1.198l-1.522.082-.082-1.521a.6.6 0 0 0-1.199.065l.116 2.12z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.025 14.25a4.406 4.406 0 0 1-4.43-.03.6.6 0 0 0-.611 1.034 5.606 5.606 0 1 0 5.608-9.708 5.687 5.687 0 0 0-7.814 2.173.6.6 0 0 0 1.05.581 4.487 4.487 0 0 1 6.167-1.713L13 6.59a4.406 4.406 0 0 1 .025 7.66z",
    fill: "#fff"
  }));
};

IcoBackCircle.defaultProps = {
  width: "21",
  height: "21",
  viewBox: "0 0 21 21",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoBedBunk = function IcoBedBunk(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("style", null, ".st0", "{", "fill:#272b2d", "}"), /*#__PURE__*/React.createElement("path", {
    id: "icon_1_",
    className: "st0",
    d: "M26.938 13.26C26.8 13.03 24 7.875 24 7.875V.5a.5.5 0 0 0-.5-.5h-20a.5.5 0 0 0-.5.5v7.373S.192 13.045.061 13.26c-.068.121-.059.739-.059.739v1.193L0 15.205V34a.5.5 0 1 0 1 0v-1.5h15V34a.5.5 0 1 0 1 0v-1.5h9V34a.5.5 0 1 0 1 0V17.121c0-.005.003-.009.003-.014V14s.02-.594-.065-.74zM4 1h19v6.5h-3.11l-.41-3.632c-.072-.615-.6-1.25-1.2-1.447-3.132-1.034-6.306-1.034-9.437 0-.6.196-1.129.831-1.203 1.45L7.23 7.5H4V1zm15.084 8.286v.001c.017.137-.138.314-.356.344-3.43.393-6.906.392-10.324 0-.23-.03-.383-.207-.367-.345l.088-.786.113-1 .395-3.514c.028-.234.286-.538.522-.615a13.995 13.995 0 0 1 4.406-.724c1.472 0 2.945.241 4.407.724.234.077.492.381.52.611l.395 3.518.113 1 .088.786zM3.797 8.5h3.322l-.076.673c-.08.699.472 1.35 1.238 1.451a46.408 46.408 0 0 0 10.572-.001c.755-.104 1.304-.754 1.225-1.45l-.076-.673h3.202l2.727 5H1.069l2.728-5zM1 17.606h1.6L1 20.54v-2.933zM16 29v2.5H1v-5h15V29zm0-3.5H1.002v-2H16v2zm0-5.5v2.5H1.07l-.07.127V22.5h.07l2.669-4.894H16V20zm10 11.5h-9v-2h9v2zm0-3h-9v-2h9v2zm.003-3H17v-2h9.003v2zm-.003-5v2h-9v-2h9zm-9-1v-1.894h9V19.5h-9zm9.003-4.31v1.417H1.002V14.5h25v.69z"
  }));
};

IcoBedBunk.defaultProps = {
  id: "icon",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27.0051308 34.5"
};

var IcoBedDouble = function IcoBedDouble(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M39.98 16.937c-.007-.06-.01-.12-.041-.176l-2.75-5.042-.189-.35V4h.5a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-35a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5H3v7.369l-.188.35-2.75 5.042c-.031.056-.034.117-.04.176H0v3.67a.5.5 0 0 0 .5.5h.482V28.5a.5.5 0 0 0 .5.5h2.002a.5.5 0 0 0 .5-.5V27H35.99l.027 1.509a.5.5 0 0 0 .5.491h2.002a.5.5 0 0 0 .5-.5v-7.393h.481a.5.5 0 0 0 .5-.5v-3.67h-.02zM3 1h34v2H3V1zm27.932 4.922c-3.133-1.035-6.309-1.034-9.438-.001-.602.197-1.13.833-1.203 1.45L20 9.956l-.292-2.587c-.072-.615-.6-1.25-1.2-1.447-3.134-1.035-6.31-1.034-9.437-.001-.602.197-1.13.832-1.204 1.45l-.413 3.67A.497.497 0 0 0 7.256 11H4V4h32v7h-3.256a.497.497 0 0 0-.198.042l-.414-3.674c-.072-.613-.6-1.249-1.2-1.446zm.804 6.863v.002c.016.137-.138.314-.358.343-3.43.394-6.905.394-10.321.002-.23-.031-.386-.208-.37-.347l.598-5.3c.027-.233.285-.537.522-.614a13.988 13.988 0 0 1 4.405-.724c1.472 0 2.944.242 4.406.725.236.076.494.38.52.61l.598 5.303zm-12.424 0v.001c.015.138-.139.315-.358.344a45.176 45.176 0 0 1-10.324 0c-.228-.028-.382-.206-.366-.345l.597-5.3c.028-.232.286-.537.522-.614a13.988 13.988 0 0 1 4.405-.724c1.472 0 2.945.242 4.408.725.234.076.492.38.518.61l.598 5.303zM3.797 12h3.46c.032 0 .06-.013.09-.018l-.077.69c-.08.701.472 1.351 1.238 1.452a46.232 46.232 0 0 0 10.57-.002c.376-.05.7-.237.922-.496.224.26.55.446.932.498a46.232 46.232 0 0 0 10.57-.002c.757-.101 1.307-.752 1.228-1.45l-.078-.69c.03.005.06.018.092.018h3.46l2.727 5H1.07l2.728-5zm34.222 16h-1.01l-.027-1.509a.5.5 0 0 0-.5-.491H3.484a.5.5 0 0 0-.5.5V28H1.982v-6.893h36.037V28zM39 20.107H1V18h38v2.107z"
  }));
};

IcoBedDouble.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40.0002441 29"
};

var IcoBedMat = function IcoBedMat(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M39.99 16.563a1.699 1.699 0 0 0-.114-.804l-.042-.107-.065-.095-3.974-8.212c-.283-.503-.858-1.47-2.1-1.47h-1.144l-.412-3.652c-.072-.615-.6-1.25-1.2-1.447-3.134-1.035-6.31-1.034-9.438 0-.601.196-1.128.831-1.203 1.45L20 4.87l-.298-2.648c-.073-.615-.6-1.25-1.2-1.447-3.134-1.035-6.31-1.034-9.438 0-.602.196-1.129.831-1.203 1.45l-.412 3.65H6.304c-1.24 0-1.816.966-2.1 1.47L.232 15.556l-.065.095-.042.107c-.105.267-.141.54-.113.804H0v5.767h.033c.038.216.11.425.237.612.427.626 1.202.85 1.784.85h35.892c.582 0 1.357-.224 1.784-.85.127-.187.2-.396.237-.612H40v-5.767h-.01zM20.78 6.875l.113-1 .399-3.534c.028-.234.286-.539.522-.616a13.988 13.988 0 0 1 4.405-.723c1.472 0 2.945.24 4.407.724.235.076.493.38.519.61l.399 3.54.113 1 .086.763v.001c.015.138-.139.315-.358.345a45.279 45.279 0 0 1-10.323.001c-.23-.03-.383-.208-.367-.347l.086-.764zM8.855 2.341c.028-.234.286-.539.522-.616a13.988 13.988 0 0 1 4.406-.723c1.471 0 2.944.24 4.407.724.234.076.492.38.519.61l.398 3.54.113 1 .086.763v.001c.016.138-.138.315-.357.345a45.279 45.279 0 0 1-10.323.001c-.23-.03-.383-.208-.368-.347l.086-.764.113-1 .398-3.534zM39 20.109v1.917c.03.507-.573.766-1.054.766H2.054c-.48 0-1.084-.26-1.054-.766v-4.151c.35.17.73.25 1.054.25h35.892c.324 0 .704-.08 1.054-.25v2.234zm-1.054-2.984H2.054c-.55 0-1.26-.339-1-1l4-8.25c.386-.687.7-1 1.25-1h1.033l-.074.652c-.079.7.473 1.35 1.24 1.452a46.42 46.42 0 0 0 10.57-.002c.378-.052.705-.24.927-.504.224.265.555.455.94.506a46.42 46.42 0 0 0 10.57-.002c.755-.103 1.306-.754 1.227-1.45l-.074-.652h1.033c.55 0 .864.313 1.25 1l4 8.25c.26.661-.45 1-1 1z"
  }));
};

IcoBedMat.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 23.791748"
};

var IcoBedSingle = function IcoBedSingle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M26.994 16.997a.465.465 0 0 0-.055-.236l-3-5.5c-.003-.006-.009-.01-.012-.015A.486.486 0 0 0 24 11V4.107h.5a.5.5 0 0 0 .5-.5V.5a.5.5 0 0 0-.5-.5h-22a.5.5 0 0 0-.5.5v3.107a.5.5 0 0 0 .5.5H3V11c0 .091.03.172.073.246-.003.006-.009.009-.012.015l-3 5.5a.42.42 0 0 0-.061.18H0v3.666a.5.5 0 0 0 .5.5h.482V28.5a.5.5 0 0 0 .5.5h2.002a.5.5 0 0 0 .5-.5V27h19.007l.026 1.509a.5.5 0 0 0 .5.491h2.002a.5.5 0 0 0 .5-.5v-7.393h.482a.5.5 0 0 0 .5-.5v-3.634c0-.025-.003-.008-.007.024zM3 3.107V1h21v2.107H3zm15.22 2.815c-3.132-1.035-6.308-1.034-9.438-.001-.6.196-1.128.831-1.203 1.45L7.17 11h-3.17V4.107h19V11H19.83l-.41-3.632c-.072-.615-.6-1.25-1.2-1.446zm.803 6.863v.002c.017.137-.138.314-.356.343a45.176 45.176 0 0 1-10.325 0c-.229-.028-.382-.205-.366-.345l.596-5.298c.028-.234.286-.539.522-.616a13.998 13.998 0 0 1 4.406-.725c1.472 0 2.945.243 4.407.726.234.076.492.38.52.61l.596 5.303zM3.797 12h3.262l-.076.672c-.081.7.47 1.351 1.237 1.452a46.232 46.232 0 0 0 10.572-.002c.757-.102 1.306-.752 1.226-1.45L19.942 12h3.262l2.728 5H1.07l2.727-5zm21.222 16h-1.01l-.027-1.509a.5.5 0 0 0-.5-.491H3.484a.5.5 0 0 0-.5.5V28H1.982v-6.893H25.02V28zm.982-7.893H1V18h25v2.107z"
  }));
};

IcoBedSingle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27.0006714 29"
};

var IcoBedSofa = function IcoBedSofa(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M37.33 7.755l-2.938-.951V2.262C34.392.994 33.121 0 31.464 0h-.003c-.071.005-7.114.482-11.419.482C15.74.483 8.607.006 8.502 0 6.877 0 5.604.994 5.604 2.262v4.542L2.63 7.76C1.128 8.086-.008 9.556 0 11.387L2.515 25h34.961L40 11.294c0-1.761-1.154-3.227-2.67-3.54zm-2.075.338c-1.06.597-1.796 1.8-1.796 3.201 0 .118.028.231.038.347l-1.423-1.733v-1c.04-.75.577-1.337 1.225-1.337l1.956.522zm-1.33 5.644c-.599.046-2.743.19-6.27.19H12.308c-3.442 0-5.536-.136-6.211-.187l2.727-3.152c.02-.015 1.91-1.513 4.183-1.513h14.157c2.098 0 3.875 1.276 4.15 1.485l2.61 3.177zM6.6 2.262c0-.68.87-1.255 1.868-1.256.072.004 7.238.483 11.574.483 4.338 0 11.414-.479 11.452-.482 1.03 0 1.902.575 1.902 1.255V6.58c-.034-.001-.063-.016-.097-.016-1.177 0-2.153 1.007-2.22 2.318v.325c-.868-.502-2.287-1.139-3.915-1.139H13.007c-1.735 0-3.219.719-4.081 1.249v-.316c0-1.343-.997-2.436-2.224-2.436-.034 0-.068.008-.102.01V2.262zm-.264 5.38l-.001-.003c.115-.044.239-.067.367-.067.677 0 1.228.64 1.228 1.43v1.102l-1.45 1.67c.02-.16.053-.316.053-.48 0-1.4-.735-2.602-1.794-3.2l1.597-.451zm-1.91 5.888l-.275.14v10.323h-.81L.988 11.294c0-1.433 1.02-2.6 2.275-2.6s2.275 1.167 2.275 2.6c0 .934-.442 1.8-1.11 2.236zm30.42 10.463H5.146v-5.032h29.698v5.032zm0-6.039H5.146v-3.455c.192.13.406.226.643.226h.004c.091.009 2.288.21 6.514.21h15.347c4.225 0 6.455-.201 6.503-.208.259 0 .486-.098.687-.234v3.461zm1.803 6.04h-.808V13.98l.042-.287-.275-.139c-.711-.46-1.153-1.326-1.153-2.26 0-1.433 1.02-2.6 2.274-2.6 1.255 0 2.275 1.167 2.284 2.508l-2.364 12.791z"
  }));
};

IcoBedSofa.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 25"
};

var IcoTip = function IcoTip(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7A8489",
    d: "M14.628 20.174a.605.605 0 0 0-.605-.604H7.977a.605.605 0 1 0 0 1.209h6.046c.334 0 .605-.27.605-.605zm-5.946 1.237c-.278 0-.355.17-.172.38l1.013 1.156a.253.253 0 0 0 .167.076h2.62c.056 0 .13-.034.167-.076l1.013-1.156c.183-.21.106-.38-.173-.38H8.682z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7B500",
    d: "M3.612 10.336H.664a.434.434 0 1 0 0 .868h2.948v-.868zm17.724 0h-2.948v.869h2.948a.434.434 0 1 0 0-.87zM11.434.434a.435.435 0 0 0-.868 0v2.948h.868V.434zm.254 7.331a3.09 3.09 0 0 1 2.317 2.318.384.384 0 1 0 .75-.17 3.863 3.863 0 0 0-2.897-2.898.384.384 0 1 0-.17.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFBE00",
    d: "M4.744 10.77c0 1.683.798 2.997 1.57 4.268.55.904 1.076 1.775 1.353 2.778a.602.602 0 0 0 .31 1.121h6.046a.604.604 0 0 0 .31-1.121c.277-1.003.803-1.874 1.353-2.778.772-1.271 1.57-2.585 1.57-4.268A6.264 6.264 0 0 0 11 4.514a6.264 6.264 0 0 0-6.256 6.256z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F7B500",
    d: "M18.616 3.155a.434.434 0 0 0-.615 0l-2.084 2.084.614.614 2.085-2.084a.434.434 0 0 0 0-.614zm-15.231 0a.434.434 0 0 0 0 .614l2.084 2.084.615-.614-2.085-2.085a.434.434 0 0 0-.614 0z"
  })));
};

IcoTip.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "24",
  viewBox: "0 0 22 24"
};

var IcoEmptystatePayments = function IcoEmptystatePayments(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("style", null, ".st0-icoEmptyStatePayments", "{", "fill:#dfa600", "}", ".st1-icoEmptyStatePayments", "{", "fill:#a47a00", "}", ".st2-icoEmptyStatePayments", "{", "opacity:.5;fill:none;stroke:#fff;stroke-width:1.5;enable-background:new", "}", ".st3-icoEmptyStatePayments", "{", "fill:#ffbe00", "}"), /*#__PURE__*/React.createElement("title", null, "coins"), /*#__PURE__*/React.createElement("g", {
    id: "dashboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty-states",
    transform: "translate(-1581 -2973)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "no-search-results",
    transform: "translate(1420 2810)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coins",
    transform: "translate(161 163)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8",
    transform: "translate(0 24)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coin",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    className: "st0-icoEmptyStatePayments",
    d: "M57.996 15.28c.028 1.29-.09 2.663-.09 4.087C57.906 26.896 44.959 33 28.986 33 13.015 33 .069 26.896.069 19.367c0-1.3-.086-2.557-.065-3.747"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    className: "st1-icoEmptyStatePayments",
    cx: "28.919",
    cy: "13.863",
    rx: "28.919",
    ry: "13.631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_1_",
    className: "st2-icoEmptyStatePayments",
    d: "M15.709 31.46l-.046-5.408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_2_",
    className: "st0-icoEmptyStatePayments",
    d: "M39.409 8.796c0 1.02-2.199 1.744-2.329 1.655-1.638-.998-4.44-1.745-7.286-1.745-2.889 0-4.657.68-4.657 1.698 0 1.176 2.372 1.494 5.691 1.88 3.968.452 9.185 1.289 9.185 4.255 0 2.286-3.019 3.87-8.063 4.279v.882c0 1.04-.777 1.539-2.5 1.539h-.216c-1.81 0-2.459-.476-2.459-1.539v-.838c-5.216-.294-8.191-1.537-8.191-2.807 0-.972 2.07-1.674 2.243-1.583 1.638 1.041 4.828 1.902 8.191 1.902 3.063 0 4.83-.68 4.83-1.7 0-1.243-2.673-1.583-5.82-1.969-3.794-.429-8.796-1.221-8.796-4.21 0-2.173 2.932-3.736 7.589-4.187V5.47c0-1.042.733-1.54 2.458-1.54h.258c1.769 0 2.459.476 2.459 1.54v.767c4.783.272 7.413 1.403 7.413 2.558z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coin_1_",
    transform: "translate(0 32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_3_",
    className: "st0-icoEmptyStatePayments",
    d: "M57.996 15.25c.028 1.29-.09 2.664-.09 4.088 0 7.529-12.947 13.633-28.92 13.633-15.971 0-28.917-6.104-28.917-13.633 0-1.3-.086-2.557-.065-3.747"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_1_",
    className: "st1-icoEmptyStatePayments",
    cx: "28.919",
    cy: "13.834",
    rx: "28.919",
    ry: "13.631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_4_",
    className: "st2-icoEmptyStatePayments",
    d: "M15.709 31.43l-.046-5.407"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_5_",
    className: "st0-icoEmptyStatePayments",
    d: "M39.409 8.767c0 1.02-2.199 1.744-2.329 1.655-1.638-.998-4.44-1.745-7.286-1.745-2.889 0-4.657.68-4.657 1.698 0 1.176 2.372 1.494 5.691 1.88 3.968.452 9.185 1.289 9.185 4.255 0 2.286-3.019 3.87-8.063 4.28v.881c0 1.04-.777 1.539-2.5 1.539h-.216c-1.81 0-2.459-.476-2.459-1.539v-.838c-5.216-.294-8.191-1.537-8.191-2.807 0-.972 2.07-1.674 2.243-1.583 1.638 1.041 4.828 1.902 8.191 1.902 3.063 0 4.83-.68 4.83-1.7 0-1.243-2.673-1.583-5.82-1.969-3.794-.429-8.796-1.221-8.796-4.21 0-2.173 2.932-3.736 7.589-4.187v-.837c0-1.042.733-1.54 2.458-1.54h.258c1.769 0 2.459.476 2.459 1.54v.767c4.783.272 7.413 1.404 7.413 2.558z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coin_2_",
    transform: "translate(0 24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_6_",
    className: "st0-icoEmptyStatePayments",
    d: "M57.996 15.221c.028 1.29-.09 2.664-.09 4.088 0 7.529-12.947 13.633-28.92 13.633C13.015 32.942.069 26.838.069 19.31c0-1.3-.086-2.557-.065-3.747"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_2_",
    className: "st1-icoEmptyStatePayments",
    cx: "28.919",
    cy: "13.805",
    rx: "28.919",
    ry: "13.631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_7_",
    className: "st2-icoEmptyStatePayments",
    d: "M15.709 31.401l-.046-5.407"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_8_",
    className: "st0-icoEmptyStatePayments",
    d: "M39.409 8.738c0 1.02-2.199 1.744-2.329 1.655-1.638-.998-4.44-1.745-7.286-1.745-2.889 0-4.657.68-4.657 1.699 0 1.175 2.372 1.493 5.691 1.878 3.968.453 9.185 1.29 9.185 4.256 0 2.286-3.019 3.87-8.063 4.28v.881c0 1.04-.777 1.539-2.5 1.539h-.216c-1.81 0-2.459-.476-2.459-1.539v-.838c-5.216-.294-8.191-1.537-8.191-2.807 0-.972 2.07-1.674 2.243-1.583 1.638 1.041 4.828 1.902 8.191 1.902 3.063 0 4.83-.68 4.83-1.7 0-1.243-2.673-1.583-5.82-1.969-3.794-.429-8.796-1.221-8.796-4.21 0-2.173 2.932-3.736 7.589-4.187v-.837c0-1.042.733-1.54 2.458-1.54h.258c1.769 0 2.459.476 2.459 1.54v.767c4.783.272 7.413 1.404 7.413 2.558z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coin_3_",
    transform: "translate(0 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_9_",
    className: "st0-icoEmptyStatePayments",
    d: "M57.996 15.192c.028 1.29-.09 2.664-.09 4.088 0 7.53-12.947 13.633-28.92 13.633C13.015 32.913.069 26.81.069 19.28c0-1.3-.086-2.557-.065-3.747"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3_",
    className: "st1-icoEmptyStatePayments",
    cx: "28.919",
    cy: "13.776",
    rx: "28.919",
    ry: "13.631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_10_",
    className: "st2-icoEmptyStatePayments",
    d: "M15.709 31.373l-.046-5.408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_11_",
    className: "st0-icoEmptyStatePayments",
    d: "M39.409 8.709c0 1.02-2.199 1.744-2.329 1.655-1.638-.998-4.44-1.745-7.286-1.745-2.889 0-4.657.68-4.657 1.699 0 1.175 2.372 1.493 5.691 1.878 3.968.453 9.185 1.29 9.185 4.256 0 2.286-3.019 3.87-8.063 4.28v.881c0 1.04-.777 1.539-2.5 1.539h-.216c-1.81 0-2.459-.476-2.459-1.539v-.838c-5.216-.294-8.191-1.537-8.191-2.807 0-.972 2.07-1.674 2.243-1.583 1.638 1.041 4.828 1.902 8.191 1.902 3.063 0 4.83-.68 4.83-1.7 0-1.243-2.673-1.583-5.82-1.969-3.794-.428-8.796-1.221-8.796-4.21 0-2.173 2.932-3.736 7.589-4.187v-.837c0-1.042.733-1.54 2.458-1.54h.258c1.769 0 2.459.476 2.459 1.54v.768c4.783.272 7.413 1.403 7.413 2.557z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coin_4_",
    transform: "translate(0 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_12_",
    className: "st0-icoEmptyStatePayments",
    d: "M57.996 15.163c.028 1.29-.09 2.664-.09 4.088 0 7.53-12.947 13.633-28.92 13.633C13.015 32.884.069 26.78.069 19.251c0-1.3-.086-2.557-.065-3.747"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_4_",
    className: "st1-icoEmptyStatePayments",
    cx: "28.919",
    cy: "13.747",
    rx: "28.919",
    ry: "13.631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_13_",
    className: "st2-icoEmptyStatePayments",
    d: "M15.709 31.344l-.046-5.408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_14_",
    className: "st0-icoEmptyStatePayments",
    d: "M39.409 8.68c0 1.02-2.199 1.744-2.329 1.655-1.638-.998-4.44-1.745-7.286-1.745-2.889 0-4.657.68-4.657 1.699 0 1.175 2.372 1.493 5.691 1.878 3.968.453 9.185 1.29 9.185 4.256 0 2.286-3.019 3.87-8.063 4.28v.881c0 1.04-.777 1.539-2.5 1.539h-.216c-1.81 0-2.459-.476-2.459-1.539v-.838c-5.216-.294-8.191-1.537-8.191-2.807 0-.972 2.07-1.674 2.243-1.583 1.638 1.041 4.828 1.902 8.191 1.902 3.063 0 4.83-.68 4.83-1.7 0-1.243-2.673-1.583-5.82-1.969-3.794-.428-8.796-1.221-8.796-4.21 0-2.173 2.932-3.736 7.589-4.187v-.837c0-1.042.733-1.54 2.458-1.54h.258c1.769 0 2.459.476 2.459 1.54v.768c4.783.272 7.413 1.403 7.413 2.557z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coin_5_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_15_",
    className: "st0-icoEmptyStatePayments",
    d: "M57.996 15.134c.028 1.29-.09 2.664-.09 4.088 0 7.53-12.947 13.633-28.92 13.633-15.971 0-28.917-6.104-28.917-13.633 0-1.3-.086-2.557-.065-3.747"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_5_",
    className: "st3-icoEmptyStatePayments",
    cx: "28.919",
    cy: "13.718",
    rx: "28.919",
    ry: "13.631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_16_",
    className: "st2-icoEmptyStatePayments",
    d: "M15.709 31.315l-.046-5.408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_17_",
    className: "st0-icoEmptyStatePayments",
    d: "M39.409 8.65c0 1.02-2.199 1.745-2.329 1.656-1.638-.998-4.44-1.745-7.286-1.745-2.889 0-4.657.68-4.657 1.699 0 1.175 2.372 1.493 5.691 1.878 3.968.453 9.185 1.29 9.185 4.256 0 2.286-3.019 3.87-8.063 4.28v.881c0 1.04-.777 1.539-2.5 1.539h-.216c-1.81 0-2.459-.476-2.459-1.539v-.838c-5.216-.294-8.191-1.537-8.191-2.807 0-.972 2.07-1.674 2.243-1.582 1.638 1.04 4.828 1.901 8.191 1.901 3.063 0 4.83-.68 4.83-1.7 0-1.243-2.673-1.582-5.82-1.969-3.794-.428-8.796-1.221-8.796-4.21 0-2.173 2.932-3.736 7.589-4.187v-.837c0-1.042.733-1.54 2.458-1.54h.258c1.769 0 2.459.476 2.459 1.54v.768c4.783.272 7.413 1.403 7.413 2.557z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(60)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "coin_6_",
    transform: "translate(0 64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_18_",
    className: "st0-icoEmptyStatePayments",
    d: "M57.996 15.28c.028 1.29-.09 2.663-.09 4.087C57.906 26.896 44.959 33 28.986 33 13.015 33 .069 26.896.069 19.367c0-1.3-.086-2.557-.065-3.747"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_6_",
    className: "st1-icoEmptyStatePayments",
    cx: "28.919",
    cy: "13.863",
    rx: "28.919",
    ry: "13.631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_19_",
    className: "st2-icoEmptyStatePayments",
    d: "M15.709 31.46l-.046-5.408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_20_",
    className: "st0-icoEmptyStatePayments",
    d: "M39.409 8.796c0 1.02-2.199 1.744-2.329 1.655-1.638-.998-4.44-1.745-7.286-1.745-2.889 0-4.657.68-4.657 1.698 0 1.176 2.372 1.494 5.691 1.88 3.968.452 9.185 1.289 9.185 4.255 0 2.286-3.019 3.87-8.063 4.279v.882c0 1.04-.777 1.539-2.5 1.539h-.216c-1.81 0-2.459-.476-2.459-1.539v-.838c-5.216-.294-8.191-1.537-8.191-2.807 0-.972 2.07-1.674 2.243-1.583 1.638 1.041 4.828 1.902 8.191 1.902 3.063 0 4.83-.68 4.83-1.7 0-1.243-2.673-1.583-5.82-1.969-3.794-.429-8.796-1.221-8.796-4.21 0-2.173 2.932-3.736 7.589-4.187V5.47c0-1.042.733-1.54 2.458-1.54h.258c1.769 0 2.459.476 2.459 1.54v.767c4.783.272 7.413 1.403 7.413 2.558z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coin_7_",
    transform: "translate(0 56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_21_",
    className: "st0-icoEmptyStatePayments",
    d: "M57.996 15.25c.028 1.29-.09 2.664-.09 4.088 0 7.529-12.947 13.633-28.92 13.633-15.971 0-28.917-6.104-28.917-13.633 0-1.3-.086-2.557-.065-3.747"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_7_",
    className: "st1-icoEmptyStatePayments",
    cx: "28.919",
    cy: "13.834",
    rx: "28.919",
    ry: "13.631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_22_",
    className: "st2-icoEmptyStatePayments",
    d: "M15.709 31.43l-.046-5.407"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_23_",
    className: "st0-icoEmptyStatePayments",
    d: "M39.409 8.767c0 1.02-2.199 1.744-2.329 1.655-1.638-.998-4.44-1.745-7.286-1.745-2.889 0-4.657.68-4.657 1.698 0 1.176 2.372 1.494 5.691 1.88 3.968.452 9.185 1.289 9.185 4.255 0 2.286-3.019 3.87-8.063 4.28v.881c0 1.04-.777 1.539-2.5 1.539h-.216c-1.81 0-2.459-.476-2.459-1.539v-.838c-5.216-.294-8.191-1.537-8.191-2.807 0-.972 2.07-1.674 2.243-1.583 1.638 1.041 4.828 1.902 8.191 1.902 3.063 0 4.83-.68 4.83-1.7 0-1.243-2.673-1.583-5.82-1.969-3.794-.429-8.796-1.221-8.796-4.21 0-2.173 2.932-3.736 7.589-4.187v-.837c0-1.042.733-1.54 2.458-1.54h.258c1.769 0 2.459.476 2.459 1.54v.767c4.783.272 7.413 1.404 7.413 2.558z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coin_8_",
    transform: "translate(0 48)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_24_",
    className: "st0-icoEmptyStatePayments",
    d: "M57.996 15.221c.028 1.29-.09 2.664-.09 4.088 0 7.529-12.947 13.633-28.92 13.633C13.015 32.942.069 26.838.069 19.31c0-1.3-.086-2.557-.065-3.747"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_8_",
    className: "st1-icoEmptyStatePayments",
    cx: "28.919",
    cy: "13.805",
    rx: "28.919",
    ry: "13.631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_25_",
    className: "st2-icoEmptyStatePayments",
    d: "M15.709 31.401l-.046-5.407"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_26_",
    className: "st0-icoEmptyStatePayments",
    d: "M39.409 8.738c0 1.02-2.199 1.744-2.329 1.655-1.638-.998-4.44-1.745-7.286-1.745-2.889 0-4.657.68-4.657 1.699 0 1.175 2.372 1.493 5.691 1.878 3.968.453 9.185 1.29 9.185 4.256 0 2.286-3.019 3.87-8.063 4.28v.881c0 1.04-.777 1.539-2.5 1.539h-.216c-1.81 0-2.459-.476-2.459-1.539v-.838c-5.216-.294-8.191-1.537-8.191-2.807 0-.972 2.07-1.674 2.243-1.583 1.638 1.041 4.828 1.902 8.191 1.902 3.063 0 4.83-.68 4.83-1.7 0-1.243-2.673-1.583-5.82-1.969-3.794-.429-8.796-1.221-8.796-4.21 0-2.173 2.932-3.736 7.589-4.187v-.837c0-1.042.733-1.54 2.458-1.54h.258c1.769 0 2.459.476 2.459 1.54v.767c4.783.272 7.413 1.404 7.413 2.558z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coin_9_",
    transform: "translate(0 40)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_27_",
    className: "st0-icoEmptyStatePayments",
    d: "M57.996 15.192c.028 1.29-.09 2.664-.09 4.088 0 7.53-12.947 13.633-28.92 13.633C13.015 32.913.069 26.81.069 19.28c0-1.3-.086-2.557-.065-3.747"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_9_",
    className: "st1-icoEmptyStatePayments",
    cx: "28.919",
    cy: "13.776",
    rx: "28.919",
    ry: "13.631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_28_",
    className: "st2-icoEmptyStatePayments",
    d: "M15.709 31.373l-.046-5.408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_29_",
    className: "st0-icoEmptyStatePayments",
    d: "M39.409 8.709c0 1.02-2.199 1.744-2.329 1.655-1.638-.998-4.44-1.745-7.286-1.745-2.889 0-4.657.68-4.657 1.699 0 1.175 2.372 1.493 5.691 1.878 3.968.453 9.185 1.29 9.185 4.256 0 2.286-3.019 3.87-8.063 4.28v.881c0 1.04-.777 1.539-2.5 1.539h-.216c-1.81 0-2.459-.476-2.459-1.539v-.838c-5.216-.294-8.191-1.537-8.191-2.807 0-.972 2.07-1.674 2.243-1.583 1.638 1.041 4.828 1.902 8.191 1.902 3.063 0 4.83-.68 4.83-1.7 0-1.243-2.673-1.583-5.82-1.969-3.794-.428-8.796-1.221-8.796-4.21 0-2.173 2.932-3.736 7.589-4.187v-.837c0-1.042.733-1.54 2.458-1.54h.258c1.769 0 2.459.476 2.459 1.54v.768c4.783.272 7.413 1.403 7.413 2.557z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coin_10_",
    transform: "translate(0 32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_30_",
    className: "st0-icoEmptyStatePayments",
    d: "M57.996 15.163c.028 1.29-.09 2.664-.09 4.088 0 7.53-12.947 13.633-28.92 13.633C13.015 32.884.069 26.78.069 19.251c0-1.3-.086-2.557-.065-3.747"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_10_",
    className: "st1-icoEmptyStatePayments",
    cx: "28.919",
    cy: "13.747",
    rx: "28.919",
    ry: "13.631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_31_",
    className: "st2-icoEmptyStatePayments",
    d: "M15.709 31.344l-.046-5.408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_32_",
    className: "st0-icoEmptyStatePayments",
    d: "M39.409 8.68c0 1.02-2.199 1.744-2.329 1.655-1.638-.998-4.44-1.745-7.286-1.745-2.889 0-4.657.68-4.657 1.699 0 1.175 2.372 1.493 5.691 1.878 3.968.453 9.185 1.29 9.185 4.256 0 2.286-3.019 3.87-8.063 4.28v.881c0 1.04-.777 1.539-2.5 1.539h-.216c-1.81 0-2.459-.476-2.459-1.539v-.838c-5.216-.294-8.191-1.537-8.191-2.807 0-.972 2.07-1.674 2.243-1.583 1.638 1.041 4.828 1.902 8.191 1.902 3.063 0 4.83-.68 4.83-1.7 0-1.243-2.673-1.583-5.82-1.969-3.794-.428-8.796-1.221-8.796-4.21 0-2.173 2.932-3.736 7.589-4.187v-.837c0-1.042.733-1.54 2.458-1.54h.258c1.769 0 2.459.476 2.459 1.54v.768c4.783.272 7.413 1.403 7.413 2.557z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coin_11_",
    transform: "translate(0 24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_33_",
    className: "st0-icoEmptyStatePayments",
    d: "M57.996 15.134c.028 1.29-.09 2.664-.09 4.088 0 7.53-12.947 13.633-28.92 13.633-15.971 0-28.917-6.104-28.917-13.633 0-1.3-.086-2.557-.065-3.747"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_11_",
    className: "st1-icoEmptyStatePayments",
    cx: "28.919",
    cy: "13.718",
    rx: "28.919",
    ry: "13.631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_34_",
    className: "st2-icoEmptyStatePayments",
    d: "M15.709 31.315l-.046-5.408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_35_",
    className: "st0-icoEmptyStatePayments",
    d: "M39.409 8.65c0 1.02-2.199 1.745-2.329 1.656-1.638-.998-4.44-1.745-7.286-1.745-2.889 0-4.657.68-4.657 1.699 0 1.175 2.372 1.493 5.691 1.878 3.968.453 9.185 1.29 9.185 4.256 0 2.286-3.019 3.87-8.063 4.28v.881c0 1.04-.777 1.539-2.5 1.539h-.216c-1.81 0-2.459-.476-2.459-1.539v-.838c-5.216-.294-8.191-1.537-8.191-2.807 0-.972 2.07-1.674 2.243-1.582 1.638 1.04 4.828 1.901 8.191 1.901 3.063 0 4.83-.68 4.83-1.7 0-1.243-2.673-1.582-5.82-1.969-3.794-.428-8.796-1.221-8.796-4.21 0-2.173 2.932-3.736 7.589-4.187v-.837c0-1.042.733-1.54 2.458-1.54h.258c1.769 0 2.459.476 2.459 1.54v.768c4.783.272 7.413 1.403 7.413 2.557z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coin_12_",
    transform: "translate(0 16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_36_",
    className: "st0-icoEmptyStatePayments",
    d: "M57.996 15.105c.028 1.29-.09 2.664-.09 4.088 0 7.53-12.947 13.633-28.92 13.633-15.971 0-28.917-6.104-28.917-13.633 0-1.3-.086-2.557-.065-3.747"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_12_",
    className: "st1-icoEmptyStatePayments",
    cx: "28.919",
    cy: "13.689",
    rx: "28.919",
    ry: "13.631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_37_",
    className: "st2-icoEmptyStatePayments",
    d: "M15.709 31.286l-.046-5.408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_38_",
    className: "st0-icoEmptyStatePayments",
    d: "M39.409 8.622c0 1.02-2.199 1.744-2.329 1.655-1.638-.998-4.44-1.744-7.286-1.744-2.889 0-4.657.679-4.657 1.698 0 1.175 2.372 1.493 5.691 1.878 3.968.453 9.185 1.29 9.185 4.256 0 2.286-3.019 3.87-8.063 4.28v.881c0 1.04-.777 1.539-2.5 1.539h-.216c-1.81 0-2.459-.476-2.459-1.539v-.838c-5.216-.294-8.191-1.537-8.191-2.807 0-.972 2.07-1.674 2.243-1.582 1.638 1.04 4.828 1.901 8.191 1.901 3.063 0 4.83-.679 4.83-1.7 0-1.243-2.673-1.582-5.82-1.969-3.794-.428-8.796-1.221-8.796-4.21 0-2.173 2.932-3.736 7.589-4.187v-.837c0-1.042.733-1.54 2.458-1.54h.258c1.769 0 2.459.476 2.459 1.54v.768c4.783.272 7.413 1.403 7.413 2.557z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coin_13_",
    transform: "translate(0 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_39_",
    className: "st0-icoEmptyStatePayments",
    d: "M57.996 15.076c.028 1.29-.09 2.664-.09 4.088 0 7.53-12.947 13.633-28.92 13.633-15.971 0-28.917-6.104-28.917-13.633 0-1.3-.086-2.557-.065-3.747"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_13_",
    className: "st1-icoEmptyStatePayments",
    cx: "28.919",
    cy: "13.66",
    rx: "28.919",
    ry: "13.631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_40_",
    className: "st2-icoEmptyStatePayments",
    d: "M15.709 31.257l-.046-5.408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_41_",
    className: "st0-icoEmptyStatePayments",
    d: "M39.409 8.593c0 1.02-2.199 1.744-2.329 1.655-1.638-.998-4.44-1.744-7.286-1.744-2.889 0-4.657.679-4.657 1.698 0 1.175 2.372 1.493 5.691 1.878 3.968.453 9.185 1.29 9.185 4.256 0 2.286-3.019 3.87-8.063 4.28v.881c0 1.04-.777 1.539-2.5 1.539h-.216c-1.81 0-2.459-.476-2.459-1.539v-.838c-5.216-.294-8.191-1.537-8.191-2.807 0-.972 2.07-1.674 2.243-1.582 1.638 1.04 4.828 1.901 8.191 1.901 3.063 0 4.83-.679 4.83-1.7 0-1.243-2.673-1.582-5.82-1.969-3.794-.428-8.796-1.221-8.796-4.21 0-2.173 2.932-3.735 7.589-4.187v-.837c0-1.042.733-1.54 2.458-1.54h.258c1.769 0 2.459.476 2.459 1.54v.768c4.783.272 7.413 1.403 7.413 2.557z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "coin_14_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape_42_",
    className: "st0-icoEmptyStatePayments",
    d: "M57.996 15.047c.028 1.29-.09 2.664-.09 4.088 0 7.53-12.947 13.633-28.92 13.633-15.971 0-28.917-6.104-28.917-13.633 0-1.3-.086-2.557-.065-3.746"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_14_",
    className: "st3-icoEmptyStatePayments",
    cx: "28.919",
    cy: "13.631",
    rx: "28.919",
    ry: "13.631"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_43_",
    className: "st2-icoEmptyStatePayments",
    d: "M15.709 31.228l-.046-5.408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape_44_",
    className: "st0-icoEmptyStatePayments",
    d: "M39.409 8.564c0 1.02-2.199 1.744-2.329 1.655-1.638-.998-4.44-1.744-7.286-1.744-2.889 0-4.657.679-4.657 1.698 0 1.175 2.372 1.493 5.691 1.878 3.968.453 9.185 1.29 9.185 4.256 0 2.286-3.019 3.87-8.063 4.28v.881c0 1.04-.777 1.539-2.5 1.539h-.216c-1.81 0-2.459-.476-2.459-1.539v-.838c-5.216-.294-8.191-1.537-8.191-2.807 0-.972 2.07-1.674 2.243-1.582 1.638 1.04 4.828 1.901 8.191 1.901 3.063 0 4.83-.679 4.83-1.7 0-1.243-2.673-1.582-5.82-1.969-3.794-.428-8.796-1.221-8.796-4.21 0-2.173 2.932-3.735 7.589-4.187v-.837c0-1.042.733-1.54 2.458-1.54h.258c1.769 0 2.459.476 2.459 1.54v.768c4.783.272 7.413 1.403 7.413 2.557z"
  }))))))));
};

IcoEmptystatePayments.defaultProps = {
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 118.0002975 97"
};

var IcoEmptystateAccessAcount = function IcoEmptystateAccessAcount(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("style", null, ".st0", "{", "fill:#556268", "}", ".st1", "{", "fill:#48bdf3", "}", ".st2", "{", "fill:#30abe5", "}", ".st3", "{", "fill:#272b2d", "}", ".st4", "{", "fill:#7a8489", "}", ".st5", "{", "fill:#aeb6ba", "}", ".st6", "{", "fill:#515c61", "}"), /*#__PURE__*/React.createElement("title", null, "door"), /*#__PURE__*/React.createElement("g", {
    id: "dashboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty-states",
    transform: "translate(-1560 -3323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "accout-deactivated-TBD",
    transform: "translate(1380 3210)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "door",
    transform: "translate(180 113)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    className: "st0",
    d: "M8.23 0h65.54C78.308 0 82 3.684 82 8.212V146H0V8.212C0 3.684 3.692 0 8.23 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    className: "st1",
    d: "M8.23 6.74h65.54c.814 0 1.474.66 1.474 1.472v135.273H6.756V8.212c0-.813.66-1.471 1.474-1.471"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    className: "st2",
    d: "M18.953 132.162h44.094V18.911H18.953v113.251zm45.032 1.872h-45.97a.937.937 0 0 1-.938-.936V17.975c0-.518.42-.937.938-.937h45.97c.518 0 .939.42.939.937v115.123c0 .518-.42.936-.939.936z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-9",
    className: "st3",
    d: "M74.66 18.91h1.169c.226 0 .41.182.41.408v11.617a.409.409 0 0 1-.41.407H74.66a.408.408 0 0 1-.41-.407V19.318c0-.226.184-.408.41-.408"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    className: "st3",
    d: "M74.66 119.729h1.169a.41.41 0 0 1 .41.409v11.615a.41.41 0 0 1-.41.408H74.66a.409.409 0 0 1-.41-.408v-11.615c0-.226.184-.41.41-.41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-11",
    className: "st3",
    d: "M13.852 73.606H9.974a.828.828 0 0 0-.83.827v16.859c0 .457.373.826.83.826h3.878c.458 0 .829-.37.829-.826V74.433a.827.827 0 0 0-.829-.827"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    className: "st4",
    d: "M11.913 84.507a.766.766 0 0 0-.767.766c0 .244.116.46.294.6a.18.18 0 0 1 .073.14v1.744c0 .097.08.176.177.176h.447a.177.177 0 0 0 .176-.176v-1.744a.18.18 0 0 1 .073-.14.76.76 0 0 0 .295-.6.767.767 0 0 0-.768-.766"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    className: "st3",
    d: "M12.3 85.273a.386.386 0 1 0-.772.001.386.386 0 0 0 .771-.001"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    className: "st5",
    d: "M21.739 77.578H11.313a.86.86 0 0 0-.861.86v2.255c0 .475.386.86.861.86h10.426a.86.86 0 0 0 .86-.86v-2.256a.86.86 0 0 0-.86-.86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "st6",
    d: "M21.739 77.578H11.313a.86.86 0 0 0-.861.86v.873c0 .475.386.86.861.86h10.426a.86.86 0 0 0 .86-.86v-.874a.86.86 0 0 0-.86-.86"
  }))))));
};

IcoEmptystateAccessAcount.defaultProps = {
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 82 146"
};

var IcoEmptystateArchived = function IcoEmptystateArchived(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M66 36H28v12h38V36zm-1 11H29V37h36v10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94 9c0-4.962-4.037-9-9-9H9C4.038 0 0 4.038 0 9v7h5v43c0 4.963 4.038 9 9 9h66c4.963 0 9-4.037 9-9V16h5V9zm-6 50c0 4.411-3.589 8-8 8H14c-4.411 0-8-3.589-8-8V16h82v43zm5-44H1V9c0-4.411 3.589-8 8-8h76c4.411 0 8 3.589 8 8v6z"
  }));
};

IcoEmptystateArchived.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 94 68"
};

var IcoEmptystateColumns = function IcoEmptystateColumns(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M27 0H0v46h40V0H27zM13 45H1V1h12v44zm13 0H14V1h12v44zm13 0H27V1h12v44z"
  }));
};

IcoEmptystateColumns.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 46.0004883"
};

var IcoEmptystateFavs = function IcoEmptystateFavs(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.1 50l3.1-18.1L0 19.1l18.3-2.6L26.5 0l8.2 16.5L53 19.1 39.8 31.9 42.9 50l-16.4-8.5L10.1 50zm16.4-9.7l15.1 7.9-2.9-16.6 12.2-11.8L34 17.4 26.5 2.2 19 17.4 2.2 19.8l12.2 11.8-2.9 16.6 15-7.9z"
  }));
};

IcoEmptystateFavs.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 53 50"
};

var IcoEmptystateInactivePropertoes = function IcoEmptystateInactivePropertoes(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M82.44 40.896H71.52a.5.5 0 0 0-.5.5v7.574a.5.5 0 0 0 .5.5h10.92a.5.5 0 0 0 .5-.5v-7.574a.5.5 0 0 0-.5-.5zm-.5 7.574h-9.92v-6.574h9.92v6.574zM45.48 40.896H34.561a.5.5 0 0 0-.5.5v7.574a.5.5 0 0 0 .5.5H45.48a.5.5 0 0 0 .5-.5v-7.574a.5.5 0 0 0-.5-.5zm-.5 7.574h-9.919v-6.574H44.98v6.574zM63.96 26.59H53.04a.5.5 0 0 0-.5.5v7.573a.5.5 0 0 0 .5.5h10.92a.5.5 0 0 0 .5-.5V27.09a.5.5 0 0 0-.5-.5zm-.5 7.573h-9.92V27.59h9.92v6.574zM71.02 27.09v7.573a.5.5 0 0 0 .5.5h10.92a.5.5 0 0 0 .5-.5V27.09a.5.5 0 0 0-.5-.5H71.52a.5.5 0 0 0-.5.5zm1 .5h9.92v6.573h-9.92V27.59zM45.48 26.59H34.56a.5.5 0 0 0-.5.5v7.573a.5.5 0 0 0 .5.5h10.92a.5.5 0 0 0 .5-.5V27.09a.5.5 0 0 0-.5-.5zm-.5 7.573h-9.92V27.59h9.92v6.574zM63.96 40.896H53.04a.5.5 0 0 0-.5.5v7.574a.5.5 0 0 0 .5.5h10.92a.5.5 0 0 0 .5-.5v-7.574a.5.5 0 0 0-.5-.5zm-.5 7.574h-9.92v-6.574h9.92v6.574zM7.144 36.05V41.9a.5.5 0 0 0 .5.5h8.305a.5.5 0 0 0 .5-.5V36.05a.5.5 0 0 0-.5-.5H7.644a.5.5 0 0 0-.5.5zm1 .5h7.305V41.4H8.144V36.55zM15.95 47.247H7.643a.5.5 0 0 0-.5.5v5.847a.5.5 0 0 0 .5.5h8.305a.5.5 0 0 0 .5-.5v-5.847a.5.5 0 0 0-.5-.5zm-.5 5.847H8.143v-4.847h7.305v4.847z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115 23.854h-8.636V16a.5.5 0 0 0-.5-.5H90.5v-3.56a.5.5 0 0 0-.5-.5H78.74V1a.5.5 0 0 0-.5-.5H37.92a.5.5 0 0 0-.5.5v10.44H27a.5.5 0 0 0-.5.5v3.56H9.305a.5.5 0 0 0-.5.5v7.854H1a.5.5 0 0 0-.5.5V82a.5.5 0 0 0 .5.5h25.5V86a.5.5 0 0 0 .5.5h63a.5.5 0 0 0 .5-.5v-3.5H115a.5.5 0 0 0 .5-.5V24.354a.5.5 0 0 0-.5-.5zM26.5 81.5h-7.56V70.803h7.56V81.5zm0-28.406h-5.068v-4.847H26.5v4.847zm0-11.695h-5.068V36.55H26.5v4.848zm0-5.848h-5.568a.5.5 0 0 0-.5.5v5.848a.5.5 0 0 0 .5.5H26.5v4.848h-5.568a.5.5 0 0 0-.5.5v5.847a.5.5 0 0 0 .5.5H26.5v15.71h-8.06a.5.5 0 0 0-.5.5V81.5H1.5V24.854h25v10.697zm0-11.697H9.805V16.5H26.5v7.354zM38.42 1.5h39.32v9.94H38.42V1.5zm29.24 80v4H50.18V71.35h17.48V81.5zm21.84-66v70H68.66V70.85a.5.5 0 0 0-.5-.5H49.68a.495.495 0 0 0-.18.037.497.497 0 0 0-.32.463V85.5H27.5V12.44h62v3.06zm1 1h14.864v7.354H90.5V16.5zm0 20.05h3.237V41.4H90.5V36.55zm0 11.697h3.237v4.847H90.5v-4.847zM97.06 81.5H90.5V70.803h6.56V81.5zm17.44 0H98.06V70.303a.5.5 0 0 0-.5-.5H90.5V54.094h3.737a.5.5 0 0 0 .5-.5v-5.847a.5.5 0 0 0-.5-.5H90.5v-4.848h3.737a.5.5 0 0 0 .5-.5V36.05a.5.5 0 0 0-.5-.5H90.5V24.854h24V81.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.382 36.05V41.9a.5.5 0 0 0 .5.5h8.305a.5.5 0 0 0 .5-.5V36.05a.5.5 0 0 0-.5-.5h-8.305a.5.5 0 0 0-.5.5zm1 .5h7.305V41.4h-7.305V36.55zM109.187 47.247h-8.305a.5.5 0 0 0-.5.5v5.847a.5.5 0 0 0 .5.5h8.305a.5.5 0 0 0 .5-.5v-5.847a.5.5 0 0 0-.5-.5zm-.5 5.847h-7.305v-4.847h7.305v4.847z"
  }));
};

IcoEmptystateInactivePropertoes.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 116 87"
};

var IcoEmptystateInbox = function IcoEmptystateInbox(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M87.278 91h-.209v-4.267c0-1.506-1.265-2.733-2.821-2.733H50.069V3.5c0-1.93-1.57-3.5-3.5-3.5h-3c-1.93 0-3.5 1.57-3.5 3.5V84H5.892c-1.557 0-2.823 1.227-2.823 2.733V91h-.211L0 113h25.784l2.112-2.917L30.111 113h60.028l-2.86-22zM41.07 3.5c0-1.378 1.122-2.5 2.5-2.5h3c1.38 0 2.5 1.122 2.5 2.5V84h-8V3.5zm-37 83.233c0-.956.818-1.733 1.823-1.733h78.356c1.004 0 1.821.777 1.821 1.733V91h-82v-4.267zm23.808 21.67L25.273 112H1.139l2.598-20h82.662L89 112H30.607l-2.73-3.597z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.069 94.5h1v15h-1zM69.069 94.5h1v15h-1zM55.069 94.5h1v15h-1zM41.069 94.5h1v15h-1zM27.069 94.5h1v11h-1zM14.069 94.5h1v15h-1z"
  }));
};

IcoEmptystateInbox.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 90.1386719 113"
};

var IcoEmptystateInboxTickets = function IcoEmptystateInboxTickets(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M161.984.496H16.016c-1.39 0-2.52 1.13-2.52 2.52V7.5H9A2.503 2.503 0 0 0 6.5 10v.5H6A2.503 2.503 0 0 0 3.5 13v.5H3A2.503 2.503 0 0 0 .5 16v56c0 1.379 1.122 2.5 2.5 2.5h146c1.379 0 2.5-1.121 2.5-2.5v-.5h.5c1.379 0 2.5-1.121 2.5-2.5v-.5h.5c1.379 0 2.5-1.121 2.5-2.5v-4.496h4.484c1.39 0 2.52-1.13 2.52-2.52V3.016c0-1.39-1.13-2.52-2.52-2.52zM150.5 72c0 .827-.673 1.5-1.5 1.5H3c-.827 0-1.5-.673-1.5-1.5V16c0-.827.673-1.5 1.5-1.5h.5V69c0 1.379 1.122 2.5 2.5 2.5h144.5v.5zm3-3c0 .827-.673 1.5-1.5 1.5H6c-.827 0-1.5-.673-1.5-1.5V13c0-.827.673-1.5 1.5-1.5h.5V66c0 1.379 1.122 2.5 2.5 2.5h144.5v.5zm3-3c0 .827-.673 1.5-1.5 1.5H9c-.827 0-1.5-.673-1.5-1.5V10c0-.827.673-1.5 1.5-1.5h4.496v50.484c0 1.39 1.13 2.52 2.52 2.52H156.5V66zm6.996-7.016c0 .834-.678 1.512-1.512 1.512H16.016a1.513 1.513 0 0 1-1.512-1.512V3.016c0-.834.678-1.512 1.512-1.512h145.968c.834 0 1.512.678 1.512 1.512v55.968z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.268 46.996h48.366v1.008H54.268zM54.268 36.996h31.209v1.008H54.268zM123.228 17.496h26.176v1.008h-26.176zM139.335 46.496h11.075v1.008h-11.075zM33.6 21.504h21.202a5.01 5.01 0 0 0 5.004-5.004c0-.712-.154-1.386-.423-2a4.979 4.979 0 0 0-.601-1c-.907-1.2-2.328-1.987-3.941-2-.013 0-.026-.004-.039-.004H33.601c-.014 0-.026.004-.039.004-1.613.013-3.034.8-3.941 2-.235.31-.443.64-.601 1a4.965 4.965 0 0 0-.423 2 5.01 5.01 0 0 0 5.004 5.004zM30.162 14.5c.221-.378.5-.714.828-1a3.962 3.962 0 0 1 2.612-.996h21.201c1.003 0 1.91.384 2.612.996.328.286.607.622.827 1a3.95 3.95 0 0 1 .557 2 4 4 0 0 1-3.996 3.996H33.601a4 4 0 0 1-3.997-3.996c0-.732.213-1.41.557-2zM39.168 30.996c-5.83 0-10.571 4.712-10.571 10.504s4.742 10.504 10.571 10.504 10.57-4.712 10.57-10.504-4.741-10.504-10.57-10.504zm0 20c-5.273 0-9.564-4.26-9.564-9.496s4.29-9.496 9.564-9.496c5.273 0 9.563 4.26 9.563 9.496s-4.29 9.496-9.563 9.496zM147.879 39.504c1.38 0 2.504-1.123 2.504-2.504s-1.123-2.504-2.504-2.504c-1.208 0-2.22.86-2.453 2h-6.167a2.508 2.508 0 0 0-2.453-2c-1.381 0-2.504 1.123-2.504 2.504s1.123 2.504 2.504 2.504c1.208 0 2.219-.86 2.453-2h6.167c.234 1.14 1.245 2 2.453 2zm0-4c.825 0 1.496.671 1.496 1.496s-.67 1.496-1.496 1.496a1.497 1.497 0 0 1 0-2.992zm-11.073 2.992c-.826 0-1.496-.671-1.496-1.496s.67-1.496 1.496-1.496a1.497 1.497 0 0 1 0 2.992z"
  }));
};

IcoEmptystateInboxTickets.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 165 75"
};

var IcoEmptystateLinks = function IcoEmptystateLinks(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M54.349 4.65C46.327-3.37 40.938-.84 29.783 10.316c-4.44 4.438-7.342 7.926-8.88 10.663-3.156 1.717-6.596 4.812-10.586 8.801C-.838 40.936-3.372 46.323 4.65 54.347c3.163 3.163 5.917 4.685 8.776 4.684 4.392 0 9.033-3.593 15.789-10.348 4.679-4.678 7.322-7.861 8.813-10.606 3.028-1.645 6.427-4.633 10.654-8.86C59.838 18.062 62.37 12.674 54.349 4.65zm-25.84 43.326c-10.81 10.81-15.67 13.141-23.151 5.664-7.48-7.48-5.145-12.342 5.666-23.153 4.398-4.398 8.095-7.68 11.413-9.155l.287-.123c.37-.154.736-.284 1.097-.39.352-.099.699-.176.983-.232a7.888 7.888 0 0 1 .935-.106c.084-.003.168-.008.25-.008.063-.001.126.001.188.002a8.625 8.625 0 0 1 1.6.193c2.021.478 4.07 1.828 6.398 4.156 2.105 2.102 3.364 3.923 3.958 5.705-2.009 1.564-3.533 2.138-5.088 1.732-.427-1.133-1.259-2.305-2.629-3.674-1.48-1.481-2.78-2.376-4.041-2.76a3.013 3.013 0 0 0-.669-.162 4.797 4.797 0 0 0-.13-.02 7.63 7.63 0 0 0-1.043-.047c-.701.043-1.965.44-2.927 1.09-.89.604-1.352.94-1.594 1.168-1.71 1.365-3.643 3.3-5.981 5.638C6.5 41.021 3.382 44.138 9.12 49.88c2.042 2.04 3.75 2.96 5.445 2.96 3.07 0 6.09-3.019 10.94-7.87 2.16-2.158 4.022-4.03 5.374-5.667.67.171 1.338.263 2.013.263 1.145 0 2.308-.25 3.52-.73-1.537 2.393-3.989 5.225-7.904 9.14zm10.448-18.124c-.687-1.817-1.994-3.658-4.075-5.735-2.047-2.047-3.91-3.388-5.735-4.084 1.35-1.574 3.226-3.471 5.055-5.298 8.042-8.042 10.123-9.756 14.972-4.908 2.528 2.528 3.182 4.325 2.333 6.41-.906 2.226-3.565 4.884-7.243 8.562-2.139 2.138-3.847 3.814-5.307 5.053zm-7.343 1.775c-.722-.448-1.478-1.079-2.321-1.92-.852-.852-1.458-1.605-1.89-2.304.715.44 1.468 1.053 2.306 1.89.86.861 1.47 1.62 1.905 2.334zm-11.577-2.49c.687 1.818 1.999 3.663 4.08 5.744 2.039 2.038 3.907 3.386 5.743 4.093-1.3 1.528-3.059 3.287-5.061 5.29-8.042 8.042-10.125 9.755-14.971 4.909-4.847-4.85-3.133-6.933 4.91-14.972 2.053-2.054 3.78-3.773 5.3-5.063zm4.787 5.037c-2.102-2.102-3.371-3.926-3.966-5.706.876-.68 1.685-1.202 2.44-1.509.911-.37 1.77-.434 2.656-.2.431 1.127 1.273 2.296 2.632 3.654 2.829 2.83 5 3.567 7.493 2.554 2.413-.983 5.131-3.7 8.892-7.461 3.761-3.76 6.48-6.478 7.463-8.892 1.015-2.494.276-4.665-2.553-7.494-5.741-5.742-8.858-2.62-16.386 4.908-1.968 1.966-3.997 4.017-5.387 5.683a8.128 8.128 0 0 0-2.453-.232c-.16.008-.322.02-.485.039-.086.01-.173.026-.26.038-.065.01-.13.016-.196.029l-.055.011c-.304.053-.61.116-.919.2-.069.02-.139.045-.208.066-.171.048-.34.1-.508.159l-.03.01-.063.02c-.13.048-.257.097-.38.147 1.62-2.45 4.234-5.47 7.94-9.175C41.297.215 46.157-2.123 53.64 5.357c7.48 7.48 5.145 12.342-5.665 23.153-10.811 10.81-15.671 13.144-23.152 5.664z"
  }));
};

IcoEmptystateLinks.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 59 59"
};

var IcoEmptystateMaintenance = function IcoEmptystateMaintenance(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("style", null, ".st0", "{", "fill:none", "}"), /*#__PURE__*/React.createElement("path", {
    id: "_x34_04_1_",
    d: "M45 56.75H18a.75.75 0 0 1 0-1.5h27a.75.75 0 0 1 0 1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M40.24 41.586a14.601 14.601 0 0 1-7.406 2.982l-.228.015c-.174.016-.35.018-.526.027-.356.014-.711.022-1.065.026-5.41-.102-10.112-3.134-12.577-7.58a14.595 14.595 0 0 1-1.838-7.1c0-8.102 6.591-14.694 14.694-14.694 5.168 0 9.712 2.689 12.333 6.734h17.315C58.962 11.99 46.93 1.63 30.144 1.751 15.018 1.874 1.75 15.681 1.75 31.3v98.951h59.5V37.028H44.166a14.786 14.786 0 0 1-3.926 4.558z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 35.528H43.236a13.193 13.193 0 0 1-.834 1.5 13.268 13.268 0 0 1-3.073 3.369c-1.6 1.76-3.783 2.458-6.567 2.666-.483.054-.971.087-1.468.087-.105 0-.206-.014-.31-.016-.145.002-.285.006-.433.006-4.745 0-8.844-2.782-10.795-6.799a13.105 13.105 0 0 1-1.656-6.385c0-7.275 5.919-13.194 13.194-13.194 4.285 0 8.093 2.059 10.503 5.234.361.477.693.977.989 1.5H61.83a.752.752 0 0 0 .742-.854C60.618 8.755 44.426.25 30.422.25l-.29.001C14.213.381.25 14.888.25 31.3V131c0 .414.336.75.75.75h61a.75.75 0 0 0 .75-.75V36.278a.75.75 0 0 0-.75-.75zm-.75 94.722H1.75V31.3C1.75 15.68 15.018 1.874 30.144 1.75c16.786-.121 28.818 10.24 30.798 20.245H43.627c-2.62-4.045-7.165-6.734-12.333-6.734-8.103 0-14.694 6.592-14.694 14.694 0 2.575.67 4.994 1.838 7.1 2.465 4.446 7.168 7.478 12.577 7.58.354-.004.709-.012 1.065-.026.175-.01.352-.011.526-.027l.228-.015a14.601 14.601 0 0 0 7.406-2.982 14.786 14.786 0 0 0 3.926-4.558H61.25v93.222z"
  }));
};

IcoEmptystateMaintenance.defaultProps = {
  id: "_x34_04",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 63 132"
};

var IcoEmptystateNotifications = function IcoEmptystateNotifications(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M109.167 18.639l-8.134-5.68V3.855A3.86 3.86 0 0 0 97.178 0H60.143L56.48.94 52.906.016 15.78 0a3.86 3.86 0 0 0-3.855 3.855v9.103l-8.079 5.646.004.006C1.576 19.702 0 22.002 0 24.664c0 2.682 1.642 5.123 4.121 6.179v15.03c0 1.669 2.56 2.262 4.753 2.262s4.754-.593 4.754-2.263v-2.469h85.7l-.001 2.47c0 .538.287 1.286 1.656 1.79.826.304 1.926.472 3.098.472 2.193 0 4.754-.593 4.754-2.263v-15.03c2.48-1.055 4.122-3.496 4.122-6.178 0-2.639-1.548-4.921-3.79-6.025zm-9.83 6.22l-.002 2.788-2.381-3.084-.076-.1c-.032-.033-3.297-3.454-1.657-7.01a6.43 6.43 0 0 1 5.119-3.758l6.086 4.25c-.095-.004-.188-.014-.283-.014-3.758 0-6.814 3.02-6.814 6.733 0 .066.004.13.007.195zm-85.71 4.554l3.395-4.01h38.96v7.578H15.78a2.84 2.84 0 0 1-2.152-.989v-2.58zm43.356-4.01H96.34l2.993 3.865v2.727c-.549.63-1.32 1-2.156 1H56.983v-7.592zM60.207 1h36.971a2.858 2.858 0 0 1 2.855 2.855v8.872c-1.117.159-4.145.898-5.72 4.307-1.443 3.13.228 6.04 1.22 7.37h-38.55V1.841L60.207 1zM15.78 1h36.937l3.266.845v22.558H17.705c.91-1.356 2.373-4.266.94-7.369-1.573-3.407-4.6-4.147-5.72-4.307V3.855A2.858 2.858 0 0 1 15.78 1zm-3.163 12.695c.724.076 3.651.577 5.12 3.758 1.491 3.229-.822 6.387-1.272 6.95h-.017l-2.82 3.227v-2.515c0-.048-.005-.095-.008-.232.004-.072.008-.146.008-.22 0-3.712-3.057-6.732-6.814-6.732-.094 0-.185.01-.278.014l6.081-4.25zm.01 11.42v20.757c0 .685-1.718 1.263-3.753 1.263s-3.753-.578-3.753-1.263V30.153l-.328-.12C2.524 29.203 1 27.045 1 24.663c0-3.16 2.608-5.732 5.814-5.732s5.814 2.571 5.814 5.733l-.013.297c0 .048.005.095.013.154zm1 17.288v-9.1c.632.428 1.372.679 2.153.679h40.696v.013h40.702a3.82 3.82 0 0 0 2.154-.684l-.004 9.092h-85.7zm94.537-12.37l-.328.12v15.72c0 .684-1.72 1.262-3.755 1.262s-3.754-.578-3.754-1.263l.002-20.76.014-.12-.014-.328c0-3.161 2.608-5.733 5.814-5.733.9 0 1.75.208 2.511.57l1.515 1.058.009-.014a5.675 5.675 0 0 1 1.779 4.119c0 2.38-1.525 4.54-3.793 5.37z"
  }));
};

IcoEmptystateNotifications.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 112.9565 48.1348"
};

var IcoEmptystateSearch = function IcoEmptystateSearch(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M84.8 76.7L74 11C72.6 1.8 68.6-1.1 59.4.3L3.9 8.8l1.7 10.5C2 20-.4 23.5.1 27.1c.2 1.6 1 3 2 4-.4 1.1-.6 2.3-.4 3.5.2 1.6.9 3 2.1 4.1-.9 1.4-1.4 3.1-1.1 4.9.2 1.7 1.1 3.2 2.4 4.3-.5 1.2-.8 2.5-.6 3.9.2 1.6 1 3.1 2.1 4.1-.9 1.4-1.4 3.1-1.1 4.9.2 1.7 1.1 3.2 2.3 4.3-.6 1.2-.8 2.6-.6 3.9.2 1.6.9 3 2.1 4.1-.9 1.4-1.4 3.1-1.1 4.9.2 1.7 1.1 3.2 2.4 4.3-.5 1.2-.8 2.5-.6 3.9.2 1.8 1.2 3.5 2.7 4.6 1.2.9 2.7 1.4 4.2 1.4h.5l1.2 7.6 55.5-8.5c4.7-.8 7.6-2.2 9.3-4.4s2.1-5.5 1.4-10.2zM1.3 26.9c-.5-3 1.5-5.8 4.5-6.4l1 6.4c-1.8.5-3.2 1.6-4.1 3.1-.7-.9-1.3-1.9-1.4-3.1zm6.3 4.9c-1.5.2-2.9-.2-4.1-1.1.7-1.3 1.9-2.3 3.4-2.7l.7 3.8zm-4.7 2.6c-.1-.9-.1-1.7.2-2.5 1.1.8 2.5 1.2 3.9 1.2.2 0 .5 0 .8-.1l.5 2.8c-1.4.3-2.7 1-3.6 1.9-1-.9-1.6-2-1.8-3.3zm7.4 13.9c-1.3.1-2.5-.2-3.6-.8.7-1 1.8-1.9 3.1-2.2l.5 3zm-1.5-9c-1.1 0-2.3-.3-3.2-.9.8-.7 1.7-1.2 2.8-1.4l.4 2.3zm-4.9 4.1c-.2-1.4.1-2.8.9-4 1.1.7 2.5 1.2 3.8 1.2H9l.6 3.5c-1.6.4-3 1.4-3.9 2.7-1-.9-1.6-2.1-1.8-3.4zm1.8 8.2c-.2-1 0-2.1.4-3 1.1.6 2.3 1 3.5 1 .3 0 .5-.1.9-.1l.6 3.5c-1.4.3-2.7 1-3.6 2-1-.9-1.6-2.1-1.8-3.4zm7.4 13.9c-1.3.2-2.6-.1-3.7-.8.8-1.1 1.9-1.9 3.2-2.2l.5 3zm-1.5-8.9c-1.2.1-2.3-.3-3.3-.9.8-.8 1.8-1.3 2.9-1.5l.4 2.4zm-4.9 4c-.2-1.4.1-2.8.9-4 1.1.8 2.4 1.2 3.8 1.2h.4l.6 3.4c-1.6.4-3 1.4-3.9 2.7-1-.8-1.6-2-1.8-3.3zm1.7 8.2c-.2-1.1 0-2.1.4-3 1.1.7 2.3 1 3.6 1 .3 0 .5 0 .9-.1l.6 3.4c-1.4.3-2.7 1-3.7 2-1-.9-1.6-2-1.8-3.3zm7.4 13.9c-1.3.1-2.6-.2-3.7-.8.7-1.1 1.9-1.9 3.2-2.2l.5 3zm-1.4-9c-1.2 0-2.3-.3-3.3-.9.8-.7 1.8-1.3 2.9-1.5l.4 2.4zm-5 4.1c-.2-1.4.1-2.8.9-4 1.1.7 2.5 1.2 3.8 1.2h.5l.6 3.5c-1.6.4-3 1.4-3.9 2.7-1.1-.9-1.7-2.1-1.9-3.4zm4.1 12c-1.3-.9-2.1-2.3-2.3-3.8-.2-1 0-2.1.4-3 1.1.6 2.3 1 3.5 1 .3 0 .6 0 .9-.1l1.1 7c-1.2 0-2.5-.3-3.6-1.1zm68.9-3.5c-1.4 2-4.1 3.2-8.5 3.9l-54.3 8.3-3.1-19c2.9-.2 5.6 1.9 6.1 4.9l1.2-.2c-.5-3.7-3.8-6.2-7.5-5.9l-1.1-7c2.8 0 5.2 2.1 5.6 5l1.2-.2c-.5-3.5-3.5-6-7-6l-1.3-7.8c2.9-.2 5.7 1.9 6.1 4.9L21 67c-.5-3.6-3.8-6.2-7.4-5.9l-1.1-7c1.2 0 2.5.4 3.5 1.1 1.2.9 2 2.3 2.2 3.8l1.2-.2c-.2-1.8-1.2-3.5-2.7-4.6-1.3-.9-2.8-1.4-4.4-1.4l-1.2-7.7c1.4-.1 2.8.3 3.9 1.1 1.2.9 2 2.3 2.2 3.8l1.2-.2c-.2-1.8-1.2-3.5-2.7-4.6-1.4-1-3.1-1.5-4.8-1.3l-1.1-7c2.8 0 5.3 2.1 5.7 5l1.2-.2c-.5-3.5-3.6-6-7-6l-1.3-7.8c3-.3 5.7 1.9 6.1 4.9l1.2-.2c-.5-3.7-3.8-6.2-7.5-5.9l-1-6.3c2.8 0 5.3 2 5.7 5l1.2-.2c-.5-3.5-3.6-6-7.1-6L5.5 10l54.3-8.3C68.4.4 71.7 2.8 73 11.4l10.8 65.7c.4 4.3 0 7.2-1.4 9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 25.7l4.2 26.5 44.7-7.1-4.2-26.5-44.7 7.1zm5.2 25.2l-3.8-24.2L63.2 20 67 44.2l-42.3 6.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.175 32.491l27.354-4.374.189 1.185-27.354 4.374zM30.175 39.092l27.354-4.374.19 1.185-27.354 4.374z"
  }));
};

IcoEmptystateSearch.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 85.1 99.8"
};

var IcoEmptystateSearchResults = function IcoEmptystateSearchResults(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M130.5 8.9c-.4-5.2-5.1-9.1-10.3-8.7L65.5 4.8 10.1.1H8.4C3.8.1.5 3.7.5 8.9v66.2c0 2 .7 3.8 1.8 5.3.2 4.6 4.1 8.3 8.8 8.3h108c4.9 0 9-3.8 9.5-8.6 1.2-1.6 1.8-3.5 1.8-5.6V9.7c.1-.3.1-.6.1-.8zm-129 0c0-4.6 2.8-7.8 6.9-7.8h1.7l44.2 3.8 10.3.9v.1h.4v-.1h.5V12c-.2 0-.3 0-.5.1-.2 0-.3.1-.5.1-2.8.7-4.9 3.1-5 6.1h1c.1-2.5 1.7-4.5 4-5.1.2 0 .3-.1.5-.1h.5v7.7c-.2 0-.3 0-.5.1-.2 0-.3.1-.5.1-2.8.7-4.9 3.1-5 6.1h1c.1-2.5 1.7-4.5 4-5.1.2 0 .3-.1.5-.1h.5v7.7c-.2 0-.3 0-.5.1-.2 0-.3.1-.5.1-2.8.7-4.9 3.1-5 6.1h1c.1-2.5 1.7-4.5 4-5.1.2 0 .3-.1.5-.1h.5v7.7c-.2 0-.3 0-.5.1-.2 0-.3.1-.5.1-2.8.7-4.9 3.1-5 6.1h1c.1-2.5 1.7-4.5 4-5.1.2 0 .3-.1.5-.1h.5V47c-.2 0-.3 0-.5.1-.2 0-.3.1-.5.1-2.8.7-4.9 3.1-5 6.1h1c.1-2.5 1.7-4.5 4-5.1.2 0 .3-.1.5-.1h.5v7.7c-.2 0-.3 0-.5.1-.2 0-.3.1-.5.1-2.8.7-4.9 3.1-5 6.1h1c.1-2.5 1.7-4.5 4-5.1.2 0 .3-.1.5-.1h.5v7.7c-.2 0-.3 0-.5.1-.2 0-.3.1-.5.1-2.8.7-4.9 3.1-5 6.1h1c.1-2.5 1.7-4.5 4-5.1.2 0 .3-.1.5-.1h.5v7.7c-.2 0-.3 0-.5.1-.2 0-.3.1-.5.1-2.8.7-4.9 3.1-5 6.1h1c.1-2.5 1.7-4.5 4-5.1.2 0 .3-.1.5-.1h.5v13.3h-1l-55.8-5c-2.2-.2-4.1-1.3-5.4-2.8-.4-.5-.7-1-1-1.5-.5-1-.8-2.2-.8-3.4V8.9zm120.2 74l-55.2 4.7V74.3c2.8.2 4.9 2.5 5 5.3h1c-.1-3.4-2.7-6-6-6.3v-7.7c2.8.2 4.9 2.5 5 5.3h1c-.1-3.4-2.7-6-6-6.3v-7.7c2.8.2 4.9 2.5 5 5.3h1c-.1-3.4-2.7-6-6-6.3v-7.7c2.8.2 4.9 2.5 5 5.3h1c-.1-3.4-2.7-6-6-6.3v-7.7c2.8.2 4.9 2.5 5 5.3h1c-.1-3.4-2.7-6-6-6.3v-7.7c2.8.2 4.9 2.5 5 5.3h1c-.1-3.4-2.7-6-6-6.3v-7.7c2.8.2 4.9 2.5 5 5.3h1c-.1-3.4-2.7-6-6-6.3v-7.7c2.8.2 4.9 2.5 5 5.3h1c-.1-3.4-2.7-6-6-6.3V5.8l10.3-.9 43.5-3.7c4.7-.4 8.8 3.1 9.2 7.8v65.4c0 1.3-.3 2.5-.8 3.6-.3.6-.6 1.2-1 1.7-1.4 1.8-3.5 3-6 3.2zM11.2 87.7c-3.7 0-6.9-2.6-7.7-6.1 1.4 1.2 3.2 2 5.1 2.2l45.6 3.9h-43zm108 0H76.8l45-3.8c2.2-.2 4.1-1.1 5.6-2.4-1 3.6-4.3 6.2-8.2 6.2z"
  }));
};

IcoEmptystateSearchResults.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 131 89"
};

var IcoKeychain = function IcoKeychain(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.251 7.47C7.828 6.288 6.69 4.958 6.047 3.725c-.559-1.07-.671-1.965-.3-2.394.202-.233.567-.352 1.046-.352.401 0 .881.083 1.414.248 1.347.42 2.872 1.301 4.295 2.483 1.423 1.18 2.561 2.51 3.204 3.744.008.016.011.027.019.042a6.512 6.512 0 0 0-1.922-.29 6.446 6.446 0 0 0-3.529 1.046 16.423 16.423 0 0 1-1.023-.782zm6.221 6.266c1.068 0 1.936-.852 1.936-1.898 0-.547-.241-1.037-.62-1.384a1.945 1.945 0 0 0-.975-.479 1.952 1.952 0 0 0-.341-.034c-.322 0-.621.085-.889.222a5.276 5.276 0 0 1-1.037-.211c-.761-.237-1.581-.635-2.406-1.139a5.509 5.509 0 0 1 5.007-.16c.38.18.738.397 1.064.654 1.247.98 2.048 2.482 2.048 4.166 0 2.949-2.447 5.346-5.456 5.346-3.008 0-5.455-2.397-5.455-5.346 0-1.621.743-3.074 1.911-4.055 1.015.656 2.036 1.173 2.985 1.467.173.055.332.083.497.122a1.84 1.84 0 0 0-.205.83c0 1.047.869 1.899 1.936 1.899zm-.511-2.556a2.91 2.91 0 0 0 1.051-.176c.286.178.487.477.487.834 0 .555-.46 1.006-1.027 1.006-.566 0-1.027-.45-1.027-1.006 0-.264.11-.5.28-.68.077.005.162.022.236.022zM2.962 23.9v2.178H.94v-2.402l7.283-7.137a6.338 6.338 0 0 0 2.451 2.403l-2.838 2.78H5.185V23.9H2.962zM17.045 8.08a6.396 6.396 0 0 0-.448-1.072c-.702-1.346-1.927-2.784-3.449-4.046C11.627 1.7 9.98.752 8.509.294 6.896-.207 5.644-.064 4.984.698c-.659.762-.598 1.996.172 3.474.702 1.345 1.927 2.782 3.449 4.045.283.235.574.448.865.66-1.265 1.146-2.063 2.78-2.063 4.596 0 .732.127 1.447.379 2.13L0 23.231V27h3.903v-2.178h2.223v-2.177h2.163l3.341-3.274c.696.245 1.427.37 2.173.37 3.527 0 6.397-2.812 6.397-6.268 0-2.296-1.271-4.301-3.155-5.393z"
  }));
};

IcoKeychain.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20.2000008 27"
};

var IcoEmptystateSharedReports = function IcoEmptystateSharedReports(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M69.5 13H54.551l-.002-5.021a6.985 6.985 0 0 1 4.086-6.351A7.127 7.127 0 0 1 61.555 1h.936C66.355 1 69.5 4.102 69.5 7.915V13zm-16-5.085l.062 33.918a.464.464 0 0 0-.013.112L53.518 58H53.5v5.085c0 2.174-1.033 4.111-2.64 5.378.08-.061.172-.107.249-.172-.089.076-.193.134-.286.205.013-.01.025-.022.037-.033-.139.107-.29.2-.434.3a6.78 6.78 0 0 1-1.283.705.255.255 0 0 1-.036.012 7.052 7.052 0 0 1-1.842.469c-.199.022-.4.035-.601.04-.073.002-.144.011-.219.011h-.936c-3.864 0-7.009-3.103-7.009-6.915V58h.016v-.5a.5.5 0 0 0-.5-.5l-.008.016L38 57H16.438l-.006-37.903a.415.415 0 0 0 .006-.079V7.979C16.438 4.131 19.556 1 23.387 1h34.259C55.176 2.354 53.5 4.944 53.5 7.915zm-4.933 61.759c.114-.036.224-.079.335-.119-.111.04-.221.083-.335.119zM8.5 70h-.452C4.162 70 1 66.9 1 63.091V58h36.5v5.085c0 2.971 1.667 5.561 4.122 6.915H8.5zM62.491 0h-.936l-.044.002L61.5 0H23.387c-4.383 0-7.949 3.58-7.949 7.979v10.959a.528.528 0 0 0-.006.08L15.438 57H.5a.5.5 0 0 0-.5.5v5.591C0 67.452 3.61 71 8.048 71h38.585c.174 0 .344-.023.515-.035l.146-.01a7.925 7.925 0 0 0 5.78-3.329c.083-.116.157-.239.236-.36.061-.1.132-.192.191-.294l.002-.005.022-.034.054-.092c.03-.055.058-.112.124-.251.009-.018.014-.035.023-.053a7.775 7.775 0 0 0 .661-1.908v-.001l.036-.229c.029-.169.057-.337.077-.515l.001-.003a8.14 8.14 0 0 0 .048-.86L54.551 14H70a.5.5 0 0 0 .5-.5V7.915C70.5 3.551 66.907 0 62.491 0z"
  }));
};

IcoEmptystateSharedReports.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 71 71"
};

var IcoEmptystateSnoozed = function IcoEmptystateSnoozed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M75.39 30.136c3.325-3.316 5.19-7.933 5.107-12.735-.08-4.734-1.958-9.112-5.289-12.328C72.075 2.048 67.98.411 63.726.503c-4.962.09-9.55 2.474-12.63 6.532A37.133 37.133 0 0 0 40.502 5.5H40.5c-3.641 0-7.2.527-10.595 1.536C26.824 2.977 22.237.594 17.275.502 13.008.413 8.926 2.047 5.792 5.073 2.461 8.29.582 12.667.502 17.401c-.081 4.802 1.784 9.42 5.108 12.736A37.028 37.028 0 0 0 3.5 42.5c0 9.803 3.79 19.02 10.671 25.988l-2.649 8.62.956.292 2.498-8.128C21.888 75.869 30.912 79.5 40.5 79.5c9.532 0 18.507-3.59 25.403-10.115l2.463 8.015.955-.293-2.61-8.496C73.667 61.63 77.5 52.36 77.5 42.5a37.03 37.03 0 0 0-2.11-12.364zM63.743 1.502c4.036-.088 7.83 1.451 10.77 4.291 3.14 3.03 4.909 7.159 4.984 11.625.075 4.375-1.569 8.58-4.501 11.678a36.905 36.905 0 0 0-8.335-12.76 36.82 36.82 0 0 0-14.54-8.972c2.89-3.64 7.087-5.778 11.622-5.862zM1.503 17.418c.075-4.467 1.845-8.595 4.983-11.626 2.942-2.839 6.79-4.373 10.77-4.29 4.537.084 8.734 2.223 11.624 5.863a36.825 36.825 0 0 0-14.54 8.973 36.893 36.893 0 0 0-8.335 12.758c-2.933-3.098-4.577-7.303-4.503-11.678zm64.451 50.538l-.09.086-.289.275C58.82 74.883 49.94 78.5 40.5 78.5c-9.496 0-18.426-3.657-25.195-10.296l.017-.058-.115-.035c-.053-.053-.11-.102-.164-.156C8.244 61.156 4.5 52.116 4.5 42.5c0-9.616 3.746-18.656 10.546-25.455C21.845 10.245 30.884 6.5 40.5 6.5h.002c9.614 0 18.654 3.744 25.452 10.542 6.8 6.8 10.546 15.842 10.546 25.458s-3.745 18.656-10.546 25.456z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.318 44.5v-23h-1v24h21.69v-1z"
  }));
};

IcoEmptystateSnoozed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 81 80"
};

var IcoEmptystateViews = function IcoEmptystateViews(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v46h71V0H0zm70 45H1V1h69v44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8 43H68V7H3v36h13.8zm0-1v-5.5h11.8V42H16.8zm24.6-12.5v6H29.6v-6h11.8zm-11.8-1v-6h11.8v6H29.6zm12.8 1h11.8v6H42.4v-6zm0-1v-6h11.8v6H42.4zm0-7v-6h11.8v6H42.4zm-1 0H29.6v-6h11.8v6zm-12.8 0H16.8v-6h11.8v6zm0 1v6H16.8v-6h11.8zm0 7v6H16.8v-6h11.8zm1 12.5v-5.5h11.8V42H29.6zm12.8 0v-5.5h11.8V42H42.4zM67 42H55.2v-5.5H67V42zm0-6.5H55.2v-6H67v6zm0-7H55.2v-6H67v6zm0-7H55.2v-6H67v6zM67 8v6.5H55.2V8H67zM54.2 8v6.5H42.4V8h11.8zM41.4 8v6.5H29.6V8h11.8zM28.6 8v6.5H16.8V8h11.8zM4 8h11.8v6.5H4V8zm0 7.5h11.8v6H4v-6zm0 7h11.8v6H4v-6zm0 7h11.8v6H4v-6zM4 42v-5.5h11.8V42H4z"
  }));
};

IcoEmptystateViews.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 71 46.0004883"
};

var IcoEmptystateExtraInfo = function IcoEmptystateExtraInfo(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "form"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 0h76a4 4 0 0 1 4 4v92a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fill: "#EEF1F3"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEB6BA",
    d: "M8.096 17h29.35v2H8.096zM8.096 36h12.145v2H8.096zM8.096 56h29.35v2H8.096zM8.096 76h25.302v2H8.096zM8.096 22H49.59v2H8.096zM8.096 42H29.35v2H8.096zM8.096 62h62.747v2H8.096zM8.096 82h46.555v2H8.096z"
  })));
};

IcoEmptystateExtraInfo.defaultProps = {
  width: "84",
  height: "100",
  viewBox: "0 0 84 100",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoEmptystateListEmpty = function IcoEmptystateListEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "assigned"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#30ABE5",
    y: "9",
    width: "74",
    height: "92",
    rx: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F4F6F7",
    x: "4",
    y: "13",
    width: "66",
    height: "84",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 6h21a7.5 7.5 0 0 1 7.5 7.5V18H19v-4.5A7.5 7.5 0 0 1 26.5 6z",
    fill: "#E02A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 4h21a7.5 7.5 0 0 1 7.5 7.5V16H19v-4.5A7.5 7.5 0 0 1 26.5 4z",
    fill: "#FF5F5F"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FF5F5F",
    strokeWidth: "4",
    cx: "37",
    cy: "5",
    r: "5"
  })));
};

IcoEmptystateListEmpty.defaultProps = {
  width: "74",
  height: "103",
  viewBox: "0 0 74 103",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoEmptystateListFull = function IcoEmptystateListFull(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "assigned"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#30ABE5",
    y: "9",
    width: "74",
    height: "92",
    rx: "4"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#F4F6F7",
    x: "4",
    y: "13",
    width: "66",
    height: "84",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEB6BA",
    d: "M14 33h10v7H14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18 37h2v3.005h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F5F",
    d: "M12 33l7-5 7 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEB6BA",
    d: "M14 53h10v7H14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18 57h2v3.005h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F5F",
    d: "M12 53l7-5 7 5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEB6BA",
    d: "M14 73h10v7H14z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M18 77h2v3.005h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F5F",
    d: "M12 73l7-5 7 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 35h21.702M29.5 55h17.702M29.5 75h27.702",
    stroke: "#7A8489",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 6h21a7.5 7.5 0 0 1 7.5 7.5V18H19v-4.5A7.5 7.5 0 0 1 26.5 6z",
    fill: "#E02A2A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.5 4h21a7.5 7.5 0 0 1 7.5 7.5V16H19v-4.5A7.5 7.5 0 0 1 26.5 4z",
    fill: "#FF5F5F"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#FF5F5F",
    strokeWidth: "4",
    cx: "37",
    cy: "5",
    r: "5"
  })));
};

IcoEmptystateListFull.defaultProps = {
  width: "74",
  height: "103",
  viewBox: "0 0 74 103",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoFilterBoolean = function IcoFilterBoolean(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16h-11A2.503 2.503 0 0 1 0 13.5v-11C0 1.122 1.122 0 2.5 0h11C14.879 0 16 1.122 16 2.5v11c0 1.379-1.121 2.5-2.5 2.5zM2.5 1C1.673 1 1 1.673 1 2.5v11c0 .827.673 1.5 1.5 1.5h11c.827 0 1.5-.673 1.5-1.5v-11c0-.827-.673-1.5-1.5-1.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 10c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2c0 1.102-.898 2-2 2zM5 10c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2c0 1.102-.897 2-2 2zm0-3c-.551 0-1 .449-1 1s.449 1 1 1 1-.449 1-1-.449-1-1-1z"
  }));
};

IcoFilterBoolean.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};

var IcoFilterDate = function IcoFilterDate(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 1H11V0h-1v1H6V0H5v1H2.5A2.503 2.503 0 0 0 0 3.5v10C0 14.879 1.122 16 2.5 16h11c1.379 0 2.5-1.121 2.5-2.5v-10C16 2.122 14.879 1 13.5 1zM15 13.5c0 .827-.673 1.5-1.5 1.5h-11c-.827 0-1.5-.673-1.5-1.5V7h14v6.5zM1 6V3.5C1 2.673 1.673 2 2.5 2H5v1h1V2h4v1h1V2h2.5c.827 0 1.5.673 1.5 1.5V6H1z"
  }));
};

IcoFilterDate.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};

var IcoFilterNumber = function IcoFilterNumber(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16h-11A2.503 2.503 0 0 1 0 13.5v-11C0 1.122 1.122 0 2.5 0h11C14.879 0 16 1.122 16 2.5v11c0 1.379-1.121 2.5-2.5 2.5zM2.5 1C1.673 1 1 1.673 1 2.5v11c0 .827.673 1.5 1.5 1.5h11c.827 0 1.5-.673 1.5-1.5v-11c0-.827-.673-1.5-1.5-1.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.202 9.639L8.722 12H8.26a.297.297 0 0 1-.223-.095.34.34 0 0 1-.088-.287.884.884 0 0 1 .008-.048l.406-1.932h-1.41l-.406 1.982c-.03.138-.088.236-.174.294a.514.514 0 0 1-.294.086h-.451l.485-2.361H5.28a.304.304 0 0 1-.206-.065C5.024 9.531 5 9.458 5 9.354a.73.73 0 0 1 .012-.129l.045-.318h1.165l.37-1.82H5.269l.075-.413a.367.367 0 0 1 .13-.24c.07-.052.178-.078.326-.078h.902l.411-1.999a.427.427 0 0 1 .157-.262A.467.467 0 0 1 7.563 4h.457l-.48 2.356h1.41L9.43 4h.451c.095 0 .174.028.237.084a.278.278 0 0 1 .094.217c0 .03-.002.054-.005.073L9.79 6.356H11l-.074.419c-.02.108-.064.187-.134.237s-.178.075-.323.075h-.788l-.37 1.82h1.021c.091 0 .162.022.211.065s.075.118.075.226a.636.636 0 0 1-.012.122l-.051.319H9.202zM7.06 8.907h1.41l.371-1.82h-1.41l-.371 1.82z"
  }));
};

IcoFilterNumber.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};

var IcoFilterPeople = function IcoFilterPeople(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16h-11A2.503 2.503 0 0 1 0 13.5v-11C0 1.122 1.122 0 2.5 0h11C14.879 0 16 1.122 16 2.5v11c0 1.379-1.121 2.5-2.5 2.5zM2.5 1C1.673 1 1 1.673 1 2.5v11c0 .827.673 1.5 1.5 1.5h11c.827 0 1.5-.673 1.5-1.5v-11c0-.827-.673-1.5-1.5-1.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.575 15.264l-1.238-2c-.12-.17-.956-1.172-4.162-1.943l-.383-.092v-.394c0-.682-.066-1.098-.067-1.102l-.033-.203.12-.17a5.911 5.911 0 0 0 .94-2.905c.022-1.277-.594-1.904-1.881-1.952-1.276.048-1.904.676-1.884 1.918.066 1.697.932 2.928.941 2.94l.12.167-.033.206c0 .004-.067.42-.067 1.101v.394l-.383.092c-3.081.742-3.964 1.676-4.162 1.946L1.45 15.22l-.898-.442 1-2.029c.423-.589 1.49-1.55 4.404-2.307.01-.293.03-.521.047-.671-.275-.44-.95-1.675-1.014-3.277-.03-1.853 1.021-2.923 2.883-2.992 1.875.07 2.912 1.139 2.883 2.933a7.034 7.034 0 0 1-1.016 3.336c.017.15.037.377.047.67 2.963.77 4.019 1.745 4.386 2.27l1.254 2.024-.85.528z"
  }));
};

IcoFilterPeople.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};

var IcoFilterSelection = function IcoFilterSelection(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16h-11A2.503 2.503 0 0 1 0 13.5v-11C0 1.122 1.122 0 2.5 0h11C14.879 0 16 1.122 16 2.5v11c0 1.379-1.121 2.5-2.5 2.5zM2.5 1C1.673 1 1 1.673 1 2.5v11c0 .827.673 1.5 1.5 1.5h11c.827 0 1.5-.673 1.5-1.5v-11c0-.827-.673-1.5-1.5-1.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4.5h8v1H4zM4 7.5h8v1H4zM4 10.5h8v1H4z"
  }));
};

IcoFilterSelection.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};

var IcoFilterString = function IcoFilterString(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16h-11A2.503 2.503 0 0 1 0 13.5v-11C0 1.122 1.122 0 2.5 0h11C14.879 0 16 1.122 16 2.5v11c0 1.379-1.121 2.5-2.5 2.5zM2.5 1C1.673 1 1 1.673 1 2.5v11c0 .827.673 1.5 1.5 1.5h11c.827 0 1.5-.673 1.5-1.5v-11c0-.827-.673-1.5-1.5-1.5h-11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.276 4v1.215H8.883v6.738h-1.48V5.215H5V4z"
  }));
};

IcoFilterString.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};

var IcoFilterTime = function IcoFilterTime(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.045 3.955h-1V9.5h5.092v-1H8.045z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 0h-11A2.503 2.503 0 0 0 0 2.5v11C0 14.879 1.122 16 2.5 16h11c1.379 0 2.5-1.121 2.5-2.5v-11C16 1.122 14.879 0 13.5 0zM15 13.5c0 .827-.673 1.5-1.5 1.5h-11c-.827 0-1.5-.673-1.5-1.5v-11C1 1.673 1.673 1 2.5 1h11c.827 0 1.5.673 1.5 1.5v11z"
  }));
};

IcoFilterTime.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
};

var IcoFinderBoard = function IcoFinderBoard(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F4F6F7",
    stroke: "#7A8489",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3",
    d: "M67.344 4v8.054H36.656V4H4v71h96V4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D1D8DB",
    d: "M53.383 23.437l-.834 1.31a12.551 12.551 0 0 0-11.298 1.368 12.607 12.607 0 0 0-3.114 2.97l1.4 1.05A10.812 10.812 0 0 1 51.58 26.27l-.745 1.17 5.72.855-3.171-4.858zm26.926 21.884l-1.522-.31a12.551 12.551 0 0 1-8.833 7.177 12.607 12.607 0 0 1-4.3.176l.22-1.736a10.812 10.812 0 0 0 11.144-5.977l-1.36-.278 3.36-4.708 1.29 5.656z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: "32",
    height: "12",
    x: "36",
    y: "5",
    fill: "#D1D8DB",
    rx: "2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F6F7",
    stroke: "#7A8489",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3",
    d: "M37 0h30v12H37z"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#FF5F5F",
    fontFamily: "Nunito-Bold, Nunito",
    fontSize: "10",
    fontWeight: "bold",
    letterSpacing: ".138"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "18",
    y: "36"
  }, "-30%")), /*#__PURE__*/React.createElement("text", {
    fill: "#72D28F",
    fontFamily: "Nunito-Bold, Nunito",
    fontSize: "10",
    fontWeight: "bold",
    letterSpacing: ".138"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "37",
    y: "54"
  }, "+15%")), /*#__PURE__*/React.createElement("text", {
    fill: "#72D28F",
    fontFamily: "Nunito-Bold, Nunito",
    fontSize: "10",
    fontWeight: "bold",
    letterSpacing: ".138"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "60",
    y: "31"
  }, "+10%")), /*#__PURE__*/React.createElement("path", {
    stroke: "#7A8489",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3",
    d: "M78 113L67.369 81H35.63L25 113m7-18.5h39"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEB6BA",
    stroke: "#7A8489",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "3",
    d: "M101.033 75H2.967C1.327 75 0 76.308 0 77.923v.154C0 79.692 1.327 81 2.967 81h98.066c1.64 0 2.967-1.308 2.967-2.923v-.154c0-1.615-1.327-2.923-2.967-2.923z"
  })));
};

IcoFinderBoard.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "108",
  height: "117",
  viewBox: "0 0 108 117"
};

var IcoMap = function IcoMap(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.59 0C4.303 0 0 4.302 0 9.589c0 6.61 8.105 15.456 9.87 16.73 1.798-1.432 9.313-11.02 9.313-16.73C19.182 4.302 14.879 0 9.59 0zm-.048 13.795c-2.651 0-4.808-2.107-4.808-4.698 0-2.592 2.157-4.7 4.808-4.7s4.808 2.108 4.808 4.7c0 2.59-2.158 4.698-4.808 4.698z"
  }));
};

IcoMap.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19.1826172 26.3193359"
};

var IcoMultiRate = function IcoMultiRate(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#D1D8DB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.918 18A1.08 1.08 0 0 0 18 16.919V2.081A1.08 1.08 0 0 0 16.92 1H2.08A1.08 1.08 0 0 0 1 2.081v14.836a1.08 1.08 0 0 0 1.081 1.081L16.918 18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.98 5.218a.374.374 0 0 1-.169-.313v.313H3.603v-.313c0 .13-.066.246-.168.313H3.23a.38.38 0 0 1 .15.03.373.373 0 0 1-.15.032h.206a.374.374 0 0 1 .168.312V5.28h3.208v.312c0-.13.067-.245.168-.312h.207a.372.372 0 0 1-.15-.031.373.373 0 0 1 .15-.031H6.98zM5.18 3.65v3.21h-.32c.136 0 .255.073.32.18v.194c0-.049.01-.096.028-.14a.387.387 0 0 1 .027.14v-.193a.374.374 0 0 1 .32-.18h-.32V3.65h.32a.375.375 0 0 1-.32-.181v-.194a.38.38 0 0 1-.027.14.373.373 0 0 1-.027-.14v.194a.374.374 0 0 1-.32.18h.32zm10.41 1.571a.374.374 0 0 1-.168-.312v.312h-3.207v-.312c0 .13-.066.245-.167.312h-.207c.053 0 .104.011.15.031a.372.372 0 0 1-.15.032h.207c.1.067.167.181.167.311v-.311h3.207v.311c0-.13.067-.244.167-.311h.208a.372.372 0 0 1-.15-.032.373.373 0 0 1 .15-.031h-.207zm-9.1 7.256a.373.373 0 0 1 .078-.115l-.134.134a.376.376 0 0 1-.354-.096l.225.225-.799.798-.31.31-1.114-1.115.219-.218a.373.373 0 0 1-.337.1l-.147-.147a.388.388 0 0 1 .084.129.374.374 0 0 1-.128-.084l.147.146a.374.374 0 0 1-.099.334l.217-.216.8.8.353.352.044-.044-.038-.037-1.162 1.162-.226-.227a.375.375 0 0 1 .099.354l-.135.134a.368.368 0 0 1 .116-.077.373.373 0 0 1-.08.118l.137-.137a.375.375 0 0 1 .353.1l-.226-.227.808-.81.31-.308 1.114 1.114-.22.22a.374.374 0 0 1 .34-.101l.145.146a.376.376 0 0 1-.084-.128c.047.018.09.046.127.083l-.145-.145a.373.373 0 0 1 .102-.34l-.22.221-.8-.799-.315-.316 1.108-1.108.228.227a.375.375 0 0 1-.1-.355l.135-.135a.37.37 0 0 1-.115.078zM4.3 12.4l.002-.002-.001.002zm1.78 0a.384.384 0 0 1-.004-.004l.004.004zm9.51 2.153a.374.374 0 0 1-.168-.312v.312h-3.207v-.312c0 .13-.066.245-.168.312h-.206a.38.38 0 0 1 .15.031.373.373 0 0 1-.15.031h.206a.374.374 0 0 1 .168.313v-.313h3.207v.313c0-.13.067-.246.169-.313h.206a.373.373 0 0 1-.15-.03.373.373 0 0 1 .15-.032h-.206zm0-1.569a.374.374 0 0 1-.168-.312v.312h-3.207v-.312c0 .13-.066.245-.167.312h-.207c.053 0 .104.011.15.031a.373.373 0 0 1-.15.032h.207c.1.067.167.181.167.311v-.311h3.207v.311c0-.13.067-.244.167-.311h.208a.373.373 0 0 1-.15-.032.373.373 0 0 1 .15-.031h-.207zm-5.832 4.919V1M1 9.758h16.902"
  })));
};

IcoMultiRate.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "19",
  viewBox: "0 0 19 19"
};

var IcoNotice = function IcoNotice(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.701 0 0 4.701 0 10.5S4.701 21 10.5 21 21 16.299 21 10.5 16.299 0 10.5 0zm-.923 5.53h1.885v3.717c0 .4-.024.795-.071 1.187-.048.392-.11.792-.189 1.199H9.837c-.078-.407-.14-.807-.189-1.2a9.873 9.873 0 0 1-.07-1.186V5.53zm1.98 8.888c-.059.137-.14.255-.245.354a1.17 1.17 0 0 1-.812.319c-.165 0-.316-.028-.455-.084a1.088 1.088 0 0 1-.601-.589c-.059-.136-.088-.282-.088-.439a1.076 1.076 0 0 1 .329-.786 1.145 1.145 0 0 1 .815-.325 1.175 1.175 0 0 1 .813.325 1.082 1.082 0 0 1 .331.786c0 .157-.03.303-.087.439z"
  }));
};

IcoNotice.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
};

var IcoNoticeOutline = function IcoNoticeOutline(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.85 7.15h1.3v-3.9h-1.3v3.9zm0 2.6h1.3v-1.3h-1.3v1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0C2.916 0 0 2.916 0 6.5S2.916 13 6.5 13 13 10.084 13 6.5 10.084 0 6.5 0zm0 12A5.507 5.507 0 0 1 1 6.5C1 3.467 3.467 1 6.5 1 9.532 1 12 3.467 12 6.5 12 9.532 9.532 12 6.5 12z"
  }));
};

IcoNoticeOutline.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13 13"
};

var IcoPayment = function IcoPayment(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.627 5.838c0 .434.077.805.231 1.113.154.308.364.572.63.793s.573.41.92.567.715.303 1.107.435l.294-5.796c-.532.028-.996.126-1.391.294-.396.168-.727.384-.993.646s-.465.562-.598.898c-.133.336-.2.686-.2 1.05zm6.689 7.077c0-.462-.087-.854-.263-1.176a2.55 2.55 0 0 0-.703-.819 4.213 4.213 0 0 0-1.013-.562 18.5 18.5 0 0 0-1.202-.425l-.326 6.479a4.37 4.37 0 0 0 1.496-.342 3.39 3.39 0 0 0 1.103-.756c.297-.311.523-.672.677-1.081s.231-.849.231-1.318zm-4.221 4.337c-.896-.042-1.677-.235-2.341-.578S.503 15.88 0 15.32l.283-.41c.085-.105.182-.158.294-.158.063 0 .142.039.237.116.094.077.208.173.341.289s.29.241.472.378c.182.136.394.266.636.388s.516.23.824.32.658.147 1.05.168l.336-6.678c-.476-.147-.94-.311-1.391-.493s-.854-.415-1.208-.698-.639-.634-.856-1.05-.325-.94-.325-1.57c0-.483.091-.95.273-1.402s.45-.854.803-1.207.79-.639 1.307-.856c.518-.217 1.11-.336 1.775-.357L4.946.336a.412.412 0 0 1 .089-.241C5.087.03 5.162 0 5.26 0h.378l-.116 2.11c.707.05 1.327.205 1.859.468A5.5 5.5 0 0 1 8.84 3.633l-.231.357c-.07.119-.161.178-.273.178-.084 0-.194-.057-.33-.173a4.969 4.969 0 0 0-.536-.383c-.22-.14-.494-.275-.82-.404s-.715-.212-1.17-.247l-.304 6.006c.329.105.66.213.992.326.332.112.65.238.955.378.305.14.586.3.845.483.26.182.485.397.678.645.192.249.343.532.451.85.109.32.163.689.163 1.109 0 .602-.102 1.169-.305 1.7s-.495 1-.876 1.402-.85.727-1.407.972-1.192.385-1.906.42l-.115 2.215a.399.399 0 0 1-.09.231.265.265 0 0 1-.215.095h-.378l.126-2.541z"
  }));
};

IcoPayment.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9.261 19.7925"
};

var IcoPaymentFailed = function IcoPaymentFailed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M94 42.4V10.8C94 4.8 89.2 0 83.2 0H10.8C4.8 0 0 4.8 0 10.8v47.5C0 64.2 4.8 69 10.8 69h61.3c3.2 4.8 8.7 8 14.9 8 9.9 0 18-8.1 18-18 0-7.4-4.5-13.8-11-16.6zM1.4 10.8c.1-5.1 4.2-9.2 9.3-9.2h72.5c5.1 0 9.2 4.1 9.2 9.2v3.4h-91v-3.4zm9.4 56.7c-5.1 0-9.2-4.1-9.2-9.2V30.8h91v11.1c-1.8-.6-3.7-.9-5.6-.9-9.9 0-18 8.1-18 18 0 3.1.8 6 2.2 8.5H10.8zm76.2 8c-5.3 0-10-2.5-13.1-6.5-.4-.5-.7-1-1-1.5-1.5-2.5-2.4-5.4-2.4-8.5 0-9.1 7.4-16.5 16.5-16.5 1.9 0 3.8.4 5.5 1l1.5.6c5.6 2.6 9.5 8.3 9.5 14.9 0 9.1-7.4 16.5-16.5 16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4 51.3L87 57.7l-6.4-6.4-1.3 1.3 6.4 6.4-6.4 6.4 1.3 1.3 6.4-6.4 6.4 6.4 1.3-1.3-6.4-6.4 6.4-6.4z"
  }));
};

IcoPaymentFailed.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 105 77"
};

var IcoPaymentsCash = function IcoPaymentsCash(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.654 10.74V9.175c.296.011.511.124.646.341a.959.959 0 0 1 .132.421h.563c-.01-.363-.13-.655-.359-.877-.228-.222-.555-.347-.982-.377v-.42h-.305v.426c-.432.005-.766.138-1.006.4a1.274 1.274 0 0 0-.358.88c0 .365.11.65.333.856.222.206.565.352 1.03.44v1.753c-.363-.03-.61-.166-.744-.408-.076-.135-.123-.35-.14-.644h-.569c0 .37.061.661.183.878.223.402.647.622 1.27.663v.623h.306v-.623c.388-.043.685-.13.89-.263.372-.24.557-.646.557-1.216 0-.395-.144-.693-.434-.895-.178-.122-.516-.253-1.013-.391zm-.305-.06c-.24-.048-.432-.132-.573-.252s-.213-.286-.213-.498a.83.83 0 0 1 .18-.505c.12-.16.322-.247.606-.258v1.512zm1.064 1.951c-.14.251-.392.385-.76.403V11.34c.269.074.46.15.574.232.196.14.295.344.295.611 0 .17-.036.318-.109.447z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.87 7.328l2.527-3h-3.253l2.774-3.303h-8.607L20.136 0H11.87l-.825 1.025h-4.85L0 8.4h3.166L.259 11.328h2.98l-2.822 3h2.821l-2.947 3h6.186v1.337h7.982v-1.462h8.156l5.624-6.875H25.87l2.4-3h-2.4zm.374-2l-4.096 4.875H14.46V8.4h7.264l2.58-3.072h1.941zm-.473-3.303L21.256 7.4h-6.797v-.344l4.047-5.03h7.265zM6.477 16.328H2.652l2-2h1.825v2zm0-3H2.652l2-2h1.825v2zm0-3H2.652L4.58 8.4h1.897v1.928zm0-2.928h-4.33l4.515-5.375h3.578L6.477 6.703V7.4zm6.982-.697v10.962H7.477V7.055L12.348 1h5.7l-4.589 5.703zm12.785 4.625l-4.096 4.875H14.46v-2h8.156l2.415-2.875h1.214zm-4.096 1.875H14.46v-2h8.156l2.415-2.875h1.214l-4.096 4.875z"
  }));
};

IcoPaymentsCash.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 28.3967896 18.6645508"
};

var IcoPaymentsCreditCard = function IcoPaymentsCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 0h-21A2.503 2.503 0 0 0 0 2.5v14C0 17.879 1.122 19 2.5 19h21c1.379 0 2.5-1.121 2.5-2.5v-14C26 1.122 24.879 0 23.5 0zM25 16.5c0 .827-.673 1.5-1.5 1.5h-21c-.827 0-1.5-.673-1.5-1.5v-9h24v9zm0-11H1v-3C1 1.673 1.673 1 2.5 1h21c.827 0 1.5.673 1.5 1.5v3z"
  }));
};

IcoPaymentsCreditCard.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 19"
};

var IcoPaymentsEcheck = function IcoPaymentsEcheck(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14 16h8v1h-8zM4 16h8v1H4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 6h-.916l2.129-2.129c.695-.74.7-1.945-.017-2.713-.784-.732-2-.721-2.714.017l-.388.389-.467-.457a.703.703 0 0 0-.524-.302.778.778 0 0 0-.622.232L17.498 3.55l.711.703 2.318-2.345.362.36-.336.336c-.033.029-.07.051-.1.082L17.15 6H2.5A2.503 2.503 0 0 0 0 8.5v9C0 18.879 1.122 20 2.5 20h21c1.379 0 2.5-1.121 2.5-2.5v-9C26 7.122 24.879 6 23.5 6zm-.808-4.121l.007-.007c.332-.346.936-.337 1.29-.008.333.36.331.965.006 1.31l-.335.336a1.854 1.854 0 0 0-.491-.824 1.778 1.778 0 0 0-.791-.492l.314-.315zM17.58 7l.998-1 2.644-2.648c.183-.156.404-.244.636-.248.227.007.433.101.58.265l.03.03a.866.866 0 0 1 .275.635.89.89 0 0 1-.293.652L21.146 6l-.992 1-1.985 2h-.58a1.897 1.897 0 0 0-.294-.419 1.989 1.989 0 0 0-.812-.483L17.58 7zm-.76 3a.95.95 0 0 1-.218.552c-.033.017-.068.03-.096.055l-1.962.716L15.01 10l.23-.656.07-.07.004-.003a.797.797 0 0 1 .58-.267.908.908 0 0 1 .686.276.94.94 0 0 1 .24.72zM25 17.5c0 .827-.673 1.5-1.5 1.5h-21c-.827 0-1.5-.673-1.5-1.5v-9C1 7.673 1.673 7 2.5 7h13.655l-.836.84-.646.646a14.53 14.53 0 0 0-.103.108.496.496 0 0 0-.221.268L14.3 9H4v1h9.949l-.699 1.99V12H4v1h18.03v-1h-6.421l1.378-.503a.44.44 0 0 0 .144-.097c.006-.006.016-.009.022-.015l.01-.007.001-.001a.482.482 0 0 0 .136-.094c.012-.013.02-.028.032-.041l.013-.01c.014-.014.03-.021.044-.036L18.586 10h3.444V9h-2.444l2-2H23.5c.827 0 1.5.673 1.5 1.5v9z"
  }));
};

IcoPaymentsEcheck.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 20"
};

var IcoPaymentsExpenses = function IcoPaymentsExpenses(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.378 13.73c-1.643 0-2.98 1.322-2.98 2.945 0 1.624 1.337 2.945 2.98 2.945s2.98-1.321 2.98-2.945c0-1.623-1.337-2.945-2.98-2.945zm0 4.89c-1.091 0-1.98-.873-1.98-1.945s.889-1.945 1.98-1.945c1.092 0 1.98.872 1.98 1.945s-.888 1.945-1.98 1.945z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.959 15.914l-8.775-4.677 8.778-4.756a.498.498 0 0 0 .108-.8 3.522 3.522 0 0 0-4.068-.458h-.001l-7.074 3.812-5.83-3.164a4.63 4.63 0 0 0 .107-.989C10.204 2.315 8.09.227 5.49.227S.773 2.315.773 4.882 2.89 9.537 5.49 9.537a4.73 4.73 0 0 0 2.97-1.044l4.23 2.286-4.404 2.373a4.612 4.612 0 0 0-2.907-1.024c-2.54 0-4.605 2.04-4.605 4.547 0 2.507 2.066 4.548 4.605 4.548s4.605-2.04 4.605-4.548c0-.317-.033-.632-.1-.94l5.447-2.951a.49.49 0 0 0 .252.376l7.541 3.997a3.514 3.514 0 0 0 1.658.426c1.045 0 1.889-.49 2.286-.864a.5.5 0 0 0-.108-.805zM8.392 7.389a.5.5 0 0 0-.342.136A3.733 3.733 0 0 1 5.49 8.537c-2.05 0-3.716-1.64-3.716-3.655 0-2.016 1.667-3.655 3.716-3.655s3.715 1.64 3.715 3.655c0 .371-.057.738-.168 1.09a.5.5 0 0 0 .238.59l5.495 2.982-1.129.612L8.63 7.45a.498.498 0 0 0-.238-.06zm.671 7.653a.5.5 0 0 0-.24.588c.106.339.16.69.16 1.045 0 1.957-1.617 3.548-3.605 3.548-1.987 0-3.605-1.591-3.605-3.548 0-1.956 1.618-3.547 3.605-3.547.934 0 1.82.352 2.496.992a.503.503 0 0 0 .58.077l15.02-8.093c.943-.506 1.754-.34 2.275-.103L9.063 15.04zm14.528 1.231l-7.432-3.939 1.218-.66a.493.493 0 0 0 .254.401l8.097 4.315c-.504.212-1.262.345-2.137-.117z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.489 1.872c-1.68 0-3.047 1.35-3.047 3.01 0 1.66 1.367 3.01 3.047 3.01s3.046-1.35 3.046-3.01c0-1.66-1.367-3.01-3.046-3.01zm0 5.02c-1.129 0-2.047-.902-2.047-2.01 0-1.108.918-2.01 2.047-2.01s2.046.902 2.046 2.01c0 1.108-.918 2.01-2.046 2.01z"
  }));
};

IcoPaymentsExpenses.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27 22"
};

var IcoPaymentsIncome = function IcoPaymentsIncome(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.163 6.927l2.923-3.916V.849h-2.144V0H7.155v.849H5.011V3.01l2.96 3.966C3.498 8.52 0 14.557 0 19.632 0 24.52 3.408 27 10.13 27c6.721 0 10.13-2.48 10.13-7.368 0-5.123-3.563-11.234-8.097-12.705zm1.923-5.078v.83l-2.982 3.995c-.022-.003-.045-.002-.068-.005l1.756-4.82h1.294zM11.942 1v.26l-1.886 5.176-1.9-5.176V1h3.786zM6.01 2.679v-.83h1.295l1.777 4.836c-.025.004-.048.013-.072.018l.002-.002-3.002-4.022zM10.129 26C3.986 26 1 23.917 1 19.632c0-5.306 4.298-12.037 9.13-12.037s9.13 6.731 9.13 12.037c0 4.285-2.987 6.368-9.13 6.368z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.625 17.527a4.072 4.072 0 0 0-.866-.36v-2.902c.18.055.34.125.46.224.265.222.422.527.48.932l.99-.14c-.093-.653-.372-1.177-.831-1.56-.358-.297-.828-.478-1.452-.541l-.54.002c-.643.067-1.152.26-1.515.577-.52.462-.785 1.071-.785 1.81 0 .414.09.794.27 1.127.185.348.455.62.798.81.386.218.77.363 1.125.435v2.884c-.296-.05-.546-.138-.717-.28-.267-.223-.424-.528-.481-.933l-.99.14c.092.651.37 1.176.83 1.561.357.297.828.478 1.452.54l.539-.002c.644-.066 1.153-.26 1.516-.577.52-.461.785-1.07.785-1.808 0-.412-.09-.792-.27-1.13a1.988 1.988 0 0 0-.798-.809zm-2.504-.894a.989.989 0 0 1-.404-.408 1.351 1.351 0 0 1-.151-.657c0-.446.147-.793.446-1.059.17-.148.44-.24.747-.294v2.687a3.157 3.157 0 0 1-.638-.27zm2.126 3.891c-.12.106-.294.18-.488.238V18.22c.124.052.249.107.378.18.178.098.31.232.405.407.101.192.15.408.15.659 0 .446-.146.793-.445 1.058z"
  }));
};

IcoPaymentsIncome.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20.2592773 27"
};

var IcoPaymentsNetIncome = function IcoPaymentsNetIncome(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0v23l2-2 2 2 2-2 2 2 2-2 2 2 2-2 2 2 2-2V0H0zm17 5v15.586l-1 1-2-2-2 2-2-2-2 2-2-2-2 2-2-2-1 1V5h2V4H1V1h16v3h-1v1h1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 4h3v1H4zM8 4h3v1H8zM12 4h3v1h-3zM10.366 12.028a4.004 4.004 0 0 0-.866-.36V8.764c.18.055.34.125.459.224.266.222.423.526.48.932l.99-.141c-.092-.652-.371-1.177-.83-1.56-.357-.296-.828-.477-1.453-.54l-.539.002c-.644.067-1.152.26-1.515.577-.521.462-.785 1.07-.785 1.81 0 .414.09.794.27 1.127.185.347.455.62.798.81.387.218.772.363 1.125.434v2.884c-.296-.05-.546-.137-.717-.278-.267-.224-.425-.53-.482-.934l-.99.14c.092.651.371 1.175.83 1.561.358.297.829.478 1.453.54l.538-.003c.645-.065 1.154-.258 1.516-.576.52-.462.786-1.07.786-1.808 0-.413-.09-.792-.27-1.13a1.981 1.981 0 0 0-.798-.808zm-2.504-.896a.982.982 0 0 1-.404-.408 1.36 1.36 0 0 1-.151-.656c0-.446.147-.793.446-1.059.17-.149.44-.24.747-.294v2.687a3.15 3.15 0 0 1-.638-.27zm2.125 3.892c-.12.105-.293.18-.487.237V12.72c.124.051.249.107.378.18.178.098.31.232.404.406.102.193.152.409.152.66 0 .446-.147.793-.447 1.058z"
  }));
};

IcoPaymentsNetIncome.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 23"
};

var IcoPaymentsOwnersRevenue = function IcoPaymentsOwnersRevenue(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17.388 5H11v5c-3.834 0-7.238-1.033-8.908-2.5a3.918 3.918 0 0 1-.668-.738C1.153 6.359 1 5.937 1 5.5 1 3.061 5.58 1 11 1c5.046 0 9.358 1.786 9.931 4h-3.543zM11 14C5.58 14 1 11.939 1 9.5V7.817c.131.144.27.285.424.421C3.296 9.899 6.841 11 11 11v3zm10.951-9C21.46 2.159 16.83 0 11 0 4.832 0 0 2.416 0 5.5v4c0 .834.363 1.615 1 2.317C2.72 13.711 6.499 15 11 15c.338 0 .671-.01 1-.024V6h9.953c.005-.022.003-.045.007-.067.022-.143.04-.287.04-.433 0-.169-.02-.335-.049-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.076 9.262a3.884 3.884 0 0 1-.668.738c-1.668 1.467-5.074 2.5-8.908 2.5v-4h9.927a2.479 2.479 0 0 1-.35.762zM24.5 12c0 2.44-4.58 4.5-10 4.5v-3c4.16 0 7.705-1.1 9.576-2.761.154-.137.293-.278.424-.421V12zm1-4.5h-12v9.976c.33.015.663.024 1 .024 4.501 0 8.28-1.29 10-3.182.637-.702 1-1.484 1-2.318V7.5z"
  }));
};

IcoPaymentsOwnersRevenue.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25.5004997 17.4997005"
};

var IcoPaymentsStripe = function IcoPaymentsStripe(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 19h-21A2.503 2.503 0 0 1 0 16.5v-14C0 1.122 1.122 0 2.5 0h21C24.879 0 26 1.122 26 2.5v14c0 1.379-1.121 2.5-2.5 2.5zM2.5 1C1.673 1 1 1.673 1 2.5v14c0 .827.673 1.5 1.5 1.5h21c.827 0 1.5-.673 1.5-1.5v-14c0-.827-.673-1.5-1.5-1.5h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.133 10.815c-.083.823-.525 1.254-1.318 1.33a3.952 3.952 0 0 1-1.507-.168c-.042-.011-.104-.067-.105-.103-.008-.362-.004-.725-.004-1.101.251.054.488.117.728.156.149.024.306.031.453.009.077-.012.17-.091.207-.166.053-.105.004-.222-.093-.285-.128-.083-.267-.149-.4-.225-.154-.086-.316-.164-.459-.268a1.209 1.209 0 0 1-.489-.857c-.004-.033-.017-.066-.026-.1V8.77c.023-.12.038-.243.07-.36.15-.559.541-.834 1.054-.943a3.023 3.023 0 0 1 1.618.112c.085.029.118.07.116.167-.007.338-.003.675-.003 1.009-.27-.052-.53-.107-.792-.148a.79.79 0 0 0-.325.004c-.074.02-.173.1-.183.167a.319.319 0 0 0 .1.25c.115.093.259.144.388.217.167.092.345.173.497.288.417.318.524.777.473 1.283zm2.326-2.13v1.82c0 .05 0 .101.005.15.023.202.095.27.291.259.17-.01.34-.037.525-.06v1.165c-.54.103-1.08.225-1.63.084-.486-.122-.754-.54-.76-1.17-.007-.742-.002-1.482-.003-2.223v-.171h-.565V7.495h.563c.06-.307.12-.601.171-.898.017-.1.05-.154.152-.177.411-.097.82-.205 1.247-.312v1.377h.833l-.207 1.047h-.614c-.003.06-.008.107-.008.154zm12.254.74c.022-.255.039-.5.068-.745a.402.402 0 0 1 .092-.197c.142-.173.402-.126.447.096.054.273.062.556.093.847h-.7zm2.062-.534c-.052-.408-.206-.786-.505-1.076-.365-.355-.817-.427-1.288-.406-.919.043-1.468.471-1.693 1.33a4.17 4.17 0 0 0-.004 2.108c.17.67.579 1.1 1.244 1.24a3.78 3.78 0 0 0 1.765-.058c.336-.088.336-.087.336-.449v-.841l-.395.074c-.37.064-.741.145-1.117.083-.287-.045-.415-.247-.374-.57h2.136c-.033-.497-.045-.969-.105-1.435zM12.673 7.496h1.554v4.576h-1.554V7.496zm1.576-1.392c0 .456-.353.826-.79.826h-.002a.77.77 0 0 1-.548-.233.844.844 0 0 1-.241-.593c0-.414.29-.757.67-.817a.176.176 0 0 1 .028-.01h.171l.012.007c.395.046.7.396.7.82zM12.292 7.62c-.006.407-.002.814-.002 1.23-.175-.023-.33-.047-.485-.063a1.112 1.112 0 0 0-.242.01c-.325.044-.37.098-.37.433v2.838h-1.56V7.501c.032-.005.068-.012.103-.012.338 0 .675.003 1.013-.003.088-.001.14.028.177.111.048.107.108.209.166.316.288-.478.579-.6 1.07-.464.091.026.131.064.13.171zm4.807 3.007c-.072.362-.277.463-.625.33v-.306c0-.59.004-1.182-.002-1.772-.001-.103.033-.155.12-.184.05-.017.097-.04.148-.055.215-.065.355.01.383.24.075.581.09 1.167-.024 1.747zm1.555-2.554c-.135-.29-.334-.511-.638-.599-.467-.134-.913-.086-1.32.211-.038.028-.076.054-.132.096-.116-.319-.362-.313-.617-.292-.038.004-.076 0-.114 0h-.753v6.084c0 .05.003.1.006.15h1.57v-1.626c.234.024.455.066.676.064.758-.007 1.212-.371 1.438-1.13.01-.032.02-.065.027-.1.15-.61.148-1.23.096-1.85-.028-.35-.091-.691-.24-1.008z"
  }));
};

IcoPaymentsStripe.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 19"
};

var IcoPaymentCash = function IcoPaymentCash(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.708 2.17L17.531 0l-2.744 2.735c-.095-.011-.189-.029-.287-.029h-12a2.503 2.503 0 0 0-2.5 2.5v12c0 1.379 1.122 2.5 2.5 2.5h12c1.379 0 2.5-1.121 2.5-2.5v-12c0-.108-.018-.211-.032-.316l2.74-2.72zm-3.844 2.42l-3.127 3.116-1.003 1-2.007 2-.265.264-1.426.684.438-.948.228-.495 1.51-1.505 1.004-1L15.1 3.834l.736-.733 1.694-1.689.761.758-1.693 1.688-.735.732zM16 17.206c0 .827-.673 1.5-1.5 1.5h-12c-.827 0-1.5-.673-1.5-1.5v-12c0-.827.673-1.5 1.5-1.5h11.313l-4.014 4H3v1h5.795l-.862.86-.536 1.14H3v1h3.927l-.939 2H3v1h11v-1H6.072l3.9-1.871.13-.129H14v-1h-2.891l2.015-2H14v-.87l2-1.985v11.355z"
  }));
};

IcoPaymentCash.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19.7080078 19.7060547"
};

var IcoPaymentCreditCard = function IcoPaymentCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20 0H2C.897 0 0 .897 0 2v13c0 1.103.897 2 2 2h18c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2zm1 15a1 1 0 0 1-1 1H2c-.551 0-1-.448-1-1V8h20v7zM1 5V2c0-.551.449-1 1-1h18c.552 0 1 .449 1 1v3H1z"
  }));
};

IcoPaymentCreditCard.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 17"
};

var IcoPaymentsAmericanExpress = function IcoPaymentsAmericanExpress(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z",
    fill: "#1F72CD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z",
    fill: "#D4D8E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.031 5.8L3 10.194h2.432l.301-.7h.69l.301.7h2.677V9.66l.238.534h1.385l.239-.546v.546h5.567l.677-.682.634.682L21 10.2l-2.038-2.19L21 5.8h-2.815l-.659.67-.614-.67h-6.056l-.52 1.134L9.803 5.8H7.377v.517l-.27-.517H5.03zm.471.624h1.185l1.348 2.98v-2.98h1.299l1.04 2.137.96-2.137h1.292v3.153h-.787l-.006-2.47-1.146 2.47h-.704l-1.152-2.47v2.47H7.213l-.306-.707H5.25l-.306.707h-.867l1.425-3.153zm11.04 0h-3.197v3.151h3.147l1.015-1.044.977 1.044h1.023L18.02 8.01l1.486-1.585h-.978l-1.01 1.032-.977-1.032zm-10.463.534l-.546 1.259h1.09l-.544-1.26zm8.055.694v-.575h1.995l.87.92-.909.925h-1.956v-.628h1.744v-.642h-1.744z",
    fill: "#fff"
  }));
};

IcoPaymentsAmericanExpress.defaultProps = {
  width: "24",
  height: "16",
  viewBox: "0 0 24 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoPaymentsChainaUnionPay = function IcoPaymentsChainaUnionPay(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z",
    fill: "#D4D8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.133 3h3.994c.557 0 .904.455.774 1.013l-1.86 7.976C9.912 12.546 9.353 13 8.796 13H4.8c-.556 0-.904-.454-.774-1.011l1.86-7.976c.13-.558.688-1.012 1.246-1.012z",
    fill: "#E21836"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.794 3h4.593c.557 0 .306.454.175 1.013l-1.86 7.975c-.13.557-.089 1.011-.647 1.011H8.462c-.558 0-.904-.454-.773-1.01l1.859-7.976C9.68 3.454 10.237 3 10.794 3z",
    fill: "#00447C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.205 3h3.993c.559 0 .905.454.774 1.013l-1.859 7.975c-.13.557-.69 1.011-1.248 1.011h-3.991c-.559 0-.905-.454-.774-1.01l1.859-7.976c.13-.559.687-1.013 1.246-1.013z",
    fill: "#007B84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.176 5.556c-.41.004-.532 0-.57-.01l-.293 1.35c-.06.258-.103.442-.25.561a.447.447 0 0 1-.296.103c-.182 0-.288-.09-.306-.262l-.003-.059.055-.348s.291-1.164.343-1.318a.113.113 0 0 0 .005-.017c-.567.005-.667 0-.674-.01a2.173 2.173 0 0 0-.018.085l-.297 1.312-.025.112-.05.363c0 .108.022.196.064.271.135.236.521.272.74.272.28 0 .545-.06.723-.17.31-.182.39-.467.463-.721l.033-.13s.3-1.21.35-1.367l.006-.017zm1.02.975a.792.792 0 0 0-.323.076c-.043.022-.084.047-.127.073l.039-.14-.021-.024c-.252.051-.308.058-.54.09l-.02.014a6.86 6.86 0 0 1-.15.83l-.118.487.011.02c.238-.012.31-.012.517-.009l.017-.018c.026-.135.03-.166.088-.439.027-.129.084-.413.112-.514a.386.386 0 0 1 .152-.047c.115 0 .101.101.097.141a5.065 5.065 0 0 1-.09.478l-.03.123-.062.267.009.018c.234-.012.306-.012.506-.009l.024-.018c.036-.21.047-.266.11-.572l.033-.14c.063-.276.095-.415.047-.529-.05-.127-.17-.158-.281-.158zm1.138.288c-.124.024-.204.04-.283.05-.078.013-.155.024-.275.04l-.01.01-.008.006c-.013.09-.022.168-.038.259a4.73 4.73 0 0 1-.072.355 1.393 1.393 0 0 1-.057.2c-.015.042-.031.082-.062.198l.007.01.006.01c.113-.005.186-.009.262-.01.076-.002.154 0 .275.001l.01-.009.012-.01c.018-.104.02-.132.031-.183.01-.054.03-.13.074-.332.021-.095.045-.19.067-.286l.07-.287-.004-.011-.005-.011zm.003-.388c-.113-.067-.312-.046-.446.046-.133.09-.149.22-.036.287.112.065.311.046.444-.048.133-.092.15-.22.038-.285zm.685 1.547c.23 0 .464-.063.641-.25.136-.152.199-.378.22-.471.07-.309.016-.453-.053-.54-.104-.134-.29-.177-.48-.177-.116 0-.39.011-.605.209-.154.142-.225.336-.268.52-.043.19-.093.53.22.656a.918.918 0 0 0 .325.053zm-.018-.694c.053-.234.116-.43.275-.43.125 0 .134.146.078.38-.01.053-.055.246-.117.328-.043.061-.094.098-.15.098-.017 0-.116 0-.118-.148 0-.073.014-.147.032-.228zm1.453.664l.017-.018c.026-.135.03-.166.086-.439.028-.129.087-.412.114-.514.052-.024.102-.047.152-.047.115 0 .101.101.097.141a4.618 4.618 0 0 1-.09.478l-.028.122c-.021.09-.044.179-.064.268l.009.018a5.55 5.55 0 0 1 .505-.009l.025-.018c.035-.21.045-.267.11-.572l.032-.14c.063-.276.095-.415.049-.529-.052-.127-.173-.158-.283-.158a.788.788 0 0 0-.448.149l.036-.14-.02-.024c-.25.051-.308.058-.54.09l-.018.014a7.1 7.1 0 0 1-.151.83l-.117.487.01.02c.239-.012.31-.012.517-.009zm1.729.01l.103-.5s.075-.315.08-.326c0 0 .023-.033.047-.046h.034c.327 0 .697 0 .986-.212.197-.146.332-.362.392-.623a.94.94 0 0 0 .027-.217c0-.1-.02-.2-.079-.277-.147-.206-.441-.21-.78-.212l-.168.002a7.733 7.733 0 0 1-.68-.005l-.017.088-.155.721-.39 1.604c.379-.005.534-.005.6.002zm.288-1.28l.165-.716.005-.037.002-.028.066.006.35.03c.134.053.19.187.15.362a.525.525 0 0 1-.272.36c-.11.054-.244.059-.383.059h-.09l.007-.036zm1.03.62c-.044.185-.094.525.217.647.1.042.188.054.279.05a.46.46 0 0 0 .266-.122l-.022.085.014.018c.224-.01.293-.01.536-.007l.022-.017c.035-.208.069-.41.16-.809.046-.19.09-.38.137-.569l-.008-.021c-.25.046-.317.056-.558.09l-.019.015-.007.057a.344.344 0 0 0-.175-.144c-.108-.043-.36.012-.576.209-.152.14-.225.333-.266.517zm.526.01c.054-.229.115-.423.275-.423.1 0 .154.093.143.252a7.4 7.4 0 0 1-.029.128l-.05.204a.492.492 0 0 1-.059.119c-.04.058-.139.094-.195.094-.016 0-.114 0-.118-.145 0-.072.014-.147.033-.228zm2.748-.757l-.02-.022c-.247.05-.292.058-.52.089l-.017.017-.002.01-.001-.003c-.17.39-.165.306-.303.614l-.001-.038-.035-.667-.022-.022c-.26.05-.265.058-.505.089l-.019.017c-.003.008-.003.016-.004.026l.001.003c.03.153.023.12.053.36.014.12.033.239.047.356.024.196.037.292.066.591-.162.267-.2.368-.356.603v.002l-.11.174c-.012.018-.023.03-.04.036a.166.166 0 0 1-.071.01h-.06l-.091.3.31.006c.182-.001.297-.086.358-.2l.195-.334h-.003l.02-.024c.132-.282 1.13-1.993 1.13-1.993zm-3.274 3.947h-.132l.487-1.61h.162l.051-.166.005.185c-.006.114.084.215.32.198h.272l.094-.31h-.103c-.059 0-.086-.015-.082-.047l-.005-.187h-.505c-.164.004-.651.016-.75.043-.12.03-.245.12-.245.12l.05-.165h-.473l-.098.33-.494 1.634h-.096l-.094.307h.941l-.031.103h.463l.03-.103h.13l.103-.332zm-.386-1.283c-.076.021-.217.085-.217.085l.126-.412h.375l-.09.3s-.117.007-.194.027zm.007.588s-.118.015-.195.032c-.077.023-.22.096-.22.096l.13-.428h.376l-.091.3zm-.21.699h-.377l.11-.362h.375l-.108.362zm.906-.999h.543l-.078.253h-.55l-.083.275h.482l-.365.513a.15.15 0 0 1-.073.061.217.217 0 0 1-.098.028h-.134l-.091.303h.349a.425.425 0 0 0 .367-.191l.25-.342.054.347a.163.163 0 0 0 .09.118c.035.017.07.047.122.052l.12.004h.172l.103-.338h-.068c-.039 0-.106-.007-.117-.019-.011-.014-.011-.037-.018-.072l-.054-.347h-.223l.098-.117h.549l.084-.275h-.508l.08-.253h.506l.094-.31h-1.51l-.093.31zm-4.582 1.069l.126-.421h.52l.096-.313h-.521l.08-.26h.509l.094-.302h-1.274l-.092.303h.289l-.077.259h-.29l-.097.318h.29l-.169.557c-.023.074.01.102.032.136a.14.14 0 0 0 .093.068.56.56 0 0 0 .133.018h.587l.105-.346-.26.035c-.05 0-.19-.006-.174-.052zm.06-2.015l-.133.238a.276.276 0 0 1-.076.1c-.02.012-.06.017-.118.017h-.069l-.092.305h.229c.11 0 .194-.04.234-.06.044-.024.055-.01.089-.043l.077-.067h.713l.095-.317h-.522l.09-.173h-.518zm1.053 2.021c-.012-.017-.003-.048.015-.112l.195-.646h.694c.101-.001.174-.002.222-.006a.453.453 0 0 0 .167-.056.312.312 0 0 0 .121-.112.95.95 0 0 0 .12-.27l.245-.817-.72.004s-.222.033-.32.069c-.098.04-.239.153-.239.153l.065-.224h-.444l-.623 2.063a1.27 1.27 0 0 0-.04.174c-.002.037.047.075.078.103.038.028.093.023.146.028.055.004.134.006.243.006h.342l.105-.354-.306.03a.08.08 0 0 1-.066-.033zm.336-1.193h.729l-.046.145c-.007.003-.023-.007-.097.001h-.63l.044-.146zm.146-.487h.735l-.053.175s-.346-.004-.402.007a.82.82 0 0 0-.386.172l.106-.354zm.553 1.118a.077.077 0 0 1-.029.045c-.015.01-.039.013-.074.013h-.104l.006-.177h-.432l-.018.864c0 .062.006.098.051.127.046.036.187.04.376.04h.27l.098-.323-.235.013-.079.005c-.01-.005-.02-.009-.032-.02-.01-.01-.027-.004-.024-.066l.002-.222.247-.01a.32.32 0 0 0 .24-.085c.046-.04.06-.085.078-.146l.042-.197h-.34l-.043.139z",
    fill: "#FEFEFE"
  }));
};

IcoPaymentsChainaUnionPay.defaultProps = {
  width: "24",
  height: "16",
  viewBox: "0 0 24 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoPaymentsDiners = function IcoPaymentsDiners(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.086a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-12z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.212 13.476c2.84.014 5.434-2.316 5.434-5.15 0-3.099-2.593-5.241-5.434-5.24h-2.445c-2.875-.001-5.242 2.142-5.242 5.24 0 2.835 2.367 5.164 5.242 5.15h2.445z",
    fill: "#0079BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.778 3.515a4.757 4.757 0 1 0 .002 9.515 4.757 4.757 0 0 0-.002-9.515zM7.764 8.272c-.001-.608.183-1.201.529-1.703a3.042 3.042 0 0 1 1.406-1.11v5.626a3.042 3.042 0 0 1-1.406-1.11 2.997 2.997 0 0 1-.53-1.703zm4.093 2.814V5.458a3.04 3.04 0 0 1 1.408 1.11c.346.503.53 1.096.53 1.704 0 .608-.184 1.201-.53 1.703-.346.502-.836.89-1.408 1.11z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.212 13.476c2.84.014 5.434-2.316 5.434-5.15 0-3.099-2.593-5.241-5.434-5.24h-2.445c-2.875-.001-5.242 2.142-5.242 5.24 0 2.835 2.367 5.164 5.242 5.15h2.445z",
    fill: "#0079BE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.778 3.515a4.757 4.757 0 1 0 .002 9.515 4.757 4.757 0 0 0-.002-9.515zM7.764 8.272c-.001-.608.183-1.201.529-1.703a3.042 3.042 0 0 1 1.406-1.11v5.626a3.042 3.042 0 0 1-1.406-1.11 2.997 2.997 0 0 1-.53-1.703zm4.093 2.814V5.458a3.04 3.04 0 0 1 1.408 1.11c.346.503.53 1.096.53 1.704 0 .608-.184 1.201-.53 1.703-.346.502-.836.89-1.408 1.11z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 1.086H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1v-12a1 1 0 0 0-1-1zm-20-1a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2v-12a2 2 0 0 0-2-2H2z",
    fill: "#D4D8E1"
  }));
};

IcoPaymentsDiners.defaultProps = {
  width: "24",
  height: "16",
  viewBox: "0 0 24 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoPaymentsDiscover = function IcoPaymentsDiscover(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 15l14-4v4H9z",
    fill: "#FD6020"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z",
    fill: "#D4D8E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.74 6.567c.663 0 1.028.29 1.028.838a.787.787 0 0 1-.663.838L21 9.436h-.696l-.763-1.161h-.066v1.16h-.563V6.568h.828zm-.265 1.321h.166c.365 0 .53-.161.53-.451 0-.258-.165-.42-.53-.42h-.166v.871zm-2.52 1.548h1.592v-.484h-1.028v-.774h.995v-.483h-.995V7.05h1.028v-.483h-1.591v2.869zM15.299 8.5l-.762-1.934h-.597L15.166 9.5h.298l1.227-2.933h-.597L15.298 8.5zM8.57 8.017c0 .806.663 1.483 1.492 1.483.265 0 .497-.064.73-.161v-.645a.874.874 0 0 1-.664.322c-.53 0-.961-.386-.961-.902v-.065c-.033-.515.398-.967.928-.999.265 0 .53.129.696.322v-.644c-.199-.13-.464-.161-.696-.161-.862-.065-1.525.612-1.525 1.45zm-1.028-.354c-.331-.13-.43-.194-.43-.355.033-.193.198-.355.397-.322.166 0 .332.096.464.225l.299-.387a1.328 1.328 0 0 0-.829-.322.842.842 0 0 0-.895.774v.032c0 .387.166.612.696.774.133.032.265.096.398.16.1.065.166.162.166.29 0 .227-.2.42-.398.42h-.033a.655.655 0 0 1-.597-.387l-.365.355c.2.354.597.548.995.548a.926.926 0 0 0 .994-.87V8.5c-.033-.387-.199-.58-.862-.838zM5.62 9.436h.563v-2.87H5.62v2.87zM3 6.566h.994c.796.033 1.426.677 1.393 1.451 0 .42-.2.806-.53 1.096-.299.226-.664.355-1.028.323H3v-2.87zm.73 2.386a1.07 1.07 0 0 0 .762-.226c.199-.193.298-.451.298-.741 0-.258-.1-.516-.298-.71a1.07 1.07 0 0 0-.763-.225h-.165v1.902h.165z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.48 6.5c-.828 0-1.524.645-1.524 1.483 0 .806.663 1.483 1.525 1.515.862.032 1.524-.645 1.558-1.483-.034-.838-.696-1.515-1.558-1.515z",
    fill: "#FD6020"
  }));
};

IcoPaymentsDiscover.defaultProps = {
  width: "24",
  height: "16",
  viewBox: "0 0 24 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoPaymentsJCB = function IcoPaymentsJCB(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z",
    fill: "#D4D8E1"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(.6666)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.53 12.287c.52.011 1.04-.022 1.557.018.523.097.65.88.185 1.138-.317.169-.694.063-1.038.093h-.703v-1.249zm1.857-1.413c.115.403-.277.765-.668.71H22.53c.008-.38-.016-.793.012-1.153.476.014.956-.027 1.43.021.202.05.373.216.414.422zm2.86-5.974c.021.77.002 1.58.009 2.365-.002 3.19.003 6.382-.003 9.573-.02 1.196-1.09 2.235-2.29 2.26-1.2.004-2.4 0-3.6.001v-4.824c1.307-.007 2.616.013 3.923-.01.606-.038 1.27-.434 1.299-1.095.071-.664-.56-1.124-1.16-1.196-.231-.006-.224-.067 0-.093.572-.123 1.021-.71.853-1.297-.144-.618-.833-.857-1.407-.856-1.17-.008-2.339 0-3.508-.003.007-.9-.016-1.802.012-2.702.093-1.175 1.19-2.143 2.372-2.122h3.5z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.148 7.144c.03-1.194 1.104-2.225 2.301-2.242 1.196-.004 2.392 0 3.588-.002-.004 3.995.006 7.991-.005 11.986-.046 1.18-1.11 2.19-2.293 2.211-1.199.005-2.397 0-3.595.002v-4.987c1.164.272 2.384.388 3.572.208.71-.113 1.486-.459 1.726-1.188.177-.624.077-1.28.103-1.92V9.725h-2.054c-.01.983.019 1.968-.015 2.95-.055.604-.659.988-1.234.967-.713.008-2.125-.511-2.125-.511-.004-1.843.02-4.15.03-5.987z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.803 10.325c-.108.022-.022-.365-.05-.512.008-.93-.015-1.86.013-2.79.093-1.18 1.198-2.15 2.385-2.123h3.495c-.003 3.996.007 7.991-.005 11.986-.046 1.18-1.109 2.19-2.293 2.211-1.198.005-2.396.001-3.594.002v-5.464c.818.665 1.93.769 2.95.77.768 0 1.532-.117 2.278-.292V13.11c-.84.416-1.83.68-2.762.44a1.492 1.492 0 0 1-1.112-1.447c-.075-.691.334-1.421 1.02-1.627.851-.264 1.78-.062 2.578.281.17.09.345.2.276-.084v-.787c-1.335-.314-2.756-.43-4.097-.088-.388.109-.767.273-1.082.526z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "21.322",
    y1: "11.696",
    x2: "27.218",
    y2: "11.696",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#58B03A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#55B330"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: "8.019",
    y1: "12.136",
    x2: "13.94",
    y2: "12.136",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F6EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#006DBA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "14.745",
    y1: "11.834",
    x2: "20.645",
    y2: "11.834",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DE0D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#E30138"
  })))));
};

IcoPaymentsJCB.defaultProps = {
  width: "24",
  height: "16",
  viewBox: "0 0 24 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoPaymentsMasterCard = function IcoPaymentsMasterCard(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z",
    fill: "#D4D8E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.044A3.894 3.894 0 0 1 9.443 12C7.265 12 5.5 10.21 5.5 8s1.765-4 3.943-4c.976 0 1.869.36 2.557.956A3.894 3.894 0 0 1 14.557 4C16.735 4 18.5 5.79 18.5 8s-1.765 4-3.943 4c-.976 0-1.869-.36-2.557-.956z",
    fill: "#ED0006"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.044A4.015 4.015 0 0 0 13.385 8c0-1.22-.537-2.31-1.385-3.044A3.894 3.894 0 0 1 14.557 4C16.735 4 18.5 5.79 18.5 8s-1.765 4-3.943 4c-.976 0-1.869-.36-2.557-.956z",
    fill: "#F9A000"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.044A4.015 4.015 0 0 0 13.385 8c0-1.22-.537-2.31-1.385-3.044A4.015 4.015 0 0 0 10.615 8c0 1.22.537 2.31 1.385 3.044z",
    fill: "#FF5E00"
  }));
};

IcoPaymentsMasterCard.defaultProps = {
  width: "24",
  height: "16",
  viewBox: "0 0 24 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoPaymentsVisa = function IcoPaymentsVisa(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z",
    fill: "#D4D8E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 10.7H5.942L4.774 6.243c-.055-.205-.173-.386-.346-.471A5.07 5.07 0 0 0 3 5.3v-.172h2.51c.346 0 .606.258.649.558L6.765 8.9l1.557-3.772h1.514L7.5 10.7zm3.202 0h-1.47l1.21-5.572h1.472L10.702 10.7zm3.115-4.028c.043-.3.303-.472.606-.472.476-.043.995.043 1.428.257l.26-1.2A3.724 3.724 0 0 0 14.77 5c-1.428 0-2.467.772-2.467 1.843 0 .815.736 1.242 1.255 1.5.562.257.779.429.735.686 0 .385-.432.557-.865.557a3.71 3.71 0 0 1-1.514-.343l-.26 1.2c.52.214 1.082.3 1.601.3 1.601.042 2.596-.729 2.596-1.886 0-1.457-2.034-1.543-2.034-2.185zM21 10.7l-1.168-5.572h-1.255c-.26 0-.52.172-.606.43L15.808 10.7h1.514l.303-.814h1.86l.174.814H21zm-2.206-4.071l.432 2.1h-1.212l.78-2.1z",
    fill: "#172B85"
  }));
};

IcoPaymentsVisa.defaultProps = {
  width: "24",
  height: "16",
  viewBox: "0 0 24 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoPaymentsIsraCard = function IcoPaymentsIsraCard(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z",
    fill: "#D4D8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.405 3.039l4.76 4.77a.132.132 0 0 1 0 .185l-4.776 4.776a.131.131 0 0 1-.186 0L9.443 8a.132.132 0 0 1 0-.186l4.776-4.776a.131.131 0 0 1 .186 0z",
    fill: "#002B59",
    stroke: "#002B59",
    strokeWidth: ".5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3.039l4.76 4.77a.132.132 0 0 1 0 .185L9.984 12.77a.131.131 0 0 1-.185 0L5.039 8a.132.132 0 0 1 0-.186l4.775-4.776a.131.131 0 0 1 .186 0z",
    fill: "#C51015"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.107 5.15l2.653 2.658a.132.132 0 0 1 0 .186l-2.664 2.665L9.443 8a.132.132 0 0 1 0-.186l2.664-2.664z",
    fill: "#950B0E"
  }));
};

IcoPaymentsIsraCard.defaultProps = {
  width: "24",
  height: "16",
  viewBox: "0 0 24 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoPaymentsMaestro = function IcoPaymentsMaestro(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 2a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 1H2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h20a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h20a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z",
    fill: "#D4D8E1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.044A3.894 3.894 0 0 1 9.443 12C7.265 12 5.5 10.21 5.5 8s1.765-4 3.943-4c.976 0 1.869.36 2.557.956A3.894 3.894 0 0 1 14.557 4C16.735 4 18.5 5.79 18.5 8s-1.765 4-3.943 4c-.976 0-1.869-.36-2.557-.956z",
    fill: "#0066CB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.044A4.015 4.015 0 0 0 13.385 8c0-1.22-.537-2.31-1.385-3.044A3.894 3.894 0 0 1 14.557 4C16.735 4 18.5 5.79 18.5 8s-1.765 4-3.943 4c-.976 0-1.869-.36-2.557-.956z",
    fill: "#CC0001"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.044A4.015 4.015 0 0 0 13.385 8c0-1.22-.537-2.31-1.385-3.044A4.015 4.015 0 0 0 10.615 8c0 1.22.537 2.31 1.385 3.044z",
    fill: "#990002"
  }));
};

IcoPaymentsMaestro.defaultProps = {
  width: "24",
  height: "16",
  viewBox: "0 0 24 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoVirtualCreditCard = function IcoVirtualCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null), /*#__PURE__*/React.createElement("path", {
    d: "M1204.706 0c66.534 0 120.471 53.937 120.471 120.471V903.53c0 66.534-53.937 120.471-120.471 120.471H120.471C53.937 1024.001 0 970.064 0 903.53V120.471C0 53.937 53.937 0 120.471 0h1084.235zm60.235 481.882H60.235v421.647c0 30.891 23.253 56.351 53.211 59.83l7.025.405h1084.235c30.891 0 56.351-23.253 59.83-53.211l.405-7.025V481.881zm-559.153 60.236c26.246 0 49.191 4.198 68.835 12.593s36.475 19.521 50.495 33.378l-22.007 30.566c-1.304 1.956-2.975 3.668-5.013 5.135s-4.85 2.201-8.436 2.201c-3.749 0-7.58-1.467-11.493-4.401s-8.884-6.113-14.916-9.537c-6.032-3.423-13.653-6.602-22.863-9.537s-20.907-4.401-35.09-4.401c-16.628 0-31.911 2.894-45.849 8.681s-25.92 14.06-35.946 24.82c-10.026 10.759-17.85 23.841-23.475 39.247s-8.436 32.726-8.436 51.962c0 19.888 2.812 37.576 8.436 53.062s13.245 28.528 22.863 39.124c9.618 10.596 20.948 18.706 33.989 24.33s27.061 8.436 42.059 8.436c8.966 0 17.076-.489 24.33-1.467s13.938-2.527 20.051-4.646a88.996 88.996 0 0 0 17.361-8.192c3.641-2.228 7.263-4.8 10.868-7.716l5.393-4.632c1.63-1.467 3.342-2.649 5.135-3.546s3.749-1.345 5.869-1.345c3.586 0 6.684 1.386 9.292 4.157l25.92 28.121c-14.346 17.769-31.992 31.381-52.94 40.836s-46.093 14.183-75.437 14.183c-26.246 0-49.843-4.483-70.791-13.449s-38.839-21.437-53.674-37.413c-14.835-15.976-26.205-35.049-34.112-57.219s-11.86-46.379-11.86-72.625c0-26.572 4.401-50.902 13.204-72.991s21.192-41.121 37.168-57.097c15.976-15.976 35.09-28.406 57.342-37.29s46.827-13.327 73.725-13.327zm323.836 0c26.246 0 49.191 4.198 68.835 12.593s36.475 19.521 50.495 33.378l-22.007 30.566c-1.304 1.956-2.975 3.668-5.013 5.135s-4.85 2.201-8.436 2.201c-3.749 0-7.58-1.467-11.493-4.401s-8.884-6.113-14.916-9.537c-6.032-3.423-13.653-6.602-22.863-9.537s-20.907-4.401-35.09-4.401c-16.628 0-31.911 2.894-45.849 8.681s-25.92 14.06-35.946 24.82c-10.026 10.759-17.85 23.841-23.475 39.247s-8.436 32.726-8.436 51.962c0 19.888 2.812 37.576 8.436 53.062s13.245 28.528 22.863 39.124c9.618 10.596 20.948 18.706 33.989 24.33s27.061 8.436 42.059 8.436c8.966 0 17.076-.489 24.33-1.467s13.938-2.527 20.051-4.646a88.996 88.996 0 0 0 17.361-8.192c3.641-2.228 7.263-4.8 10.868-7.716l5.393-4.632c1.63-1.467 3.342-2.649 5.135-3.546s3.749-1.345 5.869-1.345c3.586 0 6.684 1.386 9.292 4.157l25.92 28.121c-14.346 17.769-31.992 31.381-52.94 40.836s-46.093 14.183-75.437 14.183c-26.246 0-49.843-4.483-70.791-13.449s-38.839-21.437-53.674-37.413c-14.835-15.976-26.205-35.049-34.112-57.219s-11.86-46.379-11.86-72.625c0-26.572 4.401-50.902 13.204-72.991s21.192-41.121 37.168-57.097c15.976-15.976 35.09-28.406 57.342-37.29s46.827-13.327 73.725-13.327zm-795.856 3.912c5.706 0 10.352 1.386 13.938 4.157s6.276 6.358 8.069 10.759l83.139 215.673c2.771 7.01 5.42 14.712 7.947 23.108s4.931 17.239 7.214 26.531c3.749-18.747 8.395-35.293 13.938-49.639l82.895-215.673c1.467-3.749 4.075-7.173 7.825-10.27s8.395-4.646 13.938-4.646h53.062L382.929 899.617h-59.42L180.705 546.03h53.062zm970.938-485.795H120.471c-30.891 0-56.351 23.253-59.83 53.211l-.405 7.025v180.706h1204.706V120.471c0-30.891-23.253-56.351-53.211-59.83l-7.025-.405z"
  }));
};

IcoVirtualCreditCard.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1325",
  height: "1024",
  viewBox: "0 0 1325 1024"
};

var IcoBankTransfer = function IcoBankTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M3 17.502v-7.004A.499.499 0 0 0 2.5 10a.5.5 0 0 0-.5.498v7.004a.499.499 0 1 0 1 0zM.438 20h20.125a.5.5 0 1 0 0-1H.438a.5.5 0 1 0 0 1zM5 17.502v-7.004A.499.499 0 0 0 4.5 10a.5.5 0 0 0-.5.498v7.004a.499.499 0 1 0 1 0zm5 0v-7.004A.499.499 0 0 0 9.5 10a.5.5 0 0 0-.5.498v7.004a.499.499 0 1 0 1 0zm2 0v-7.004a.499.499 0 0 0-.5-.498.5.5 0 0 0-.5.498v7.004a.499.499 0 1 0 1 0zm5 0v-7.004a.499.499 0 0 0-.5-.498.5.5 0 0 0-.5.498v7.004a.499.499 0 1 0 1 0zm2 0v-7.004a.499.499 0 0 0-.5-.498.5.5 0 0 0-.5.498v7.004a.499.499 0 1 0 1 0zM10.22.108a.491.491 0 0 1 .615 0L20.81 8.1c.37.296.163.9-.308.9H.498C.026 9-.18 8.395.191 8.099L10.221.108zm.303.892L2 8h17l-8.477-7zM.5 22.06h20a.5.5 0 1 0 0-1H.5a.5.5 0 1 0 0 1z"
  }));
};

IcoBankTransfer.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "21",
  height: "22",
  viewBox: "0 0 21 22"
};

var IcoPaymentRefunded = function IcoPaymentRefunded(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5 10V1.626l3.236 3.236a.488.488 0 0 0 .69-.69L4.89.139A.477.477 0 0 0 4.53.002a.474.474 0 0 0-.357.136L.137 4.173a.488.488 0 0 0 .69.69L4 1.687V11h6v-1H5z"
  }));
};

IcoPaymentRefunded.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 11"
};

var IcoCollectPaymentRecord = function IcoCollectPaymentRecord(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.031 25.98h20.147v1.199H6.031z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.217.153l-4.652 4.636H2.6A2.603 2.603 0 0 0 0 7.39V34.4C0 35.834 1.167 37 2.6 37h27.01c1.434 0 2.6-1.166 2.6-2.6V8.388l4.64-4.612L33.217.153zM31.01 7.901l-6.733 6.71-.602.6-.602.6-4.5 4.484-.441.44-.332.16-1.25.6-2.045.98.453-.98.276-.6.277-.6.687-1.488 3.006-2.996.602-.6.603-.6 8.65-8.622 1.133-1.128 3.024-3.014 1.933 1.928-3.019 3.009-1.12 1.117zm0 26.499c0 .771-.63 1.4-1.4 1.4H2.6c-.773 0-1.4-.629-1.4-1.4V7.39c0-.773.627-1.4 1.4-1.4h24.76l-8.651 8.62H6.03v1.2h11.475l-2.23 2.223-1.058 2.262H6.031v1.2h7.627l-1.638 3.503 6.724-3.224.28-.28h7.155v-1.199H20.23l4.511-4.484h1.437v-1.2h-.23l5.062-5.032V34.4z"
  }));
};

IcoCollectPaymentRecord.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 37 37"
};

var IcoCollectPaymentAH = function IcoCollectPaymentAH(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.865 38.991l-.191-.064C6.7 35.572 0 26.788 0 17.069V5.605l.703.122c1.531.266 3.167.4 4.86.4 2.323 0 4.63-1.004 7.716-3.36l.1-.078C15.258 1.194 16.12.538 16.51.25l.354-.26.355.26c2.025 1.478 2.887 2.153 3.247 2.526l.006-.009c3.096 2.356 5.4 3.36 7.7 3.36 1.7 0 3.33-.134 4.85-.399l.704-.123V17.07c0 9.733-6.7 18.517-16.671 21.859l-.191.063zM1.2 7.021V17.07c0 9.142 6.287 17.418 15.666 20.656 9.376-3.225 15.661-11.501 15.661-20.656V7.023a30.138 30.138 0 0 1-4.354.305c-2.584 0-5.105-1.078-8.427-3.606l-.483-.367.008-.01a162.793 162.793 0 0 0-2.403-1.863c-.484.367-1.315 1.012-2.743 2.146l-.116.091c-3.314 2.53-5.84 3.609-8.447 3.609A30.3 30.3 0 0 1 1.2 7.022z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.617 26.813a6.392 6.392 0 0 1-2.25-.607 6.12 6.12 0 0 1-1.749-1.26l.54-.837a.582.582 0 0 1 .48-.255c.13 0 .276.066.44.195.162.129.362.277.6.443.239.167.523.328.852.485.33.157.726.261 1.189.316l.377-5.416a18.062 18.062 0 0 1-1.402-.485c-.46-.18-.87-.416-1.235-.706s-.656-.655-.877-1.095c-.22-.44-.332-.99-.332-1.651 0-.498.098-.984.292-1.457s.475-.895.846-1.263c.37-.368.828-.67 1.372-.905s1.17-.353 1.877-.353l.102-1.49a.618.618 0 0 1 .153-.346.448.448 0 0 1 .357-.153h.673l-.143 2.02c.714.088 1.33.272 1.847.55.517.28.978.615 1.387 1.01l-.439.673c-.136.204-.293.306-.47.306-.094 0-.211-.043-.351-.128s-.308-.183-.505-.295-.425-.224-.684-.336a3.444 3.444 0 0 0-.886-.24l-.337 4.936c.49.15.972.314 1.448.492.476.177.904.405 1.285.686s.689.63.923 1.05c.235.42.353.943.353 1.57 0 .615-.103 1.191-.307 1.731a4.18 4.18 0 0 1-.893 1.423c-.39.41-.87.742-1.437.998-.568.256-1.216.384-1.943.384l-.123 1.826c-.014.129-.066.242-.158.34s-.21.15-.352.15h-.673l.153-2.306zm-1.653-11.046c0 .326.058.61.174.851s.275.454.48.638.441.343.713.478c.272.137.568.26.888.368l.305-4.6a3.89 3.89 0 0 0-1.147.265 2.515 2.515 0 0 0-.795.51c-.208.205-.363.434-.465.689s-.153.521-.153.8zm5.662 6.772c0-.34-.063-.633-.19-.877-.125-.245-.296-.456-.514-.633s-.473-.33-.765-.459a10.063 10.063 0 0 0-.938-.356l-.348 5.08a3.722 3.722 0 0 0 1.179-.292c.343-.152.632-.348.867-.586.234-.238.411-.515.53-.83.12-.317.179-.666.179-1.047z"
  })));
};

IcoCollectPaymentAH.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 34 39"
};

var IcoCollectPaymentCharge = function IcoCollectPaymentCharge(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M33.6 0H3.4A3.404 3.404 0 0 0 0 3.4v22.2C0 27.475 1.525 29 3.4 29h30.2c1.875 0 3.4-1.525 3.4-3.4V3.4C37 1.526 35.475 0 33.6 0zM3.4 1.2h30.2c1.213 0 2.2.987 2.2 2.2v5.13H1.2V3.4c0-1.213.987-2.2 2.2-2.2zm30.2 26.6H3.4c-1.213 0-2.2-.987-2.2-2.2V13.647h34.6V25.6c0 1.213-.987 2.2-2.2 2.2z"
  }));
};

IcoCollectPaymentCharge.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 37 29"
};

var IcoRateStrategy = function IcoRateStrategy(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.105 6.579V1.297c0-.164-.149-.297-.335-.297h-2.013c-.185 0-.336.133-.336.297v5.282m0 2.694v6.578c0 .198.15.36.336.36h2.013c.186 0 .335-.162.335-.36V9.263"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.478 9.263h-3.43a.51.51 0 0 1-.522-.496V7.076a.51.51 0 0 1 .522-.497h3.43a.51.51 0 0 1 .522.497v1.69a.51.51 0 0 1-.522.497zm-6.636 1.579V1.34c0-.187-.15-.34-.335-.34H8.494a.338.338 0 0 0-.336.34v9.496m0 2.69v2.345c0 .188.15.34.336.34h2.013a.337.337 0 0 0 .335-.34v-2.338"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.216 13.526H7.785a.51.51 0 0 1-.522-.496v-1.692a.51.51 0 0 1 .522-.496h3.43a.51.51 0 0 1 .522.496v1.692a.51.51 0 0 1-.521.496zM4.579 3.775V1.388c0-.214-.15-.388-.335-.388H2.23c-.185 0-.335.174-.335.388v2.401m0 2.697v9.39c0 .185.15.335.335.335h2.014c.185 0 .335-.15.335-.334V6.474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.953 6.474H1.52A.51.51 0 0 1 1 5.977V4.286a.51.51 0 0 1 .521-.497h3.432a.51.51 0 0 1 .52.497v1.69a.51.51 0 0 1-.52.498z"
  })));
};

IcoRateStrategy.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "19",
  height: "17",
  stroke: "#30ABE5",
  viewBox: "0 0 19 17"
};

var IcoReservationCompleted = function IcoReservationCompleted(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0c-2.31 0-4.197 1.756-4.45 4H8.95C8.696 1.756 6.81 0 4.5 0 2.019 0 0 2.019 0 4.5S2.019 9 4.5 9c2.31 0 4.197-1.756 4.45-4h14.1c.253 2.244 2.14 4 4.45 4C29.981 9 32 6.981 32 4.5S29.981 0 27.5 0z"
  }));
};

IcoReservationCompleted.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 9"
};

var IcoReservationCurrently = function IcoReservationCurrently(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M27.5 0c-2.31 0-4.197 1.756-4.45 4H16v1h7.05c.253 2.244 2.14 4 4.45 4C29.981 9 32 6.981 32 4.5S29.981 0 27.5 0zm0 8C25.57 8 24 6.43 24 4.5S25.57 1 27.5 1 31 2.57 31 4.5 29.43 8 27.5 8zM8.95 4C8.696 1.756 6.81 0 4.5 0 2.019 0 0 2.019 0 4.5S2.019 9 4.5 9c2.31 0 4.197-1.756 4.45-4H16V4H8.95z"
  }));
};

IcoReservationCurrently.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 9"
};

var IcoReservationPlanned = function IcoReservationPlanned(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("style", null, ".st0", "{", "display:none", "}"), /*#__PURE__*/React.createElement("path", {
    id: "reservation_1_",
    d: "M27.5 0c-2.31 0-4.197 1.756-4.45 4H8.95C8.696 1.756 6.81 0 4.5 0 2.019 0 0 2.019 0 4.5S2.019 9 4.5 9c2.31 0 4.197-1.756 4.45-4h14.1c.253 2.244 2.14 4 4.45 4C29.981 9 32 6.981 32 4.5S29.981 0 27.5 0zm-23 8C2.57 8 1 6.43 1 4.5S2.57 1 4.5 1 8 2.57 8 4.5 6.43 8 4.5 8zm23 0C25.57 8 24 6.43 24 4.5S25.57 1 27.5 1 31 2.57 31 4.5 29.43 8 27.5 8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "reservation",
    className: "st0",
    d: "M8.5 4H16v1H8.5z"
  }));
};

IcoReservationPlanned.defaultProps = {
  id: "reservation_2_",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 9"
};

var IcoReservationSummaryGeneral = function IcoReservationSummaryGeneral(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21v1H0zM0 5.5h15.5v1H0zM0 10.5h17v1H0zM0 15.5h13v1H0z"
  }));
};

IcoReservationSummaryGeneral.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 16.5"
};

var IcoReservationSummaryStatusReserved = function IcoReservationSummaryStatusReserved(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 23C5.2 23 0 17.8 0 11.5S5.2 0 11.5 0 23 5.2 23 11.5 17.8 23 11.5 23zm0-22C5.7 1 1 5.7 1 11.5S5.7 22 11.5 22 22 17.3 22 11.5 17.3 1 11.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.09 9.393V8.187c0-1.974-1.57-3.58-3.5-3.58s-3.5 1.606-3.5 3.58v1.206H6v9h11v-9h-1.91zm-6-1.206c0-1.422 1.12-2.58 2.5-2.58s2.5 1.158 2.5 2.58v1.206h-5V8.187zM16 17.393H7v-7h9v7z"
  }));
};

IcoReservationSummaryStatusReserved.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23 23"
};

var IcoReservationSummaryStatusV = function IcoReservationSummaryStatusV(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 23C5.2 23 0 17.8 0 11.5S5.2 0 11.5 0 23 5.2 23 11.5 17.8 23 11.5 23zm0-22C5.7 1 1 5.7 1 11.5S5.7 22 11.5 22 22 17.3 22 11.5 17.3 1 11.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.965 6.887a.625.625 0 0 0-.864.168l-5.098 7.55-2.163-2.354a.625.625 0 0 0-.88-.034.625.625 0 0 0-.034.88L9.62 16.03c.021.022.05.033.073.052.015.012.023.03.04.04.012.008.026.01.039.016.042.024.084.041.13.055a.6.6 0 0 0 .104.024c.04.004.078.003.119 0a.605.605 0 0 0 .12-.019.598.598 0 0 0 .097-.039.6.6 0 0 0 .123-.074c.01-.01.025-.012.035-.022.014-.013.02-.03.032-.045.021-.022.047-.037.065-.063l5.537-8.202a.625.625 0 0 0-.168-.865z"
  }));
};

IcoReservationSummaryStatusV.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23 23"
};

var IcoReservationSummaryStatusX = function IcoReservationSummaryStatusX(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.5 23C5.2 23 0 17.8 0 11.5S5.2 0 11.5 0 23 5.2 23 11.5 17.8 23 11.5 23zm0-22C5.7 1 1 5.7 1 11.5S5.7 22 11.5 22 22 17.3 22 11.5 17.3 1 11.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.523 7.08l-.707-.706-4.493 4.492-4.139-4.139-.707.707 4.14 4.14-3.993 3.992.707.707 3.992-3.993 4.346 4.346.707-.707-4.346-4.346z"
  }));
};

IcoReservationSummaryStatusX.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23 23"
};

var IcoTasks = function IcoTasks(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.379 2.5h-1.155l.006-.476a.5.5 0 0 0-.5-.507H9.848l-.117-.09A5.47 5.47 0 0 1 8.52.207.5.5 0 0 0 8.12 0h-.007a.5.5 0 0 0-.396.195 6.059 6.059 0 0 1-1.27 1.244l-.102.078H3.5a.503.503 0 0 0-.5.507l.007.476H1.622C.727 2.5 0 3.189 0 4.036v15.927c0 .848.728 1.537 1.622 1.537H14.38c.91 0 1.621-.675 1.621-1.537V4.036c0-.847-.727-1.536-1.621-1.536zm-7.858.017a.5.5 0 0 0 .32-.116c.062-.052.134-.106.213-.166.261-.199.626-.476 1.051-.945.403.457.76.731 1.016.93.084.063.158.12.222.175a.5.5 0 0 0 .327.122h2.547a.493.493 0 0 0-.415.483v1.5H4.235V3a.492.492 0 0 0-.227-.408l-.001-.075H6.52zM15 19.963c0 .307-.267.537-.621.537H1.622c-.343 0-.622-.24-.622-.537V4.036c0-.285.291-.536.622-.536h1.4l.022 1.56a.5.5 0 0 0 .5.492h9.143a.5.5 0 0 0 .5-.493l.022-1.559h1.17c.343 0 .621.24.621.536v15.927z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.866 7.345H8.79v1H2.866zM2.866 9.773h9v1h-9zM2.866 12.2h8.385v1H2.866zM2.866 14.627h7.154v1H2.866zM2.866 17.055h10.231v1H2.866z"
  }));
};

IcoTasks.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 21.5"
};

var BtnInfo = function BtnInfo(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21C4.71 21 0 16.29 0 10.5S4.71 0 10.5 0 21 4.71 21 10.5 16.29 21 10.5 21zm0-20C5.262 1 1 5.262 1 10.5S5.262 20 10.5 20s9.5-4.262 9.5-9.5S15.738 1 10.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.204 8.896V16H9.78V8.896h1.424zm.32-2.544a.906.906 0 0 1-.084.388c-.056.12-.13.227-.224.32a1.04 1.04 0 0 1-.324.22c-.123.053-.253.08-.392.08s-.268-.027-.388-.08a1.055 1.055 0 0 1-.54-.54 1.001 1.001 0 0 1 0-.784 1.028 1.028 0 0 1 .54-.548c.12-.053.25-.08.388-.08s.27.027.392.08a1.043 1.043 0 0 1 .548.548.96.96 0 0 1 .084.396z"
  }));
};

BtnInfo.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
};

var BtnRate = function BtnRate(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.202 21L5.5 13.401 0 8.02l7.603-1.108L11 0l3.403 6.911 7.6 1.108-5.5 5.382 1.3 7.598L11 17.411 4.202 21zm6.799-4.706l5.478 2.89-1.048-6.121 4.453-4.357-6.15-.897-2.732-5.551-2.73 5.55-6.152.898 4.453 4.357-1.047 6.12 5.475-2.89z"
  }));
};

BtnRate.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22.003418 21"
};

var IcoAvatarGSC = function IcoAvatarGSC(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0zm10 28.153a.85.85 0 0 1-.849.847.85.85 0 0 1-.848-.847V16.69L20 10.885l-8.303 5.805v10.615h11.917v-8.247L20 16.532l-3.614 2.526v4.302a.85.85 0 0 1-.848.847.85.85 0 0 1-.849-.847v-4.714-.007a.847.847 0 0 1 .361-.715l4.36-3.048a.849.849 0 0 1 .547-.226c.014-.001.028-.004.043-.004.015 0 .029.003.043.004.2.008.396.084.547.225l4.36 3.049a.845.845 0 0 1 .352.785c.003.029.009.057.009.086v9.358a.85.85 0 0 1-.849.847H10.85a.85.85 0 0 1-.849-.847V16.295l.002-.017a.846.846 0 0 1 .359-.722l9.05-6.327a.849.849 0 0 1 .546-.226c.014 0 .028-.003.043-.003.015 0 .029.003.043.003.2.01.396.085.547.226l9.049 6.327c.243.17.368.446.36.722l.001.017v11.858z"
  }));
};

IcoAvatarGSC.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
};

var IcoEmptystateNoMessages = function IcoEmptystateNoMessages(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "IcoEmptystateNoMessages"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 52.814c0 4.807 3.83 8.83 8.718 9.16l.636.043.006.633s.1 10.217.1 13.334V76c.1-.011.27-.048.533-.155 1.381-.784 13.109-9.305 19.117-13.702l.183-.132 56.338-.004c5.166 0 9.369-4.124 9.369-9.193V9.191C95 4.123 90.797 0 85.631 0H9.365C4.205 0 .003 4.123 0 9.191v43.623z",
    fill: "#E3E8EB",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5 23a6.5 6.5 0 0 1 6.5 6.5v27.9l-13 9.182V29.5a6.5 6.5 0 0 1 6.5-6.5z",
    fill: "#D1D8DB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121 71.814c0 4.807-3.83 8.83-8.718 9.16l-.636.043-.006.633s-.1 10.217-.1 13.334V95a2.088 2.088 0 0 1-.533-.155c-1.381-.784-13.109-9.305-19.117-13.702l-.183-.132-56.338-.004c-5.166 0-9.369-4.124-9.369-9.193V28.191C26 23.123 30.203 19 35.369 19h76.266c5.16 0 9.362 4.123 9.365 9.191v43.623z",
    fill: "#EEF1F3",
    fillRule: "nonzero"
  })));
};

IcoEmptystateNoMessages.defaultProps = {
  width: "121",
  height: "95",
  viewBox: "0 0 121 95",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoEmptystateAutoMessages = function IcoEmptystateAutoMessages(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("style", null, ".st0", "{", "fill:#aeb6ba", "}", ".st1", "{", "fill:#e3e8eb", "}", ".st2", "{", "fill:#d1d8db", "}", ".st3", "{", "fill:#515c61", "}"), /*#__PURE__*/React.createElement("g", {
    id: "dashboard"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty-states",
    transform: "translate(-2435 -1382)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "inbox-no-auto-messages-TBD",
    transform: "translate(2260 1210)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "snoozed",
    transform: "translate(175 172)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-13",
    className: "st0",
    d: "M44 0c24.3 0 44 19.7 44 44S68.3 88 44 88 0 68.3 0 44 19.7 0 44 0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    className: "st1",
    d: "M44 5c21.54 0 39 17.46 39 39S65.54 83 44 83 5 65.54 5 44 22.46 5 44 5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    className: "st2",
    d: "M44 10.895c20.387.026 37.315 15.869 38.844 36.355 0-.983.156-1.965.156-2.948C83 22.596 65.54 5 44 5S5 22.596 5 44.302c0 1.003 0 1.965.156 2.948C6.685 26.764 23.613 10.92 44 10.895"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    className: "st3",
    d: "M45.667 42.333v-18.5a1.833 1.833 0 1 0-3.667 0v20.334C42 45.18 42.821 46 43.833 46h20.334C65.18 46 66 45.18 66 44.167c0-1.014-.82-1.834-1.833-1.834h-18.5z"
  }))))));
};

IcoEmptystateAutoMessages.defaultProps = {
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 88 88"
};

var IcoEditA = function IcoEditA(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.217 4.465H4.382A1.382 1.382 0 0 0 3 5.846v9.672a1.382 1.382 0 0 0 1.382 1.381h9.67a1.382 1.382 0 0 0 1.382-1.381v-4.836",
    stroke: "#77838D",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.397 3.43a1.465 1.465 0 0 1 2.073 2.072l-6.563 6.562-2.763.691.69-2.763 6.563-6.563z",
    stroke: "#77838D",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

IcoEditA.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoNotes = function IcoNotes(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.79 17H1.64C.74 17 0 16.26 0 15.36V1.64C0 .74.74 0 1.64 0h13.71C16.26 0 17 .74 17 1.64v9.14c0 .13-.05.26-.15.35l-5.71 5.71c-.09.11-.22.16-.35.16zM1.64 1c-.35 0-.64.29-.64.64v13.71c0 .36.29.65.64.65h8.94L16 10.58V1.64c0-.35-.29-.64-.64-.64H1.64z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.79 17c-.06 0-.13-.01-.19-.04a.499.499 0 0 1-.31-.46v-4.57c0-.91.74-1.64 1.64-1.64h4.57c.2 0 .38.12.46.31s.04.4-.11.54l-5.71 5.71c-.1.1-.22.15-.35.15zm1.14-5.71c-.35 0-.64.29-.64.64v3.36l4.01-4.01h-3.37zM2.79 4.57h10.29v1H2.79zM2.79 8h6.86v1H2.79z",
    fill: "#fff"
  }));
};

IcoNotes.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 17",
  fill: "none"
};

var IcoNotificationPaymentApplicationWarning = function IcoNotificationPaymentApplicationWarning(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.002 11.749a.75.75 0 0 1 .75-.75h4a2.25 2.25 0 0 1 2.25 2.25V17a.75.75 0 0 1-1.5 0v-3.751a.75.75 0 0 0-.75-.75h-4a.75.75 0 0 1-.75-.75zM8.002 13.249a2.25 2.25 0 0 1 2.25-2.25h4a.75.75 0 0 1 0 1.5h-4a.75.75 0 0 0-.75.75v16.5c0 .414.336.75.75.75H18.5a.75.75 0 0 1 0 1.5h-8.248a2.25 2.25 0 0 1-2.25-2.25v-16.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.292 9.499l1 3H21.711l1-3h-8.419zm.002-1.5a1.5 1.5 0 0 0-1.425 1.975l1 3a1.502 1.502 0 0 0 1.424 1.025h6.42a1.501 1.501 0 0 0 1.421-1.025l1-3A1.5 1.5 0 0 0 22.712 8M11.75 13.999a.75.75 0 0 1 .75.75v12.75h3.752a.75.75 0 0 1 0 1.5H12.5a1.5 1.5 0 0 1-1.5-1.5v-12.75a.75.75 0 0 1 .75-.75zM25.252 13.999a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75zM25.25 19.999a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5zm-6.75 5.25a6.75 6.75 0 1 1 13.5 0 6.75 6.75 0 0 1-13.5 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.25 21c.414 0 .75.246.75.55v4.4c0 .304-.336.55-.75.55s-.75-.246-.75-.55v-4.4c0-.304.336-.55.75-.55zM25.25 27.501c.414 0 .75.067.75.15v1.2c0 .083-.336.15-.75.15s-.75-.067-.75-.15v-1.2c0-.083.336-.15.75-.15zM14.002 17.749a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5h-4.5a.75.75 0 0 1-.75-.75zM14.002 22.249a.75.75 0 0 1 .75-.75h1.5a.75.75 0 0 1 0 1.5h-1.5a.75.75 0 0 1-.75-.75z",
    fill: "#fff"
  }));
};

IcoNotificationPaymentApplicationWarning.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoNotificationPaymentApplicationSuccess = function IcoNotificationPaymentApplicationSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.252 17v-3.751a1.5 1.5 0 0 0-1.5-1.5h-4M14.252 11.749h-4a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5H18.5",
    stroke: "#fff",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.423 12.736a.75.75 0 0 1-.711.513h-6.42a.751.751 0 0 1-.711-.513l-1-3a.749.749 0 0 1 .712-.987h8.419a.75.75 0 0 1 .71.987l-1 3z",
    stroke: "#fff",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.252 28.249H12.5a.75.75 0 0 1-.75-.75v-12.75M25.252 14.749v1.5",
    stroke: "#fff",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "25.25",
    cy: "25.249",
    r: "6",
    stroke: "#fff",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.924 23.5l-2.905 3.874a.75.75 0 0 1-1.13.08l-1.5-1.5M14.752 17.749h4.5M14.752 22.249h1.5",
    stroke: "#fff",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

IcoNotificationPaymentApplicationSuccess.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoNotificationPaymentApplicationCancelled = function IcoNotificationPaymentApplicationCancelled(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.25 17v-3.751a1.5 1.5 0 0 0-1.5-1.5h-4M14.25 11.749h-4a1.5 1.5 0 0 0-1.5 1.5v16.5a1.5 1.5 0 0 0 1.5 1.5h8.25",
    stroke: "#fff",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.42 12.736a.751.751 0 0 1-.71.513h-6.42a.75.75 0 0 1-.711-.513l-1-3a.749.749 0 0 1 .712-.987h8.418a.749.749 0 0 1 .712.987l-1 3z",
    stroke: "#fff",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.25 28.249H12.5a.75.75 0 0 1-.75-.75v-12.75M25.25 14.749v1.5M14.75 17.749h4.5M14.75 22.249h1.5",
    stroke: "#fff",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "25.25",
    cy: "25.249",
    r: "6",
    stroke: "#fff",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.25 25.249h6",
    stroke: "#fff",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

IcoNotificationPaymentApplicationCancelled.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoNotificationAirbnb = function IcoNotificationAirbnb(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M21.87 20.325a1.719 1.719 0 0 0-.29-.755c-.315-.494-.905-.787-1.58-.787-.652 0-1.23.289-1.584.79a1.737 1.737 0 0 0-.284.747c-.056.335-.037.703.056 1.13.216.974.84 2.145 1.811 3.396.97-1.266 1.596-2.438 1.814-3.397.09-.404.11-.793.056-1.124z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.304 24.164c-.03-.07-.063-.142-.094-.22-.075-.146-.15-.315-.224-.483-.071-.161-.142-.323-.218-.475l-.017-.053a254.47 254.47 0 0 0-4.229-8.691l-.058-.116a36.612 36.612 0 0 1-.232-.445c-.078-.15-.155-.3-.232-.445a4.137 4.137 0 0 0-.525-.827 1.87 1.87 0 0 0-1.436-.664c-.559 0-1.057.23-1.44.666a4.065 4.065 0 0 0-.52.822c-.076.142-.15.284-.223.427-.081.158-.163.316-.244.469l-.057.112a210.626 210.626 0 0 0-4.263 8.702l-.057.117a36.382 36.382 0 0 0-.492 1.084c-.066.15-.123.28-.16.406-.176.49-.23.95-.17 1.453a2.721 2.721 0 0 0 1.67 2.147c.44.172.925.236 1.401.182a3.612 3.612 0 0 0 1.416-.484c.674-.374 1.357-.948 2.088-1.756-1.234-1.557-2.006-2.991-2.296-4.266a4.151 4.151 0 0 1-.097-1.704c.08-.51.265-.975.548-1.381.634-.902 1.702-1.44 2.857-1.44 1.185 0 2.227.525 2.857 1.44.282.403.466.867.55 1.38a4.997 4.997 0 0 1-.1 1.705c-.293 1.29-1.065 2.717-2.294 4.247.776.838 1.441 1.398 2.084 1.756.467.269.931.427 1.419.487.495.057.966-.004 1.398-.184a2.726 2.726 0 0 0 1.673-2.15v-.003c.07-.454.03-.908-.13-1.427a3.6 3.6 0 0 0-.153-.388z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0zm9.065 26.189a4.262 4.262 0 0 1-2.612 3.325 4.05 4.05 0 0 1-2.147.28 5.244 5.244 0 0 1-1.996-.679c-.77-.442-1.533-1.072-2.329-1.924-.825.884-1.569 1.499-2.331 1.925a5.26 5.26 0 0 1-1.994.678 4.46 4.46 0 0 1-.522.041c-.588 0-1.12-.105-1.63-.323a4.28 4.28 0 0 1-2.61-3.335c-.1-.715-.021-1.423.24-2.166.1-.259.197-.492.295-.709l.197-.437c.087-.189.17-.373.248-.55l.022-.046a226.05 226.05 0 0 1 4.288-8.765l.056-.114c.16-.303.315-.607.464-.911.203-.364.422-.743.718-1.097.682-.786 1.604-1.217 2.598-1.217a3.3 3.3 0 0 1 2.58 1.259c.295.331.485.678.67 1.013l.04.074c.153.312.31.613.467.915l.06.117a204.944 204.944 0 0 1 4.275 8.745l.033.047c.077.178.16.363.249.553l.197.434c.07.157.142.334.213.511l.08.2c.275.78.334 1.485.181 2.156z"
  }));
};

IcoNotificationAirbnb.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
};

var IcoNotificationGuesty = function IcoNotificationGuesty(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0zm8.98 26.282a.718.718 0 1 1-1.437 0v-9.733l-7.062-4.952-7.062 4.952v9.015h10.144V18.57l-3.072-2.155-3.073 2.155v3.723a.718.718 0 1 1-1.437 0v-4.082a.699.699 0 0 1 .302-.605l3.706-2.599c.123-.085.294-.18.464-.189h.075c.17 0 .331.095.464.19l3.715 2.589c.218.16.303.32.303.614v8.07a.718.718 0 0 1-.719.718H12.72a.718.718 0 0 1-.718-.718V16.199a.704.704 0 0 1 .302-.614L20 10.189a.868.868 0 0 1 .463-.189h.076c.17 0 .321.085.463.189l7.696 5.396a.661.661 0 0 1 .284.633v10.064z"
  }));
};

IcoNotificationGuesty.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
};

var IcoNotificationPayment = function IcoNotificationPayment(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.25A2.25 2.25 0 0 1 10.25 11h19.5A2.25 2.25 0 0 1 32 13.25v13.5A2.25 2.25 0 0 1 29.75 29h-19.5A2.25 2.25 0 0 1 8 26.75v-13.5zm2.25-.75a.75.75 0 0 0-.75.75v13.5c0 .414.336.75.75.75h19.5a.75.75 0 0 0 .75-.75v-13.5a.75.75 0 0 0-.75-.75h-19.5z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16.25a.75.75 0 0 1 .75-.75h22.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1-.75-.75zM12.5 20.75a.75.75 0 0 1 .75-.75h8.25a.75.75 0 0 1 0 1.5h-8.25a.75.75 0 0 1-.75-.75zM12.5 23.75a.75.75 0 0 1 .75-.75h5.25a.75.75 0 0 1 0 1.5h-5.25a.75.75 0 0 1-.75-.75z",
    fill: "#fff"
  }));
};

IcoNotificationPayment.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
};

var IcoNotificationPaymentBan = function IcoNotificationPaymentBan(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.25 20a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5zm-6.75 5.25a6.75 6.75 0 1 1 13.5 0 6.75 6.75 0 0 1-13.5 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.022 20.478a.75.75 0 0 1 0 1.06l-8.484 8.483a.75.75 0 0 1-1.06-1.06l8.484-8.483a.75.75 0 0 1 1.06 0zM8 10.25A2.25 2.25 0 0 1 10.25 8h16.5A2.25 2.25 0 0 1 29 10.25v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 0-.75-.75h-16.5a.75.75 0 0 0-.75.75v12c0 .414.336.75.75.75h6a.75.75 0 0 1 0 1.5h-6A2.25 2.25 0 0 1 8 22.25v-12z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.25a.75.75 0 0 1 .75-.75h19.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1-.75-.75zM11 17a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6A.75.75 0 0 1 11 17zM11 20a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 11 20z",
    fill: "#fff"
  }));
};

IcoNotificationPaymentBan.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
};

var IcoNotificationPaymentCircleXMark = function IcoNotificationPaymentCircleXMark(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.25 20a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5zm-6.75 5.25a6.75 6.75 0 1 1 13.5 0 6.75 6.75 0 0 1-13.5 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.03 22.47a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 1 1-1.06-1.06l4.5-4.5a.75.75 0 0 1 1.06 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.47 22.47a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06zM8 10.25A2.25 2.25 0 0 1 10.25 8h16.5A2.25 2.25 0 0 1 29 10.25v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 0-.75-.75h-16.5a.75.75 0 0 0-.75.75v12c0 .414.336.75.75.75h6a.75.75 0 0 1 0 1.5h-6A2.25 2.25 0 0 1 8 22.25v-12z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.25a.75.75 0 0 1 .75-.75h19.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1-.75-.75zM11 17a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6A.75.75 0 0 1 11 17zM11 20a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 11 20z",
    fill: "#fff"
  }));
};

IcoNotificationPaymentCircleXMark.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
};

var IcoNotificationPaymentClock = function IcoNotificationPaymentClock(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.25 20a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5zm-6.75 5.25a6.75 6.75 0 1 1 13.5 0 6.75 6.75 0 0 1-13.5 0z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.235 21.833a.75.75 0 0 1 .75.75v1.902h1.902a.75.75 0 0 1 0 1.5h-2.652a.75.75 0 0 1-.75-.75v-2.652a.75.75 0 0 1 .75-.75zM8 10.25A2.25 2.25 0 0 1 10.25 8h16.5A2.25 2.25 0 0 1 29 10.25v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 0-.75-.75h-16.5a.75.75 0 0 0-.75.75v12c0 .414.336.75.75.75h6a.75.75 0 0 1 0 1.5h-6A2.25 2.25 0 0 1 8 22.25v-12z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.25a.75.75 0 0 1 .75-.75h19.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1-.75-.75zM11 17a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6A.75.75 0 0 1 11 17zM11 20a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 11 20z",
    fill: "#fff"
  }));
};

IcoNotificationPaymentClock.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
};

var IcoNotificationPaymentFlag = function IcoNotificationPaymentFlag(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.25A2.25 2.25 0 0 1 10.25 8h16.5A2.25 2.25 0 0 1 29 10.25v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 0-.75-.75h-16.5a.75.75 0 0 0-.75.75v12c0 .414.336.75.75.75h9a.75.75 0 0 1 0 1.5h-9A2.25 2.25 0 0 1 8 22.25v-12z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.25a.75.75 0 0 1 .75-.75h19.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1-.75-.75zM11 17a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6A.75.75 0 0 1 11 17zM11 20a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 11 20zM22.25 20.619a.75.75 0 0 1 .75.75v9.881a.75.75 0 0 1-1.5 0v-9.881a.75.75 0 0 1 .75-.75z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.303 18.727a4.434 4.434 0 0 1 3.863.518c.754.503 1.697.63 2.557.342l1.29-.43a.75.75 0 0 1 .987.712v7a.75.75 0 0 1-.513.712l-1.29.43a4.434 4.434 0 0 1-3.863-.518 2.934 2.934 0 0 0-2.557-.342l-1.29.43a.75.75 0 0 1-.987-.712v-7a.75.75 0 0 1 .513-.712l1.29-.43zm3.03 1.766a2.934 2.934 0 0 0-2.556-.342L23 20.41v5.418l.303-.1a4.434 4.434 0 0 1 3.863.517c.754.503 1.697.63 2.557.342l.777-.259V20.91l-.303.1a4.434 4.434 0 0 1-3.863-.517z",
    fill: "#fff"
  }));
};

IcoNotificationPaymentFlag.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
};

var IcoNotificationPaymentPadlock = function IcoNotificationPaymentPadlock(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.072 10.822a2.25 2.25 0 0 1 2.25-2.25h16.5a2.25 2.25 0 0 1 2.25 2.25v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 0-.75-.75h-16.5a.75.75 0 0 0-.75.75v12c0 .414.336.75.75.75h9a.75.75 0 0 1 0 1.5h-9a2.25 2.25 0 0 1-2.25-2.25v-12z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.072 13.822a.75.75 0 0 1 .75-.75h19.5a.75.75 0 0 1 0 1.5h-19.5a.75.75 0 0 1-.75-.75zM12.072 17.569a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75zM12.072 20.569a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75zM22.572 25.822a2.25 2.25 0 0 1 2.25-2.25h6a2.25 2.25 0 0 1 2.25 2.25v4.5a2.25 2.25 0 0 1-2.25 2.25h-6a2.25 2.25 0 0 1-2.25-2.25v-4.5zm2.25-.75a.75.75 0 0 0-.75.75v4.5c0 .414.336.75.75.75h6a.75.75 0 0 0 .75-.75v-4.5a.75.75 0 0 0-.75-.75h-6z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.072 22.822a3.75 3.75 0 0 1 7.5 0v1.5a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1-.75-.75v-1.5zm3.75-2.25a2.25 2.25 0 0 0-2.25 2.25v.75h4.5v-.75a2.25 2.25 0 0 0-2.25-2.25zM27.822 26.976a1.125 1.125 0 1 0 0 2.25 1.125 1.125 0 0 0 0-2.25z",
    fill: "#fff"
  }));
};

IcoNotificationPaymentPadlock.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
};

var IcoNotificationPaymentShieldPlus = function IcoNotificationPaymentShieldPlus(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.25A2.25 2.25 0 0 1 10.25 8h16.5A2.25 2.25 0 0 1 29 10.25v5.25a.75.75 0 0 1-1.5 0v-5.25a.75.75 0 0 0-.75-.75h-16.5a.75.75 0 0 0-.75.75v12c0 .414.336.75.75.75h6a.75.75 0 0 1 0 1.5h-6A2.25 2.25 0 0 1 8 22.25v-12z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.25a.75.75 0 0 1 .75-.75h19.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1-.75-.75zM11 17a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6A.75.75 0 0 1 11 17zM11 20a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 11 20z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.25 23.75a7.67 7.67 0 0 1-6 7.5 7.67 7.67 0 0 1-6-7.5v-3.541a1.5 1.5 0 0 1 .915-1.382 12.543 12.543 0 0 1 10.17 0 1.5 1.5 0 0 1 .915 1.382v3.541z",
    stroke: "#fff",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.25 20a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 1 .75-.75z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5 23.75a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75z",
    fill: "#fff"
  }));
};

IcoNotificationPaymentShieldPlus.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
};

var IcoNotificationPaymentShieldXMark = function IcoNotificationPaymentShieldXMark(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.25 15.5v-5.25a1.5 1.5 0 0 0-1.5-1.5h-16.5a1.5 1.5 0 0 0-1.5 1.5v12a1.5 1.5 0 0 0 1.5 1.5h6M8.75 13.25h19.5M11.75 17h6M11.75 20h3",
    stroke: "#fff",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.25 23.75a7.67 7.67 0 0 1-6 7.5 7.67 7.67 0 0 1-6-7.5v-3.541a1.5 1.5 0 0 1 .915-1.382 12.543 12.543 0 0 1 10.17 0 1.5 1.5 0 0 1 .915 1.382v3.541z",
    stroke: "#fff",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.371 21.629L23.13 25.87M23.129 21.629l4.242 4.242",
    stroke: "#fff",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

IcoNotificationPaymentShieldXMark.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
};

var IcoNotificationPaymentSync = function IcoNotificationPaymentSync(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 26.75a.75.75 0 0 1 .75-.75H23a.75.75 0 0 1 0 1.5h-3v3a.75.75 0 0 1-1.5 0v-3.75z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.783 26.014a.75.75 0 0 1 .88.592 4.822 4.822 0 0 0 9.294.634.75.75 0 1 1 1.42.486 6.322 6.322 0 0 1-12.186-.832.75.75 0 0 1 .592-.88zM31.25 19.25A.75.75 0 0 1 32 20v3.75a.75.75 0 0 1-.75.75H27.5a.75.75 0 0 1 0-1.5h3v-3a.75.75 0 0 1 .75-.75z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.433 20.01a4.822 4.822 0 0 0-4.89 3.25.75.75 0 1 1-1.42-.486 6.322 6.322 0 0 1 12.186.832.75.75 0 0 1-1.472.288 4.822 4.822 0 0 0-4.404-3.884z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.25A2.25 2.25 0 0 1 10.25 8h16.5A2.25 2.25 0 0 1 29 10.25v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 0-.75-.75h-16.5a.75.75 0 0 0-.75.75v12c0 .414.336.75.75.75h6a.75.75 0 0 1 0 1.5h-6A2.25 2.25 0 0 1 8 22.25v-12z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.25a.75.75 0 0 1 .75-.75h19.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1-.75-.75zM11 17a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6A.75.75 0 0 1 11 17zM11 20a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 11 20z",
    fill: "#fff"
  }));
};

IcoNotificationPaymentSync.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
};

var IcoNotificationPaymentRefresh = function IcoNotificationPaymentRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "20",
    cy: "20",
    r: "20"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.25A2.25 2.25 0 0 1 10.25 8h16.5A2.25 2.25 0 0 1 29 10.25v6a.75.75 0 0 1-1.5 0v-6a.75.75 0 0 0-.75-.75h-16.5a.75.75 0 0 0-.75.75v12c0 .414.336.75.75.75h6a.75.75 0 0 1 0 1.5h-6A2.25 2.25 0 0 1 8 22.25v-12z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13.25a.75.75 0 0 1 .75-.75h19.5a.75.75 0 0 1 0 1.5H8.75a.75.75 0 0 1-.75-.75zM11 17a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6A.75.75 0 0 1 11 17zM11 20a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3A.75.75 0 0 1 11 20zM31.268 18.24c.404 0 .732.34.732.76v4.56c0 .42-.328.76-.732.76h-3.657c-.404 0-.731-.34-.731-.76s.327-.76.731-.76h2.926V19c0-.42.328-.76.732-.76z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.075 18.241c3.085-.066 5.81 2.07 6.581 5.16a.767.767 0 0 1-.53.93.737.737 0 0 1-.901-.548c-.6-2.404-2.72-4.065-5.12-4.013-2.4.052-4.45 1.804-4.951 4.231-.502 2.427.676 4.893 2.846 5.955 2.169 1.062 4.76.442 6.258-1.497a.723.723 0 0 1 1.039-.12c.319.263.371.744.116 1.074-1.925 2.493-5.257 3.29-8.046 1.925-2.79-1.366-4.305-4.536-3.66-7.657.646-3.12 3.282-5.373 6.368-5.44z",
    fill: "#fff"
  }));
};

IcoNotificationPaymentRefresh.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "40",
  height: "40",
  viewBox: "0 0 40 40"
};

var IcoNotificationProperty = function IcoNotificationProperty(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14 16h2v1h-2zM14 20h2v1h-2zM19 16h2v1h-2zM19 20h2v1h-2zM18 28h4v3h-4zM15 9h10v2H15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0zm9 31.5a.5.5 0 0 1-.5.5h-17a.5.5 0 0 1-.5-.5v-20a.5.5 0 0 1 .5-.5H14V8.5a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 .5.5V11h2.5a.5.5 0 0 1 .5.5v20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 16h2v1h-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5 12H12v19h5v-3.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 .5.5V31h5V12H14.5zm2.5 9.5a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v2zm0-4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v2zm5 4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v2zm0-4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v2zm5 4a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v2zm0-6v2a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-2a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 20h2v1h-2z"
  }));
};

IcoNotificationProperty.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
};

var IcoNotificationReservation = function IcoNotificationReservation(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -158)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "10",
    cy: "178",
    r: "3"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "30",
    cy: "178",
    r: "3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 158c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20zm10 24c-2.035 0-3.7-1.532-3.95-3.5h-12.1c-.25 1.968-1.916 3.5-3.95 3.5-2.206 0-4-1.794-4-4s1.794-4 4-4c2.034 0 3.7 1.532 3.95 3.5h12.1c.25-1.968 1.915-3.5 3.95-3.5 2.206 0 4 1.794 4 4s-1.794 4-4 4z"
  })));
};

IcoNotificationReservation.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
};

var IcoNotificationTask = function IcoNotificationTask(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M16.236 12.251v1.5h7.566v-1.5c0-.246.18-.441.415-.483H21.67a.5.5 0 0 1-.327-.122 4.86 4.86 0 0 0-.222-.176c-.256-.197-.613-.472-1.015-.929-.425.468-.79.745-1.05.944-.08.06-.152.115-.215.167a.499.499 0 0 1-.32.116h-2.514l.001.075c.134.09.228.235.228.408z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.379 12.751h-1.17l-.022 1.56a.5.5 0 0 1-.5.492h-9.143a.5.5 0 0 1-.5-.493l-.023-1.559h-1.399c-.331 0-.622.25-.622.536v15.928c0 .296.28.536.622.536H26.38c.354 0 .621-.23.621-.536V13.287c0-.296-.278-.536-.621-.536zm-11.512 3.845h5.923v1h-5.923v-1zm0 2.428h9v1h-9v-1zm0 2.427h8.384v1h-8.384v-1zm0 2.428h7.154v1h-7.154v-1zm10.23 3.427h-10.23v-1h10.23v1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 0C8.954 0 0 8.954 0 20s8.954 20 20 20 20-8.954 20-20S31.046 0 20 0zm8 29.215c0 .861-.712 1.536-1.621 1.536H13.622c-.894 0-1.622-.69-1.622-1.536V13.287c0-.847.728-1.536 1.622-1.536h1.385L15 11.276a.5.5 0 0 1 .5-.508h2.846l.104-.079c.317-.241.751-.571 1.268-1.243.096-.125.237-.212.403-.195a.5.5 0 0 1 .398.206c.476.654.902.982 1.212 1.22l.117.091h2.882a.503.503 0 0 1 .5.508l-.006.475h1.155c.893 0 1.621.69 1.621 1.536v15.928z"
  }));
};

IcoNotificationTask.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
};

var IcoPopupAdd = function IcoPopupAdd(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18 19.125h-5.25a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5H18a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5zm-.5 3.5h-4.25v-2.5h4.25v2.5zM9.25 19.125H4a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5h5.25a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5zm-.5 3.5H4.5v-2.5h4.25v2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.75 40.125h-9.5v-6.5a.5.5 0 0 0-.5-.5H11a.5.5 0 0 0-.5.5v6.5H1v-34h28.75v4.394c.126-.005.248-.019.375-.019.211 0 .417.02.625.032V5.625a.5.5 0 0 0-.5-.5h-4.875V.5a.5.5 0 0 0-.5-.5H5.625a.5.5 0 0 0-.5.5v4.625H.5a.5.5 0 0 0-.5.5v35a.5.5 0 0 0 .5.5h29.75a.5.5 0 0 0 .5-.5v-9.157c-.208.013-.414.032-.625.032-.127 0-.25-.014-.375-.019v8.644zM6.125 1h18.25v4.125H6.125V1zM19.25 40.125H11.5v-6h7.75v6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12.125h-5.25a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5H18a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5zm-.5 3.5h-4.25v-2.5h4.25v2.5zM30.75 10.532c-.208-.013-.414-.032-.625-.032-.127 0-.25.015-.375.019a10.42 10.42 0 0 0-5.211 1.606H21.5a.5.5 0 0 0-.5.5v3.2A10.425 10.425 0 0 0 19.625 21c0 5.663 4.51 10.281 10.125 10.481.125.004.248.019.375.019.21 0 .417-.02.625-.032 5.499-.326 9.875-4.889 9.875-10.468s-4.376-10.142-9.875-10.468zM22 13.125h1.203c-.432.38-.838.789-1.203 1.234v-1.234zm8.75 17.343c-.208.014-.414.032-.625.032-.127 0-.25-.014-.375-.019-5.064-.2-9.125-4.37-9.125-9.481 0-1.578.393-3.064 1.076-4.375a9.507 9.507 0 0 1 3.116-3.5 9.485 9.485 0 0 1 1.943-.998 9.428 9.428 0 0 1 2.99-.608c.125-.005.248-.019.375-.019.211 0 .417.018.625.032 4.947.324 8.875 4.44 8.875 9.468s-3.928 9.144-8.875 9.468zM9.25 12.125H4a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5h5.25a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5zm-.5 3.5H4.5v-2.5h4.25v2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.75 20.583h-5v-5h-1v5h-5v1h5v5h1v-5h5z"
  }));
};

IcoPopupAdd.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40.625 41.125"
};

var IcoPopupConnect = function IcoPopupConnect(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M86.25 5.125h-4.875V.5a.5.5 0 0 0-.5-.5h-19.25a.5.5 0 0 0-.5.5v4.625H56.5a.5.5 0 0 0-.5.5v35a.5.5 0 0 0 .5.5h29.75a.5.5 0 0 0 .5-.5v-35a.5.5 0 0 0-.5-.5zM62.125 1h18.25v4.125h-18.25V1zM75.25 40.125H67.5v-6h7.75v6zm10.5 0h-9.5v-6.5a.5.5 0 0 0-.5-.5H67a.5.5 0 0 0-.5.5v6.5H57v-34h28.75v34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74 12.125h-5.25a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5H74a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5zm-.5 3.5h-4.25v-2.5h4.25v2.5zM77.5 12.125a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5h5.25a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5H77.5zm4.75 3.5H78v-2.5h4.25v2.5zM65.25 12.125H60a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5h5.25a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5zm-.5 3.5H60.5v-2.5h4.25v2.5zM74 19.125h-5.25a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5H74a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5zm-.5 3.5h-4.25v-2.5h4.25v2.5zM82.75 19.125H77.5a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5h5.25a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5zm-.5 3.5H78v-2.5h4.25v2.5zM65.25 19.125H60a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5h5.25a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5zm-.5 3.5H60.5v-2.5h4.25v2.5zM30.25 5.125h-4.875V.5a.5.5 0 0 0-.5-.5H5.625a.5.5 0 0 0-.5.5v4.625H.5a.5.5 0 0 0-.5.5v35a.5.5 0 0 0 .5.5h29.75a.5.5 0 0 0 .5-.5v-35a.5.5 0 0 0-.5-.5zM6.125 1h18.25v4.125H6.125V1zM19.25 40.125H11.5v-6h7.75v6zm10.5 0h-9.5v-6.5a.5.5 0 0 0-.5-.5H11a.5.5 0 0 0-.5.5v6.5H1v-34h28.75v34z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12.125h-5.25a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5H18a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5zm-.5 3.5h-4.25v-2.5h4.25v2.5zM21.5 12.125a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5h5.25a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5H21.5zm4.75 3.5H22v-2.5h4.25v2.5zM9.25 12.125H4a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5h5.25a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5zm-.5 3.5H4.5v-2.5h4.25v2.5zM18 19.125h-5.25a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5H18a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5zm-.5 3.5h-4.25v-2.5h4.25v2.5zM26.75 19.125H21.5a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5h5.25a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5zm-.5 3.5H22v-2.5h4.25v2.5zM9.25 19.125H4a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5h5.25a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5zm-.5 3.5H4.5v-2.5h4.25v2.5zM46.474 20.646a.497.497 0 0 0-.703.703l2.151 2.151h-9.594l2.151-2.15a.498.498 0 0 0-.703-.704l-3.005 3.005a.498.498 0 0 0 0 .703l3.005 3.005a.497.497 0 0 0 .703-.703L38.323 24.5h9.604l-2.156 2.156a.498.498 0 0 0 .703.703l3.005-3.005a.498.498 0 0 0 0-.703l-3.005-3.005z"
  }));
};

IcoPopupConnect.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 86.75 41.125"
};

var IcoPopupImport = function IcoPopupImport(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M33.86 21.646l-3.015 3.015-.102.101V16a.5.5 0 0 0-.5-.5.49.49 0 0 0-.398.213.488.488 0 0 0-.102.287v8.852l-2.398-2.398-.808-.808a.489.489 0 0 0-.192-.115.5.5 0 0 0-.518.119.508.508 0 0 0-.004.71l.265.265.957.957 2.775 2.775c.007.007.017.009.025.016a.494.494 0 0 0 .38.127l.01-.002.008.002c.026 0 .047-.014.071-.018.04-.006.08-.012.116-.028a.477.477 0 0 0 .104-.068c.014-.012.03-.016.043-.03l.054-.053.214-.214 3.729-3.729a.5.5 0 0 0-.004-.71.508.508 0 0 0-.71-.004zM18 19.125h-5.25a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5H18a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5zm-.5 3.5h-4.25v-2.5h4.25v2.5zM9.25 19.125H4a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5h5.25a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5zm-.5 3.5H4.5v-2.5h4.25v2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.75 40.125h-9.5v-6.5a.5.5 0 0 0-.5-.5H11a.5.5 0 0 0-.5.5v6.5H1v-34h28.75v4.394c.126-.005.248-.019.375-.019.211 0 .417.02.625.032V5.625a.5.5 0 0 0-.5-.5h-4.875V.5a.5.5 0 0 0-.5-.5H5.625a.5.5 0 0 0-.5.5v4.625H.5a.5.5 0 0 0-.5.5v35a.5.5 0 0 0 .5.5h29.75a.5.5 0 0 0 .5-.5v-9.157c-.208.013-.414.032-.625.032-.127 0-.25-.014-.375-.019v8.644zM6.125 1h18.25v4.125H6.125V1zM19.25 40.125H11.5v-6h7.75v6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 12.125h-5.25a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5H18a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5zm-.5 3.5h-4.25v-2.5h4.25v2.5zM30.75 10.532c-.208-.013-.414-.032-.625-.032-.127 0-.25.015-.375.019a10.42 10.42 0 0 0-5.211 1.606H21.5a.5.5 0 0 0-.5.5v3.2A10.425 10.425 0 0 0 19.625 21c0 5.663 4.51 10.281 10.125 10.481.125.004.248.019.375.019.21 0 .417-.02.625-.032 5.499-.326 9.875-4.889 9.875-10.468s-4.376-10.142-9.875-10.468zM22 13.125h1.203c-.432.38-.838.789-1.203 1.234v-1.234zm8.75 17.343c-.208.014-.414.032-.625.032-.127 0-.25-.014-.375-.019-5.064-.2-9.125-4.37-9.125-9.481 0-1.578.393-3.064 1.076-4.375a9.507 9.507 0 0 1 3.116-3.5 9.485 9.485 0 0 1 1.943-.998 9.428 9.428 0 0 1 2.99-.608c.125-.005.248-.019.375-.019.211 0 .417.018.625.032 4.947.324 8.875 4.44 8.875 9.468s-3.928 9.144-8.875 9.468zM9.25 12.125H4a.5.5 0 0 0-.5.5v3.5a.5.5 0 0 0 .5.5h5.25a.5.5 0 0 0 .5-.5v-3.5a.5.5 0 0 0-.5-.5zm-.5 3.5H4.5v-2.5h4.25v2.5z"
  }));
};

IcoPopupImport.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40.625 41.125"
};

var IcoPopupSync = function IcoPopupSync(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.698 12.91a.748.748 0 0 0-1.064.245l-4.141 6.82-.042-.609c-.242-3.49.543-6.906 2.27-9.877 2.186-3.761 5.622-6.393 9.672-7.41 5.596-1.403 11.444.566 15.261 5.145a.742.742 0 0 0 1.087.07.855.855 0 0 0 .066-1.153C31.616 1.114 25.19-1.054 19.037.49c-4.45 1.119-8.224 4.01-10.626 8.142a18.932 18.932 0 0 0-2.539 10.284l.023.585-4.545-5.572a.742.742 0 0 0-1.086-.082A.856.856 0 0 0 .187 15l6.299 7.72v-.002c.006 0 .027.014.047.036.05.053.105.097.168.134h.001l.076.046c.105.045.2.067.289.067l.069-.01c.059-.005.086-.006.112-.012a.325.325 0 0 0 .062-.032c.022-.012.043-.026.066-.037l.051-.021c.019-.009.037-.016.054-.028a.75.75 0 0 0 .198-.202l.056-.06 5.194-8.557a.85.85 0 0 0-.231-1.13M40.453 15.361c.001.005-.026-.013-.05-.043a.778.778 0 0 0-.179-.178.72.72 0 0 0-.082-.044.721.721 0 0 0-.22-.07L39.836 15c-.016 0-.04 0-.063.002l-.007.006-.07.001a.681.681 0 0 0-.26.094.847.847 0 0 0-.223.19l-6.231 7.856a.85.85 0 0 0 .098 1.153c.16.14.364.208.569.186a.76.76 0 0 0 .525-.29l4.963-6.254-.027.606c-.316 7.35-5.29 13.669-12.097 15.361-5.312 1.321-10.803-.302-14.69-4.338a.757.757 0 0 0-.546-.234.757.757 0 0 0-.554.243.851.851 0 0 0 .008 1.157C14.498 34.131 18.803 36 23.35 36a16.77 16.77 0 0 0 4.021-.494c7.338-1.827 12.668-8.364 13.264-16.267l.044-.587 3.9 6.12c.227.36.732.469 1.078.223a.85.85 0 0 0 .212-1.137l-5.416-8.497z"
  }));
};

IcoPopupSync.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 46 36"
};

var BtnConnect = function BtnConnect(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 21C4.71 21 0 16.29 0 10.5S4.71 0 10.5 0 21 4.71 21 10.5 16.29 21 10.5 21zm0-20C5.262 1 1 5.262 1 10.5S5.262 20 10.5 20s9.5-4.262 9.5-9.5S15.738 1 10.5 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.55 13.5a.5.5 0 1 1 0-1l2.174-.001a1.672 1.672 0 0 0 1.197-.5 2.07 2.07 0 0 0 .579-1.491c.009-.59-.192-1.113-.566-1.493a1.686 1.686 0 0 0-1.21-.514L11.778 8.5c-.964.001-1.778.917-1.778 2a.5.5 0 1 1-1 0c0-1.652 1.246-2.998 2.777-3l2.947.001c.724 0 1.407.289 1.922.812.564.572.867 1.352.854 2.195a3.067 3.067 0 0 1-.871 2.197 2.642 2.642 0 0 1-1.881.794h-.03l-2.168.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.226 13.501c-.68 0-1.336-.277-1.844-.782a3.08 3.08 0 0 1-.882-2.227 3.058 3.058 0 0 1 .88-2.21c.52-.52 1.197-.805 1.907-.782h2.164a.5.5 0 1 1 0 1H6.276c-.442-.019-.864.165-1.19.49a2.066 2.066 0 0 0-.586 1.5c-.009.591.206 1.139.588 1.52.326.325.735.496 1.178.49h2.958c.447.002.86-.166 1.186-.49.383-.381.599-.929.59-1.503a.5.5 0 0 1 .492-.507h.008a.5.5 0 0 1 .5.493 3.083 3.083 0 0 1-.886 2.227 2.652 2.652 0 0 1-1.9.78H6.276l-.05.001z"
  }));
};

BtnConnect.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
};

var BtnMarketplace = function BtnMarketplace(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.352 11.273H6.75c-.965 0-1.75.715-1.75 1.593v1.215c0 .879.785 1.594 1.75 1.594h2.602c.964 0 1.75-.715 1.75-1.594v-1.215c0-.878-.786-1.593-1.75-1.593zm.75 2.808c0 .322-.344.594-.75.594H6.75c-.414 0-.75-.267-.75-.594v-1.215c0-.327.336-.593.75-.593h2.602c.406 0 .75.272.75.593v1.215z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.26 17.925h-.857V9.912c.76-.443 1.296-1.173 1.41-2.04.176-.51.159-1.597.004-2.15C22.227 3.585 20.897 0 18.618 0H4.696C1.697 0 .862 5.985.772 6.73v.802c0 1.123.73 2.086 1.778 2.545v7.848h-.856C.76 17.925 0 18.722 0 19.7s.76 1.776 1.694 1.776H22.26c.934 0 1.694-.797 1.694-1.776 0-.977-.76-1.774-1.694-1.775zm-.406-11.936c.128.464.091 1.368.016 1.55l-.044.16c-.097.935-1.031 1.669-2.124 1.669-.61 0-1.195-.23-1.604-.633a1.692 1.692 0 0 1-.527-1.199V1h1.047c1.37 0 2.57 2.577 3.236 4.99zM16.57 7.536a1.693 1.693 0 0 1-.528 1.2c-.816.803-2.393.803-3.211 0a1.695 1.695 0 0 1-.528-1.202V1h4.267v6.536zM7.039 1h4.265v6.534c0 .44-.187.866-.527 1.201-.817.804-2.394.804-3.21 0a1.689 1.689 0 0 1-.528-1.203V1zM1.772 7.532l-.003-.74C1.957 5.29 2.898 1 4.696 1h1.343v6.532c0 .44-.188.868-.53 1.203a2.297 2.297 0 0 1-1.604.633c-1.176 0-2.133-.824-2.133-1.836zm1.778 2.803c.118.012.233.033.355.033.871 0 1.712-.335 2.306-.92a2.89 2.89 0 0 0 .327-.388c.097.136.204.267.327.388.593.584 1.434.92 2.306.92.872 0 1.713-.335 2.308-.92.122-.121.229-.252.325-.388.097.136.204.267.327.389a3.311 3.311 0 0 0 2.307.919c.872 0 1.712-.335 2.307-.92a2.92 2.92 0 0 0 .325-.388c.097.136.204.268.326.389.595.584 1.436.919 2.306.919.242 0 .475-.032.701-.079v7.636h-1.55V12.9c0-.897-.784-1.628-1.749-1.628h-2.602c-.965 0-1.75.73-1.75 1.628v5.024H3.55v-7.59zm14.304 7.59h-4.102V12.9c0-.346.337-.628.75-.628h2.602c.414 0 .75.282.75.628v5.024zm4.406 2.55H1.694c-.383 0-.694-.347-.694-.775s.311-.775.694-.775h20.565c.384 0 .695.348.695.775 0 .428-.311.776-.694.776z"
  }));
};

BtnMarketplace.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23.9541016 21.4755859"
};

var BtnPublish = function BtnPublish(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M26.835 5.968L20.907.628a.5.5 0 0 0-.835.372v1.87H16V2h-3V0H3v2H0v18h16V9.27h4.072v2.41a.5.5 0 0 0 .835.37l5.928-5.34a.503.503 0 0 0 0-.742zm-5.763 4.588V8.77a.5.5 0 0 0-.5-.5H15.46c-.155 0-.307.02-.459.034v-.012c-.049.005-.096.017-.145.023a4.683 4.683 0 0 0-.652.134c-.062.017-.124.032-.185.052-.201.065-.399.14-.59.233l-.013.007a4.64 4.64 0 0 0-.464.259h-.005l-.128.088-.6.412-.218.15V6.938c0-.188.026-.374.066-.558.012-.057.03-.112.045-.168.02-.071.05-.141.077-.212.034-.093.056-.187.1-.278l.002-.002c.037-.077.086-.147.13-.22.107-.178.227-.347.369-.5l.015-.019c.123-.131.258-.251.402-.362.051-.039.108-.072.162-.109a3.497 3.497 0 0 1 .534-.3c.09-.04.183-.075.277-.109.089-.031.176-.064.267-.09.13-.035.263-.06.398-.081.052-.009.103-.021.156-.028.164-.02.33-.032.5-.032h5.072a.5.5 0 0 0 .5-.5V2.124l4.68 4.215-4.68 4.217zM4 1h8v1H4V1zm6 18H6v-2h4v2zm5 0h-4v-3H5v3H1V3h13.344c-.021.005-.04.016-.061.02-.26.066-.512.15-.752.257-.047.02-.091.047-.138.069a4.56 4.56 0 0 0-.568.325c-.056.038-.113.075-.167.115-.21.156-.41.324-.586.513-.012.012-.02.027-.032.04-.164.178-.307.375-.436.58-.018.029-.044.052-.061.081h.013c-.056.093-.117.182-.165.28v.003A3.737 3.737 0 0 0 11 6.938v4.698c0 .097.013.176.026.258.003.021.003.046.006.067l.006.039.01.062a.5.5 0 0 0 .496.438h.005a.5.5 0 0 0 .492-.447c.002-.018.009-.035.011-.053a2.83 2.83 0 0 1 .346-1c.034-.062.07-.122.11-.181.04-.062.076-.124.12-.183.064-.084.137-.162.21-.24.047-.05.089-.104.139-.151l.023-.019c.12-.112.246-.219.385-.314a3.606 3.606 0 0 1 .834-.417c.07-.025.139-.052.21-.073.106-.03.216-.052.325-.073.069-.013.136-.03.206-.04.013-.002.027-.002.04-.003V19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8h3V5h-3v3zm1-2h1v1h-1V6zM2 8h3V5H2v3zm1-2h1v1H3V6zM6.5 12h3V9h-3v3zm1-2h1v1h-1v-1zM2 12h3V9H2v3zm1-2h1v1H3v-1z"
  }));
};

BtnPublish.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 27 20"
};

var BtnRefresh = function BtnRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M21.695 3.695a.5.5 0 0 0-.658.258L20 6.33C18.652 2.59 15.072 0 10.998 0c-4.56 0-8.51 3.242-9.393 7.71a.5.5 0 0 0 .982.193c.79-4 4.327-6.903 8.41-6.903A8.593 8.593 0 0 1 19.2 7.066l-2.68-.829a.5.5 0 1 0-.295.955l3.528 1.092c.017.005.035-.001.052.002.032.006.063.02.096.02.016 0 .03-.012.046-.013a.473.473 0 0 0 .152-.045c.034-.015.066-.027.096-.05.012-.009.029-.01.04-.02.036-.032.051-.076.076-.116.013-.021.037-.032.048-.056l1.595-3.652a.5.5 0 0 0-.258-.659zM19.996 10.843a.502.502 0 0 0-.587.394c-.79 4-4.327 6.903-8.411 6.903a8.594 8.594 0 0 1-8.202-6.066l2.68.83a.5.5 0 1 0 .296-.955l-3.443-1.066c-.01-.005-.017-.015-.028-.02a.498.498 0 0 0-.658.258l-1.6 3.665a.5.5 0 1 0 .915.4l1.038-2.375c1.347 3.737 4.928 6.329 9.002 6.329 4.56 0 8.51-3.243 9.392-7.71a.5.5 0 0 0-.394-.587z"
  }));
};

BtnRefresh.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21.9950886 19.1396484"
};

var IcoConnectChannels = function IcoConnectChannels(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M29.854 5.15L24.85.147a.497.497 0 0 0-.703.703L28.297 5H1.703L5.854.85a.498.498 0 0 0-.703-.704L.146 5.15a.499.499 0 0 0 0 .703L5.15 10.86a.497.497 0 0 0 .703-.703L1.698 6h26.604l-4.156 4.156a.498.498 0 0 0 .703.703l5.005-5.005a.498.498 0 0 0 0-.703z"
  }));
};

IcoConnectChannels.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 30 11"
};

var IcoEmptystateMarketplace = function IcoEmptystateMarketplace(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M51.71 34.664h10.92a.5.5 0 0 0 .5-.5v-7.575a.5.5 0 0 0-.5-.5H51.71a.5.5 0 0 0-.5.5v7.575a.5.5 0 0 0 .5.5zm.5-7.575h9.92v6.575h-9.92v-6.575zM70.189 34.664h10.92a.5.5 0 0 0 .5-.5v-7.575a.5.5 0 0 0-.5-.5H70.19a.5.5 0 0 0-.5.5v7.575a.5.5 0 0 0 .5.5zm.5-7.575h9.92v6.575h-9.92v-6.575zM33.23 34.664h10.92a.5.5 0 0 0 .5-.5v-7.575a.5.5 0 0 0-.5-.5H33.23a.5.5 0 0 0-.5.5v7.575a.5.5 0 0 0 .5.5zm.5-7.575h9.92v6.575h-9.92v-6.575zM51.71 48.97h10.92a.5.5 0 0 0 .5-.5v-7.574a.5.5 0 0 0-.5-.5H51.71a.5.5 0 0 0-.5.5v7.574a.5.5 0 0 0 .5.5zm.5-7.574h9.92v6.574h-9.92v-6.574zM70.189 48.97h10.92a.5.5 0 0 0 .5-.5v-7.574a.5.5 0 0 0-.5-.5H70.19a.5.5 0 0 0-.5.5v7.574a.5.5 0 0 0 .5.5zm.5-7.574h9.921v6.574h-9.921v-6.574zM33.23 48.97H44.148a.5.5 0 0 0 .5-.5v-7.574a.5.5 0 0 0-.5-.5H33.23a.5.5 0 0 0-.5.5v7.574a.5.5 0 0 0 .5.5zm.5-7.574H43.648v6.574H33.73v-6.574zM56.17 94.929h1V86h8.928v-1H57.17v-8.929h-1V85h-8.928v1h8.928v.06zM15.45 35.05H7.143a.5.5 0 0 0-.5.5V41.4a.5.5 0 0 0 .5.5h8.305a.5.5 0 0 0 .5-.5V35.55a.5.5 0 0 0-.5-.5zm-.5 5.849H7.643V36.05h7.305v4.848zM15.45 46.747H7.143a.5.5 0 0 0-.5.5v5.848a.5.5 0 0 0 .5.5h8.305a.5.5 0 0 0 .5-.5v-5.848a.5.5 0 0 0-.5-.5zm-.5 5.848H7.643v-4.848h7.305v4.848zM99.051 35.55V41.4a.5.5 0 0 0 .5.5h8.305a.5.5 0 0 0 .5-.5V35.55a.5.5 0 0 0-.5-.5h-8.305a.5.5 0 0 0-.5.5zm1 .5h7.305V40.9h-7.305V36.05zM107.856 46.747h-8.305a.5.5 0 0 0-.5.5v5.848a.5.5 0 0 0 .5.5h8.305a.5.5 0 0 0 .5-.5v-5.848a.5.5 0 0 0-.5-.5zm-.5 5.848h-7.305v-4.848h7.305v4.848z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.67 23.354h-8.636V15.5a.5.5 0 0 0-.5-.5H89.169v-3.5a.5.5 0 0 0-.5-.5H77.41V.5a.5.5 0 0 0-.5-.5H36.59a.5.5 0 0 0-.5.5V11H25.67a.5.5 0 0 0-.5.5V15H8.805a.5.5 0 0 0-.5.5v7.854H.5a.5.5 0 0 0-.5.5V81.5a.5.5 0 0 0 .5.5h24.67v3.56a.5.5 0 0 0 .5.5h13.028c.298 9.68 8.22 17.44 17.971 17.44s17.674-7.76 17.972-17.44H88.67a.5.5 0 0 0 .5-.5V82h24.5a.5.5 0 0 0 .5-.5V23.854a.5.5 0 0 0-.5-.5zM104.033 16v7.354H89.169V16h14.865zM89.169 47.747h3.238v4.848h-3.238v-4.848zm0-11.696h3.238v4.848h-3.238V36.05zM37.09 1h39.32v9.94H37.09V1zM26.17 12h62v73.06H74.647a18.076 18.076 0 0 0-.324-3.06c-.067-.339-.158-.668-.244-1a18.02 18.02 0 0 0-8.91-11.366c-.325-.175-.663-.327-1-.482-2.285-1.05-4.82-1.652-7.5-1.652s-5.214.602-7.5 1.652c-.336.155-.674.307-1 .482A18.02 18.02 0 0 0 39.26 81c-.085.332-.176.661-.243 1a18.076 18.076 0 0 0-.324 3.06H26.169V12zm-1 28.899h-4.237V36.05h4.237v4.848zm0 11.696h-4.237v-4.848h4.237v4.848zM9.305 16H25.17v7.354H9.305V16zm8.136 53.804V81H1V24.354h24.169v10.697h-4.737a.5.5 0 0 0-.5.5v5.848a.5.5 0 0 0 .5.5h4.737v4.848h-4.737a.5.5 0 0 0-.5.5v5.848a.5.5 0 0 0 .5.5h4.737v15.709h-7.228a.5.5 0 0 0-.5.5zm1 11.196V70.304h6.728V81h-6.728zm21.257 5.06c-.006-.168-.025-.332-.026-.5l-.003-.06c0-.149.019-.293.023-.44.027-1.045.135-2.07.344-3.06.07-.339.166-.669.257-1a17.047 17.047 0 0 1 7.876-10.2c.327-.19.66-.365 1-.533 2.266-1.12 4.806-1.767 7.5-1.767s5.235.647 7.5 1.767c.34.168.674.344 1 .533A17.047 17.047 0 0 1 73.046 81c.09.331.186.661.257 1 .208.99.317 2.015.344 3.06.004.147.022.291.022.44l-.003.06c0 .168-.02.332-.025.5-.299 9.113-7.786 16.44-16.972 16.44s-16.672-7.327-16.971-16.44zM95.729 81h-6.56V70.304h6.56V81zm17.44 0H96.73V69.804a.5.5 0 0 0-.5-.5h-7.06v-15.71h3.738a.5.5 0 0 0 .5-.5v-5.847a.5.5 0 0 0-.5-.5h-3.738V41.9h3.738a.5.5 0 0 0 .5-.5V35.55a.5.5 0 0 0-.5-.5h-3.738V24.354h24V81z"
  }));
};

IcoEmptystateMarketplace.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 114.1694336 103.5"
};

var IcoPopupPublish = function IcoPopupPublish(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M44.501 14.028l-9.878-8.9a.5.5 0 0 0-.835.372v3.45h-4.455V5.5a.5.5 0 0 0-.5-.5h-4.5V.5a.5.5 0 0 0-.5-.5H5.5a.5.5 0 0 0-.5.5V5H.5a.5.5 0 0 0-.5.5v33.333a.5.5 0 0 0 .5.5h28.333a.5.5 0 0 0 .5-.5V18.95h4.455v4.35a.5.5 0 0 0 .835.37l9.878-8.899a.503.503 0 0 0 0-.743zM6 1h17.333v4H6V1zm5 37.333v-5.666h7.333v5.666H11zm17.333 0h-9v-6.166a.5.5 0 0 0-.5-.5H10.5a.5.5 0 0 0-.5.5v6.166H1V6h27.333v2.95h-1.568c-2.383 0-4.49 1.075-5.779 2.717A6.219 6.219 0 0 0 20 13.448a5.884 5.884 0 0 0-.333 1.95v7.828c0 .182.022.33.048.484l.028.184a.5.5 0 0 0 .496.44h.004a.5.5 0 0 0 .493-.448c.046-.426.16-.83.305-1.22H25.5a.5.5 0 0 0 .5-.5v-3.151c.253-.029.503-.065.765-.065h1.568v19.383zm-6.787-16.666a5.87 5.87 0 0 1 2.98-2.334c.153-.054.314-.09.474-.131v2.465h-3.454zm13.242.51V18.45a.5.5 0 0 0-.5-.5h-7.523c-.831 0-1.624.143-2.365.383-.73.236-1.408.57-2.005 1-.536.386-1.001.847-1.395 1.36-.114.15-.233.296-.333.454v-5.75c0-.617.12-1.208.333-1.761.13-.34.297-.664.497-.97.236-.362.517-.697.836-1 1.113-1.054 2.686-1.716 4.432-1.716h7.523a.5.5 0 0 0 .5-.5V6.624l8.631 7.775-8.631 7.777z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.167 11.667h-5a.5.5 0 0 0-.5.5V15.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-3.333a.5.5 0 0 0-.5-.5zm-.5 3.333h-4v-2.333h4V15zM8.833 11.667h-5a.5.5 0 0 0-.5.5V15.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-3.333a.5.5 0 0 0-.5-.5zM8.333 15h-4v-2.333h4V15zM17.167 18.333h-5a.5.5 0 0 0-.5.5v3.334a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-3.334a.5.5 0 0 0-.5-.5zm-.5 3.334h-4v-2.334h4v2.334zM8.833 18.333h-5a.5.5 0 0 0-.5.5v3.334a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-3.334a.5.5 0 0 0-.5-.5zm-.5 3.334h-4v-2.334h4v2.334z"
  }));
};

IcoPopupPublish.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 44.6665039 39.3334961"
};

var IcoDeclined = function IcoDeclined(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.701 0 0 4.701 0 10.5S4.701 21 10.5 21 21 16.299 21 10.5 16.299 0 10.5 0zm4.212 13.75l-.962.962-.106-.106-3.144-3.144-3.25 3.25-.962-.962 3.25-3.25-3.25-3.25.962-.962 3.25 3.25 3.25-3.25.962.962-3.25 3.25 3.25 3.25z"
  }));
};

IcoDeclined.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
};

var IcoCleaner = function IcoCleaner(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12.59 2.774V0h-2.281v.092h-8.04L.702 2.06l.784.622.13-.164.392 1.087v1.519l-.013.11c-.006.049-.608 4.875-1.608 9.64-.817 3.9-.105 7.778-.009 8.264.034.764.765 1.378 1.66 1.378h7.108c.888 0 1.616-.607 1.658-1.365.11-.46.75-3.424-.006-7.795-.16-.92-1.009-1.604-1.907-2.328-.636-.512-1.278-1.037-1.709-1.649v-.01h-.007c-.304-.435-.503-.913-.503-1.466V4.66c.19-.014.382-.026.574-.078.51-.137.928-.395 1.188-.71l2.16 2.992.81-.585L9.1 3.086l1.209-.396v.084h2.28zM11.308 1h.28v.774h-.28V1zM8.264 13.807c.748.602 1.455 1.172 1.55 1.72.766 4.431.016 7.399.01 7.43l-.017.125c0 .205-.272.434-.66.434H2.038c-.389 0-.66-.229-.66-.434l-.01-.102c-.009-.039-.815-4.022-.001-7.9.192-.914.368-1.827.53-2.711h4.798c.478.55 1.05 1.02 1.569 1.438zm-6.19-2.438c.442-2.535.74-4.683.857-5.573h2.742v4.107c0 .546.14 1.027.353 1.466H2.075zm.935-6.573V3.518l-.202-.648h3.736l-.87.285v1.64H3.008zM2.132 1.87l.619-.778h7.558v.778H2.132z"
  }));
};

IcoCleaner.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 12.5890732 24.515625"
};

var IcoGeneralNote = function IcoGeneralNote(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1.75 0v8.635c0 .395-.019.787-.057 1.176s-.088.785-.15 1.189H.457c-.062-.404-.112-.8-.15-1.189S.25 9.031.25 8.635V0h1.5zM0 15a.995.995 0 0 1 .602-.921A.988.988 0 0 1 1 14c.14 0 .27.026.392.079.121.053.227.124.318.213A.969.969 0 0 1 2 15c0 .14-.026.272-.077.395a.961.961 0 0 1-.531.529C1.271 15.974 1.14 16 1 16a1.02 1.02 0 0 1-.398-.076.962.962 0 0 1-.525-.53A1.017 1.017 0 0 1 0 15z"
  }));
};

IcoGeneralNote.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 2 16"
};

var BtnAllAcountsListings = function BtnAllAcountsListings(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17.833 2h-1.5V.5a.5.5 0 0 0-.5-.5H8.5a.5.5 0 0 0-.5.5V2H6.5a.5.5 0 0 0-.5.5V8H2.5a.5.5 0 0 0-.5.5V10H.5a.5.5 0 0 0-.5.5v13.334a.5.5 0 0 0 .5.5h11.333a.5.5 0 0 0 .5-.5v-7.5h5.5a.5.5 0 0 0 .5-.5V2.5a.5.5 0 0 0-.5-.5zm-.5 13.334h-3v-2.167a.5.5 0 0 0-.5-.5h-1.5V10.5a.5.5 0 0 0-.5-.5h-1.5V8.5a.494.494 0 0 0-.166-.367v-.966h-2V8H7V3h10.333v12.334zm-5 0v-1.667h1v1.667h-1zm-1 1v7h-3v-2.167a.5.5 0 0 0-.5-.5H4.5a.5.5 0 0 0-.5.5v2.167H1V11h10.333v5.334zm-6.333 7v-1.667h2.333v1.667H5zM3 9h6.333v1H3V9zm6-8h6.333v1H9V1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.167 4.167h2v1.5h-2zM11.167 4.167h2v1.5h-2zM11.167 7.167h2v1.5h-2zM14.167 4.167h2v1.5h-2zM14.167 7.167h2v1.5h-2zM2.167 12.167h2v1.5h-2zM2.167 15.167h2v1.5h-2zM6.5 12.167H5.167v1.5h2v-1.5H7zM6.5 15.167H5.167v1.5h2v-1.5H7zM8.167 13.667h2v-1.5h-2zM8.167 15.167v1.5h2v-1.5H10z"
  }));
};

BtnAllAcountsListings.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18.3334961 24.3339844"
};

var BtnLeftSmall = function BtnLeftSmall(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M.137 4.172L4.172.137a.488.488 0 0 1 .689.69L1.156 4.53l3.705 3.705a.488.488 0 0 1-.69.69L.138 4.89A.477.477 0 0 1 0 4.53a.474.474 0 0 1 .136-.357z"
  }));
};

BtnLeftSmall.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 4.9977479 9.0618038"
};

var BtnRight = function BtnRight(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M.849.146L5.854 5.15a.497.497 0 0 1 0 .703L.85 10.86a.497.497 0 1 1-.703-.703l4.653-4.654L.146.849A.497.497 0 1 1 .849.146z"
  }));
};

BtnRight.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 6 11.0054388"
};

var BtnRightSmall = function BtnRightSmall(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.997 4.529a.477.477 0 0 1-.136.361L.826 8.925a.489.489 0 0 1-.69-.69l3.706-3.704L.137.826a.489.489 0 0 1 .69-.69L4.86 4.173a.474.474 0 0 1 .136.357z"
  }));
};

BtnRightSmall.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 4.9977479 9.0618038"
};

var BtnTimeFill = function BtnTimeFill(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C4.71 0 0 4.71 0 10.5S4.71 21 10.5 21 21 16.29 21 10.5 16.29 0 10.5 0zM16 12H9V5h1v6h6v1z"
  }));
};

BtnTimeFill.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21 21"
};

var BtnYieldAvailabilty = function BtnYieldAvailabilty(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.903 4.044c.06.31.097.63.097.959v.027c0 .655-.406 1.213-.979 1.442-.18.072-.373.114-.577.114a1.55 1.55 0 0 1-1.383-.86 1.448 1.448 0 0 1-.16-.484c-.005-.03-.005-.06-.03-.166-.241-1.046-1-1.834-1.87-1.834-1.015 0-1.787.694-1.836 1.649-.036.709.09 1.202.383 1.512.371.39 1.092.572 2.272.572 1.416 0 2.487.227 3.2.674.22.137.407.291.558.47.314.371.402.743.422.991v8.071A1.82 1.82 0 0 1 8.182 19H1.818A1.82 1.82 0 0 1 0 17.181V5.003A5.007 5.007 0 0 1 5 0C7.43 0 9.453 1.743 9.903 4.044zm-.877 5.208c0-.003 0-.036-.005-.081v-.003a.781.781 0 0 0-.212-.442c-.26-.288-.994-.772-2.989-.772-1 0-2.244-.1-2.982-.876-.487-.514-.7-1.246-.65-2.236.074-1.47 1.283-2.58 2.812-2.58 1.087 0 2.027.723 2.533 1.782.16.337.31.987.31.987-.008.314.284.576.601.576s.577-.259.577-.576v-.028c0-.332-.052-.65-.128-.959C8.46 2.29 6.885.98 5 .98A4.027 4.027 0 0 0 .98 5.003v12.178c0 .462.377.84.839.84h6.364a.84.84 0 0 0 .839-.84v-8.01a.783.783 0 0 1 .005.081"
  }));
};

BtnYieldAvailabilty.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 10 19"
};

var BtnYieldGaps = function BtnYieldGaps(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M17.855 3.637L14.057.133a.512.512 0 0 0-.69 0 .43.43 0 0 0 0 .636l2.801 2.583H1.83L4.632.767a.422.422 0 0 0 0-.636.523.523 0 0 0-.69 0L.146 3.634a.425.425 0 0 0-.14.382.429.429 0 0 0 .14.347l3.798 3.504c.195.18.499.175.69 0a.43.43 0 0 0 0-.636L1.394 4.245c.012 0 .023.006.035.006H16.6l-3.232 2.982a.422.422 0 0 0 0 .636c.185.17.499.176.69 0l3.797-3.503a.425.425 0 0 0 .14-.382.429.429 0 0 0-.14-.347z"
  }));
};

BtnYieldGaps.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 8"
};

var BtnYieldHolidays = function BtnYieldHolidays(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5.335 17.701l-.022-.002h-.33v-5.095l.572.015.094-.04C7.873 11.634 9 7.831 9 1.28 9 .221 6.448 0 4.307 0c-1.052 0-2.021.072-2.73.203C1.148.283 0 .494 0 1.278 0 7.793 1.114 11.59 3.312 12.563l.705.017v5.12l-.353.001c-1.433.125-2.964.62-2.964 1.63C.7 20.479 2.67 21 4.5 21s3.8-.522 3.8-1.668c0-1.011-1.531-1.506-2.965-1.63zM8.033 1.4a46.88 46.88 0 0 1-.046 1.929H1.013A47.017 47.017 0 0 1 .967 1.37C1.759.781 7.13.807 8.033 1.4zM1.063 4.28h6.874c-.362 5.368-1.692 6.946-2.584 7.384l-1.731-.013c-.883-.449-2.198-2.038-2.559-7.37zM4.5 20.05c-1.83 0-2.781-.524-2.833-.711.04-.153.697-.567 2.04-.687H5.27c1.37.124 2.023.535 2.064.675-.053.199-1.004.723-2.834.723z"
  }));
};

BtnYieldHolidays.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 9 21"
};

var BtnYieldRecurring = function BtnYieldRecurring(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.797 13.008c-3.27 0-5.907-2.612-5.907-5.853 0-1.241.404-2.443 1.144-3.436h.3V7h1.11V2.625H0v1.094h1.831A6.774 6.774 0 0 0 .89 7.155C.889 10.925 3.992 14 7.797 14a6.602 6.602 0 0 0 2.87-.628l-.4-.893c-.768.364-1.603.529-2.47.529zM14.148 10.281a6.73 6.73 0 0 0 .963-3.456C15.111 3.066 12.008 0 8.203 0c-1 0-1.969.23-2.87.626l.4.89C6.502 1.155 7.337.99 8.204.99c3.27 0 5.907 2.605 5.907 5.836a5.737 5.737 0 0 1-1.173 3.456h-.27V7h-1.111v4.375H16v-1.094h-1.852z"
  }));
};

BtnYieldRecurring.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 14"
};

var BtnYieldSeasons = function BtnYieldSeasons(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M18.288.255c-2.15.31-3.852.109-5.352-.068C10.9-.052 9.145-.259 7.13.885c-2.623 1.49-3.633 4.667-2.297 7.232l.003-.001c.011.026.027.053.04.08-1.455.476-3.141.676-4.138-.4L0 8.458c.683.737 1.622 1.107 2.778 1.107.793 0 1.69-.178 2.677-.527C6.509 10.308 8.095 11 9.73 11c.982 0 1.98-.246 2.887-.762 4.7-2.669 6.169-9.12 6.229-9.393L19 .153l-.712.102zm-6.169 9.133c-1.906 1.083-4.283.724-5.695-.76.247-.12.495-.251.743-.375.803.768 1.837 1.01 2.806 1.01 1.48 0 2.801-.548 2.894-.587l-.394-.902c-.031.012-2.726 1.125-4.341-.008a80.126 80.126 0 0 0 3.55-1.977c.28.1.576.16.882.16 1.205 0 2.463-.63 2.643-.725l-.465-.868c-.284.147-.931.417-1.579.541a248.32 248.32 0 0 0 3.507-2.174l-.54-.827a195.323 195.323 0 0 1-4.906 3.018c.407-.918 1.443-1.754 1.924-2.064l-.545-.822c-.108.07-2.504 1.63-2.545 3.556-.635.364-1.271.728-1.904 1.066-.555-2.535 2.304-4.388 2.435-4.472l-.54-.826c-1.353.854-3.561 3.1-2.807 5.76-.476.244-.953.497-1.428.723a10.4 10.4 0 0 1-.094-.167c-1.091-2.1-.253-4.705 1.91-5.933 1.726-.98 3.254-.8 5.187-.573 1.39.165 2.945.347 4.871.155-.504 1.694-2.106 6.104-5.569 8.071z"
  }));
};

BtnYieldSeasons.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 19 11"
};

var BtnYieldAvailability = function BtnYieldAvailability(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "#7A8489",
    fillRule: "evenodd",
    d: "M9.903 4.044c.06.31.097.63.097.959v.027c0 .655-.406 1.213-.979 1.442-.18.072-.373.114-.577.114a1.55 1.55 0 0 1-1.383-.86 1.448 1.448 0 0 1-.16-.484c-.005-.03-.005-.06-.03-.166-.241-1.046-1-1.834-1.87-1.834-1.015 0-1.787.694-1.836 1.649-.036.709.09 1.202.383 1.512.371.39 1.092.572 2.272.572 1.416 0 2.487.227 3.2.674.22.137.407.291.558.47.314.371.402.743.422.991v8.071A1.82 1.82 0 0 1 8.182 19H1.818A1.82 1.82 0 0 1 0 17.181V5.003A5.007 5.007 0 0 1 5 0c2.43 0 4.453 1.743 4.903 4.044zm-1.01 0C8.46 2.29 6.885.98 5 .98A4.027 4.027 0 0 0 .98 5.003v12.178c0 .462.377.84.839.84h6.364a.84.84 0 0 0 .839-.84v-8.01a.784.784 0 0 1 .005.081l.208.032-.208-.032c0-.003 0-.036-.005-.081v-.003a.781.781 0 0 0-.212-.442c-.26-.288-.994-.772-2.989-.772-1 0-2.244-.1-2.982-.876-.487-.514-.7-1.246-.65-2.236.074-1.47 1.283-2.58 2.812-2.58 1.087 0 2.027.723 2.533 1.782.16.337.31.987.31.987-.008.314.284.576.601.576a.578.578 0 0 0 .577-.576v-.028c0-.332-.052-.65-.128-.959z"
  }));
};

BtnYieldAvailability.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "19",
  viewBox: "0 0 10 19"
};

var Accessibility = function Accessibility(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "accessibility"), /*#__PURE__*/React.createElement("path", {
    d: "M31 16.6h-7.3v15.9h-2.4v-7.3h-2.4v7.3h-2.6V16.6H9v-2.5h22v2.5zM20 8c1.4 0 2.4 1.1 2.4 2.4 0 1.3-1.1 2.4-2.4 2.4-1.3 0-2.4-1-2.4-2.4S18.6 8 20 8z",
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }));
};

Accessibility.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Aircondition = function Aircondition(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "air condition"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.842 20.352H9.158c-.291 0-.658-2.55-.658-6.168 0-3.618.367-5.17.658-5.17h21.684c.291 0 .658 1.511.658 5.17s-.367 6.168-.658 6.168z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    d: "M30.053 20.352l-.291-2.883H10.238l-.293 2.883M31.496 13.133H8.503M8.525 15.226h22.95M21.062 22.313V31M23.687 22.313v4.344M17.875 22.313v5.764M15.437 22.313V24"
  })));
};

Aircondition.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Baby = function Baby(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "baby"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.1 32.6c-.3-1.1-.6-5.6-.6-7.4 0-3.2 1-4.4 1-7 0-6.6-4.7-9.7-10.5-9.7S9.5 11.6 9.5 18.2c0 2.6 1 2.5 1 7 0 2.2-.2 6.5-.5 7.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1 10.6a7.1 7.1 0 1 1 0 14.2 7.1 7.1 0 0 1 0-14.2zM23.6 23.9S20.6 26 20 27M15.9 23.4c.1.1 6.1 4.4 8.7 9.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 16c.718 0 1.3.627 1.3 1.4 0 .773-.582 1.4-1.3 1.4-.718 0-1.3-.627-1.3-1.4 0-.773.582-1.4 1.3-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4 16.1a.5.5 0 1 1-.001 1.002.5.5 0 0 1 .001-1.002zM17.2 16c.718 0 1.3.627 1.3 1.4 0 .773-.582 1.4-1.3 1.4-.718 0-1.3-.627-1.3-1.4 0-.773.582-1.4 1.3-1.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7 16.3a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zM19.2 22.1c-.4-.3-.6-.7-.6-1.2 0-.9.7-1.5 1.5-1.5s1.5.7 1.5 1.5c0 .5-.2.9-.6 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6 20.7l.3.6c.2.6.5 1.1.2 1.4-.1.2-.4.3-.9.3s-.8-.1-.9-.3c-.2-.3 0-.7.2-1.2.1-.3.2-.5.3-.8M19.9 13.9v-1.4s.1-.7.8-.7c.5 0 .9.1.9.9 0 0 .1.8-1.2.8 0 0-.8 0-1.2-.7-.2-.4-.2-.9.1-1.4 0 0 .4-.6.5-1.2 0-.4-.1-.7-.1-.7"
  })));
};

Baby.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Bath = function Bath(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "bath"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.9 33.903c-.1 0-.9-.101-1.4-.4-.5-.401-.8-1-.8-1.1M11.3 32.302s-.5.8-1 1.1c-.5.4-1.3.4-1.4.4M33.8 24.402s-1.7 7.9-3.9 7.9h-20c-2.2 0-3.9-7.9-3.9-7.9M33.7 24.402c.5 0 .7-.3.7-.6s-.2-.6-.7-.6H6.2c-.5 0-.7.3-.7.6s.2.6.7.6M30.9 8.402l-2.6.5 2.2 2.2zM29.7 12.402l-.6 1.3M28.1 15.602l-.5 1.3M27 18.602l-.6 1.3M27.2 10.002l-1.2.8M24.1 11.602l-1.2.8M20.9 13.702l-1.2.7M25.1 13.202l-1.1.9M22.6 15.402l-1.1.9M28.3 11.402l-1 1.3M26.5 14.402l-.9 1.2M24.5 17.102l-.9 1.2M33.3 23.102v-16.2l-2.4 1.5"
  })));
};

Bath.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Bbq = function Bbq(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "bbq"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 26.561h22.9V.002H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 7)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.8 4.262c.3.8-.2 1.8-1.3 1.8-1 0-1.6-1-1.2-1.8.3-.8 1.2-3 1.2-3s1 2.2 1.3 3zM16.6 5.561c-.2-.5-.7-1.7-.7-1.7s-.7 1.2-.9 1.7c-.2.5.1 1.1.8 1.1.6-.1 1-.6.8-1.1M8 5.561c-.2-.5-.7-1.8-.7-1.8s-.6 1.3-.8 1.8c-.2.5.1 1.1.7 1.1.7 0 1-.6.8-1.1M2.9 22.262l4.1-6.8M20.1 24.262H2.9M20.1 22.262l-4-6.7",
    stroke: "#58595B"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#58595B",
    mask: "url(#b)",
    d: "M.5 26.061h2.2v-4.5H.5zM20.2 26.061h2.2v-4.5h-2.2zM2.1 8.861c.6 4.6 4.7 7.601 9.6 7.601 4.9 0 8.9-3 9.6-7.6H2.1z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#58595B",
    mask: "url(#b)",
    d: "M1.7 9.062v-2.1h19.6v2.1"
  })));
};

Bbq.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var Beach = function Beach(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "beach"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.3 18.1c.1-.5.1-.9.1-.9v-.6c0-2.6-1.5-7.1-5.6-7.1-2.6 0-3.3 2.1-3.3 4.7 0 .4 0 .8.1 1.2.1.6.2 1.3.3 2.1l.4 3.3c0 .3.1.6.1.9 0 1.9.3 6.9.3 6.9 0 1.8 1.3 2.9 3.1 3 2 0 3.4-1.2 3.4-3l.6-6.2c.1-.1.4-3 .5-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 14.3c-.4.5-.8 1.2-1.1 1.6-.8 1.4-1.1 4-1.1 4M26.3 14.2c.5.4 1 .9 1.5 1.5 1.5 1.8 2.3 4.3 2.3 4.3M10.6 18.1c0-.5-.1-.8-.1-.9v-.6c0-2.6 1.5-7.1 5.6-7.1 2.6 0 3.3 2.1 3.3 4.7 0 .4 0 .8-.1 1.2 0 .6-.2 1.3-.3 2.1l-.4 3.3c0 .3-.1.6-.1.9 0 1.9-.3 6.9-.3 6.9 0 1.8-1.3 2.9-3.1 3-2 0-3.4-1.2-3.4-3l-.6-6.2c0-.1-.3-3-.5-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14.3c.3.6.8 1.2 1 1.7.8 1.4 1.2 3.9 1.2 3.9M14.7 14.2c-.5.4-1 .9-1.5 1.5-1.6 1.8-2.4 4.3-2.4 4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6 13a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4zM25.4 13a1.2 1.2 0 1 1 0 2.399 1.2 1.2 0 0 1 0-2.399z"
  })));
};

Beach.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Bed = function Bed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "bed"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 17.5l-.7 3.6M29.6 17.4h2.7M10.9 17.4H8.2M6.8 21.8V30h1.6v-2.4h24.2V30h1.1v-8.2M32.6 17.1v-6M7.9 11.1v6M29.3 17.9c0 .3-.2.6-.6.7-2.5.3-5 .3-7.5 0-.4 0-.6-.4-.6-.7.1-1.4.3-2.7.4-4.1 0-.3.3-.7.6-.8 2.2-.7 4.4-.7 6.6 0 .3.1.6.5.6.8.2 1.3.4 2.7.5 4.1zM19.9 17.9c0 .3-.2.6-.6.7-2.5.3-5 .3-7.5 0-.4 0-.6-.4-.6-.7.1-1.4.3-2.7.4-4.1 0-.3.3-.7.6-.8 2.2-.7 4.4-.7 6.6 0 .3.1.6.5.6.8.2 1.3.3 2.7.5 4.1zM32.5 17.5l.7 3.6M6.8 21.8h26.9M6.5 10.5h27.2"
  })));
};

Bed.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Breakfast = function Breakfast(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "breakfast"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.482 16.594c.398-1.33 1.76-3.33 3.487-3.33h2.062c1.904 0 3.08 1.474 3.213 2.959M23.556 21.717c-.453.93-1.952 1.783-3.556 1.783a4.445 4.445 0 0 1-3.533-1.795",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.383 22.064c-.684.82-1.785.947-2.922.703-.805-.173-1.672-.594-1.905-1.05M24.244 16.79a2.19 2.19 0 0 1 1.989-.208l1.654.618c1.282.582 1.472 1.447 1.396 2.515",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.283 18.715c.25-.14 2.217.425 2.217 3.675 0 1.606-2.422 1.279-3.118-.327M11.617 22.064c.684.82 1.784.947 2.921.703.806-.173 1.674-.594 1.905-1.05M15.482 16.637a2.203 2.203 0 0 0-1.715-.056l-1.654.618c-1.282.583-1.472 1.448-1.396 2.516",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.717 18.715c-.252-.14-2.217.425-2.217 3.675 0 1.606 2.422 1.279 3.118-.327M23.677 21.265l.567-4.476M29.283 19.715l-.586 2.015M16.262 21.265l-.78-4.627M10.717 19.715l.587 2.185",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

Breakfast.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Buzzer = function Buzzer(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "buzzer"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.658v1.818l.007.816C10.636 23.626 14.836 25.5 20 25.5c5.247 0 9.5-1.934 9.5-4.319v-2.399",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.606 15.096c1.785.854 2.894 2.05 2.894 3.375 0 2.594-4.253 4.696-9.5 4.696s-9.5-2.102-9.5-4.696c0-1.297 1.063-2.47 2.782-3.32",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.623 13.636v3.758c0 1.809-2.966 3.275-6.623 3.275-3.658 0-6.623-1.466-6.623-3.276v-3.758",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 16.879c3.658 0 6.623-1.466 6.623-3.274S23.658 10.33 20 10.33c-3.658 0-6.623 1.466-6.623 3.274s2.965 3.274 6.623 3.274z",
    stroke: "#464646"
  })));
};

Buzzer.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Cats = function Cats(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "cats"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.95 10.938c-.1-.7.4-2.8.4-2.8 0-1-.8-.3-.8-.3l-1.3 1.7c-.4-.2-.8-.3-1.3-.3s-1.1.1-1.6.2l-1.3-1.7s-.8-.7-.8.3c0 0 .4 1.9.4 2.7-.4.9.1 2.1.3 3 0 0-3.2 2.1-5 3.7-1.3 1.2-3.4 3.8-3.4 7 0 0 0 3.1.1 4 0 0-.6 2.5.6 3.6 1.2 1.2 3.7 2.6 8.3-.6 0 0 .2-.5-.7-.2-.9.3-6.1 2.1-5.9-1.7h7.8s.5-.2.2-1c-.1-.4-.3-.4-.8-.4h-.8l1.8-1.9 1.1 2s.6 1.2.8 1.3c.2.2 1 .2 1.3 0 .3-.2.5-1 .4-1.3-.2-.3-.8-.4-.8-.4l-1.1-6.2s2.1-3.3 1.6-7.3c-.1-.1 1.3-1.6.5-3.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.15 11.838c0 .2-.4.4-.7.4-.3 0-.6-.4-.6-.6 0-.2.4-.4.7-.4.4 0 .6.4.6.6zM24.55 11.838c0 .2.4.4.7.4.3 0 .6-.4.6-.6 0-.2-.4-.4-.7-.4-.4 0-.6.4-.6.6zM18.15 20.138s4.3.4 5 6.1"
  })));
};

Cats.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Chair = function Chair(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "chair"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9 19.9v15.6h-1.4V20.4M28.9 20.4v15.1h-1.4V19.9M14.4 12.8v4.7M27 12.8v4.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M29.9 19.4c0 .3-.2.5-.5.5H12c-.3 0-.5-.2-.5-.5V18c0-.3.2-.5.5-.5h17.4c.3 0 .5.2.5.5v1.4zM28.4 10.8c0 1.1-.9 1.9-1.9 1.9H14.9c-1.1.1-1.9-.8-1.9-1.9V7.4c0-1.1.9-1.9 1.9-1.9h11.6c1.1 0 1.9.9 1.9 1.9v3.4zM13.9 23.3h13.6"
  }))));
};

Chair.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Checkin = function Checkin(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "checkin"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.451 28.264l.82-.822a4.861 4.861 0 0 0 3.8-1.418 4.917 4.917 0 0 0-.002-6.931 4.866 4.866 0 0 0-6.901 0 4.898 4.898 0 0 0-1.413 3.816l-.96.963.607.61-4.685 4.704.044 3.27 3.256.044.427-.428-.299-1.116 1.111.3.805-.808-.297-1.116 1.11.299.806-.808-.3-1.116 1.114.3",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.606 22.31a1.226 1.226 0 0 1-1.74 0 1.238 1.238 0 0 1 0-1.747 1.228 1.228 0 0 1 1.74 0 1.238 1.238 0 0 1 0 1.747zM21.414 25.382l-1.042-1.045M25.98 14.235a2.465 2.465 0 0 1-2.46 2.471H11.96a2.466 2.466 0 0 1-2.46-2.47v-3.883a2.466 2.466 0 0 1 2.46-2.47h11.56a2.465 2.465 0 0 1 2.46 2.47v3.882z",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.79 13.477a1.11 1.11 0 0 1-1.106-1.113c0-.614.496-1.111 1.107-1.111",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.81 21.06c1.358 0 2.466-1.07 2.466-2.437v-3.787c0-1.365-.988-2.542-2.346-2.542h-3.697M16.092 13.477c0 .617-.588 1.023-1.202 1.023h-.755c-.616 0-1.34-.406-1.34-1.023v-2.52c0-.617.518-.869 1.134-.869h1.099c.613 0 1.064.252 1.064.869v2.52zM18.274 9.602c.616 0 1.114.738 1.114 1.355v2.991M17.74 14.5h3.296",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

Checkin.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Cleaning = function Cleaning(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "cleaning"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3 19.9c0-.4.3-.7.7-.7h7.8c.4 0 .7.3.7.7v1.7h-9.2v-1.7zM19.9 5v14M15.3 21.6c0 4.6-3.8 12.3-3.8 12.3 0 .6.5 1.1 1.1 1.1h1.9c1.8-2.4 3.2-6.6 3.2-6.6.2 3.3-.2 5.4-.7 6.6h2.3c.6-1.3 1.5-2.3 1.5-2.3V35h2.7c-.2-1.1-.3-2.6-.2-4.5 0 0 .8 2.3 1.9 4.5H27c.6 0 1.1-.5 1.1-1.1 0 0-3.8-7.7-3.8-12.3"
  })));
};

Cleaning.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Cmdetector = function Cmdetector(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "CM detector"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 17.84l-.007-3.742c-.144-2.14-4.785-3.859-10.493-3.859-5.8 0-10.5 1.774-10.5 3.962v3.638",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.698 20.868c-1.973-.783-3.199-1.88-3.199-3.096 0-2.379 4.701-4.307 10.5-4.307 5.8 0 10.5 1.928 10.5 4.307 0 1.19-1.174 2.267-3.075 3.046",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.68 23.208V19.76c0-1.66 3.278-3.004 7.32-3.004 4.043 0 7.32 1.345 7.32 3.004v3.447",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20.233c-4.043 0-7.32 1.345-7.32 3.003 0 1.66 3.277 3.003 7.32 3.003s7.32-1.344 7.32-3.003c0-1.658-3.277-3.003-7.32-3.003z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 22.256c-1.319 0-2.389.44-2.389.98 0 .541 1.07.98 2.389.98 1.319 0 2.389-.439 2.389-.98 0-.54-1.07-.98-2.389-.98z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.06 27.834c-.028.019-.688.47-.688.998 0 .51.618.96.681 1.005.002 0 .002.002.004.003.005.004.576.404.576.837 0 .427-.566.817-.575.823M20.057 27.834c-.027.019-.687.47-.687.998 0 .51.618.96.68 1.005a.014.014 0 0 1 .004.003c.006.004.576.404.576.837 0 .427-.564.817-.574.823M24.056 27.834c-.028.019-.687.47-.687.998 0 .51.617.96.68 1.005a.014.014 0 0 1 .004.003c.005.004.575.404.575.837 0 .427-.564.817-.573.823",
    stroke: "#464646",
    strokeLinecap: "round"
  })));
};

Cmdetector.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Coffee = function Coffee(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "coffee"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.6 25.2c1.4-.7 2.4-1.8 3.1-3.1 2.3-.3 3.7-2.1 3.7-4.2 0-1.7-.6-3.8-2.3-4.4H10.9c0 3.1-.2 9.2 4.5 11.7M33.5 25.2c0 2.1-8.3 2.7-13.1 2.7-3.9 0-12.9-.8-12.9-2.7h26zM29.8 15.8l-.9 3.9"
  })));
};

Coffee.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Console = function Console(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "console"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.763 15.507s-1.4-4.2-5.101-4c0 0-1.1.1-2.4.6l-2.9.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.362 15.507s1.4-4.2 5.1-4c0 0 1.1.1 2.4.6l2.9.1M20.362 24.707h4.8s.6-.1 1.5.6c0 0 3.6 4.2 5 3.8 0 0 1.6-.8 1.9-3.1.3-2.3-.5-5.8-2-9 0 0-.8-2.4-2.7-3.4 0 0-2.8-1.3-4-.2l-1.899 2.1h-2.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.763 24.707h-4.8s-.6-.1-1.5.6c0 0-3.6 4.2-5 3.8 0 0-1.6-.8-1.9-3.1-.3-2.3.5-5.8 2-9 0 0 .8-2.4 2.7-3.4 0 0 2.8-1.3 4-.2l1.9 2.1h2.6M20.862 12.207a1.4 1.4 0 1 1 .001 2.8 1.4 1.4 0 0 1 0-2.8zM22.562 17.907a.2.2 0 1 1 0 .4.2.2 0 0 1 0-.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.562 17.907a.2.2 0 1 1 0 .4.2.2 0 0 1 0-.4zM23.463 20.307a1.4 1.4 0 1 1-.002 2.8 1.4 1.4 0 0 1 .002-2.8zM18.062 20.307a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8zM14.162 15.707a1.4 1.4 0 1 1 .001 2.8 1.4 1.4 0 0 1 0-2.8zM26.562 15.907a.2.2 0 1 1 0 .4.2.2 0 0 1 0-.4zM26.562 17.907a.2.2 0 1 1 0 .4.2.2 0 0 1 0-.4zM27.562 16.907a.2.2 0 1 1 0 .4.2.2 0 0 1 0-.4zM25.562 16.907a.2.2 0 1 1 0 .4.2.2 0 0 1 0-.4z"
  })));
};

Console.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Dishes = function Dishes(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "dishes"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.745 31.936l-5.9-13.3c.2-2-.6-5-1.3-6.9-1.2-2.9-4-4.5-4.9-4.2 0 0 1.2 3.3 2.4 6.2 1.2 2.9 2.9 6.8 2.9 6.8l4.401 12.1c.1.3.8.4 1.5.2.6-.2 1-.6.9-.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.146 24.236l-3.2 7.6c-.1.299.3.799 1 1 .7.2 1.4.1 1.5-.201l1.8-5.299M19.245 21.736l1.9-4.5c-1.9-.8-1.9-2.3-1-4.9v-.1l6.4 1.9c0 .1 0 .1-.1.2-1 2.5-2 3.6-3.9 3.4l-2.2 6.6M20.146 12.236l1.8-4.7M22.245 12.736l1.8-4.7M24.346 13.436l1.8-4.6M26.545 14.136l1.801-4.7"
  })));
};

Dishes.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Dishwasher = function Dishwasher(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "dishwasher"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 19.2h23V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 10)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.4 4.7V2.5c0-1.1.9-2 2-2h16.3c1.1 0 2 .9 2 2v2.2H1.4z",
    stroke: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7 2.2H7.3c-.9 0-1.7.3-1.7.8v.1h11.8V3c0-.5-.8-.8-1.7-.8",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#58595B",
    mask: "url(#b)",
    d: "M1.4 15.5h20.3V4.8H1.4zM4.4 7l6.1 6M18.6 7l-6.1 6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 16.5c0 1.2-1 2.2-2.2 2.2H2.7c-1.2 0-2.2-1-2.2-2.2v-1.1h22v1.1z",
    stroke: "#58595B",
    mask: "url(#b)"
  })));
};

Dishwasher.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var Dogs = function Dogs(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "dogs"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.314 27.745l.9 3.3s0 .099.1.2c.1.1.2 0 .2 0l2.2-.101c-.1-1.3-1.2-.9-1.2-.9l-.2-2.2c1.9-1.7 2.7-3.5 3.1-4.6M24.015 24.245c1 1.7 1 4.899 1 5.899v.4c.1.1.3.1.3.1l1.5.2c.6-1-.8-1.4-.8-1.4l.5-3.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.814 12.544c-.2-.5-2.7-.9-2.7-.9-.8-.5-.199-1.2-1.8-2-.6-.3-1.899-.1-2.399.3-.9.7-1.4 1.8-1.7 3.1-.6 2.3-.7 2.9-1.7 3.3-3.1 1.3-5.8.4-8.3.3-1.5 0-3.4.4-4.6 1.2-.4.3-.7.6-.9 1-.7.7-1.6 1.6-2.1 1.8-.8.3-2.1.2-2.7.8 0 0 1.7.6 2.7.2.8-.3 1.7-.9 1.9-1.1.3 1.6 1 4.1 1 4.1-.1 1-1.4 2.1-2 2.5-.2.1-.2.1-.2.2s-.1.3-.1.3v3.4s0 .1.1.2.2.1.2.1l2.1.1c.2-1.3-.9-1.1-.9-1.1l.4-1.8c3.6-2 4.7-4.7 4.7-4.7s2.3-.3 4-.1c2.3.4 5.7.6 5.7.6 1.6 1.3 2.2 5 2.4 6.1 0 .1 0 .3.1.4.1.1.4.1.4.1h1.5c.4-1-1-1.2-1-1.2l-.2-6.7c.7-.9 1-3.4 1.1-4.1 0-.7.5-1 1.1-2.6.6-1.8 1.1-1.7 1.1-1.7s1.1 0 1.4-.1c1.2-.2 1.6-1.5 1.4-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.814 10.745c-.2.2-1.7 2.5-1.6 2.8.1.3 2 1.9 2.4 1.6.4-.3.2-1.9.2-1.9M24.715 20.645c0 .1-.3 1.2-.2 1.6.099.4 1.3 2.3 1.3 2.3"
  })));
};

Dogs.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Doorman = function Doorman(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "doorman"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .918h21.565V22H0"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.59 14.245v4.208a3.161 3.161 0 0 1-3.16 3.16h-3.295a3.162 3.162 0 0 1-3.16-3.16v-4.208",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.127 21.073v1.01c0 1.088-.884 1.97-1.974 1.97M23.437 21.073v1.01c0 1.088.884 1.97 1.974 1.97",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 29v-2.595a2.352 2.352 0 0 1 2.351-2.352",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 7)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.845 21.498h20.312",
    stroke: "#464646",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M14.256 24.053h-2.405M30.065 29v-2.595a2.352 2.352 0 0 0-2.35-2.352M25.309 24.053h2.405",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.896 23.083l3.888 1.424M23.672 23.083l-3.889 1.424v3.99M17.529 16.684h.587M21.448 16.684h.59",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.782 8.418c-2.76 0-5 .943-5 2.106v3.201c0 .604 2.24 1.095 5 1.095 2.761 0 5-.49 5-1.095v-3.2c0-1.164-2.239-2.107-5-2.107z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.812 11.744c-.29.615-2.415 1.096-5.032 1.096-2.614 0-4.745-.481-5.032-1.096",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

Doorman.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var Dryer = function Dryer(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "dryer"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.038 32.414c0 .6-.488 1.085-1.087 1.085H10.585A1.086 1.086 0 0 1 9.5 32.414V8.585c0-.599.487-1.086 1.086-1.086h18.366c.6 0 1.087.488 1.087 1.087v23.828zM9.35 14.486h20.672",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.731 11.875a.5.5 0 0 1 .999 0 .498.498 0 1 1-.999 0zM23.712 11.875a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0zM14.786 11.875a.5.5 0 0 1 .999 0 .498.498 0 1 1-.999 0zM11.768 11.875a.5.5 0 1 1 .998 0 .5.5 0 0 1-.998 0zM18.186 10.993a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0zM26.165 29.898h-9.304a3.489 3.489 0 0 1-3.488-3.49v-4.651a3.488 3.488 0 0 1 3.488-3.488h9.304v11.629zM15.785 22.023v4.12",
    stroke: "#464646"
  })));
};

Dryer.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Elevator = function Elevator(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "elevator"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 27.196l-3.115-3.087M23.615 24.11L20.5 27.196M20.5 14.11l3.115 3.086M17.385 17.195L20.5 14.11M27.5 29.5a2 2 0 0 1-2 2h-10a2 2 0 0 1-2-2v-18a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v18zM13.5 20.5h14",
    stroke: "#464646",
    strokeLinecap: "round"
  })));
};

Elevator.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Essentials = function Essentials(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "essentials"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.186 15.289c0-2.517-1.635-4.557-3.65-4.557-2.015 0-3.65 2.04-3.65 4.558v.504l-.002.029v6.089c0 .295.192.535.429.535h6.873v-7.158zM28.787 12.672l2.554-.043M8.747 12.629h7.502M32.376 13.656c.621 0 1.124-.501 1.124-1.12 0-.618-.503-1.12-1.124-1.12-.62 0-1.124.502-1.124 1.12 0 .619.503 1.12 1.124 1.12zM7.623 13.655c.62 0 1.123-.501 1.123-1.12 0-.618-.503-1.12-1.123-1.12s-1.123.502-1.123 1.12c0 .619.503 1.12 1.123 1.12z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.45 15.29c0-2.517-1.635-4.558-3.65-4.558H13.536c2.016 0 3.65 2.04 3.65 4.558 0 .057-.004 2.823-.006 8.104a.68.68 0 0 0-.012.12v6.452c0 .295.192.534.428.534h11.422c.236 0 .428-.24.428-.534l.004-14.676z",
    stroke: "#464646"
  })));
};

Essentials.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Ev = function Ev(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "ev"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 .23v28h13.1v-28z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 6)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#58595B",
    strokeLinecap: "square",
    strokeLinejoin: "bevel",
    mask: "url(#b)",
    d: "M13.1 12.73H8V.23l-8 15.5h5.1v12.5z"
  })));
};

Ev.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var Events = function Events(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "events"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    d: "M23.43 13.277l-1.348 5.996-3.515-5.124M29.33 10.293l.905 5.925-5.129-3.566M16.25 14.171l-3.276 5.22-1.665-5.963"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#464646"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.7 13.064a26.315 26.315 0 0 0 6.7 1.127c.26.01.527.014.8.014 3.536 0 8.162-.81 12.338-4.1M21.64 24.97l-4.06 4.695-.67-6.178M28.316 25.13l-2.096 5.633-2.848-5.543M14.803 22.56l-5.37 3.168 1.37-6.064"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.384 17.285c.529.635 2.714 3.104 6.255 5.133 2.605 1.492 6.333 2.952 10.946 2.952 1.941 0 4.042-.263 6.28-.888"
  }))));
};

Events.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Familyfriendly = function Familyfriendly(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "family friendly"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.363 30.732a9.965 9.965 0 0 1-2.377.262c-.844 0-1.65-.081-2.392-.267M12.889 13.087a2.031 2.031 0 0 1-.86-.876c-.61-1.22.188-2.844 1.782-3.627 1.54-.756 3.26-.449 3.923.676M27.073 13.091c.376-.204.678-.5.867-.88.61-1.221-.188-2.844-1.78-3.627-1.558-.764-3.298-.442-3.945.712",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.045 20.227c4.054 0 7.341-2.519 7.341-5.627 0-3.107-3.287-5.626-7.34-5.626-4.055 0-7.342 2.52-7.342 5.626 0 3.108 3.287 5.627 7.341 5.627z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.16 13.653c.445 0 .806-.327.806-.73 0-.404-.36-.731-.806-.731-.445 0-.806.327-.806.73 0 .404.361.73.806.73zM22.838 13.653c.445 0 .807-.327.807-.73 0-.404-.362-.731-.807-.731-.445 0-.807.327-.807.73 0 .404.362.73.807.73zM20.008 20.024c2.242 0 4.06-1.393 4.06-3.111 0-1.719-1.818-3.113-4.06-3.113-2.242 0-4.06 1.394-4.06 3.113 0 1.718 1.818 3.111 4.06 3.111z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.654 15.394c0 .707-1.668 1.537-1.668 1.537s-1.668-.83-1.668-1.537c0-.706.746-1.02 1.668-1.02.921 0 1.668.314 1.668 1.02zM17.866 17.897c.023.025.233.254.513.336.086.025.224.046.387.046.288 0 .654-.065.946-.28.092-.069.19-.164.275-.293.085.128.183.224.275.292.293.216.658.281.946.281.163 0 .301-.02.387-.046.28-.082.49-.31.513-.336M14.753 19.65c-.261.073-3.645 1.406-4.156 2.866-.348.992.276 2.01 1.37 2.27 1.095.258 2.255-.34 2.592-1.335.036-.108.055-3.588.194-3.801zM25.283 19.64c.261.073 3.667 1.437 4.132 2.888.32 1-.293 2.011-1.39 2.263-1.096.251-2.252-.353-2.58-1.35-.036-.109-.025-3.588-.162-3.802zM18.629 27.308c.519.476.921.8 1.003.866a.683.683 0 0 0 .473.187.687.687 0 0 0 .474-.187c.057-.047.272-.22.575-.485",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.841 27.963c.399 1.898-1.121 3.048-2.939 3.425-1.819.376-3.247-.164-3.646-2.063-.399-1.897.382-4.435 2.201-4.811 1.818-.377 3.985 1.55 4.384 3.449zM21.092 27.963c-.399 1.898 1.121 3.048 2.939 3.425 1.819.376 3.247-.164 3.646-2.063.399-1.897-.382-4.435-2.201-4.811-1.818-.377-3.985 1.55-4.384 3.449z",
    stroke: "#464646"
  })));
};

Familyfriendly.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Fireextinguisher = function Fireextinguisher(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "fire extinguisher"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M10 2.942h20V32H10z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.828 9.536h-1.11c-2.528 0-4.552 2.053-4.552 4.64V31.5h10.247V14.176c0-2.587-2.03-4.64-4.585-4.64z",
    stroke: "#464646",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    strokeLinejoin: "round",
    mask: "url(#b)",
    d: "M23.413 25.914h-5.695V15.682h5.695zM19.721 9.536h-2.863V5.471h2.863zM29.5 10.36l-6.087-2.58V6.02L29.5 3.442zM23.149 6.903h-3.428M10.5 10.825v-.778c0-1.757 1.374-3.145 3.104-3.145h3.151"
  })));
};

Fireextinguisher.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var Fireplace = function Fireplace(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "fireplace"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    d: "M8.5 30.5h23V10.92h-23z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    d: "M11.517 28.427h17.009V12.916H11.517z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    d: "M22.625 24.021h3.715l1.65 4.406H12.01l1.65-4.406h3.759M13.869 12.81v11.21M26.312 12.81v11.21M20.429 25.39l3.025 1.697M21.703 24.995h2.66M15.637 24.995h2.566M19.5 25.43l-2.954 1.657"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.497 18.523c.49-1.265.396-3.175.396-3.175s1.302.542 2.2 2.03c.846 1.397.047 3.48.047 3.48.623-.618.853-1.236.874-1.978.7 1.11 1.24 2.378 1.24 3.664 0 1.59-1.457 2.878-3.255 2.88-1.797-.002-3.254-1.29-3.254-2.88 0-1.549 1.175-2.53 1.752-4.02z",
    stroke: "#464646"
  })));
};

Fireplace.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Firstaid = function Firstaid(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "first aid"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 13.13c0-.815-.666-1.476-1.488-1.476H9.988c-.822 0-1.488.661-1.488 1.476v12.894c0 .815.666 1.476 1.488 1.476h20.024c.822 0 1.488-.66 1.488-1.476V13.13zM15.09 11.61V9.251c0-.816.665-1.477 1.487-1.477h7.143c.821 0 1.488.661 1.488 1.477v2.357",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.95 24.646c2.872 0 5.198-2.308 5.198-5.156 0-2.847-2.326-5.156-5.197-5.156-2.872 0-5.199 2.31-5.199 5.156 0 2.848 2.327 5.156 5.199 5.156zM17.232 19.577h5.537M20 16.831v5.492",
    stroke: "#464646"
  })));
};

Firstaid.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Garden = function Garden(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "garden"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.7 20.4v13.3M24.9 14.8h.4c.5-.2-.1-.6.3-1 1.3-1.3 1.4-2.8.5-3.6-.8-.8-2.2-.8-3.5.3v-.1c0-1.8-1-2.9-2.2-2.9-1.2 0-2.1 1-2.2 2.6-1.2-1.2-2.7-1.3-3.6-.4-.8.9-.7 2.4.6 3.6.1.1.2.1.2.2-1.8 0-2.9 1-2.9 2.3 0 1.2 1.1 2.2 3 2.2h.4c-.1.2-.2.3-.2.5-.7 1.7-.2 3.1 1 3.6 1.1.5 2.4-.2 3.1-1.8.7 1.5 2 2.1 3.1 1.6.9-.4 1.4-1.4 1.2-2.7.2 0 .4.1.6.1 1.8.1 3-.8 3.1-2-.1-1.3-1.1-2.4-2.9-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9 13.6A1.5 1.5 0 1 1 19.9 16.6 1.5 1.5 0 0 1 19.9 13.6z"
  })));
};

Garden.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Guard = function Guard(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "Guard"), /*#__PURE__*/React.createElement("path", {
    d: "M9 12.067v9.8c0 .6.4 2.2 1.6 4 .4.7 1 1.4 1.7 2.1 1.6 1.6 3.8 3.2 7 4.3 9.5-4 9.8-10.4 9.8-10.4v-9.8c-.3 0-.6.1-.9.1-1.3.1-2.5 0-3.6-.2-3.7-.7-5.5-2.7-5.5-2.7s-3.5 3.6-10.1 2.8z"
  }));
};

Guard.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  stroke: "currentColor"
};

var Gym = function Gym(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "gym"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.269 21.214c.68 0 1.23-.548 1.23-1.223 0-.676-.55-1.223-1.23-1.223M12.204 21.214H27.87M7.731 18.769c-.68 0-1.23.547-1.23 1.223 0 .675.55 1.223 1.23 1.223M27.81 18.769H12.145M31.3 15.896c-.505 0-.914.148-.949.618v-.947c0-.676-.552-.88-1.23-.88-.682 0-1.233.204-1.233.88v9.052c0 .677.552.88 1.232.88.68 0 1.231-.203 1.231-.88v-.945c.035.47.444.618.95.618.526 0 .955-.158.955-.682v-7.032c0-.525-.429-.682-.956-.682zM10.894 14.688c-.68 0-1.231.202-1.231.878v.943c-.038-.468-.446-.614-.949-.614-.529 0-.956.157-.956.683v7.032c0 .524.427.68.956.68.503 0 .911-.146.949-.613v.942c0 .677.551.88 1.231.88s1.231-.203 1.231-.88v-9.053c0-.675-.551-.879-1.231-.879z",
    stroke: "#464646"
  })));
};

Gym.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Hairdryer = function Hairdryer(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "hair dryer"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.437 34.791s-1.772-3.863-1.709-6.74M30.03 11.736c-5.153-3.669-9.779-1.76-11.453-.827l-7.685-.27c-.68-.04-1.255.34-1.283.844l-.108 1.944c-.03.505.5.946 1.18.985l7.641.985c2.36 1.928 6.483 2.68 6.483 2.68 2.344-.213 4.731-1.185 4.731-1.185 1.38-1.338 1.024-4.78.494-5.156z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.03 16.486c.482.287 1.376 1.036 1.554 2.72l.492 8.394s1.323.87 3.286.152l-.159-9.671M11.771 10.67l-.205 3.856",
    stroke: "#464646"
  })));
};

Hairdryer.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Hangers = function Hangers(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "hangers"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h26v15H0"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7 11)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.631 14.005h22.791",
    stroke: "#464646",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20 15.809v-1.263c.709-.104 1.257-.744 1.257-1.515 0-.844-.655-1.531-1.46-1.531-.744 0-1.358.588-1.446 1.344M25.824 20.412c-2.043-.874-3.131-2.35-3.131-2.35C21.616 15.873 20 15.873 20 15.873H20s-1.616 0-2.693 2.19c0 0-1.087 1.475-3.13 2.35-4.21 1.8-7.642 2.026-6.43 4.921L20 19.858l12.253 5.476c1.21-2.895-2.223-3.122-6.43-4.922z",
    stroke: "#464646"
  })));
};

Hangers.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var Heating = function Heating(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "heating"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.488 21.156V10.312a2.282 2.282 0 0 0-2.282-2.282h-.456a2.282 2.282 0 0 0-2.284 2.282v10.844a5.477 5.477 0 1 0 7.987 4.867 5.472 5.472 0 0 0-2.965-4.867z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.85 28.133a2.055 2.055 0 1 0-.001-4.109 2.055 2.055 0 0 0 0 4.11zM19.977 23.893V10.55",
    stroke: "#464646"
  })));
};

Heating.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Hottub = function Hottub(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "hot tub"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 14.339c0-.252.205-.456.458-.456h20.083c.254 0 .459.204.459.456v1.32a.456.456 0 0 1-.459.454H9.958a.456.456 0 0 1-.458-.454v-1.32zM29.494 16.19v8.854a.458.458 0 0 1-.46.456h-18.07a.458.458 0 0 1-.46-.456V16.19M25.696 25.216V16.19M14.302 16.19v9.026M18.1 25.216V16.19M21.898 16.19v9.026",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.06 5.5c-.028.031-.688.77-.688 1.633 0 .835.618 1.571.681 1.644l.004.006c.005.006.576.661.576 1.369 0 .699-.566 1.338-.575 1.348M20.057 5.5c-.027.031-.687.77-.687 1.633 0 .835.618 1.571.68 1.644l.004.006c.006.006.576.661.576 1.369 0 .699-.564 1.338-.574 1.348M24.056 5.5c-.028.031-.687.77-.687 1.633 0 .835.617 1.571.68 1.644l.004.006c.005.006.575.661.575 1.369 0 .699-.564 1.338-.573 1.348",
    stroke: "#464646",
    strokeLinecap: "round"
  })));
};

Hottub.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Hotwater = function Hotwater(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "hot_water"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8 21.2h-15c-.7 0-1.3-.6-1.3-1.3v-.6c0-2.8 2.3-5.1 5.1-5.1H24c2.8 0 5.1 2.3 5.1 5.1v.7c0 .7-.6 1.2-1.3 1.2zM18.2 12.4h4.2M20.3 9.5V11",
    strokeLinecap: "square",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4 25.1l-1-1.3-1 1.3c-.2.2-.3.5-.3.8 0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.4-.2-.6-.3-.8zM21.3 25.1l-1-1.3-1 1.3c-.2.2-.3.4-.3.7 0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3-.1-.3-.2-.5-.3-.7zM27.2 25.1l-1-1.3-1 1.3c-.2.2-.3.5-.3.8 0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3-.1-.4-.2-.6-.3-.8zM18.3 29.4l-1-1.3-1 1.3c-.2.2-.3.5-.3.8 0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.3-.1-.5-.3-.8zM24.2 29.4l-1-1.3-1 1.3c-.2.2-.3.5-.3.8 0 .7.6 1.3 1.3 1.3.7 0 1.3-.6 1.3-1.3 0-.3-.1-.5-.3-.8z",
    strokeLinecap: "round"
  })));
};

Hotwater.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Internet = function Internet(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "internet"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 9.5c5.8 0 10.5 4.701 10.5 10.5 0 5.8-4.7 10.5-10.5 10.5-5.799 0-10.5-4.7-10.5-10.5 0-5.799 4.701-10.5 10.5-10.5z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.5c2.927 0 5.3 4.701 5.3 10.5 0 5.8-2.373 10.5-5.3 10.5-2.927 0-5.3-4.7-5.3-10.5 0-5.799 2.373-10.5 5.3-10.5z",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9 26.7c1.9-1.1 4.9-1.9 8.1-1.9 3.2 0 6.1.7 8.1 1.9M28.2 13.2c-1.9 1.2-4.9 1.9-8.2 1.9-3.2.1-6.1-.7-8-1.8M9.5 20h21.1M20 9.5v21"
  })));
};

Internet.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Iron = function Iron(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "iron"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.667 24.414c-.16.272-.207.452-.132.602.18.353.992.769 1.623.859 3.51.5 12.355.749 16.401.564.004 0 2.702-.067 2.702-.63 0-.26-.279-.534-.773-.81M16.5 15.694v-1.242s-.036-.742.96-.989h3.388",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.643 24.336c-.125-.247.174-.558.672-1.238 2.258-3.082 10.165-11.006 19.501-11.075.31-.003.658.015.854.085.221.08.276.115.44.422.835 1.563 2.674 6.47 3.259 8.857.188.768.156.88.018 1.075-.256.36-.552.376-1.229.529-.697.157-1.451.346-2.434.728-.988.384-20.903.97-21.081.617zM26.194 25.501c1.497-.1 1.542-1.398 2.53-1.783",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.986 16.569c2.165-1.463 4.855-2.632 7.758-2.69.33-.007.732.127.83.326.387.783.71 1.838.853 2.478.112.496-.342.932-.777 1.029-.447.1-5.26 1.528-8.442 2.316-.894.22-1.691-.41-1.851-1.138-.185-.836.4-1.49 1.629-2.321z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.34 18.865l-.13-.96a.362.362 0 0 0-.445-.25l-2.948.816a.357.357 0 0 0-.25.441l.145.967M32.085 20.35l-17.393 2.203c-.786.195-1.376.68-1.376.68l-.962 1.195",
    stroke: "#464646"
  })));
};

Iron.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Keypad = function Keypad(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "keypad"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M8 9.704h24V31H8z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 28.664c0 1.175-.674 1.836-1.875 1.836h-19.25c-1.201 0-1.875-.66-1.875-1.836V12.04c0-1.175.674-1.836 1.875-1.836h19.25c1.201 0 1.875.66 1.875 1.836v16.624z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    mask: "url(#b)",
    d: "M10.483 28.158h19.034V12.545H10.483z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.097 17.03a.45.45 0 0 1-.455.448h-1.325a.451.451 0 0 1-.455-.447v-1.306c0-.247.204-.447.455-.447h1.325c.252 0 .455.2.455.447v1.306zM19.11 17.03a.45.45 0 0 1-.454.448H17.33a.45.45 0 0 1-.454-.447v-1.306a.45.45 0 0 1 .454-.447h1.326c.25 0 .454.2.454.447v1.306zM23.124 17.03a.45.45 0 0 1-.454.448h-1.326a.45.45 0 0 1-.454-.447v-1.306a.45.45 0 0 1 .454-.447h1.326c.25 0 .454.2.454.447v1.306zM27.138 17.03a.45.45 0 0 1-.453.448h-1.326a.45.45 0 0 1-.455-.447v-1.306a.45.45 0 0 1 .455-.447h1.326c.25 0 .453.2.453.447v1.306zM15.097 21.005a.451.451 0 0 1-.455.447h-1.325a.452.452 0 0 1-.455-.447v-1.307c0-.246.204-.447.455-.447h1.325c.252 0 .455.201.455.447v1.307zM19.11 21.005a.45.45 0 0 1-.454.447H17.33a.45.45 0 0 1-.454-.447v-1.307a.45.45 0 0 1 .454-.447h1.326a.45.45 0 0 1 .454.447v1.307zM23.124 21.005a.452.452 0 0 1-.454.447h-1.326a.45.45 0 0 1-.454-.447v-1.307a.45.45 0 0 1 .454-.447h1.326c.25 0 .454.201.454.447v1.307zM27.138 21.005a.45.45 0 0 1-.453.447h-1.326a.451.451 0 0 1-.455-.447v-1.307c0-.246.203-.447.455-.447h1.326a.45.45 0 0 1 .453.447v1.307zM15.097 24.979a.45.45 0 0 1-.455.447h-1.325a.451.451 0 0 1-.455-.447v-1.306c0-.247.204-.447.455-.447h1.325c.252 0 .455.2.455.447v1.306zM19.11 24.979a.45.45 0 0 1-.454.447H17.33a.45.45 0 0 1-.454-.447v-1.306a.45.45 0 0 1 .454-.447h1.326c.25 0 .454.2.454.447v1.306zM23.124 24.979a.45.45 0 0 1-.454.447h-1.326a.45.45 0 0 1-.454-.447v-1.306a.45.45 0 0 1 .454-.447h1.326c.25 0 .454.2.454.447v1.306zM27.138 24.979a.45.45 0 0 1-.453.447h-1.326a.45.45 0 0 1-.455-.447v-1.306a.45.45 0 0 1 .455-.447h1.326c.25 0 .453.2.453.447v1.306z",
    stroke: "#464646",
    mask: "url(#b)"
  })));
};

Keypad.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var Kitchen = function Kitchen(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "kitchen"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.662 14.785c1.568 0 2.838 1.431 2.838 3.195 0 1.765-1.27 3.195-2.838 3.195",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.662 16.458c.746 0 1.352.682 1.352 1.522s-.605 1.522-1.352 1.522M10.338 21.175c-1.567 0-2.838-1.431-2.838-3.195 0-1.765 1.27-3.195 2.838-3.195",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.338 19.501c-.746 0-1.351-.682-1.351-1.52 0-.842.604-1.524 1.35-1.524M29.535 14.56v10.19c0 .673-4.197 1.75-9.603 1.75-5.404 0-9.497-1.077-9.497-1.75V14.598M18.16 10.32c0-.497.823-.9 1.84-.9 1.017 0 1.84.403 1.84.9",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.737 14.515s-4.806.939-9.803.939c-4.997 0-9.7-.94-9.7-.94 0-1.652 4.365-4.194 9.751-4.194 5.386 0 9.752 2.542 9.752 4.195z",
    stroke: "#464646"
  })));
};

Kitchen.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Laptop = function Laptop(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "laptop"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M28.844 23.18h-18v-10h18z"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.844 12.86a2 2 0 0 0-2-2h-18a2 2 0 0 0-2 2V25.5h22V12.86zM10.047 25.5H6.5v.458c0 1.404.93 2.542 2.077 2.542h22.846c1.147 0 2.077-1.138 2.077-2.542V25.5h-2.922"
  }))));
};

Laptop.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Lockbox = function Lockbox(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "lockbox"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.454 21v3.5h2.207c.048 0 .09.014.135.022v-3.544c-.045.008-.087.022-.135.022h-2.207z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.454 26.5v2.017H11.841V11.483h15.613V13.5h2.207c.048 0 .09.014.135.022v-3.147c0-1.201-.66-1.875-1.836-1.875H11.336c-1.176 0-1.836.674-1.836 1.875v19.25c0 1.201.661 1.875 1.836 1.875H27.96c1.175 0 1.836-.674 1.836-1.875v-3.147c-.045.008-.087.022-.135.022h-2.207z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.661 15.5h-2.207V19h2.207c.048 0 .09.014.135.022v-3.544c-.045.008-.087.022-.135.022zM26.27 14.974v-.948c0-.29.296-.526.661-.526h.523v-2.017H11.841v17.034h15.613V26.5h-.523c-.365 0-.66-.235-.66-.526v-.948c0-.29.295-.526.66-.526h.523V21h-.523c-.365 0-.66-.235-.66-.526v-.948c0-.29.295-.526.66-.526h.523v-3.5h-.523c-.365 0-.66-.235-.66-.526z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.796 15.478c.298-.05.526-.252.526-.504v-.948c0-.253-.228-.454-.526-.505M29.796 13.522c-.045-.008-.087-.022-.135-.022h-2.207M27.454 15.5h2.207c.048 0 .09-.014.135-.022",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.454 13.5h-.523c-.365 0-.66.236-.66.526v.948c0 .291.295.526.66.526h.523M29.796 20.978c.298-.05.526-.252.526-.504v-.948c0-.253-.228-.454-.526-.505M29.796 19.022c-.045-.008-.087-.022-.135-.022h-2.207M27.454 21h2.207c.048 0 .09-.014.135-.022",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.454 19h-.523c-.365 0-.66.236-.66.526v.948c0 .291.295.526.66.526h.523M29.796 26.478c.298-.05.526-.252.526-.504v-.948c0-.253-.228-.454-.526-.505M29.796 24.522c-.045-.008-.087-.022-.135-.022h-2.207M27.454 26.5h2.207c.048 0 .09-.014.135-.022",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.454 24.5h-.523c-.365 0-.66.236-.66.526v.948c0 .291.295.526.66.526h.523M19.911 24.629a4.632 4.632 0 0 0 4.636-4.63 4.632 4.632 0 0 0-4.636-4.627A4.632 4.632 0 0 0 15.275 20a4.632 4.632 0 0 0 4.636 4.629z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.807 17.66a2.33 2.33 0 0 0-1.593.632l-2.72.093L17.464 20a2.341 2.341 0 0 0 2.343 2.34A2.342 2.342 0 0 0 22.15 20a2.339 2.339 0 0 0-2.343-2.34z",
    stroke: "#464646"
  })));
};

Lockbox.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Locker = function Locker(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "locker"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.495 16.465c-.026-4.178-3.37-7.965-7.488-7.965-4.111 0-7.447 3.77-7.488 7.936a.089.089 0 0 0-.02.05v9.421c0 .88.734 1.593 1.638 1.593h11.726c.905 0 1.637-.714 1.637-1.593v-9.422c0-.007-.004-.013-.005-.02zm-13.018-.444c.244-2.92 2.626-5.554 5.529-5.554 2.904 0 5.286 2.634 5.529 5.556-2.87-.262-8.181-.263-11.058-.002z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.734 20.303c0-.918-.748-1.662-1.672-1.662-.922 0-1.67.744-1.67 1.662 0 .7.435 1.298 1.05 1.543v1.533a.591.591 0 0 0 1.185 0v-1.513a1.661 1.661 0 0 0 1.107-1.563z",
    stroke: "#464646"
  })));
};

Locker.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Longterm = function Longterm(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "long_term"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.6 17.3v11.5c0 .7-.5 1.2-1.2 1.2H10.7c-.7 0-1.2-.5-1.2-1.2V17.3M26.3 19.9h3.1M29.4 23.4h-3.1M29.4 26.9h-3.1M11.7 19.9h3.1M14.8 23.4h-3.1M14.8 26.9h-3.1M16.6 19.9h3.1M19.7 23.4h-3.1M19.7 26.9h-3.1M21.5 19.9h3.1M24.6 23.4h-3.1M24.6 26.9h-3.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.4 12c.7 0 1.2.5 1.2 1.2v4.2H9.5v-4.2c0-.7.5-1.2 1.2-1.2h19.7zM25.2 14.1V10M16.2 14.1V10"
  })));
};

Longterm.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Luggage = function Luggage(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "luggage"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 33.6v.3c0 .3-.3.6-.6.6s-.6-.3-.6-.6v-.3M24.8 33.6v.3c0 .3-.3.6-.6.6s-.6-.3-.6-.6v-.3M28 31.9c0 .9-.7 1.7-1.7 1.7H14.2c-.9 0-1.7-.7-1.7-1.7V13.1c0-.9.7-1.7 1.7-1.7h12.2c.9 0 1.7.7 1.7 1.7v18.8H28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9 30.2c0 .7-.5 1.3-1.2 1.3h-8.9c-.7 0-1.2-.6-1.2-1.3v-7.8c0-.7.5-1.3 1.2-1.3h8.9c.7 0 1.2.6 1.2 1.3v7.8zM25.9 18c0 .7-.5 1.3-1.2 1.3h-8.9c-.7 0-1.2-.6-1.2-1.3v-3.3c0-.7.5-1.3 1.2-1.3h8.9c.7 0 1.2.6 1.2 1.3V18zM17.9 11.4V6.6M22.5 11.4V6.6M17.5 6.5H23"
  })));
};

Luggage.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Microwave = function Microwave(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "microwave"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 19.4h29.1V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 10)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 17.8c0 .6-.5 1.1-1.1 1.1H1.6c-.6 0-1.1-.5-1.1-1.1V1.6C.5 1 1 .5 1.6.5h25.9c.6 0 1.1.5 1.1 1.1v16.2h-.1zM2.8 10h18.6",
    stroke: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 3.9a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6zM25 8.2a1.3 1.3 0 1 1 0 2.6 1.3 1.3 0 0 1 0-2.6zM5.9 5h13.2",
    stroke: "#58595B"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#58595B",
    mask: "url(#b)",
    d: "M2.9 16.7h18.7V3H2.9z"
  })));
};

Microwave.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var Otherpets = function Otherpets(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "other_pets"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.014 10.51c-.2-1-.2-1.9.1-2 .5-.2 3.1 2.7 3.6 4.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.214 17.11c-1.3-2.1-1.7-3.8-3.7-3.8-.5 0-1.1.1-1.5.3-.6-1.7-3.3-4.7-3.7-4.5-.7.5 0 5.2 1.7 6.4-.2.5-.3 1-.3 1.5 0 2.1 1.7 3.8 3.7 3.8s4.9-1.9 3.8-3.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.614 15.21a.7.7 0 1 1 0 1.399.7.7 0 0 1 0-1.4zM29.214 17.11l-.8.3s0 .9.9 1.1l.1-.1c0-.3.1-.8-.2-1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.214 17.11l-.8.2s.1.9 1 1c0 0 .1-.6-.2-1.2zM22.314 19.11l-.1.2s-12 .7-10.3 10.6c0 0 .7 2.3 3 2.5 0 0 2.4.099 2.9.3.8.4 2.9.1 2.9.1.6-.1.9-.4.9-.801 0-.599-1-.799-2.2-1 1.5-.599 3.5-1.599 4.3-2.099 0 0-.4 2.9 1.2 3.7 0 0 1.7.6 2.2-.101 0 0 .5-1.099-.8-1.199-.3 0-1.2.6-1-.9 0 0 2.3-5.5 2-9.1v-.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.814 30.01c-.1 0-.3-.1-.4-.2-.8-.4-1.1-1.2-.8-1.7.2-.3.6-.5 1.1-.5M19.314 31.11s3.4-4.7-2.8-6.2"
  })));
};

Otherpets.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Oven = function Oven(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "oven"), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 29h22.379V0H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#58595B",
    d: "M9.69 34.5h21V11.8h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#58595B",
    d: "M11.99 27.5h16.2v-9h-16.2z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(9 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.69 24.1h21-21z",
    stroke: "#58595B"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#58595B",
    mask: "url(#b)",
    d: "M.69 10.1h21V5.8h-21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.59 7.8a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zM8.89 7.8a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zM13.29 7.8a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zM17.69 7.8a.5.5 0 1 1 0 1 .5.5 0 0 1 0-1zM19.89.5H2.49L.69 6h21zM4.59 15.2h12.8M4.59 18.5h12.8",
    stroke: "#58595B",
    mask: "url(#b)"
  }))));
};

Oven.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
};

var Parking = function Parking(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "parking"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5 20c0 5.799-4.701 10.5-10.5 10.5S9.5 25.799 9.5 20 14.201 9.5 20 9.5 30.5 14.201 30.5 20z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.608 17.73c0 .666-.218 1.226-.647 1.664-.43.437-1.088.658-1.958.658h-2.77v-4.669h2.77c.87 0 1.528.224 1.958.666.429.443.647 1.008.647 1.68m.136-2.416c-.648-.604-1.57-.91-2.741-.91h-3.884v11.194h1.115v-4.564h2.769c1.172 0 2.094-.303 2.74-.903.65-.602.979-1.414.979-2.416 0-.987-.33-1.794-.978-2.4",
    fill: "#464646"
  })));
};

Parking.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Patio = function Patio(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "patio"), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8 12)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.1.5v11.8M7.6.5v11.8M12 .5v11.8M16.4.5v11.8M20.9.5v11.8",
    stroke: "#58595B"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#58595B",
    fill: "#FFF",
    fillRule: "nonzero",
    cx: "3.1",
    cy: "6.1",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#58595B",
    fill: "#FFF",
    fillRule: "nonzero",
    cx: "7.6",
    cy: "6.1",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#58595B",
    fill: "#FFF",
    fillRule: "nonzero",
    cx: "12",
    cy: "6.1",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#58595B",
    fill: "#FFF",
    fillRule: "nonzero",
    cx: "16.4",
    cy: "6.1",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "#58595B",
    fill: "#FFF",
    fillRule: "nonzero",
    cx: "20.9",
    cy: "6.1",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#58595B",
    fillRule: "nonzero",
    cx: "12",
    cy: "2.9",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#58595B",
    fillRule: "nonzero",
    cx: "12",
    cy: "9.7",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#58595B",
    fillRule: "nonzero",
    cx: "16.4",
    cy: "2.9",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#58595B",
    fillRule: "nonzero",
    cx: "16.4",
    cy: "9.7",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#58595B",
    fillRule: "nonzero",
    cx: "20.9",
    cy: "3",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#58595B",
    fillRule: "nonzero",
    cx: "20.9",
    cy: "9.8",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#58595B",
    fillRule: "nonzero",
    cx: "7.6",
    cy: "3",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#58595B",
    fillRule: "nonzero",
    cx: "7.6",
    cy: "9.8",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#58595B",
    fillRule: "nonzero",
    cx: "3.1",
    cy: "3",
    r: "1"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#58595B",
    fillRule: "nonzero",
    cx: "3.1",
    cy: "9.8",
    r: "1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 13.4c0 1.2-1 2.2-2.2 2.2H3c-1.2 0-2.2-1-2.2-2.2v-1.1H23v1.1zM0 .5h24",
    stroke: "#58595B"
  })));
};

Patio.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Petsallowed = function Petsallowed(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "pets allowed"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.497 24.85c0-3.517 1.436-8.871 6.526-8.871 4.699 0 6.526 5.354 6.526 8.87 0 1.73-.523 3.473-1.853 3.473-3.063 0-2.797-2.03-4.629-2.03-1.662 0-1.871 2.208-4.373 2.208-1.495 0-2.197-1.754-2.197-3.65zM14.005 17.827c.961-.742.882-2.4-.176-3.707-1.059-1.305-2.696-1.762-3.657-1.02-.96.741-.882 2.401.176 3.706 1.058 1.306 2.696 1.763 3.657 1.021zM29.828 12.904c-.961-.742-2.598-.285-3.657 1.021-1.058 1.305-1.137 2.965-.176 3.706.96.742 2.598.285 3.657-1.02 1.058-1.306 1.137-2.965.176-3.707zM20.73 11.385c-.306 1.752.432 3.306 1.65 3.472 1.219.167 2.455-1.119 2.763-2.87.307-1.752-.431-3.307-1.65-3.473-1.218-.165-2.455 1.12-2.762 2.871zM19.265 11.385c.307 1.752-.431 3.306-1.65 3.472-1.218.167-2.454-1.119-2.762-2.87-.307-1.752.432-3.307 1.65-3.473 1.218-.165 2.454 1.12 2.762 2.871z",
    stroke: "#464646"
  })));
};

Petsallowed.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Petslive = function Petslive(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "pets live"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.981 13.033a26.17 26.17 0 0 1 1.635.208M27.705 13.813c1.112.38 1.765.845 1.765 1.348 0 1.281-4.24 2.318-9.471 2.318-5.23 0-9.47-1.037-9.47-2.318 0-1.033 2.765-1.909 6.583-2.209M31.5 22.195c0 1.825-5.149 3.305-11.501 3.305-6.352 0-11.499-1.48-11.499-3.305M29.959 18.63c-1.989.987-5.705 1.652-9.96 1.652-4.255 0-7.97-.665-9.958-1.652M29.47 15.618l2.03 6.777M8.5 22.395l2.029-6.777",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.512 14.61l1.912-2.327a.593.593 0 0 1 .858-.072l1.262 1.116a.647.647 0 0 1 .07.89l-2.294 2.76M16.495 17.158a.891.891 0 0 1-.01-.264l.393-3.363a.813.813 0 0 1 .897-.73l1.688.213c.442.056.756.472.703.93l-.393 3.363c0 .012-.003.023-.005.035",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.868 13.178a.813.813 0 0 1 .402-.314l1.609-.57a.8.8 0 0 1 1.023.522l.991 3.454c.143.437-.104.847-.526.997l-.303.107M20.91 17.32a.863.863 0 0 1-.088-.189l-.751-2.284M13.79 16.686l-.525-1.556a.776.776 0 0 1 .455-.977l1.474-.533a.733.733 0 0 1 .942.47l1.054 3.13",
    stroke: "#464646"
  })));
};

Petslive.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Pool = function Pool(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "pool"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 9.5C14.201 9.5 9.5 14.201 9.5 20S14.201 30.5 20 30.5c5.8 0 10.5-4.701 10.5-10.5S25.8 9.5 20 9.5zm0 14.978a4.479 4.479 0 1 1 0-8.958 4.479 4.479 0 0 1 0 8.958zM23.167 16.833l4.257-4.257M16.739 16.932l-4.228-4.228M23.167 23.386l4.257 4.257M16.739 23.287l-4.228 4.228",
    stroke: "#464646"
  })));
};

Pool.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Privateentrance = function Privateentrance(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "private entrance"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    d: "M13.5 30.5h14v-24h-14z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.396 18.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    d: "M13.5 30.386l8.697-2.506V9.91L13.5 6.828"
  })));
};

Privateentrance.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Privatelivingroom = function Privatelivingroom(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "private livingroom"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.337 20.778l-1.104-1.954s-1.175-1.231-.58-2.545c.598-1.315 1.889-1.366 1.889-1.366l3.297 2.343M10.694 25.063H29.34M10.441 14.912v-3.137a1.12 1.12 0 0 1 1.11-1.129h7.227l1.223.323v10.77h-8.45c-.343 0-.648-.157-.85-.404",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.999 10.969l1.212-.322h7.24c.613 0 1.108.506 1.108 1.128v3.137M29.328 21.308a1.103 1.103 0 0 1-.877.436h-8.452M11.768 18.824s1.175-1.23.579-2.546c-.596-1.314-1.888-1.366-1.888-1.366L7.7 16.874M20.067 18.824h-8.3L10.7 20.686",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.673 18.774a2.091 2.091 0 0 0-2.087-2.096A2.09 2.09 0 0 0 6.5 18.774c0 .902.567 1.668 1.362 1.964v5.17c0 .79 2.811.79 2.811 0v-6.982c0-.018-.004-.034-.004-.052.001-.033.004-.066.004-.1zM19.933 18.824h8.3M29.327 18.774c0-1.158.936-2.096 2.087-2.096a2.09 2.09 0 0 1 2.086 2.096c0 .902-.567 1.668-1.362 1.964v5.17c0 .79-2.812.79-2.812 0v-6.982c0-.018.005-.034.005-.052 0-.033-.004-.066-.004-.1z",
    stroke: "#464646"
  })));
};

Privatelivingroom.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Refrigerator = function Refrigerator(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "iPhone 7"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.8 31.4c0 .6-.5 1.1-1.1 1.1H15.6c-.6 0-1.1-.5-1.1-1.1V8.6c0-.6.5-1.1 1.1-1.1h10.1c.6 0 1.1.5 1.1 1.1v22.8zM26.8 15.8H14.5M17.5 10.9v3.4M17.5 17.6v3.5"
  })));
};

Refrigerator.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Rug = function Rug(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.062 89.255h6M0 81.87h6m-6-7.386h6m-6-7.387h6m-6-7.386h6m-6-7.386h6M0 44.94h6m-6-7.386h6m-6-7.386h6m-6-7.386h6m-6-7.385h6M0 8.01h6M0 .625h6M128 44.94h6m-6-7.386h6m-6-7.386h6m-6-7.386h6m-6-7.385h6m-6-7.387h6m-6-7.385h6",
    stroke: "#AEB6BA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F5F",
    d: "M5.197.063v89.775h67.272l.57-1.209 54.11-41.435h1.489V.064z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30ABE5",
    d: "M117.192 9.265v44.888L84.705 78.84H16.194V9.265z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#48BDF3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.391 65.912l7.07 7.07 7.072-7.07-7.072-7.07zm14.106-.142l7.071 7.071 7.072-7.07-7.072-7.07zM27.462 78.841h11.54l-5.77-5.77zm13.965 0H53.25l-5.91-5.91zM68.764 37.54l7.07 7.07 7.073-7.07-7.072-7.072zm14.106-.141l7.072 7.07 7.07-7.07-7.07-7.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.533 51.77l7.071 7.07 7.072-7.07-7.072-7.071zm14.107-.14l7.07 7.07 7.072-7.07-7.071-7.072zM55.393 78.841h12.07l-6.035-6.035zm13.966 0h12.35l-6.174-6.176zM82.73 51.505l7.07 7.07 7.072-7.07-7.072-7.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5 65.735l7.07 7.07 7.071-7.07-7.072-7.07zm28.735-56.47l6.973 6.973 6.973-6.973zM82.906 23.396l7.07 7.072 7.073-7.072-7.073-7.07zm14.106-.14l7.071 7.071 7.072-7.07-7.072-7.072zm14.09-.124l6.09 6.09v-12.18zm-14.23 14.231l7.07 7.07 7.073-7.07-7.072-7.071zm14.106-.141l6.214 6.214V31.007zM16.194 20.109v7.358l3.392 3.393 7.071-7.072-7.071-7.071z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.194 9.265v4.166l3.428 3.428 7.071-7.071-.522-.523zm10.845 0l-.382.382 7.072 7.07 7.07-7.07-.381-.382zm-10.845 24.81v7.64l3.251 3.25 7.071-7.07-7.071-7.072zm10.286 3.679l7.071 7.07 7.072-7.07-7.072-7.07zM16.194 48.04v7.888l3.128 3.127 7.07-7.071-7.07-7.07zm24.81-38.775l-.257.257 7.07 7.07 7.071-7.07-.257-.257zm13.965 0l-.116.116 7.07 7.07 7.073-7.07-.117-.116z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.516 23.752l7.071 7.071 7.072-7.071-7.072-7.07zm14.107-.14l7.07 7.07 7.073-7.07-7.072-7.071zM26.428 51.948l7.07 7.071 7.073-7.07-7.072-7.072zm14.106-.14l7.07 7.07 7.073-7.07-7.072-7.071zm-24.34 10.374v7.993l3.074 3.075 7.072-7.07-7.072-7.073zm10.11 3.856l7.07 7.072 7.072-7.072-7.071-7.07zm-10.11 10.11v2.693h8.305L19 73.342zM54.8 23.576l7.071 7.07 7.072-7.07-7.072-7.07zm14.106-.142l7.071 7.071 7.072-7.07-7.072-7.07z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.57 37.805l7.07 7.071 7.072-7.07-7.072-7.07zm14.106-.14l7.071 7.071 7.072-7.07-7.072-7.072zm14.436-28.4l-.169.169 7.071 7.07 7.071-7.07-.169-.17zm13.966 0l-.03.029 7.072 7.07 7.07-7.07-.028-.03z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0073AD",
    fillOpacity: ".5",
    d: "M73.324 87.421L127.5 47.793 85 32.633z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E8EB",
    d: "M72.584 89.838l56.11-42.644-40.797-11.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.079 30.328l-1.604 5.782m8.737-3.869l-1.603 5.782m8.721-3.808l-1.604 5.782m8.722-3.807l-1.604 5.78m8.721-3.807l-1.604 5.782m8.721-3.808l-1.604 5.781",
    stroke: "#E3E8EB"
  })));
};

Rug.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "134",
  height: "90",
  viewBox: "0 0 134 90"
};

var Safetycard = function Safetycard(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "safety card"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 23.909c0 .773-.685 1.591-1.523 1.591H10.034c-.84 0-1.534-.818-1.534-1.591V12.104c0-.773.695-1.249 1.534-1.249h19.943c.838 0 1.523.449 1.523 1.223v11.831zM31.5 13.677h-23M31.5 16.677h-23",
    stroke: "#464646",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

Safetycard.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Shades = function Shades(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "shades"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 28.2h24V8.5h-24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 30.7h16.9V12.4H12zM12 15h17M12 17.7h17M12 20.3h17M12 22.9h17M12 25.6h17"
  })));
};

Shades.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Shampoo = function Shampoo(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "shampoo"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#464646",
    d: "M17.762 13.12V8.821h4.477v4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.231 13.12H17.77s-6.377 4.27-1.318 18.38h7.098c5.06-14.11-1.318-18.38-1.318-18.38zM20.99 10.207a.985.985 0 0 1-.99.981.986.986 0 0 1-.99-.981M17.797 10.092h4.399",
    stroke: "#464646"
  })));
};

Shampoo.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Smartlock = function Smartlock(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "smartlock"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.622 15.752c1.859 0 3.622.053 4.96.148-.476-2.534-2.591-4.508-4.95-4.508-2.36 0-4.475 1.974-4.951 4.507 1.336-.094 3.092-.147 4.94-.147zM26.708 17l-.594-.053c-1.354-.124-3.356-.195-5.492-.195-2.124 0-4.12.07-5.475.193l-.592.053.049-.594c.278-3.315 2.98-6.011 6.028-6.011 3.047 0 5.75 2.697 6.026 6.014l.05.593zm-13.082.044v9.288c0 .604.51 1.093 1.137 1.093h11.725c.627 0 1.138-.49 1.138-1.093l-.001-9.37c-.03-4.117-3.23-7.537-6.993-7.537-3.748 0-6.947 3.409-6.988 7.441l-.018.178zm12.862 11.381H14.763c-1.178 0-2.137-.939-2.137-2.093l.02-9.611c.117-4.511 3.744-8.296 7.986-8.296 4.27 0 7.907 3.82 7.987 8.363l.007.122v9.422c0 1.154-.96 2.093-2.138 2.093z",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("text", {
    fontFamily: "Roboto-Medium, Roboto",
    fontSize: "8",
    fontWeight: "400",
    fill: "#464646"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "16.078",
    y: "24.512"
  }, "00"))));
};

Smartlock.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Smokedetector = function Smokedetector(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "Smoke detector"), /*#__PURE__*/React.createElement("g", {
    stroke: "#464646",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.5 15.5c1.2-.5 2-1.6 2-3v-1.1h-21v1.1c0 1.4.8 2.5 2 3M11.5 15.5c.4.1.8.2 1.2.2h14.6c.4 0 .8-.1 1.2-.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 15.5v4c0 3.5 2.1 6.6 5.1 7.9v-3.1c0-1.9 1.5-3.5 3.4-3.5s3.4 1.6 3.4 3.5v3.1c3-1.3 5.1-4.4 5.1-7.9v-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 20.9c-1.9 0-3.4 1.6-3.4 3.5v3.1c1.1.5 2.2.7 3.4.7 1.2 0 2.4-.3 3.4-.7v-3.1c0-1.9-1.5-3.5-3.4-3.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 24.4c0-.6.4-1 1-1 .5 0 1 .4 1 1s-.4 1-1 1c-.5 0-1-.5-1-1z"
  })));
};

Smokedetector.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Smoking = function Smoking(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "smoking"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v41H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.967 20.43c-1.45.494-2.718 1.128-3.773 1.128-1.576 0-3.39-1.147-6.054-1.703-2.94-.615-5.372-.807-5.372-.807s1.945 4.89 6.868 6.796c1.183.459 3.282-.054 4.56-.054 1.402 0 3.241.49 4.384.068a10.879 10.879 0 0 0 3.02-1.72M28.07 21.505c.967-1.357 1.394-2.457 1.394-2.457s-1.409.2-3.324.51M29.014 17.95s-2.516-1.128-5.41-1.486c-1.834-.227-3.819.256-5.413.256-1.616 0-3.657-.478-5.538-.247-2.907.356-5.435 1.476-5.435 1.476s3.046-5.915 5.688-5.915c2.641 0 5.285 1.063 5.285 1.063s2.641-1.063 5.283-1.063c2.642 0 5.54 5.915 5.54 5.915zM32.785 26.321l-5.635-5.743M24.644 23.13l5.5 5.607M32.785 26.32s-.904-.328-1.878.535c-.973.862-.936 1.736-.679 1.998.256.26.955.79 2.21-.3 1.152-1.001.665-1.814.347-2.232z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.191 16.72l6.453 6.411s-.172-1.11.59-1.885c.763-.777 1.915-.668 1.915-.668l-4.479-4.173",
    stroke: "#464646"
  })));
};

Smoking.defaultProps = {
  width: "40",
  height: "41",
  viewBox: "0 0 40 41",
  xmlns: "http://www.w3.org/2000/svg"
};

var Stove = function Stove(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "stove"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1 17.767l2.9-3.9s4.1-2.3 3.4-4c-.1-.3-.9-.6-1.6-.1-.6.4-2.8 1.9-3.7 2.7-.9.7-4.1 3.7-4.1 3.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2 15.467c5.357 0 9.7 2.776 9.7 6.2 0 3.424-4.343 6.2-9.7 6.2-5.357 0-9.7-2.776-9.7-6.2 0-3.424 4.343-6.2 9.7-6.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 23.767c0-3.1 4-5.5 8.9-5.5s8.9 2.5 8.9 5.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.7 21.868v1.699c0 3.4 4.3 6.7 9.7 6.7 5.4 0 9.6-3.3 9.6-6.8v-1.7M31.8 10.168l-.3.3c-.3.2-.6.1-.7 0"
  })));
};

Stove.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Table = function Table(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "table"), /*#__PURE__*/React.createElement("g", {
    stroke: "#58595B",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.809 14.2v15h1.8v-15M14.009 25.8v-9.4M31.109 14.2v15h1.7v-15M27.609 16.4v9.4M32.809 14.1h-24l1.3-2.6h21.4zM10.21 16.4h21.2"
  })));
};

Table.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Tv = function Tv(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "tv"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5 26.779a.723.723 0 0 1-.725.72H8.225a.723.723 0 0 1-.725-.72V11.99c0-.4.325-.723.725-.723h23.55c.4 0 .725.323.725.723v14.788z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.224 14.484c0-.535.436-.969.973-.969h14.941c.537 0 .973.434.973.969v9.717a.971.971 0 0 1-.973.969h-14.94a.971.971 0 0 1-.974-.969v-9.717zM29.448 15.893c.714 0 1.293-.568 1.293-1.269 0-.702-.58-1.27-1.293-1.27-.714 0-1.293.568-1.293 1.27 0 .701.579 1.27 1.293 1.27zM29.448 20.11c.714 0 1.293-.567 1.293-1.268 0-.702-.58-1.27-1.293-1.27-.714 0-1.293.568-1.293 1.27 0 .7.579 1.269 1.293 1.269zM15.183 4.792l4.62 6.23a.216.216 0 0 0 .174.086h.035a.216.216 0 0 0 .174-.086l4.59-6.23",
    stroke: "#464646"
  })));
};

Tv.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Washer = function Washer(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "washer"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.038 32.414c0 .6-.488 1.085-1.087 1.085H10.585A1.086 1.086 0 0 1 9.5 32.414V8.585c0-.599.487-1.086 1.086-1.086h18.366c.6 0 1.087.488 1.087 1.087v23.828z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.466 22.017h.912a.26.26 0 0 1 .26.261v3.107a.26.26 0 0 1-.26.261h-.907",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.769 30.773c3.866 0 7-3.108 7-6.941 0-3.834-3.134-6.942-7-6.942s-7 3.108-7 6.942c0 3.833 3.134 6.94 7 6.94z",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.769 28.925c2.835 0 5.133-2.28 5.133-5.094 0-2.813-2.298-5.094-5.133-5.094s-5.133 2.281-5.133 5.094 2.298 5.094 5.133 5.094zM17.085 23.746a2.894 2.894 0 0 1 2.9-2.887M9.366 14.486h20.672M11.185 12.285h5.482V9.719H11.18zM26.746 11.875a.5.5 0 0 1 .999 0 .498.498 0 1 1-.999 0zM23.727 11.875a.5.5 0 1 1 1 .002.5.5 0 0 1-1-.002z",
    stroke: "#464646"
  })));
};

Washer.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Wheelchair = function Wheelchair(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "wheelchair"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9 13.94a1.665 1.665 0 0 1 1.217 1.6l.003 6.291",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.951 20.831h-9.207V22.8c0 1.263 1.091 2.215 2.538 2.215h5.95l1.828 4.482c.268.665 1.05 1.133 1.902 1.133.32 0 .622-.066.895-.197.893-.427 1.384-1.61 1.033-2.481l-2.067-5.12c-.256-.635-.646-1.163-1.08-1.464-.421-.347-1.053-.537-1.791-.537m0 1c.55 0 .968.136 1.185.335.271.171.56.55.758 1.04l2.067 5.121c.14.344-.1.995-.537 1.204a1.081 1.081 0 0 1-.463.099c-.425 0-.857-.214-.977-.51l-2.081-5.105h-6.622c-.814 0-1.538-.46-1.538-1.215v-.969h8.207M19.43 5.385a4.152 4.152 0 0 0-4.152 4.142 4.152 4.152 0 0 0 8.304 0 4.152 4.152 0 0 0-4.152-4.142m0 1a3.147 3.147 0 0 1 3.152 3.142 3.147 3.147 0 0 1-3.152 3.143 3.147 3.147 0 0 1-3.152-3.143 3.147 3.147 0 0 1 3.152-3.142",
    fill: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.927 7.638s-1.569 1.019-2.102 2.169c-.37.798-3.045 1.42-3.045 1.42M21.246 9.268c0 .1.077.181.173.181a.177.177 0 0 0 .172-.18M13.244 23.743a6.854 6.854 0 0 0 1.942 6.924 6.908 6.908 0 0 0 10.88-2.02l.004.002M16.278 21.35v-4.856",
    stroke: "#464646"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.862 12.64c-.13 0-.258.015-.384.045l-8.21 1.958a1.644 1.644 0 0 0-1.024.742c-.23.376-.301.818-.198 1.246l1.514 6.31a1.644 1.644 0 0 0 1.988 1.219 1.64 1.64 0 0 0 1.024-.741c.23-.376.3-.818.198-1.247l-1.128-4.705 6.603-1.575a1.639 1.639 0 0 0 1.024-.741c.23-.376.3-.818.198-1.246a1.646 1.646 0 0 0-1.605-1.265m0 1a.65.65 0 0 1 .15 1.28l-7.576 1.807 1.362 5.679a.65.65 0 0 1-1.266.302l-1.513-6.31a.649.649 0 0 1 .48-.782l8.21-1.958a.664.664 0 0 1 .153-.018",
    fill: "#464646"
  })));
};

Wheelchair.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var Wifi = function Wifi(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("title", null, "wifi"), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h40v40H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.992 25a1.5 1.5 0 1 1-2.999.001 1.5 1.5 0 0 1 2.999 0zM15.764 21.285c2.71-2.929 6.785-2.971 9.526-.013M9.33 14.16c12.178-10.72 22.323 0 22.323 0M12.338 17.607c4.374-4.724 11.985-4.777 16.37-.04",
    stroke: "#464646"
  })));
};

Wifi.defaultProps = {
  width: "40",
  height: "40",
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
};

var BtnAutomsg = function BtnAutomsg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.999 7h5v1h-5zM4.999 12.5h8v1h-8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.031 1.968C20.821.758 19.211.09 17.5.09s-3.321.667-4.531 1.877L12.94 2H3.603C1.616 2 0 3.584 0 5.531v9.202c0 1.936 1.616 3.51 3.603 3.51h6.42l3.681 3.613a.5.5 0 0 0 .85-.356v-3.257h1.844c2.02 0 3.602-1.542 3.602-3.51v-2.33a6.397 6.397 0 0 0 2.031-1.371c1.211-1.21 1.878-2.82 1.878-4.532s-.667-3.322-1.878-4.532zM20 11.27c-.32.168-.653.303-1 .403a5.39 5.39 0 0 1-1.5.236 5.35 5.35 0 0 1-3.308-1.159c-.176-.137-.357-.265-.517-.425-.179-.179-.32-.379-.47-.575A5.385 5.385 0 0 1 13.412 3c.091-.107.164-.224.265-.325A5.37 5.37 0 0 1 17.5 1.091c1.445 0 2.803.562 3.824 1.584 1.023 1.022 1.585 2.38 1.585 3.825s-.562 2.803-1.585 3.825A5.387 5.387 0 0 1 20 11.27zm-1 3.463c0 1.408-1.143 2.51-2.602 2.51h-2.343a.5.5 0 0 0-.5.5v2.566l-2.978-2.922a.5.5 0 0 0-.35-.144H3.603C2.167 17.243 1 16.117 1 14.733V5.531C1 4.136 2.167 3 3.603 3h8.53a6.424 6.424 0 0 0-.149 6.75H5v1h7.714c.084.094.164.191.255.282A6.367 6.367 0 0 0 19 12.726v2.007z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6.433h-1V3.046h-1v4.387h4.23v-1H20z"
  }));
};

BtnAutomsg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 22"
};

var BtnActions = function BtnActions(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "1.5",
    cy: "1.5",
    r: "1.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "7",
    cy: "1.5",
    r: "1.5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "1.5",
    r: "1.5"
  }));
};

BtnActions.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 14 3"
};

var BtnDownload = function BtnDownload(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.14 17.824a.51.51 0 0 0 .39.147.507.507 0 0 0 .376-.147l5.941-5.941a.507.507 0 0 0 .005-.711.508.508 0 0 0-.712.004l-5.117 5.117V.5a.5.5 0 0 0-1 0v15.793l-5.117-5.117a.507.507 0 0 0-.711-.004.508.508 0 0 0 .004.711l5.941 5.941zM22.5 21H.5a.5.5 0 0 0 0 1h22a.5.5 0 0 0 0-1z"
  }));
};

BtnDownload.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23 22"
};

var Doc = function Doc(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M25.028 27.647c0 .756-.608 1.37-1.356 1.37H7.48a1.365 1.365 0 0 1-1.356-1.37v-3.242h12.015c1.44 0 2.612-1.185 2.612-2.641v-6.57c0-1.455-1.172-2.64-2.612-2.64H6.123l-.046-10.2c0-.756.608-1.371 1.355-1.371H16.1v6.272c0 1.299 1.044 2.355 2.326 2.355h6.556l.046 18.037zM2.612 23.422c-.904 0-1.64-.744-1.64-1.658v-6.57a1.65 1.65 0 0 1 1.64-1.657h15.526c.904 0 1.64.743 1.64 1.657v6.57c0 .914-.736 1.658-1.64 1.658H2.612zM17.07 1.645l.003.004 7.184 6.978h-5.834a1.363 1.363 0 0 1-1.353-1.372v-5.61zm8.591 6.983L17.072.286 16.778 0H7.432C6.15 0 5.105 1.056 5.105 2.354l.046 10.2H2.612c-1.44 0-2.612 1.185-2.612 2.64v6.57c0 1.456 1.172 2.64 2.612 2.64h2.54v3.243C5.151 28.944 6.194 30 7.478 30h16.193C24.956 30 26 28.944 26 27.647L25.954 9.61v-.696l-.294-.286z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.057 16.85c.379.399.568.992.568 1.781s-.19 1.383-.568 1.782c-.379.399-.906.598-1.58.598h-1.47c-.086 0-.15-.018-.19-.057-.041-.038-.062-.101-.062-.187v-4.27c0-.086.02-.149.062-.188.04-.038.104-.058.19-.058h1.47c.674 0 1.201.2 1.58.6zm-2.41.156v3.25h.809c.398 0 .708-.135.928-.407.22-.272.33-.678.33-1.218 0-.539-.11-.945-.33-1.216-.22-.273-.53-.409-.928-.409h-.81zM12.231 16.823c.37.412.555 1.012.555 1.802s-.185 1.391-.555 1.808c-.37.418-.9.626-1.594.626-.694 0-1.226-.208-1.598-.626-.372-.417-.558-1.02-.558-1.808 0-.785.186-1.384.558-1.8.372-.413.904-.621 1.598-.621.694 0 1.225.207 1.594.619zm-2.523.56c-.21.284-.315.698-.315 1.242 0 .548.105.965.315 1.25.211.287.52.43.929.43.403 0 .71-.143.921-.43.211-.285.317-.702.317-1.25 0-.544-.106-.958-.317-1.242-.21-.283-.518-.425-.921-.425-.408 0-.718.142-.929.425zM16.542 16.265c.217.041.393.097.531.167s.207.146.207.228a.522.522 0 0 1-.064.214 1.122 1.122 0 0 1-.15.234c-.057.068-.108.102-.153.102a.878.878 0 0 1-.164-.07c-.094-.049-.213-.09-.353-.127s-.305-.055-.497-.055c-.453 0-.789.138-1.005.412-.217.274-.327.695-.327 1.261 0 .563.11.982.327 1.258.216.277.546.415.986.415.209 0 .389-.022.543-.068.154-.045.303-.102.443-.17a.419.419 0 0 1 .149-.054c.05 0 .101.032.156.099.055.065.1.14.133.223.035.084.05.147.05.188 0 .104-.076.197-.226.278a2.039 2.039 0 0 1-.574.19 3.475 3.475 0 0 1-.674.07c-.758 0-1.317-.198-1.68-.593-.363-.394-.544-1.009-.544-1.842 0-1.614.75-2.421 2.251-2.421.207 0 .42.02.635.061z"
  }));
};

Doc.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 30"
};

var Gif = function Gif(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M25.028 27.647c0 .756-.608 1.37-1.356 1.37H7.48a1.365 1.365 0 0 1-1.356-1.37v-3.242h12.015c1.44 0 2.612-1.185 2.612-2.641v-6.57c0-1.455-1.172-2.64-2.612-2.64H6.123l-.046-10.2c0-.756.608-1.371 1.355-1.371H16.1v6.272c0 1.299 1.044 2.355 2.326 2.355h6.556l.046 18.037zM2.612 23.422c-.904 0-1.64-.744-1.64-1.658v-6.57a1.65 1.65 0 0 1 1.64-1.657h15.526c.904 0 1.64.743 1.64 1.657v6.57c0 .914-.736 1.658-1.64 1.658H2.612zM17.07 1.645l.003.004 7.184 6.978h-5.834a1.363 1.363 0 0 1-1.353-1.372v-5.61zm8.591 6.983L17.072.286 16.778 0H7.432C6.15 0 5.105 1.056 5.105 2.354l.046 10.2H2.612c-1.44 0-2.612 1.185-2.612 2.64v6.57c0 1.456 1.172 2.64 2.612 2.64h2.54v3.243C5.151 28.944 6.194 30 7.478 30h16.193C24.956 30 26 28.944 26 27.647L25.954 9.61v-.696l-.294-.286z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44 16.265c.218.041.398.097.541.167.143.07.214.146.214.228 0 .086-.044.199-.133.34s-.164.21-.227.21c-.014 0-.071-.024-.173-.07a2.053 2.053 0 0 0-.867-.18c-.467-.002-.806.137-1.017.414s-.316.69-.316 1.244c0 1.125.43 1.686 1.292 1.686.258 0 .478-.02.66-.061v-1.047H7.74c-.063 0-.109-.024-.136-.071s-.04-.122-.04-.221v-.177c0-.1.013-.174.04-.222.027-.047.073-.07.136-.07h1.312c.087 0 .149.019.187.057.039.039.058.103.058.194v1.856c0 .195-.16.33-.48.405a4.72 4.72 0 0 1-1.077.112c-.734 0-1.283-.197-1.645-.592-.363-.394-.545-1.004-.545-1.829 0-1.623.75-2.434 2.251-2.434.209 0 .422.02.64.061zM11.392 16.428v4.406c0 .132-.12.198-.36.198h-.17c-.241 0-.362-.066-.362-.198v-4.406c0-.132.12-.197.361-.197h.17c.24 0 .36.065.36.197zM15.26 16.323a.458.458 0 0 1 .042.22v.171c0 .1-.014.173-.041.221s-.073.071-.136.071h-1.591v1.197h1.516c.063 0 .11.024.136.072a.456.456 0 0 1 .04.22v.17c0 .1-.013.174-.04.221-.027.048-.073.072-.136.072h-1.516v1.876c0 .127-.12.19-.36.19h-.164c-.24 0-.36-.063-.36-.19v-4.337c0-.086.02-.149.06-.188.041-.038.105-.058.19-.058h2.225c.063 0 .108.024.136.072z"
  }));
};

Gif.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 30"
};

var Jpg = function Jpg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M25.028 27.647c0 .756-.608 1.37-1.356 1.37H7.48a1.365 1.365 0 0 1-1.356-1.37v-3.242h12.015c1.44 0 2.612-1.185 2.612-2.641v-6.57c0-1.455-1.172-2.64-2.612-2.64H6.123l-.046-10.2c0-.756.608-1.371 1.355-1.371H16.1v6.272c0 1.299 1.044 2.355 2.326 2.355h6.556l.046 18.037zM2.612 23.422c-.904 0-1.64-.744-1.64-1.658v-6.57a1.65 1.65 0 0 1 1.64-1.657h15.526c.904 0 1.64.743 1.64 1.657v6.57c0 .914-.736 1.658-1.64 1.658H2.612zM17.07 1.645l.003.004 7.184 6.978h-5.834a1.363 1.363 0 0 1-1.353-1.372v-5.61zm8.591 6.983L17.072.286 16.778 0H7.432C6.15 0 5.105 1.056 5.105 2.354l.046 10.2H2.612c-1.44 0-2.612 1.185-2.612 2.64v6.57c0 1.456 1.172 2.64 2.612 2.64h2.54v3.243C5.151 28.944 6.194 30 7.478 30h16.193C24.956 30 26 28.944 26 27.647L25.954 9.61v-.696l-.294-.286z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.826 16.428v3.203c0 .453-.117.805-.35 1.054-.234.25-.598.374-1.092.374-.181 0-.358-.018-.53-.055s-.259-.11-.259-.223c0-.082.02-.19.061-.327.041-.136.098-.206.17-.211.018 0 .066.01.143.03s.163.031.259.031c.249 0 .43-.06.54-.18.111-.12.167-.312.167-.575v-3.12c0-.133.12-.198.36-.198h.17c.24 0 .36.065.36.197zM10.79 16.55c.317.2.476.578.476 1.136 0 .39-.092.692-.276.908-.183.215-.39.36-.618.435a1.996 1.996 0 0 1-.616.112h-.843v1.693c0 .127-.12.19-.36.19H8.39c-.241 0-.361-.063-.361-.19v-4.337c0-.086.02-.149.058-.188.038-.038.1-.058.187-.058h1.414c.417 0 .785.1 1.102.3zm-1.877.456v1.373h.769c.176 0 .334-.05.472-.152.138-.102.207-.282.207-.541 0-.249-.07-.425-.21-.526a.831.831 0 0 0-.504-.154h-.734zM14.823 16.265c.217.041.397.097.54.167s.214.146.214.228c0 .086-.045.199-.133.34s-.164.21-.228.21a1.01 1.01 0 0 1-.172-.07 2.061 2.061 0 0 0-.867-.18c-.468-.002-.806.137-1.017.414s-.316.69-.316 1.244c0 1.125.43 1.686 1.292 1.686.258 0 .478-.02.66-.061v-1.047h-.674c-.063 0-.108-.024-.136-.071a.46.46 0 0 1-.04-.221v-.177c0-.1.012-.174.04-.222.028-.047.073-.07.136-.07h1.313c.086 0 .148.019.187.057.037.039.057.103.057.194v1.856c0 .195-.16.33-.479.405a4.73 4.73 0 0 1-1.078.112c-.734 0-1.283-.197-1.645-.592-.363-.394-.545-1.004-.545-1.829 0-1.623.75-2.434 2.25-2.434.21 0 .422.02.641.061z"
  }));
};

Jpg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 30"
};

var Mp4 = function Mp4(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M25.028 27.647c0 .756-.608 1.37-1.356 1.37H7.48a1.365 1.365 0 0 1-1.356-1.37v-3.242h12.015c1.44 0 2.612-1.185 2.612-2.641v-6.57c0-1.455-1.172-2.64-2.612-2.64H6.123l-.046-10.2c0-.756.608-1.371 1.355-1.371H16.1v6.272c0 1.299 1.044 2.355 2.326 2.355h6.556l.046 18.037zM2.612 23.422c-.904 0-1.64-.744-1.64-1.658v-6.57a1.65 1.65 0 0 1 1.64-1.657h15.526c.904 0 1.64.743 1.64 1.657v6.57c0 .914-.736 1.658-1.64 1.658H2.612zM17.07 1.645l.003.004 7.184 6.978h-5.834a1.363 1.363 0 0 1-1.353-1.372v-5.61zm8.591 6.983L17.072.286 16.778 0H7.432C6.15 0 5.105 1.056 5.105 2.354l.046 10.2H2.612c-1.44 0-2.612 1.185-2.612 2.64v6.57c0 1.456 1.172 2.64 2.612 2.64h2.54v3.243C5.151 28.944 6.194 30 7.478 30h16.193C24.956 30 26 28.944 26 27.647L25.954 9.61v-.696l-.294-.286z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.757 16.428v4.406c0 .127-.118.19-.354.19H8.26c-.24 0-.36-.063-.36-.19v-3.12h-.02l-1.123 1.978a.26.26 0 0 1-.224.116H6.31c-.1 0-.177-.039-.231-.116L4.948 17.7l-.02-.007v3.141c0 .127-.12.19-.36.19h-.143c-.236 0-.354-.063-.354-.19v-4.406c0-.127.118-.19.354-.19h.32c.19 0 .317.054.38.163l1.19 2.101.102.218.103-.21 1.196-2.11c.059-.108.186-.162.381-.162h.306c.236 0 .354.063.354.19zM12.755 16.55c.317.2.476.578.476 1.136 0 .39-.092.692-.275.908-.184.215-.39.36-.62.435a1.996 1.996 0 0 1-.614.112h-.844v1.693c0 .127-.12.19-.36.19h-.163c-.24 0-.36-.063-.36-.19v-4.337c0-.086.019-.149.057-.188.039-.038.1-.058.187-.058h1.415c.417 0 .784.1 1.101.3zm-1.877.456v1.373h.769c.177 0 .334-.05.472-.152.139-.102.208-.282.208-.541 0-.249-.07-.425-.21-.526a.831.831 0 0 0-.504-.154h-.735zM16.604 16.428v2.87h.333c.064 0 .109.024.136.072a.456.456 0 0 1 .041.22v.102a.46.46 0 0 1-.04.222c-.028.046-.073.07-.137.07h-.333v.85c0 .127-.11.19-.333.19h-.178c-.22 0-.332-.063-.332-.19v-.85h-1.884c-.045 0-.093-.065-.143-.196s-.075-.243-.075-.333c0-.041.005-.067.014-.076l2.094-3.026a.237.237 0 0 1 .132-.092.828.828 0 0 1 .215-.023h.157c.222 0 .333.063.333.19zm-.87 1.088l-1.191 1.782h1.218v-1.775l-.028-.007z"
  }));
};

Mp4.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 30"
};

var Pdf = function Pdf(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M25.028 27.647c0 .756-.608 1.37-1.356 1.37H7.48a1.365 1.365 0 0 1-1.356-1.37v-3.242h12.015c1.44 0 2.612-1.185 2.612-2.641v-6.57c0-1.455-1.172-2.64-2.612-2.64H6.123l-.046-10.2c0-.756.608-1.371 1.355-1.371H16.1v6.272c0 1.299 1.044 2.355 2.326 2.355h6.556l.046 18.037zM2.612 23.422c-.904 0-1.64-.744-1.64-1.658v-6.57a1.65 1.65 0 0 1 1.64-1.657h15.526c.904 0 1.64.743 1.64 1.657v6.57c0 .914-.736 1.658-1.64 1.658H2.612zM17.07 1.645l.003.004 7.184 6.978h-5.834a1.363 1.363 0 0 1-1.353-1.372v-5.61zm8.591 6.983L17.072.286 16.778 0H7.432C6.15 0 5.105 1.056 5.105 2.354l.046 10.2H2.612c-1.44 0-2.612 1.185-2.612 2.64v6.57c0 1.456 1.172 2.64 2.612 2.64h2.54v3.243C5.151 28.944 6.194 30 7.478 30h16.193C24.956 30 26 28.944 26 27.647L25.954 9.61v-.696l-.294-.286z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43 16.55c.318.2.476.578.476 1.136 0 .39-.092.692-.275.908-.184.215-.39.36-.619.435a1.996 1.996 0 0 1-.615.112h-.843v1.693c0 .127-.12.19-.36.19H5.03c-.24 0-.36-.063-.36-.19v-4.337c0-.086.019-.149.058-.188.038-.038.1-.058.187-.058h1.414c.417 0 .784.1 1.102.3zm-1.876.456v1.373h.768c.177 0 .334-.05.472-.152.14-.102.208-.282.208-.541 0-.249-.07-.425-.21-.526a.831.831 0 0 0-.504-.154h-.734zM12.078 16.85c.379.399.568.992.568 1.781s-.189 1.383-.568 1.782c-.378.399-.905.598-1.58.598h-1.47c-.086 0-.15-.018-.19-.057-.04-.038-.061-.101-.061-.187v-4.27c0-.086.02-.149.061-.188.04-.038.104-.058.19-.058h1.47c.675 0 1.202.2 1.58.6zm-2.41.156v3.25h.81c.398 0 .707-.135.927-.407.22-.272.33-.678.33-1.218 0-.539-.11-.945-.33-1.216-.22-.273-.529-.409-.928-.409h-.809zM16.317 16.323a.458.458 0 0 1 .041.22v.171c0 .1-.013.173-.04.221s-.073.071-.135.071H14.59v1.197h1.515c.065 0 .11.024.137.072a.456.456 0 0 1 .041.22v.17c0 .1-.013.174-.04.221-.028.048-.073.072-.138.072h-1.515v1.876c0 .127-.121.19-.362.19h-.162c-.24 0-.36-.063-.36-.19v-4.337c0-.086.02-.149.061-.188.04-.038.104-.058.19-.058h2.225c.062 0 .107.024.134.072z"
  }));
};

Pdf.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 30"
};

var Png = function Png(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M25.028 27.647c0 .756-.608 1.37-1.356 1.37H7.48a1.365 1.365 0 0 1-1.356-1.37v-3.242h12.015c1.44 0 2.612-1.185 2.612-2.641v-6.57c0-1.455-1.172-2.64-2.612-2.64H6.123l-.046-10.2c0-.756.608-1.371 1.355-1.371H16.1v6.272c0 1.299 1.044 2.355 2.326 2.355h6.556l.046 18.037zM2.612 23.422c-.904 0-1.64-.744-1.64-1.658v-6.57a1.65 1.65 0 0 1 1.64-1.657h15.526c.904 0 1.64.743 1.64 1.657v6.57c0 .914-.736 1.658-1.64 1.658H2.612zM17.07 1.645l.003.004 7.184 6.978h-5.834a1.363 1.363 0 0 1-1.353-1.372v-5.61zm8.591 6.983L17.072.286 16.778 0H7.432C6.15 0 5.105 1.056 5.105 2.354l.046 10.2H2.612c-1.44 0-2.612 1.185-2.612 2.64v6.57c0 1.456 1.172 2.64 2.612 2.64h2.54v3.243C5.151 28.944 6.194 30 7.478 30h16.193C24.956 30 26 28.944 26 27.647L25.954 9.61v-.696l-.294-.286z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.774 16.55c.317.2.476.578.476 1.136 0 .39-.092.692-.275.908-.184.215-.39.36-.619.435a1.996 1.996 0 0 1-.615.112h-.844v1.693c0 .127-.12.19-.36.19h-.163c-.24 0-.36-.063-.36-.19v-4.337c0-.086.019-.149.057-.188.039-.038.1-.058.187-.058h1.415c.417 0 .784.1 1.101.3zm-1.877.456v1.373h.769c.177 0 .334-.05.472-.152.139-.102.208-.282.208-.541 0-.249-.07-.425-.21-.526a.831.831 0 0 0-.504-.154h-.735zM11.95 16.428v4.406c0 .127-.119.19-.354.19h-.218a.728.728 0 0 1-.228-.03.27.27 0 0 1-.146-.119L9.12 18.006l-.156-.265v3.093c0 .127-.12.19-.36.19H8.46c-.236 0-.354-.063-.354-.19v-4.406c0-.127.118-.19.354-.19h.238c.1 0 .179.012.238.034.059.022.11.065.156.129l1.809 2.767.19.314v-3.054c0-.127.12-.19.36-.19h.144c.235 0 .353.063.353.19zM15.9 16.265c.217.041.398.097.54.167s.214.146.214.228c0 .086-.044.199-.132.34-.088.14-.165.21-.228.21-.014 0-.071-.024-.173-.07a2.005 2.005 0 0 0-.867-.18c-.467-.002-.806.137-1.017.414s-.316.69-.316 1.244c0 1.125.43 1.686 1.292 1.686.259 0 .478-.02.66-.061v-1.047h-.674c-.063 0-.108-.024-.136-.071s-.04-.122-.04-.221v-.177c0-.1.013-.174.04-.222.028-.047.073-.07.136-.07h1.313c.086 0 .148.019.187.057.038.039.058.103.058.194v1.856c0 .195-.16.33-.48.405-.319.075-.678.112-1.078.112-.733 0-1.282-.197-1.645-.592-.363-.394-.544-1.004-.544-1.829 0-1.623.75-2.434 2.25-2.434.209 0 .423.02.64.061z"
  }));
};

Png.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 30"
};

var Xls = function Xls(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M25.028 27.647c0 .756-.608 1.37-1.356 1.37H7.48a1.365 1.365 0 0 1-1.356-1.37v-3.242h12.015c1.44 0 2.612-1.185 2.612-2.641v-6.57c0-1.455-1.172-2.64-2.612-2.64H6.123l-.046-10.2c0-.756.608-1.371 1.355-1.371H16.1v6.272c0 1.299 1.044 2.355 2.326 2.355h6.556l.046 18.037zM2.612 23.422c-.904 0-1.64-.744-1.64-1.658v-6.57a1.65 1.65 0 0 1 1.64-1.657h15.526c.904 0 1.64.743 1.64 1.657v6.57c0 .914-.736 1.658-1.64 1.658H2.612zM17.07 1.645l.003.004 7.184 6.978h-5.834a1.363 1.363 0 0 1-1.353-1.372v-5.61zm8.591 6.983L17.072.286 16.778 0H7.432C6.15 0 5.105 1.056 5.105 2.354l.046 10.2H2.612c-1.44 0-2.612 1.185-2.612 2.64v6.57c0 1.456 1.172 2.64 2.612 2.64h2.54v3.243C5.151 28.944 6.194 30 7.478 30h16.193C24.956 30 26 28.944 26 27.647L25.954 9.61v-.696l-.294-.286z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.72 16.36c0 .037-.024.089-.069.157L7.34 18.523l1.421 2.224c.04.058.061.11.061.156 0 .08-.13.122-.387.122h-.205c-.199 0-.321-.041-.367-.122L6.83 19.298 5.775 20.91a.235.235 0 0 1-.136.091.961.961 0 0 1-.238.024h-.184c-.258 0-.387-.041-.387-.122 0-.041.022-.093.067-.156L6.34 18.53l-1.285-2.013a.314.314 0 0 1-.061-.157c0-.081.13-.122.387-.122h.211c.2 0 .322.04.367.122l.891 1.401.925-1.408a.24.24 0 0 1 .136-.092.961.961 0 0 1 .238-.023h.184c.258 0 .387.04.387.122zM10.528 16.428v3.828h1.646c.063 0 .109.024.136.069.027.045.04.12.04.224v.17a.458.458 0 0 1-.04.225c-.027.045-.073.067-.136.067H9.896c-.086 0-.15-.018-.19-.057-.041-.038-.062-.101-.062-.187v-4.339c0-.127.12-.19.36-.19h.164c.24 0 .36.063.36.19zM15.022 16.268c.182.044.329.099.444.167.111.068.17.14.17.218 0 .08-.04.186-.114.316-.074.13-.144.194-.207.194a.56.56 0 0 1-.128-.048 1.412 1.412 0 0 0-.674-.156c-.244 0-.426.048-.544.146a.468.468 0 0 0-.177.377c0 .132.034.24.102.327a.734.734 0 0 0 .252.203c.1.051.247.114.442.19.263.105.477.207.645.303.168.098.313.239.432.422.121.184.18.418.18.704 0 .476-.145.833-.434 1.07-.29.239-.656.358-1.096.358-.294 0-.558-.03-.792-.092s-.414-.135-.544-.224c-.129-.088-.193-.17-.193-.242 0-.058.021-.128.064-.21a1.08 1.08 0 0 1 .15-.218c.057-.064.105-.095.146-.095.027 0 .082.022.163.067.14.078.279.14.415.188.136.048.297.071.483.071a.883.883 0 0 0 .517-.146c.14-.097.21-.245.21-.446 0-.122-.037-.226-.109-.312s-.162-.157-.267-.214a6.117 6.117 0 0 0-.453-.208 3.681 3.681 0 0 1-.211-.088 2.802 2.802 0 0 1-.523-.289 1.215 1.215 0 0 1-.351-.411c-.093-.173-.14-.39-.14-.653 0-.286.072-.53.215-.73.143-.203.333-.353.571-.454.238-.1.503-.15.792-.15.195 0 .383.022.564.065z"
  }));
};

Xls.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 26 30"
};

var BtnSidebarClose = function BtnSidebarClose(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0H2C.897 0 0 .897 0 2v14c0 1.103.897 2 2 2h17.5c1.379 0 2.5-1.121 2.5-2.5v-13C22 1.122 20.879 0 19.5 0zm-17 17c-.827 0-1.5-.673-1.5-1.5v-13C1 1.673 1.673 1 2.5 1H6v16H2.5zM21 15.5c0 .827-.673 1.5-1.5 1.5H7V9.5h5.914l-2.268 2.268a.5.5 0 1 0 .708.707l3.12-3.121a.5.5 0 0 0 0-.708l-3.12-3.12a.5.5 0 1 0-.708.706L12.914 8.5H7V1h12.5c.827 0 1.5.673 1.5 1.5v13z"
  }));
};

BtnSidebarClose.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 18"
};

var BtnSidebarOpen = function BtnSidebarOpen(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.5v13C0 16.879 1.121 18 2.5 18H20c1.103 0 2-.897 2-2V2c0-1.103-.897-2-2-2H2.5A2.503 2.503 0 0 0 0 2.5zM16 17V1h3.5c.827 0 1.5.673 1.5 1.5v13c0 .827-.673 1.5-1.5 1.5H16zM1 2.5C1 1.673 1.673 1 2.5 1H15v7.5H9.086l2.268-2.268a.5.5 0 1 0-.708-.707l-3.12 3.121a.5.5 0 0 0 0 .708l3.12 3.12a.5.5 0 0 0 .708-.706L9.086 9.5H15V17H2.5c-.827 0-1.5-.673-1.5-1.5v-13z"
  }));
};

BtnSidebarOpen.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 22 18"
};

var FontSize = function FontSize(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "#7A8489",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.75 1.5v6.25h-1.5V1.5H4V0h8v1.5H8.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 4.5v3.25h-1.5V4.5H0V3h5v1.5H3.25z"
  })));
};

FontSize.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "8",
  viewBox: "0 0 12 8"
};

var FontColor = function FontColor(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M10.778 9.451H9.44l-.927-2.635H4.425l-.927 2.635H2.222L5.662 0h1.676l3.44 9.451zM8.125 5.738l-1.656-4.64-1.664 4.64h3.32zM0 11.451h13v1H0z",
    fill: "#272B2D"
  }));
};

FontColor.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 13 12.4510498"
};

var Bold = function Bold(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("text", {
    fill: "#7A8489",
    fillRule: "evenodd",
    fontFamily: "Verdana-Bold, Verdana",
    fontSize: "13",
    fontWeight: "bold",
    letterSpacing: ".271",
    transform: "translate(-1 -3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0",
    y: "13"
  }, "B")));
};

Bold.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "9",
  height: "10",
  viewBox: "0 0 9 10"
};

var Italic = function Italic(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("text", {
    fill: "#7A8489",
    fillRule: "evenodd",
    fontFamily: "Verdana-Italic, Verdana",
    fontSize: "13",
    fontStyle: "italic",
    letterSpacing: ".271",
    transform: "translate(-29 -4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "29",
    y: "13"
  }, "I")));
};

Italic.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "6",
  height: "9",
  viewBox: "0 0 6 9"
};

var Bullets = function Bullets(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "#7A8489",
    fillRule: "evenodd",
    d: "M4 2h7v1H4V2zm0 4h7v1H4V6zm0 2h7v1H4V8zM0 6h2v2H0V6zm4-6h7v1H4V0zM0 0h2v2H0V0z"
  }));
};

Bullets.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "9",
  viewBox: "0 0 11 9"
};

var Numbers = function Numbers(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M5 0h7v1H5zm0 6h7v1H5zm0-4h7v1H5zm0 6h7v1H5zM3 7v1H2V7H0V6h3v1zM1 9V8h1v1h1v1H0V9h1zm2-8v3H2V1H1V0h2v1z",
    fill: "#7A8489",
    fillRule: "evenodd"
  }));
};

Numbers.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "10",
  viewBox: "0 0 12 10"
};

var Underline = function Underline(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("text", {
    fill: "#272B2D",
    fillRule: "evenodd",
    fontFamily: "Verdana",
    fontSize: "13",
    letterSpacing: ".271",
    textDecoration: "underline",
    transform: "translate(-54 -4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "54",
    y: "13"
  }, "U")));
};

Underline.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "9",
  height: "11",
  viewBox: "0 0 9 11"
};

var IcoAvatarListingMD = function IcoAvatarListingMD(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M27.833 38.405a20.017 20.017 0 0 0 6.111-4.083V22.5h-6.111v15.905zM6.5 34.726a19.973 19.973 0 0 0 6.111 3.847V22.5H6.5v12.226zM25.592 14.5H14.853c-.685 0-1.242.536-1.242 1.195v.027h13.222v-.027c0-.659-.557-1.195-1.241-1.195zM13.611 38.94A19.939 19.939 0 0 0 20 40c2.404 0 4.698-.446 6.833-1.223V16.722H13.611V38.94zm10.112-19.162h1v1.778h-1v-1.778zm0 4.89h1v1.776h-1v-1.777zm0 5.332h1v1.777h-1V30zm0 4.889h1v1.778h-1V34.89zm-1.779-15.111h1v1.778h-1v-1.778zm0 4.89h1v1.776h-1v-1.777zm0 5.332h1v1.777h-1V30zm0 4.889h1v1.778h-1V34.89zm-4.833-15.111h1v1.778h-1v-1.778zm0 4.89h1v1.776h-1v-1.777zm0 5.332h1v1.777h-1V30zm0 4.889h1v1.778h-1V34.89zm-1.778-15.111h1v1.778h-1v-1.778zm0 4.89h1v1.776h-1v-1.777zm0 5.332h1v1.777h-1V30zm0 4.889h1v1.778h-1V34.89zM6.5 20.458V21.5h6.111v-1.8H7.288c-.434 0-.788.34-.788.758z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 8.954 31.046 0 20 0S0 8.954 0 20c0 5.331 2.1 10.163 5.5 13.748v-13.29c0-.97.802-1.758 1.788-1.758h5.323v-3.005c0-1.21 1.006-2.195 2.242-2.195h10.739c1.235 0 2.241.984 2.241 2.195V18.7h5.323c.987 0 1.788.788 1.788 1.758V33.26C38.08 29.728 40 25.094 40 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.156 19.7h-5.323v1.8h6.111v-1.042c0-.418-.353-.758-.788-.758z"
  }));
};

IcoAvatarListingMD.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 40 40"
};

var IcoAvatarListingSM = function IcoAvatarListingSM(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15.578 8.833H8.866a.58.58 0 0 0-.552.39h7.817a.58.58 0 0 0-.553-.39zM8.278 24.253c1.32.475 2.738.747 4.222.747 1.276 0 2.507-.194 3.667-.55V10.223h-7.89v14.031zm5.945-12.309h1v1.112h-1v-1.112zm0 3.056h1v1.111h-1v-1.11zm0 3.333h1v1.111h-1v-1.11zm0 3.056h1V22.5h-1V21.39zm-1.112-9.445h1v1.112h-1v-1.112zm0 3.056h1v1.111h-1v-1.11zm0 3.333h1v1.111h-1v-1.11zm0 3.056h1V22.5h-1V21.39zm-2.917-9.445h1v1.112h-1v-1.112zm0 3.056h1v1.111h-1v-1.11zm0 3.333h1v1.111h-1v-1.11zm0 3.056h1V22.5h-1V21.39zm-1.11-9.445h1v1.112h-1v-1.112zm0 3.056h1v1.111h-1v-1.11zm0 3.333h1v1.111h-1v-1.11zm0 3.056h1V22.5h-1V21.39zM3.833 21.495a12.508 12.508 0 0 0 3.445 2.35V13.834H3.833v7.662zM20.307 12.083h-3.14v.75h3.444v-.464c0-.157-.136-.286-.304-.286zM17.167 23.861h.523a12.495 12.495 0 0 0 2.921-1.86v-8.168h-3.444v10.028zM3.833 12.37v.463h3.445v-.75h-3.14c-.168 0-.305.129-.305.286z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 12.5C25 5.596 19.404 0 12.5 0S0 5.596 0 12.5c0 3.008 1.064 5.766 2.833 7.923V12.37c0-.709.586-1.286 1.305-1.286h3.14v-1.69c0-.86.712-1.56 1.588-1.56h6.712c.876 0 1.589.7 1.589 1.56v1.69h3.14c.72 0 1.304.577 1.304 1.286v8.67A12.443 12.443 0 0 0 25 12.5z"
  }));
};

IcoAvatarListingSM.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 25 25"
};

var BtnHide = function BtnHide(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M14.172 3.706a.498.498 0 0 0-.32.213c-.23.341-.486.668-.744.952a.417.417 0 0 0-.07.074c-1.45 1.548-3.467 2.434-5.53 2.434-2.073 0-4.095-.888-5.54-2.429l-.024-.03a.228.228 0 0 0-.033-.032 8.004 8.004 0 0 1-.763-.97.482.482 0 0 0-.69-.125.535.535 0 0 0-.119.723c.17.254.355.503.552.74l-.737.739A.53.53 0 0 0 0 6.358v.02c.002.132.05.255.136.35.182.2.511.21.7.018L1.581 6A8.773 8.773 0 0 0 3.66 7.485l-.395.998a.535.535 0 0 0-.001.395.51.51 0 0 0 .266.283.497.497 0 0 0 .647-.28l.395-.994a8.353 8.353 0 0 0 2.442.515V9.48c0 .286.222.52.495.52a.509.509 0 0 0 .494-.52V8.402a8.31 8.31 0 0 0 2.437-.516l.381.99a.493.493 0 0 0 .644.286.497.497 0 0 0 .27-.28.537.537 0 0 0 .003-.396l-.387-1.004a8.803 8.803 0 0 0 2.068-1.481l.746.745a.49.49 0 0 0 .699-.017.53.53 0 0 0 .136-.37.524.524 0 0 0-.153-.364l-.737-.738c.197-.238.382-.487.552-.741a.537.537 0 0 0-.12-.724.476.476 0 0 0-.37-.086"
  }));
};

BtnHide.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 10"
};

var BtnShow = function BtnShow(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M4.946 5.78c0 1.483 1.15 2.691 2.563 2.691 1.403 0 2.545-1.208 2.545-2.691 0-1.473-1.142-2.672-2.545-2.672-1.413 0-2.563 1.199-2.563 2.672m.988 0c0-.9.707-1.633 1.575-1.633.859 0 1.557.733 1.557 1.633 0 .91-.698 1.652-1.557 1.652-.868 0-1.575-.741-1.575-1.652"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.509 0a.507.507 0 0 0-.495.518v1.077a8.38 8.38 0 0 0-2.442.516l-.395-.993a.49.49 0 0 0-.647-.28.531.531 0 0 0-.266.68l.396.995a8.734 8.734 0 0 0-2.078 1.486l-.747-.747a.48.48 0 0 0-.698.017.522.522 0 0 0-.137.35v.019a.527.527 0 0 0 .154.364l.737.74a8.595 8.595 0 0 0-.552.74.54.54 0 0 0-.002.595C1.97 8.533 4.65 10 7.51 10c2.847 0 5.521-1.467 7.154-3.923a.536.536 0 0 0-.001-.594 8.61 8.61 0 0 0-.552-.74l.737-.74A.532.532 0 0 0 15 3.627v-.004a.533.533 0 0 0-.136-.355.48.48 0 0 0-.348-.16.555.555 0 0 0-.351.143l-.746.746a8.744 8.744 0 0 0-2.068-1.481l.387-1.005a.537.537 0 0 0-.003-.396.497.497 0 0 0-.27-.28.464.464 0 0 0-.377.003.503.503 0 0 0-.267.283l-.381.991a8.33 8.33 0 0 0-2.437-.518V.518A.507.507 0 0 0 7.509 0zM1.356 5.78c.171-.23.357-.455.549-.664.015-.013.03-.024.058-.062 1.453-1.55 3.473-2.436 5.546-2.436 2.061 0 4.076.886 5.52 2.428l.025.03a.158.158 0 0 0 .036.035c.197.214.383.44.554.67-1.457 1.994-3.741 3.18-6.135 3.18-2.404 0-4.695-1.186-6.153-3.18z"
  }));
};

BtnShow.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 15 10"
};

var IcoCheckinFormSent = function IcoCheckinFormSent(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.354 0H1.186C.532 0 0 .5 0 1.111V18.89C0 19.5.532 20 1.186 20h13.62c.653 0 1.185-.499 1.185-1.111L16 5.145 11.354 0zm-.187 1.286l3.204 3.547h-2.606c-.325 0-.598-.43-.598-.94V1.287zM14.806 19H1.186C1.066 19 1 18.927 1 18.89V1.11c0-.037.065-.11.186-.11h8.981v2.893c0 1.087.702 1.94 1.598 1.94H15l-.009 13.055c0 .038-.065.111-.185.111z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.5h7v1h-7zM4.5 9.833h7v1h-7zM4.5 6.5h7v1h-7z"
  }));
};

IcoCheckinFormSent.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 20"
};

var IcoCheckinFormView = function IcoCheckinFormView(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.354 0H1.186C.532 0 0 .5 0 1.111V18.89C0 19.5.532 20 1.186 20h13.62c.653 0 1.185-.499 1.185-1.111L16 5.145 11.354 0zm-.187 1.286l3.204 3.547h-2.606c-.325 0-.598-.43-.598-.94V1.287zM14.806 19H1.186C1.066 19 1 18.927 1 18.89V1.11c0-.037.065-.11.186-.11h8.981v2.893c0 1.087.702 1.94 1.598 1.94H15l-.009 13.055c0 .038-.065.111-.185.111z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.203 7.76a.594.594 0 0 0-.384.255l-2.692 4.003-1.002-1.096a.594.594 0 0 0-.419-.193.603.603 0 0 0-.465 1.01l1.565 1.694.095.07a.493.493 0 0 0 .117.05l.12.028.046.002c.019 0 .039 0 .063-.002a.551.551 0 0 0 .107-.018l.093-.035a.297.297 0 0 0 .09-.052l3.276-4.787a.604.604 0 0 0-.159-.835.596.596 0 0 0-.45-.093zm-2.786 5.497z"
  }));
};

IcoCheckinFormView.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 20"
};

var IcoStatusReports = function IcoStatusReports(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M7.21 2.246h9.913a.5.5 0 1 0 0-1H7.21a.5.5 0 1 0 0 1zm0 6.054h9.913a.5.5 0 1 0 0-1H7.21a.5.5 0 1 0 0 1zm0 6h9.913a.5.5 0 1 0 0-1H7.21a.5.5 0 1 0 0 1zM1.496 1.932L.224 1.295a.5.5 0 0 0-.448.894l1.605.804a.5.5 0 0 0 .588-.105L4.364.343a.5.5 0 1 0-.728-.686l-2.14 2.275zM.224 7.295a.5.5 0 0 0-.448.894l1.605.804a.5.5 0 0 0 .588-.105l2.395-2.545a.5.5 0 1 0-.728-.686l-2.14 2.275-1.272-.637zm0 6a.5.5 0 0 0-.448.894l1.605.804a.5.5 0 0 0 .588-.105l2.395-2.545a.5.5 0 0 0-.728-.686l-2.14 2.275-1.272-.637z"
  }));
};

IcoStatusReports.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "15",
  viewBox: "0 0 18 15"
};

var IcoAgreements = function IcoAgreements(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.553L4.845.039a.498.498 0 0 0-.65.27L2.71 3.892.115 7.022a.498.498 0 0 0-.096.454l1.409 4.961a.498.498 0 0 0 .721.3l4.504-2.513a.498.498 0 0 0 .254-.389l.377-4.047L8.77 2.203a.498.498 0 0 0-.27-.65zM5.94 9.482l-3.025 1.687 1.288-3.112a.498.498 0 0 0-.92-.381l-1.289 3.112-.946-3.332L3.29 4.754l1.488.616 1.487.616-.326 3.496zm.586-4.466L4.58 4.21l-.789-.326 1.133-2.735 2.734 1.133-1.132 2.734z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.498 6.8h-5.333a2.1 2.1 0 0 0-2.098 2.097 2.1 2.1 0 0 0 2.098 2.098 1.103 1.103 0 0 1 0 2.204H.498a.498.498 0 0 0 0 .996h10.667a2.1 2.1 0 0 0 2.098-2.098 2.1 2.1 0 0 0-2.098-2.098 1.103 1.103 0 0 1-1.102-1.102c0-.608.494-1.102 1.102-1.102h5.333a.498.498 0 0 0 0-.996z"
  }));
};

IcoAgreements.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "15",
  viewBox: "0 0 17 15"
};

var IcoCheckinForm = function IcoCheckinForm(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11 .5v2h4A1.5 1.5 0 0 1 16.5 4v13a1.5 1.5 0 0 1-1.5 1.5H2A1.5 1.5 0 0 1 .5 17V4A1.5 1.5 0 0 1 2 2.5h4.5v-2H11zm0 4H6.5v-1H2a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5h-4v1zm1.77 2.59a.532.532 0 0 1 .14.733l-4.673 6.952c-.015.023-.037.035-.055.054-.01.012-.015.027-.027.038-.009.008-.02.01-.03.018a.488.488 0 0 1-.104.064c-.027.012-.052.025-.08.032a.568.568 0 0 1-.203.017.53.53 0 0 1-.088-.021.478.478 0 0 1-.11-.046c-.01-.006-.022-.007-.033-.014l-.033-.034c-.02-.016-.044-.025-.062-.045l-2.273-2.483a.533.533 0 0 1 .029-.747.525.525 0 0 1 .742.029l1.826 1.995 4.303-6.4a.526.526 0 0 1 .73-.142zM10 1.5H7.5v2H10v-2z"
  }));
};

IcoCheckinForm.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "19",
  viewBox: "0 0 17 19"
};

var IcoEmptyStateAgreements = function IcoEmptyStateAgreements(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E8EB",
    d: "M101 8H83.828c0-4.419 3.846-8 8.585-8C97.155 0 101 3.581 101 8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F6F7",
    stroke: "#EEF1F3",
    strokeWidth: "2",
    d: "M18.405 89.848H68.28v1c0 3.962 3.194 7.172 7.129 7.172 3.937 0 7.131-3.21 7.131-7.172V7.27h.056a9.172 9.172 0 0 1 3.49-6.254h-60.55c-3.939 0-7.131 3.208-7.131 7.171v81.661zM91.672.016v.083h-1V.016h1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF1F3",
    d: "M60 8.06C60 3.617 63.649.016 68.151.016h23.81c-4.57.083-8.278 3.74-8.278 8.253L83.68 90.83c0 3.009-7.893-24.581-23.68-82.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E8EB",
    d: "M76.53 98.963H8.377c-4.625 0-8.374-3.611-8.377-8.068h68.154c0 4.457 3.752 8.068 8.376 8.068"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEB6BA",
    d: "M28 60h35v2H28zm0-7h25v2H28zm22 28h25v2H50z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#30ABE5",
    d: "M55 72c1.767 2.317 5.815 8.964 8.227 4.482S71 75 71 75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AEB6BA",
    d: "M28 39h31v2H28zm0 7h41.58v2H28zm0-14h28v2H28zm0-14h35v2H28zm0 7h46.718v2H28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47 83l-4-4m4 0l-4 4",
    stroke: "#AEB6BA"
  })));
};

IcoEmptyStateAgreements.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "101",
  height: "99",
  viewBox: "0 0 101 99"
};

var IcoEmptyStateStatusReports = function IcoEmptyStateStatusReports(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E8EB",
    d: "M101 8H83.828c0-4.419 3.846-8 8.585-8C97.155 0 101 3.581 101 8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F4F6F7",
    stroke: "#EEF1F3",
    strokeWidth: "2",
    d: "M18.405 89.848H68.28v1c0 3.962 3.194 7.172 7.129 7.172 3.937 0 7.131-3.21 7.131-7.172V7.27h.056a9.172 9.172 0 0 1 3.49-6.254h-60.55c-3.939 0-7.131 3.208-7.131 7.171v81.661zM91.672.016v.083h-1V.016h1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF1F3",
    d: "M59.715 8.06c0-4.443 3.65-8.044 8.152-8.044h23.81c-4.57.083-8.28 3.74-8.28 8.253l-.002 82.561c0 3.009-7.893-24.581-23.68-82.77z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E8EB",
    d: "M76.53 98.963H8.377c-4.625 0-8.374-3.611-8.377-8.068h68.154c0 4.457 3.752 8.068 8.376 8.068"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 74h41.58v2H28zm0-7h28v2H28zm0-7h35v2H28zm0-7h25v2H28zm0-14h31v2H28zm0 7h41.58v2H28zm0-14h28v2H28zm0-14h35v2H28zm0 7h46.718v2H28z",
    fill: "#AEB6BA"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#30ABE5",
    fillRule: "nonzero",
    d: "M104.905 47.86l-13.1-13.026c-1.461-1.452-2.656-.96-2.656 1.094v5.735H69.755c-2.065 0-3.755 1.68-3.755 3.734v10.206c0 2.054 1.69 3.734 3.755 3.734H89.15v5.735c0 2.054 1.195 2.545 2.655 1.094l13.1-13.026a3.73 3.73 0 0 0 0-5.28z"
  })));
};

IcoEmptyStateStatusReports.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "106",
  height: "99",
  viewBox: "0 0 106 99"
};

var IcoPromotion = function IcoPromotion(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.784 3.723l-.129.312-.118.323-.063.19.004.029-.019.015-.032.1-.056.194.01.043-.034.04-.018.065a11.942 11.942 0 0 0-.387 3.054 12.016 12.016 0 0 0 .386 3.055s.075.267.099.343l.108.332.12.324.13.313.145.31a35.899 35.899 0 0 0-4.915-1.957l-1.278-.401V5.772l1.3-.408a35.819 35.819 0 0 0 4.89-1.947l-.143.306zm.132 3.75l.018-.235c.009-.124.018-.25.031-.372l.039-.297c.012-.1.025-.199.04-.294l.048-.25c.01-.054.02-.105.023-.152a.316.316 0 0 1 .056-.005c.202 0 .379.18.491.331.31.431.495 1.137.495 1.89 0 .753-.183 1.458-.49 1.885-.115.154-.294.338-.494.338l-.05-.003-.077-.403a9.12 9.12 0 0 1-.05-.36l-.03-.232c-.014-.12-.022-.242-.034-.408l-.015-.2a12.053 12.053 0 0 1-.001-1.234zm1.512 3.112c.437-.61.688-1.519.688-2.497 0-.976-.253-1.887-.694-2.5-.297-.399-.658-.642-1.046-.706a6.836 6.836 0 0 1 .693-1.533c.169-.263.344-.489.523-.67.15-.157.313-.29.486-.396l.193-.11a1.61 1.61 0 0 1 .701-.17c1.664 0 3.07 2.787 3.07 6.085 0 3.3-1.406 6.089-3.07 6.089-.278 0-.555-.08-.821-.237l-.057-.033a2.467 2.467 0 0 1-.504-.409 4.23 4.23 0 0 1-.516-.66 6.818 6.818 0 0 1-.697-1.54c.387-.064.75-.31 1.05-.713zM2.778 5.9v4.379H1.113a.159.159 0 0 1-.154-.163V6.063c0-.09.07-.163.154-.163H2.78zm1.565 8.975l-1.18.112-.425-3.706.426-.003.817.315.362 3.282zM12.973 1c-.38 0-.749.09-1.13.276l-.583.327a34.917 34.917 0 0 1-6.498 2.8l-1.55.495h-2.1C.499 4.898 0 5.421 0 6.063v4.053c0 .642.499 1.165 1.112 1.165h.66l.458 3.986c.048.418.387.733.789.733l.07-.003 1.505-.137a.778.778 0 0 0 .546-.303.855.855 0 0 0 .174-.623l-.341-3.091a34.954 34.954 0 0 1 6.346 2.768l.369.207c.407.239.84.36 1.284.36 2.259 0 4.028-3.114 4.028-7.09C17 4.114 15.231 1 12.972 1z"
  }));
};

IcoPromotion.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "17",
  height: "17",
  viewBox: "0 0 17 17"
};

var IcoBookingcom = function IcoBookingcom(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: "12.5",
    cy: "12.5",
    r: "12.5"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A97CC",
    d: "M15.462 16.731A1.268 1.268 0 1 1 16.728 18a1.268 1.268 0 0 1-1.266-1.269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36447D",
    d: "M13.322 12.378l-.334-.188.292-.25c.34-.292.908-.949.908-2.083C14.188 8.12 12.843 7 10.762 7H8.118A1.16 1.16 0 0 0 7 8.147v9.852h1.09l.004.001h2.716c2.313 0 3.806-1.262 3.806-3.215 0-1.051-.482-1.95-1.293-2.407zm-4.208-2.209v-.582c0-.51.215-.752.688-.783h.946c.81 0 1.296.486 1.296 1.299 0 .62-.332 1.344-1.266 1.344H9.114v-1.278zm1.848 5.97l-1.848-.002v-2.213c0-.473.183-.719.588-.775h1.26c.9 0 1.48.568 1.481 1.487 0 .943-.567 1.502-1.48 1.502z"
  }))));
};

IcoBookingcom.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25"
};

var IcoDiscount = function IcoDiscount(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M1.021 1.021a.5.5 0 0 1 .708 0L3.086 2.38l6.164.001a.5.5 0 0 1 .354.147l9.375 9.381a.5.5 0 0 1 0 .707l-6.364 6.363a.5.5 0 0 1-.707 0L2.533 9.603a.5.5 0 0 1-.146-.353L2.38 3.087 1.021 1.729a.5.5 0 0 1-.057-.638zM9.043 3.38l-4.957-.001 1.529 1.528a2 2 0 1 1-.707.708L3.381 4.089l.005 4.953 8.874 8.876 5.657-5.656L9.043 3.38zM6.63 5.63a1 1 0 0 0-.259.034l.232.232a.5.5 0 1 1-.708.708l-.232-.232a1 1 0 1 0 .967-.742z"
  }));
};

IcoDiscount.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18",
  viewBox: "0 0 18 18"
};

var IcoEmail = function IcoEmail(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.243137 0 0 0 0 0.305882 0 0 0 0 0.364706 0 0 0 1.000000 0"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 2)",
    filter: "url(#a)",
    fill: "none",
    stroke: "#3E4E5D",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "13",
    height: "9",
    x: ".5",
    y: ".5",
    rx: "1"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.151 4.361l2.224 1.983M4.849 4.361L2.625 6.344"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M13.347 1.57l-5.55 3.69c-.48.32-1.114.32-1.594 0L.653 1.57"
  })));
};

IcoEmail.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "14",
  viewBox: "0 0 14 14"
};

var IcoPadlockFilled = function IcoPadlockFilled(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.947 5h-.394V3.553a3.553 3.553 0 0 0-7.106 0V5h-.394C.47 5 0 5.471 0 6.053v5.526c0 .581.471 1.053 1.053 1.053h7.894c.582 0 1.053-.472 1.053-1.053V6.053C10 5.47 9.529 5 8.947 5zM5 9.737a1.053 1.053 0 1 1 0-2.105 1.053 1.053 0 0 1 0 2.105zm2.237-5A.263.263 0 0 1 6.974 5H3.026a.263.263 0 0 1-.263-.263V3.553a2.237 2.237 0 0 1 4.474 0v1.184z"
  }));
};

IcoPadlockFilled.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "13",
  viewBox: "0 0 10 13"
};

var IcoPaymentMethodCash = function IcoPaymentMethodCash(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.667 3.4a.767.767 0 1 0 0 1.534.767.767 0 0 0 0-1.534zM14.333 8.733a.767.767 0 1 0 0 1.534.767.767 0 0 0 0-1.534z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 3a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v7.667a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2V3zm2-1a1 1 0 0 0-1 1v7.667a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 5.2a1.633 1.633 0 1 0 0 3.267A1.633 1.633 0 0 0 9 5.2zM6.366 6.834a2.633 2.633 0 1 1 5.267 0 2.633 2.633 0 0 1-5.267 0z"
  }));
};

IcoPaymentMethodCash.defaultProps = {
  width: "18",
  height: "14",
  viewBox: "0 0 18 14",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoPaymentMethodCoin = function IcoPaymentMethodCoin(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 1.5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15zM.5 9a8.5 8.5 0 1 1 17 0 8.5 8.5 0 0 1-17 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.095 5.071h3.19a.5.5 0 1 1 0 1H8.077l-.04-.001a.766.766 0 0 0-.825.825.499.499 0 0 1 .002.04c0 .12.105.34.525.674.394.312.93.623 1.51.958l.022.012c.556.32 1.153.666 1.611 1.03.436.345.901.827.903 1.452a1.838 1.838 0 0 1-1.867 1.867H6.714a.5.5 0 1 1 0-1h3.218a.838.838 0 0 0 .854-.853v-.01c0-.12-.105-.34-.526-.674-.393-.312-.929-.623-1.51-.958l-.022-.012c-.555-.32-1.153-.666-1.61-1.03-.433-.343-.894-.82-.904-1.436a1.766 1.766 0 0 1 1.881-1.884z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3.357a.5.5 0 0 1 .5.5v1.715a.5.5 0 0 1-1 0V3.857a.5.5 0 0 1 .5-.5zM9 11.929a.5.5 0 0 1 .5.5v1.714a.5.5 0 0 1-1 0v-1.714a.5.5 0 0 1 .5-.5z"
  }));
};

IcoPaymentMethodCoin.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoPaymentMethodCheck = function IcoPaymentMethodCheck(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.248 1.538a1.1 1.1 0 0 0-1.062.284l-6.67 6.67-.26 1.815 1.815-.259 6.67-6.67a1.1 1.1 0 0 0-.493-1.84zm-1.77-.423a2.1 2.1 0 0 1 2.97 2.97L6.66 10.873a.5.5 0 0 1-.283.142l-2.64.377a.5.5 0 0 1-.565-.566l.377-2.64a.5.5 0 0 1 .141-.283l6.789-6.788z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 6.333c0-.865.701-1.566 1.567-1.566H4.2a.5.5 0 0 1 0 1H2.067a.567.567 0 0 0-.567.566V13.8c0 .313.254.567.567.567h13.866a.567.567 0 0 0 .567-.567V6.333a.567.567 0 0 0-.567-.566h-1.066a.5.5 0 1 1 0-1h1.066c.866 0 1.567.701 1.567 1.566V13.8c0 .865-.701 1.567-1.567 1.567H2.067A1.567 1.567 0 0 1 .5 13.8V6.333z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.033 12.2a.5.5 0 0 1 .5-.5h5.334a.5.5 0 1 1 0 1H9.533a.5.5 0 0 1-.5-.5zM11.167 9.533a.5.5 0 0 1 .5-.5h3.2a.5.5 0 0 1 0 1h-3.2a.5.5 0 0 1-.5-.5z"
  }));
};

IcoPaymentMethodCheck.defaultProps = {
  width: "18",
  height: "16",
  viewBox: "0 0 18 16",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoPaymentMethodNoteCoin = function IcoPaymentMethodNoteCoin(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.354 10.1H13.8a.5.5 0 1 1 0 1h-1.446a.454.454 0 0 0-.17.875c.001 0 0 0 0 0l1.468.587a1.455 1.455 0 0 1-.541 2.804h-1.445a.5.5 0 1 1 0-1h1.444a.454.454 0 0 0 .17-.875l-1.467-.588a1.455 1.455 0 0 1 .541-2.803z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.733 9.566a.5.5 0 0 1 .5.5v.534a.5.5 0 1 1-1 0v-.534a.5.5 0 0 1 .5-.5zM12.733 14.366a.5.5 0 0 1 .5.5v.534a.5.5 0 1 1-1 0v-.534a.5.5 0 0 1 .5-.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.733 8.967a3.766 3.766 0 1 0 0 7.533 3.766 3.766 0 0 0 0-7.533zm-4.766 3.766a4.766 4.766 0 1 1 9.533 0 4.766 4.766 0 0 1-9.533 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.05 1.567H12.75a1.606 1.606 0 0 1 1.55 1.65v3.116a.5.5 0 1 1-1 0V3.192a.606.606 0 0 0-.578-.626H2.077a.606.606 0 0 0-.577.626v10.62a.541.541 0 0 0 .555.554h4.279a.5.5 0 0 1 0 1H2.073A1.541 1.541 0 0 1 .5 13.794V3.217a1.606 1.606 0 0 1 1.549-1.65z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2.5a.5.5 0 0 1 .5.5v3.2a.5.5 0 1 1-1 0V1a.5.5 0 0 1 .5-.5zM7.4.5a.5.5 0 0 1 .5.5v3.2a.5.5 0 1 1-1 0V1a.5.5 0 0 1 .5-.5zM10.6.5a.5.5 0 0 1 .5.5v3.2a.5.5 0 0 1-1 0V1a.5.5 0 0 1 .5-.5z"
  }));
};

IcoPaymentMethodNoteCoin.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoPaymentMethodBankTransfer = function IcoPaymentMethodBankTransfer(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 16.86a.5.5 0 0 1 .5-.5h16a.5.5 0 1 1 0 1H1a.5.5 0 0 1-.5-.5zM9.355 2.1a.683.683 0 0 0-.71 0l-.015.008-5.746 3.28h12.232L9.37 2.109 9.355 2.1zm.518-.856a1.683 1.683 0 0 0-1.745 0L.752 5.454A.5.5 0 0 0 1 6.39h16a.5.5 0 0 0 .248-.935l-7.375-4.21zM13.571 7.583a.5.5 0 0 1 .5.5v6.083h1.286V8.083a.5.5 0 0 1 1 0v6.583a.5.5 0 0 1-.5.5h-2.286a.5.5 0 0 1-.5-.5V8.083a.5.5 0 0 1 .5-.5zM7.857 7.583a.5.5 0 0 1 .5.5v6.083h1.286V8.083a.5.5 0 1 1 1 0v6.583a.5.5 0 0 1-.5.5H7.857a.5.5 0 0 1-.5-.5V8.083a.5.5 0 0 1 .5-.5zM2.143 7.583a.5.5 0 0 1 .5.5v6.083h1.285V8.083a.5.5 0 0 1 1 0v6.583a.5.5 0 0 1-.5.5H2.143a.5.5 0 0 1-.5-.5V8.083a.5.5 0 0 1 .5-.5z"
  }));
};

IcoPaymentMethodBankTransfer.defaultProps = {
  width: "18",
  height: "18",
  viewBox: "0 0 18 18",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoPaymentMethodCreditCard = function IcoPaymentMethodCreditCard(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 2.5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v8.733a2 2 0 0 1-2 2h-13a2 2 0 0 1-2-2V2.5zm2-1a1 1 0 0 0-1 1v8.733a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V2.5a1 1 0 0 0-1-1h-13z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 4.2a.5.5 0 0 1 .5-.5h16a.5.5 0 0 1 0 1H1a.5.5 0 0 1-.5-.5zM3.7 7.4a.5.5 0 0 1 .5-.5h5.867a.5.5 0 0 1 0 1H4.2a.5.5 0 0 1-.5-.5zM3.7 9.533a.5.5 0 0 1 .5-.5h3.734a.5.5 0 0 1 0 1H4.2a.5.5 0 0 1-.5-.5z"
  }));
};

IcoPaymentMethodCreditCard.defaultProps = {
  width: "18",
  height: "14",
  viewBox: "0 0 18 14",
  xmlns: "http://www.w3.org/2000/svg"
}; // Property page new icons

var IcoActionRequired = function IcoActionRequired(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(5 2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF9C00",
    d: "M1.923 1.923a6.567 6.567 0 1 1 9.286 9.288.5.5 0 0 1-.707-.707 5.567 5.567 0 1 0-7.871 0 .5.5 0 0 1-.708.707 6.57 6.57 0 0 1 0-9.288z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "6.566",
    cy: "6.567",
    r: "4.5",
    fill: "#FED342",
    opacity: ".5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#3E4E5D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.337 6.986c0-.71.583-1.286 1.294-1.286.717 0 1.306.582 1.306 1.3v5.2l3.865 1.3c.856.276 1.051 1.288.848 2.167l-.884 4.766h-6.92l-3.48-5.2c-.393-.601-.404-1.733.462-1.733.867 0 1.776.363 3.51 3.033V6.986z"
  })));
};

IcoActionRequired.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
};

var IcoAgodaCircle = function IcoAgodaCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: "12.5",
    cy: "12.5",
    r: "12.5"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E03534",
    d: "M6 18a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB943A",
    d: "M9.25 18a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3CA863",
    d: "M12.5 18a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7A579C",
    d: "M15.75 18a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D7CB4",
    d: "M19 18a1 1 0 1 1 0 2 1 1 0 0 1 0-2"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#8D8E92",
    d: "M14.273 10.292c-.485.163-.97.327-1.485.424-.636.164-1.091.262-1.364.327-.272.065-.515.228-.727.424a1.01 1.01 0 0 0-.333.849c0 .359.151.718.424.979.303.26.667.424 1.06.391.425 0 .88-.097 1.243-.326a2.01 2.01 0 0 0 .848-.848c.243-.588.364-1.24.303-1.86l.03-.36zm.09 3.59a6.726 6.726 0 0 1-1.636 1.045 4.712 4.712 0 0 1-1.757.359c-.546 0-1.091-.13-1.576-.392a2.523 2.523 0 0 1-1.03-1.044A2.824 2.824 0 0 1 8 12.446c0-.652.212-1.273.606-1.762a2.983 2.983 0 0 1 1.667-.98l1.09-.26c.576-.131 1.092-.229 1.516-.36.424-.097.879-.228 1.363-.391 0-.522-.12-1.012-.363-1.469-.212-.293-.667-.457-1.364-.457a2.734 2.734 0 0 0-1.333.261 2.26 2.26 0 0 0-.758.784c-.212.359-.363.587-.454.685a.722.722 0 0 1-.576.163c-.242 0-.485-.098-.667-.26a.82.82 0 0 1-.272-.686c0-.457.151-.914.424-1.273.363-.49.848-.849 1.394-1.044a5.532 5.532 0 0 1 2.303-.392 5.964 5.964 0 0 1 2.394.392c.545.228 1 .652 1.242 1.24a5.66 5.66 0 0 1 .364 2.252v2.839c0 .49.09.98.212 1.469.09.326.182.653.212.979a.991.991 0 0 1-.333.718c-.212.196-.485.327-.758.327s-.515-.131-.697-.36c-.273-.326-.545-.685-.727-1.044l-.121.065z"
  }))));
};

IcoAgodaCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25"
};

var IcoAirbnbCircle = function IcoAirbnbCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "196%",
    height: "196%",
    x: "-48%",
    y: "-48%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: "2",
    "in": "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: "2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "shadowBlurOuter1",
    result: "shadowMatrixOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    "in": "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: "12.5",
    cy: "12.5",
    r: "12.5"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "c",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF5F5F",
    fillRule: "nonzero",
    stroke: "#FF5F5F",
    strokeWidth: ".2",
    d: "M18.948 17.148c-.113.78-.68 1.456-1.47 1.757-.39.15-.81.195-1.23.15a3.39 3.39 0 0 1-1.228-.39c-.581-.301-1.162-.767-1.841-1.458 1.066-1.216 1.712-2.327 1.955-3.318.114-.466.13-.885.081-1.276a2.353 2.353 0 0 0-.436-1.021c-.501-.676-1.343-1.066-2.279-1.066-.937 0-1.779.405-2.279 1.066-.226.3-.372.646-.436 1.02-.065.392-.049.826.08 1.277.243.99.905 2.117 1.955 3.333-.661.691-1.26 1.157-1.841 1.456a3.294 3.294 0 0 1-1.229.39 2.733 2.733 0 0 1-1.229-.15c-.79-.299-1.357-.975-1.47-1.755a2.326 2.326 0 0 1 .147-1.172c.047-.15.128-.3.21-.48.112-.24.242-.496.37-.751l.017-.03a159.365 159.365 0 0 1 3.555-6.742l.049-.09c.13-.225.259-.465.387-.69.13-.24.275-.466.453-.661.34-.36.792-.555 1.294-.555.5 0 .952.195 1.292.555.178.196.323.42.453.66.128.226.258.466.387.692l.049.09a192.871 192.871 0 0 1 3.539 6.757v.014c.13.24.242.511.372.751.08.18.161.33.21.48.129.39.178.765.113 1.157m-6.448-.706c-.872-1.021-1.439-1.982-1.632-2.793a2.244 2.244 0 0 1-.05-.916c.033-.24.13-.45.26-.63.307-.405.823-.661 1.422-.661.598 0 1.131.24 1.421.66.13.18.228.391.26.631.048.271.032.586-.048.916-.195.796-.76 1.757-1.633 2.793m7.288-.78c-.08-.182-.162-.377-.242-.542-.13-.27-.26-.525-.372-.765l-.016-.015a153.383 153.383 0 0 0-3.572-6.787l-.048-.09a25.585 25.585 0 0 1-.388-.706c-.161-.27-.322-.555-.581-.826A2.692 2.692 0 0 0 12.516 5c-.808 0-1.536.331-2.068.901-.243.27-.42.555-.583.826-.125.237-.255.473-.387.706l-.048.09a171.115 171.115 0 0 0-3.572 6.786l-.017.03c-.112.241-.242.496-.37.766a9.115 9.115 0 0 0-.243.54c-.21.556-.275 1.082-.194 1.622.177 1.126.986 2.072 2.101 2.493a3.52 3.52 0 0 0 1.729.21 4.48 4.48 0 0 0 1.616-.511c.663-.345 1.293-.84 2.004-1.561.711.721 1.357 1.216 2.004 1.56a4.476 4.476 0 0 0 2.037.542c.451 0 .904-.074 1.308-.24 1.132-.42 1.923-1.381 2.1-2.493.13-.526.065-1.05-.145-1.606",
    mask: "url(#c)"
  })));
};

IcoAirbnbCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25"
};

var IcoBookingcomCircle = function IcoBookingcomCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: "12.5",
    cy: "12.5",
    r: "12.5"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A97CC",
    d: "M15.462 16.731A1.268 1.268 0 1 1 16.728 18a1.268 1.268 0 0 1-1.266-1.269"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#36447D",
    d: "M13.322 12.378l-.334-.188.292-.25c.34-.292.908-.949.908-2.083C14.188 8.12 12.843 7 10.762 7H8.118A1.16 1.16 0 0 0 7 8.147v9.852h1.09l.004.001h2.716c2.313 0 3.806-1.262 3.806-3.215 0-1.051-.482-1.95-1.293-2.407zm-4.208-2.209v-.582c0-.51.215-.752.688-.783h.946c.81 0 1.296.486 1.296 1.299 0 .62-.332 1.344-1.266 1.344H9.114v-1.278zm1.848 5.97l-1.848-.002v-2.213c0-.473.183-.719.588-.775h1.26c.9 0 1.48.568 1.481 1.487 0 .943-.567 1.502-1.48 1.502z"
  }))));
};

IcoBookingcomCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25"
};

var IcoExpediaCircle = function IcoExpediaCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: "12.5",
    cy: "12.5",
    r: "12.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M.154.107h14.798v9.952H.154z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#072F54",
    d: "M13.744 10.742l-.301-.853-2.554-3.412.459-.114 4.402 3.807 2.59-.741c.305-.078.65-.096.914-.094a7.45 7.45 0 0 0-4.272-3.899c-3.888-1.386-8.162.646-9.548 4.536a7.461 7.461 0 0 0-.35 3.626l6.207-2.155 2.453-.701z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 9.899)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#072F54",
    d: "M14.529.107c-.228.147-.562.342-.894.448l-2.596.741-1.733 5.562-.45.146.367-4.248-.205-.882-2.432.695L.154 4.083a7.473 7.473 0 0 0 4.816 5.54A7.472 7.472 0 0 0 14.529.107",
    mask: "url(#d)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FBC108",
    d: "M14.018 11.772l.204.882-.366 4.248.45-.146 1.732-5.562 2.597-.741c.332-.106.666-.3.893-.448a7.674 7.674 0 0 0-.272-.672 3.733 3.733 0 0 0-.914.093l-2.59.742-4.405-3.808-.459.115 2.554 3.412.301.852-2.453.701-6.205 2.157c.02.128.042.257.068.384l6.432-1.514 2.433-.695z"
  }))));
};

IcoExpediaCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25"
};

var IcoPlus = function IcoPlus(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#206CFF",
    filter: "url(#a)",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: "6.491",
    cy: "6.539",
    opacity: ".114",
    rx: "6.491",
    ry: "6.539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.978 7.036l2.33.005c.275 0 .496-.22.495-.495a.497.497 0 0 0-.497-.497L6.98 6.043l.004-2.329a.492.492 0 0 0-.495-.495.497.497 0 0 0-.497.497l-.006 2.325-2.333-.004a.494.494 0 0 0-.495.495c0 .274.222.496.497.497l2.329.005-.003 2.336a.492.492 0 0 0 .495.495.5.5 0 0 0 .498-.498l.002-2.33z"
  })));
};

IcoPlus.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "14",
  viewBox: "0 0 13 14"
};

var IcoPlusCircle = function IcoPlusCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "#206CFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: "6.491",
    cy: "6.539",
    opacity: ".114",
    rx: "6.491",
    ry: "6.539"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.978 7.036l2.33.005c.275 0 .496-.22.495-.495a.497.497 0 0 0-.497-.497L6.98 6.043l.004-2.329a.492.492 0 0 0-.495-.495.497.497 0 0 0-.497.497l-.006 2.325-2.333-.004a.494.494 0 0 0-.495.495c0 .274.222.496.497.497l2.329.005-.003 2.336a.492.492 0 0 0 .495.495.5.5 0 0 0 .498-.498l.002-2.33z"
  })));
};

IcoPlusCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "14",
  viewBox: "0 0 13 14"
};

var IcoSiteminderCircle = function IcoSiteminderCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: "12.5",
    cy: "12.5",
    r: "12.5"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0F8BCC",
    fillRule: "nonzero",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.298 18.735a.527.527 0 0 1 .123-.159c.122-.148.203-.326.234-.515.047-.265.024-.53.028-.795.004-.3.003-.601 0-.901a.2.2 0 0 1 .091-.185 1.17 1.17 0 0 0 .479-.72c.078-.31.028-.638-.14-.91a2.101 2.101 0 0 0-.318-.386c-.351-.344-.7-.692-1.05-1.036-.438-.431-.873-.867-1.319-1.293a.863.863 0 0 0-.57-.246c-.162-.008-.324 0-.486.005-.128.006-.234.076-.339.137a1.35 1.35 0 0 0-.28.214c-.717.717-1.435 1.433-2.154 2.147-.076.077-.157.15-.231.228a1.18 1.18 0 0 0-.341.81c-.025.416.17.813.513 1.047a.222.222 0 0 1 .085.207v1.314c-.004.263.072.52.216.74.06.095.136.18.225.25.025.02.047.04.037.072-.01.032-.046.03-.074.02a.485.485 0 0 0-.161-.01c-.483 0-.966-.004-1.448 0a5.52 5.52 0 0 1-.738-.038 4.576 4.576 0 0 1-.644-.145 3.15 3.15 0 0 1-.561-.207 4.5 4.5 0 0 1-1.285-.924 3.896 3.896 0 0 1-.65-.87 4.916 4.916 0 0 1-.354-.84c-.076-.24-.111-.487-.162-.732a1.95 1.95 0 0 1-.017-.324c-.02-.344.004-.689.07-1.027.052-.275.138-.543.256-.797.091-.185.16-.38.27-.554a4.42 4.42 0 0 1 1.211-1.293c.303-.217.635-.391.985-.517.157-.054.317-.1.473-.155a.209.209 0 0 1 .043-.011c.497-.075.998-.123 1.498-.053.177.025.361.026.534.095.098.04.146.009.198-.098.057-.119.104-.242.172-.357a6.305 6.305 0 0 1 1.21-1.464c.258-.235.54-.441.842-.615.317-.185.647-.346.989-.48.16-.061.322-.113.484-.169.098-.03.199-.051.301-.062.17-.022.34-.056.508-.084.348-.062.696-.048 1.046-.046.275.01.548.044.817.102.14.025.279.056.42.081.142.034.282.077.418.132.391.14.768.32 1.124.534.246.145.478.311.692.499.158.126.308.26.452.402.236.25.454.518.652.8a6.3 6.3 0 0 1 .744 1.477c.068.19.117.385.148.584.02.13.045.261.069.39.067.361.057.724.061 1.087 0 .285-.027.57-.08.85a5.296 5.296 0 0 1-.332 1.157c-.123.29-.272.565-.421.84-.142.247-.31.479-.5.691-.228.27-.479.522-.748.752-.176.15-.36.289-.554.416-.38.25-.786.456-1.212.615-.17.075-.35.129-.533.16-.111.013-.228.061-.341.08-.222.036-.435.103-.675.083z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.166 18.123a4.377 4.377 0 0 0 0 .486c.009.124-.006.135-.13.137-.246.005-.492.01-.738.013-.147 0-.16-.011-.16-.16v-.886c0-.103.022-.206.066-.3a.458.458 0 0 1 .37-.256.518.518 0 0 1 .591.555c-.005.135 0 .273 0 .41z"
  }))));
};

IcoSiteminderCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25"
};

var IcoTipBulb = function IcoTipBulb(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "15.5",
    cy: "15.464",
    r: "6.5",
    fill: "#FEC802"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#344773",
    d: "M15.232 6.4c2.432 0 4.736.896 6.4 2.56 1.664 1.664 2.688 3.968 2.688 6.4 0 2.688-1.152 5.248-3.328 6.912-1.152.896-1.792 2.304-1.792 3.584V28.8c0 1.024-.896 1.92-1.92 1.92h-3.84c-.896 0-1.92-.768-1.92-2.304v-2.688c0-1.28-.64-2.432-1.664-3.328C7.552 20.608 6.4 18.048 6.4 15.232c.128-4.864 4.096-8.704 8.832-8.832zm2.688 20.479H12.8v1.595c.003.297.043.966.64.966h3.84c.384 0 .64-.256.64-.64v-1.921zm6.4-3.327l1.792 1.792a.619.619 0 0 1 0 .896c0 .128-.128.128-.384.128-.128 0-.384 0-.512-.128l-1.792-1.792c-.256-.256-.256-.64 0-.896s.64-.256.896 0zm-17.152 0a.619.619 0 0 1 0 .896L5.376 26.24c-.128.128-.256.128-.384.128s-.384 0-.512-.128a.619.619 0 0 1 0-.896l1.792-1.792a.619.619 0 0 1 .896 0zM15.36 7.68c-4.096 0-7.552 3.456-7.68 7.552 0 2.432 1.024 4.736 2.944 6.144 1.372 1.122 2.136 2.609 2.174 4.223h5.129c.086-1.589.961-3.258 2.297-4.351 1.792-1.408 2.816-3.584 2.816-5.888 0-2.048-.768-3.968-2.304-5.504-1.408-1.408-3.328-2.176-5.376-2.176zm14.72 7.04c.384 0 .64.256.64.64s-.256.64-.64.64h-2.56c-.384 0-.64-.256-.64-.64s.256-.64.64-.64h2.56zm-26.88 0c.384 0 .64.256.64.64s-.256.64-.64.64H.64c-.384 0-.64-.256-.64-.64s.256-.64.64-.64H3.2zM15.36 9.6c3.2 0 5.76 2.56 5.76 5.76 0 .384-.256.64-.64.64s-.64-.256-.64-.64c0-2.432-2.048-4.48-4.48-4.48-.384 0-.64-.256-.64-.64s.256-.64.64-.64zm10.752-4.992a.619.619 0 0 1 0 .896L24.32 7.296s-.256.128-.384.128-.384 0-.512-.128a.619.619 0 0 1 0-.896l1.792-1.792a.619.619 0 0 1 .896 0zM5.376 4.48l1.792 1.792a.619.619 0 0 1 0 .896c-.128.128-.256.256-.384.256s-.384 0-.512-.128L4.48 5.376c-.256-.256-.256-.64 0-.896s.64-.256.896 0zM15.36 0c.384 0 .64.256.64.64V3.2c0 .384-.256.64-.64.64s-.64-.256-.64-.64V.64c0-.384.256-.64.64-.64z"
  })));
};

IcoTipBulb.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "35",
  viewBox: "0 0 35 35"
};

var IcoHopperCircle = function IcoHopperCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.92 10.184c0 .077.038.116.306.348.572.503 1.947 1.664 1.756 2.67-.115.619-.84 1.044-2.062 1.315-.114 0-.114.077-.152.116-.038.155.114.348.534.812.496.503 1.222 1.393 1.375 2.206.076.348.038.619-.077.735-.152.193-.496.154-.802-.039-.381-.27-.801-.813-1.221-1.354-.153-.232-.344-.464-.497-.658-.763-.928-3.512-3.868-7.406-3.868-2.138 0-4.238.928-6.3 2.708-.076.038-.114.077-.19.077-.077 0-.115-.077-.153-.155-.19-.619.458-2.398 3.092-4.487.077-.117.191-.155.153-.271-.038-.078-.153-.116-.305-.116-.268-.039-.687-.039-.955-.426-.267-.425-.343-.85-.114-1.277.343-.735 1.336-1.237 2.023-1.199.038 0 .077 0 .115.039.114.155.152.735.152 1.238 0 .077 0 .077.039.116.038 0 .038.039.114.039.076 0 .191-.04.344-.116.382-.194 1.183-.503 2.252-.503 1.756 0 3.589.89 5.383 2.669.077.116.191.155.306.155.229 0 .382-.194.382-.194l.038-.038-.038-.078c-.039-.193-.42-.812-1.222-1.895-.802-1.161-.993-2.322-.84-2.94.038-.233.153-.349.267-.387h.038c.23 0 .726.502.955.89.305.464.687 1.624.992 2.553.153.58.344 1.044.458 1.354l.039.077.572-.193-.038-.078c-.076-.425-.305-1.16-.534-1.895-.191-.658-.382-1.277-.459-1.625-.152-.851-.152-1.316-.038-1.47C17.24 5 17.24 5 17.28 5c.381 0 1.489.542 1.68 2.979.076 1.044-.039 2.166-.039 2.205z",
    fill: "#FA6866"
  }));
};

IcoHopperCircle.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoTripadvisorCircle = function IcoTripadvisorCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: "12.5",
    cy: "12.5",
    r: "12.5"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B790",
    d: "M12.399 6.526c3.411 0 4.696 1.408 4.696 1.408s-3.65-.603-4.866 3.856c-1.215-4.46-4.864-3.856-4.864-3.856s1.284-1.408 4.696-1.408h.338zm4.155 6.053a.8.8 0 0 0 .81.79.8.8 0 0 0 .811-.79.8.8 0 0 0-.81-.79.8.8 0 0 0-.811.79zm-.527 1.303a1.807 1.807 0 0 1 0-2.605c.357-.349.833-.54 1.338-.54 1.043 0 1.891.827 1.891 1.842 0 1.016-.848 1.842-1.891 1.842-.505 0-.98-.191-1.338-.54 0 0 .357.349 0 0zm-.382-2.978a2.321 2.321 0 0 0 0 3.35c.46.447 1.07.694 1.72.694 1.341 0 2.432-1.063 2.432-2.369 0-1.306-1.091-2.369-2.433-2.369-.65 0-1.26.247-1.72.694zm1.72 5.622c-2.236 0-4.054-1.77-4.054-3.947s1.818-3.948 4.053-3.948c2.236 0 4.055 1.771 4.055 3.948s-1.82 3.947-4.055 3.947zM6.823 12.58a.8.8 0 0 0 .811.79.8.8 0 0 0 .811-.79.8.8 0 0 0-.811-.79.8.8 0 0 0-.811.79zm-.527 1.303a1.807 1.807 0 0 1 0-2.605c.358-.349.833-.54 1.338-.54 1.043 0 1.892.827 1.892 1.842 0 1.016-.849 1.842-1.892 1.842-.505 0-.98-.191-1.338-.54 0 0 .358.349 0 0zm-.382-2.978a2.321 2.321 0 0 0 0 3.35c.46.447 1.07.694 1.72.694 1.342 0 2.433-1.063 2.433-2.369 0-1.306-1.091-2.369-2.433-2.369-.65 0-1.26.247-1.72.694zm1.72 5.622c-2.235 0-4.054-1.77-4.054-3.947S5.4 8.631 7.635 8.631c2.235 0 4.054 1.771 4.054 3.948s-1.819 3.947-4.054 3.947zM21.36 9.49c.19-.557.481-1.212.883-1.608h-3.316c-.055-.016-.112-.027-.168-.042C18.58 7.563 17.345 6 12.414 6c-5.411 0-6.37 1.882-6.37 1.882h-3.46c.442.433.749 1.179.937 1.765A4.863 4.863 0 0 0 2.5 12.622c0 2.734 2.265 4.957 5.051 4.957a5.078 5.078 0 0 0 3.854-1.76l1.146 1.576.99-1.637a5.08 5.08 0 0 0 3.908 1.82c2.785 0 5.051-2.222 5.051-4.956a4.88 4.88 0 0 0-1.14-3.132z",
    mask: "url(#b)"
  })));
};

IcoTripadvisorCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25"
};

var IcoTripComCircle = function IcoTripComCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "26",
    height: "25"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "13",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 16.95c0 .964-.773 1.742-1.736 1.748a1.74 1.74 0 0 1-1.747-1.737c0-.963.773-1.741 1.736-1.747a1.74 1.74 0 0 1 1.741 1.731v.006",
    fill: "#F2B73F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 6v2.43h3.764v10.312h2.9V8.43h3.764V6H6.5z",
    fill: "#2B45F6"
  })));
};

IcoTripComCircle.defaultProps = {
  width: "26",
  height: "25",
  viewBox: "0 0 26 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoVrboCircle = function IcoVrboCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: "12.5",
    cy: "12.5",
    r: "12.5"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#7CB985",
    d: "M12.447 18l.341-.927-1.155-7.634C11.311 7.29 11.698 6.354 13 6.03V6h-1.204c-.349.226-1.087.903-.674 3.434L12.447 18"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB6233",
    d: "M11.55 20l.45-.932-2.024-9.64c-.38-1.869-.218-2.842.414-3.398V6H9.298c-.335.7-.435 1.4-.05 3.25l2.3 10.75"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F5998",
    d: "M10.63 21l.37-.873L8.925 9.05C8.56 7.328 8.643 6.54 8.793 6H8c-.008.932.098 1.86.315 2.76L10.631 21M6.952 6H6v.028c.423.577.55 1.28.889 2.833L9.429 22H10L7.46 8.819A26.842 26.842 0 0 1 6.952 6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#467BB2",
    d: "M5.054 6H4v.028c.962.411 1.435 1.2 1.815 3.047L8.41 22H9L6.388 8.994C5.938 6.737 5.465 6.32 5.054 6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2F5998",
    d: "M20.107 6c-1.445.804-2.305 2.29-4.107 5.976l.045.024C18.127 8.29 19.313 6.814 22 6.044V6h-1.893"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#DB6233",
    d: "M16 11.97l.048.03c1.768-3.875 2.23-4.956 2.952-5.97V6h-1.431v.04c.147 1.552-.41 2.982-1.569 5.93"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#7CB985",
    d: "M15.866 11.97l.047.03c1.138-3.507 1.506-5.055.502-6H15v.03c1.602.524 1.933 2.023.866 5.94"
  }))));
};

IcoVrboCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25"
};

var IcoWebsite = function IcoWebsite(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: "12.5",
    cy: "12.5",
    r: "12.5"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.201 19.333a10.94 10.94 0 0 1-1.316 1.534 7.74 7.74 0 0 0 2.797-1.337 7.864 7.864 0 0 0 2.461-3.129H17.65a10.347 10.347 0 0 1-1.448 2.932zm-2.672 1.331a9.972 9.972 0 0 0 1.811-1.94 9.347 9.347 0 0 0 1.199-2.323h-3.01v4.263zm-5.183-4.263h-2.49a7.882 7.882 0 0 0 2.462 3.129 7.725 7.725 0 0 0 2.83 1.345 11.316 11.316 0 0 1-2.802-4.474zm4.128 4.256V16.4h-3.01a10.28 10.28 0 0 0 3.01 4.256zM13.529 5.22v4.054h2.935a9.366 9.366 0 0 0-1.108-2.091 9.972 9.972 0 0 0-1.827-1.963zM9.784 6.576c.393-.558.84-1.08 1.336-1.56A7.72 7.72 0 0 0 8.296 6.37a7.855 7.855 0 0 0-2.344 2.903H8.42c.318-.956.775-1.86 1.363-2.698zm2.69-1.356a9.972 9.972 0 0 0-1.827 1.963 9.388 9.388 0 0 0-1.108 2.091h2.935V5.22zM4 10.329v5.018h18v-5.018H4zm6.292 3.81h-.818l-.366-1.21-.385 1.21h-.818l-.725-2.266h.786l.395 1.287.417-1.287h.702l.395 1.304.417-1.304h.725l-.725 2.264zm3.902 0h-.819l-.365-1.21-.385 1.21h-.819l-.724-2.265h.786l.395 1.287.417-1.287h.702l.395 1.304.417-1.304h.725l-.725 2.264zm3.083 0l-.366-1.21-.385 1.21h-.818l-.725-2.265h.786l.395 1.287.417-1.287h.702l.395 1.304.418-1.304h.724l-.724 2.264h-.82zm-1.058-7.563a10.392 10.392 0 0 1 1.363 2.698h2.466a7.853 7.853 0 0 0-2.344-2.903 7.702 7.702 0 0 0-2.82-1.354c.496.48.943 1.001 1.335 1.56z",
    fill: "#10275B",
    fillRule: "nonzero"
  })));
};

IcoWebsite.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25"
};

var IcoWebsiteCircle = function IcoWebsiteCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "a",
    cx: "12.5",
    cy: "12.5",
    r: "12.5"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#10275B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 21.5a9 9 0 1 0-.001-18.001A9 9 0 0 0 12.5 21.5zm0-16.875c4.342 0 7.875 3.533 7.875 7.875 0 4.342-3.533 7.875-7.875 7.875-4.342 0-7.875-3.533-7.875-7.875 0-4.342 3.533-7.875 7.875-7.875z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.213 11.688l.653 2.451h.702l.797-3.278h-.667l-.503 2.29-.575-2.29h-.787l-.599 2.251-.495-2.251h-.678l.783 3.278h.718zm3.672 2.451l.651-2.451.653 2.451h.702l.797-3.278h-.667l-.503 2.29-.575-2.29h-.787l-.599 2.251-.495-2.251h-.678l.783 3.278zm4.323 0l.651-2.451.653 2.451h.702l.797-3.278h-.666l-.504 2.29-.575-2.29h-.787l-.599 2.251-.495-2.251h-.677l.782 3.278z"
  }))));
};

IcoWebsiteCircle.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "25",
  height: "25",
  viewBox: "0 0 25 25"
};

var IcoHotelBedsCircle = function IcoHotelBedsCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "25",
    height: "25"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.962 13.097v4.411h-2.724v-3.957c0-1.102-.454-1.556-1.232-1.556-.844 0-1.557.519-1.557 1.816v3.697H9.725V7h2.724v3.568c.584-.584 1.427-.844 2.335-.844 1.816 0 3.178 1.038 3.178 3.373z",
    fill: "#003057"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.449 14.849H9.725v2.724h2.724v-2.724z",
    fill: "#B92454"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.724 12.124H7v2.725h2.724v-2.725z",
    fill: "#9FCFCA"
  })));
};

IcoHotelBedsCircle.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoSmilingHouseCircle = function IcoSmilingHouseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "25",
    height: "25"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.005 5.887c1.703 2.064 3.545 3.999 5.71 5.527 1.669 1.18.306 1.956-.668 1.172-2.145-1.724-3.804-3.608-5.439-6.06-.741-1.111-1.003-1.27-1.495-.384-1.38 2.482-3.504 4.222-5.898 5.776-1.079.7-2.87.34-.671-.77 3.352-1.694 4.974-3.75 6.383-5.568.78-1.005 1.351-.574 2.078.307z",
    fill: "#44C8F5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.798 10.56c1.72 1.258 4.004 1.884 5.385-.317 0 0-1.127.664-2.006.885-.879.221-2.281.086-3.38-.567z",
    fill: "#284866"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.844 8.579a15.44 15.44 0 0 0-.123-2.374c-.18-1.319.834-1.385.891-.552.042.605.051 1.204.027 1.812L9.844 8.58z",
    fill: "#44C8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.9 18.56h.141v.595h.99v-.594h.141v1.404H6.03v-.677h-.989v.677H4.9V18.56zM7.771 18.944a.644.644 0 0 1 .164-.233.688.688 0 0 1 .238-.139.853.853 0 0 1 .282-.046c.1 0 .194.015.283.046.089.03.168.078.238.14.07.062.124.14.163.232.04.093.06.2.06.319 0 .12-.02.225-.06.318a.646.646 0 0 1-.401.373.853.853 0 0 1-.283.046.853.853 0 0 1-.282-.046.646.646 0 0 1-.401-.373.808.808 0 0 1-.06-.318c0-.12.02-.226.06-.319zm.142.587c.032.077.076.14.131.189a.555.555 0 0 0 .189.11.696.696 0 0 0 .445.001.525.525 0 0 0 .32-.3.697.697 0 0 0 .048-.268.695.695 0 0 0-.048-.268.517.517 0 0 0-.32-.3.696.696 0 0 0-.445 0 .527.527 0 0 0-.32.3.697.697 0 0 0-.048.268c0 .102.016.192.048.268zM11.969 19.422a.936.936 0 0 1-.022.21.432.432 0 0 1-.272.316.833.833 0 0 1-.318.052.837.837 0 0 1-.318-.051.436.436 0 0 1-.272-.317.936.936 0 0 1-.022-.21v-.861h.142v.861c0 .088.013.161.038.22a.33.33 0 0 0 .104.137.41.41 0 0 0 .148.068.787.787 0 0 0 .36 0 .4.4 0 0 0 .147-.068.328.328 0 0 0 .104-.137.55.55 0 0 0 .038-.22v-.861h.143v.861zM14.496 18.962a.344.344 0 0 0-.043-.147.258.258 0 0 0-.093-.093.442.442 0 0 0-.131-.048.808.808 0 0 0-.162-.015.53.53 0 0 0-.28.066c-.072.044-.108.104-.108.181 0 .086.037.146.11.183.074.036.204.07.39.1.076.014.142.028.197.043a.663.663 0 0 1 .152.062.3.3 0 0 1 .11.105.417.417 0 0 1-.008.372.371.371 0 0 1-.132.135.596.596 0 0 1-.182.072 1.079 1.079 0 0 1-.453-.004.528.528 0 0 1-.191-.084.419.419 0 0 1-.13-.155.589.589 0 0 1-.056-.234h.142a.48.48 0 0 0 .047.178.293.293 0 0 0 .1.113c.043.027.091.047.146.058a.931.931 0 0 0 .344.003.46.46 0 0 0 .132-.045c.04-.021.07-.05.094-.086a.245.245 0 0 0 .034-.134.194.194 0 0 0-.036-.12.251.251 0 0 0-.097-.076.655.655 0 0 0-.133-.044 2.974 2.974 0 0 0-.185-.034l-.048-.008a.947.947 0 0 1-.378-.126.282.282 0 0 1-.122-.248c0-.073.015-.136.045-.189a.359.359 0 0 1 .123-.127.546.546 0 0 1 .172-.07.949.949 0 0 1 .411.001c.067.016.127.04.18.073a.371.371 0 0 1 .129.136c.032.057.05.125.051.205h-.14M16.211 18.56h1.09v.135h-.948v.476h.913v.133h-.913v.527h.962v.134h-1.104V18.56z",
    fill: "#44C8F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.39 13.947V13.988c0 .137.036.256.109.357.072.1.164.194.274.278l.79.563a6.13 6.13 0 0 1 .205.15c.185.138.34.285.466.442.125.158.194.365.205.623V16.42a.76.76 0 0 1-.055.254c-.038.101-.093.206-.169.315a1.8 1.8 0 0 1-.509.49c-.218.144-.48.217-.786.217a1.365 1.365 0 0 1-.816-.26 1.512 1.512 0 0 1-.515-.707c-.004-.004-.007-.02-.01-.046a.987.987 0 0 1-.002-.081v-.085c0-.024.002-.034.006-.03a.048.048 0 0 0 .021.006h.02c.02 0 .038-.003.054-.01a.114.114 0 0 0 .041-.026.063.063 0 0 0 .015-.022.063.063 0 0 0 .003-.021.11.11 0 0 0-.006-.03.118.118 0 0 1-.007-.036c-.003 0-.006-.001-.006-.003v-.01a.125.125 0 0 1-.012-.054l.001-.01v-.013a.07.07 0 0 1 .011-.018.136.136 0 0 1 .077-.055.227.227 0 0 1 .082-.023l.077.136a1.598 1.598 0 0 0 .536.535c.129.08.28.127.453.139h.047a.052.052 0 0 0 .024.006h.03a1.288 1.288 0 0 0 .247-.024.9.9 0 0 0 .22-.076.38.38 0 0 0 .163-.154.352.352 0 0 0 .035-.145.463.463 0 0 0-.006-.072.266.266 0 0 0-.024-.073.795.795 0 0 0-.17-.248 2.107 2.107 0 0 0-.342-.284l-.79-.538a1.903 1.903 0 0 1-.539-.529 1.264 1.264 0 0 1-.191-.728 1.31 1.31 0 0 1 .424-.956c.275-.261.598-.393.971-.393h.06c.02 0 .039.003.059.007a.74.74 0 0 1 .106.018l.088.024c.004 0 .006.001.006.003s.002.002.006.002a.639.639 0 0 0 .224.043h.064c.02 0 .037-.002.053-.006a.438.438 0 0 0 .047-.003.324.324 0 0 1 .048-.003l.176.194v.154a1.582 1.582 0 0 0 .024.26c.008.042.02.088.036.136a.925.925 0 0 0 .026.09 1.68 1.68 0 0 1 .048.155 1.2 1.2 0 0 0 .07.19c.018.041.038.086.062.134l-.056.027-.097.046a.83.83 0 0 1-.032.021l-.032.021-.033.025a.312.312 0 0 0-.032.03l-.012.012a.236.236 0 0 1-.094.066.518.518 0 0 0-.058.015.196.196 0 0 1-.06.01.287.287 0 0 1-.111-.022.334.334 0 0 1-.1-.064 3.841 3.841 0 0 0-.056-.12.907.907 0 0 1-.045-.11 1.002 1.002 0 0 1-.04-.111 3.249 3.249 0 0 1-.053-.19 2.146 2.146 0 0 1-.03-.121.94.94 0 0 1-.017-.11 1.313 1.313 0 0 1-.018-.12 8.77 8.77 0 0 1-.011-.134.413.413 0 0 0-.095-.024.684.684 0 0 0-.565.175.621.621 0 0 0-.23.46l.022.01zM7.57 17.502l.03.018.076-2.486v-.006l.003-.057c.001-.03.005-.064.009-.1a.413.413 0 0 1 .038-.118c.017-.034.044-.05.08-.05.015 0 .029.002.04.005l.036.012.006.006.03.016a.074.074 0 0 0 .035.009h.03a.259.259 0 0 0 .07-.012h.024a.052.052 0 0 1 .024-.006h.023a.12.12 0 0 1 .053.012c.028.011.055.03.083.054a.63.63 0 0 1 .07.072c.032.036.067.083.107.14l-.032.102c-.01.032-.02.065-.027.097l-.023.112a1.105 1.105 0 0 0-.018.13.795.795 0 0 0-.011.163c-.008.1-.012.196-.012.284v.212a.314.314 0 0 1 .07-.08.697.697 0 0 0 .136-.253l.023-.061a1.23 1.23 0 0 0 .024-.066l.044-.145a1.07 1.07 0 0 0 .032-.134 1.003 1.003 0 0 0 .042-.296 3.294 3.294 0 0 1 .192-.124.72.72 0 0 0 .044-.021.757.757 0 0 1 .088-.04.223.223 0 0 1 .077-.014c.016 0 .033.002.053.008.02.007.037.013.053.022.04.016.076.037.11.063.033.027.063.054.09.082.016.016.03.033.042.048.011.017.02.033.023.049l-.017.103c-.012.064-.026.14-.041.23a.297.297 0 0 1-.006.054l-.012.06-.023.182a1.06 1.06 0 0 0-.012.152c0 .036.002.065.008.087.006.022.015.036.027.04.02.008.039-.004.058-.034a.925.925 0 0 0 .115-.269c.017-.052.034-.107.05-.163l.035-.118c.012-.038.021-.075.03-.112l.023-.097.024-.102.011-.046a48.655 48.655 0 0 0 .085-.4c.022-.106.035-.163.039-.172.075-.02.138-.034.188-.042a.238.238 0 0 1 .042-.009 1.535 1.535 0 0 1 .271-.033h.03c.007 0 .013.002.017.006a.344.344 0 0 1 .026.015c.01.006.019.014.026.022.028.02.055.047.08.081s.05.07.073.106c.036.06.077.139.124.235a2.098 2.098 0 0 0-.218.556 2.062 2.062 0 0 0-.062.363l-.009.079c-.008.04-.013.081-.017.124a18.21 18.21 0 0 0-.02.25c-.003.04-.003.079-.003.115 0 .117.013.216.04.299.028.083.083.126.166.13a.258.258 0 0 0 .076-.012.292.292 0 0 0 .139-.079c.041-.04.08-.084.115-.133.031-.048.058-.094.08-.136a.38.38 0 0 1 .067-.106c.02-.011.036-.015.05-.011.013.003.022.026.026.066a.919.919 0 0 1 .007.097v.203a.592.592 0 0 1-.007.081.086.086 0 0 1-.02.051.573.573 0 0 1-.045.052l-.02.021-.021.022a1.153 1.153 0 0 1-.218.253 1.47 1.47 0 0 1-.245.178.575.575 0 0 1-.297.082h-.024a.442.442 0 0 1-.38-.209.767.767 0 0 1-.126-.45v-.072-.073-.033-.027-.151-.134a2.07 2.07 0 0 1-.006-.163 1.162 1.162 0 0 0-.194.35c-.02.05-.039.105-.057.168a2.826 2.826 0 0 0-.073.332 9.963 9.963 0 0 0-.07.632.639.639 0 0 0-.054.036.227.227 0 0 0-.047.018.117.117 0 0 1-.053.012.227.227 0 0 1-.03-.003.896.896 0 0 1-.165-.1 1.234 1.234 0 0 1-.312-.248l-.003-.046a1.277 1.277 0 0 1-.003-.1 1.306 1.306 0 0 1-.011-.175v-.045-.04-.018-.018-.015-.015c0-.037.002-.074.006-.112a22.034 22.034 0 0 0 .023-.217 4.07 4.07 0 0 1 .012-.1c.011-.072.027-.159.047-.26l-.103.103c-.065.065-.136.212-.215.442l-.036.109a3.154 3.154 0 0 0-.053.184.414.414 0 0 0-.02.091.256.256 0 0 1-.009.021l-.053.224a1.14 1.14 0 0 1-.03.115c0 .004.003.01.006.018a.254.254 0 0 1 .012.03.133.133 0 0 1 .011.055.05.05 0 0 1 .006.018v.012a.064.064 0 0 1 .003.033.03.03 0 0 1-.015.022.23.23 0 0 1-.091.076.372.372 0 0 1-.11.027.319.319 0 0 1-.087-.013.642.642 0 0 1-.148-.054 1.968 1.968 0 0 1-.13-.073.52.52 0 0 1-.1-.081c-.023-.027-.035-.044-.035-.052H7.57z",
    fill: "#284866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.94 15.222a1.767 1.767 0 0 0-.03.176l-.053.362a5.979 5.979 0 0 0-.021.143c-.006.046-.013.09-.021.13l-.015.136a3.86 3.86 0 0 0-.02.227v.072c0 .105.01.197.035.275.024.079.07.12.141.124h.012a.12.12 0 0 0 .068-.022.737.737 0 0 0 .215-.227c.04-.052.073-.101.1-.148.028-.046.047-.077.06-.093l.01-.012.012-.012a.19.19 0 0 1 .065-.04c.02-.006.03.008.03.04v.012a.336.336 0 0 1-.003.039.263.263 0 0 0-.003.04v.184c0 .038-.002.08-.006.123a.083.083 0 0 1-.009.037l-.02.042a.087.087 0 0 0-.012.015c-.004.007-.008.013-.011.022a.522.522 0 0 1-.027.036.214.214 0 0 0-.021.03.675.675 0 0 0-.065.097c-.031.052-.074.109-.13.169a.991.991 0 0 1-.22.187.574.574 0 0 1-.315.085h-.047a.19.19 0 0 1-.064-.012.503.503 0 0 1-.212-.105 1.306 1.306 0 0 1-.177-.173.693.693 0 0 1-.08-.112.299.299 0 0 1-.038-.1 2.03 2.03 0 0 1-.032-.254 5.173 5.173 0 0 1 .012-.72 8.943 8.943 0 0 1 .08-.64c0-.011 0-.024.002-.036a.204.204 0 0 0 .003-.036 2.59 2.59 0 0 0 .02-.108l.021-.121a.329.329 0 0 1-.024-.037.074.074 0 0 1-.01-.018c-.005-.008-.01-.016-.013-.024a.15.15 0 0 1-.024-.079c0-.012.003-.024.007-.036a.452.452 0 0 1 .041-.048.56.56 0 0 1 .1-.037l.13-.036a1.316 1.316 0 0 1 .235-.036h.021c.006 0 .009.002.009.006.004-.004.028.004.073.024a1.18 1.18 0 0 1 .228.136.42.42 0 0 1 .123.124c.012.02.016.04.012.06a.396.396 0 0 1-.047.106.226.226 0 0 1-.082.076l-.014-.013zm-.684-1.378c0-.13.044-.24.13-.333a.412.412 0 0 1 .312-.138c.121 0 .224.045.31.136.084.09.128.198.132.323v.012a.486.486 0 0 1-.097.299.404.404 0 0 1-.291.166h-.042a.445.445 0 0 1-.321-.136.437.437 0 0 1-.139-.324l.006-.005z",
    fill: "#284866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.682 13.027l.056-.03a.85.85 0 0 1 .109-.048l.1-.04a.415.415 0 0 1 .112-.027.233.233 0 0 1 .064-.015.686.686 0 0 1 .065-.003c.29-.004.499.117.624.363.126.246.187.55.183.913 0 .327-.052.637-.156.931a4.515 4.515 0 0 1-.339.756c-.086.149-.17.272-.25.368-.08.097-.143.16-.186.188a.068.068 0 0 0-.006.03v.042c0 .032.002.072.006.118a.618.618 0 0 0 .03.142c.02.09.053.17.1.246.047.074.108.112.182.112H13.418a.533.533 0 0 0 .289-.146 1.646 1.646 0 0 0 .347-.414l.07-.124a.219.219 0 0 1 .045-.036.077.077 0 0 1 .038-.012c.012-.004.021-.003.027.003.006.006.008.015.008.027v.233c0 .034-.002.073-.006.118a.182.182 0 0 1-.017.078.364.364 0 0 1-.07.103.216.216 0 0 1-.03.036 2.155 2.155 0 0 1-.253.374 1.705 1.705 0 0 1-.283.264.538.538 0 0 1-.324.118H13.222c-.232-.02-.404-.085-.515-.196a.919.919 0 0 1-.233-.36.945.945 0 0 1-.06-.281 5.377 5.377 0 0 1-.005-.215v-.012-.012l-.036-1.3a.306.306 0 0 0 .006-.057v-.052c0-.104.003-.2.009-.287.006-.086.012-.17.02-.25.012-.125.03-.259.056-.4a44.91 44.91 0 0 0 .145-.84l.053-.267c.016-.076.023-.12.023-.133l-.003-.006zm.395 2.643c0-.004.022-.033.068-.088.045-.054.093-.144.144-.27.055-.124.105-.293.15-.504.045-.211.068-.475.068-.789v-.06c0-.02.002-.041.006-.061v-.061-.06a.725.725 0 0 0-.024-.19.261.261 0 0 0-.111-.149c-.056-.04-.102.037-.139.233-.037.196-.07.415-.097.656l-.024.266c-.007.089-.015.172-.023.248a5.43 5.43 0 0 1-.015.224 2.36 2.36 0 0 0-.009.206v.054a5.481 5.481 0 0 0 .012.345h-.006z",
    fill: "#284866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.026 15.222a1.747 1.747 0 0 0-.03.176 105.13 105.13 0 0 1-.095.634c-.003.04-.008.086-.014.137a3.67 3.67 0 0 0-.021.227v.072a.96.96 0 0 0 .035.275c.023.079.07.12.141.124h.012a.12.12 0 0 0 .068-.022.738.738 0 0 0 .215-.227c.04-.052.073-.101.1-.148.028-.046.048-.077.06-.093l.011-.012.012-.012a.19.19 0 0 1 .064-.04c.02-.006.03.008.03.04v.012a.336.336 0 0 1-.003.039.25.25 0 0 0-.003.04v.184c0 .038-.002.08-.006.123a.083.083 0 0 1-.008.037l-.021.042a.512.512 0 0 1-.05.072.178.178 0 0 0-.02.031.633.633 0 0 0-.065.097c-.031.052-.074.109-.13.169a.991.991 0 0 1-.22.187.573.573 0 0 1-.315.085h-.047a.187.187 0 0 1-.065-.012.503.503 0 0 1-.211-.105 1.306 1.306 0 0 1-.177-.173.693.693 0 0 1-.08-.112.299.299 0 0 1-.038-.1 2.049 2.049 0 0 1-.032-.254 5.173 5.173 0 0 1 .012-.72 8.943 8.943 0 0 1 .079-.64c0-.011 0-.024.002-.036a.204.204 0 0 0 .003-.036c.008-.036.015-.072.02-.108l.022-.121a.062.062 0 0 1-.012-.016l-.012-.021a.06.06 0 0 1-.011-.018l-.013-.024a.154.154 0 0 1-.024-.079c0-.012.003-.024.007-.036a.059.059 0 0 1 .024-.03l.008-.01.009-.009a.562.562 0 0 1 .1-.036l.13-.036a1.321 1.321 0 0 1 .236-.036h.02c.006 0 .01.002.01.006.003-.004.028.004.073.024a1.133 1.133 0 0 1 .227.136.422.422 0 0 1 .124.124c.012.02.015.04.012.06a.396.396 0 0 1-.047.106.227.227 0 0 1-.083.076l-.013-.013zm-.683-1.378a.47.47 0 0 1 .13-.333.412.412 0 0 1 .312-.138c.121 0 .224.045.31.136.083.09.128.198.132.323v.012a.486.486 0 0 1-.097.299.404.404 0 0 1-.292.166h-.041a.445.445 0 0 1-.321-.136.439.439 0 0 1-.139-.324l.006-.005z",
    fill: "#284866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.479 17.308l.006.006.07-2.297c0-.004 0-.007-.002-.007s-.003-.002-.003-.006v-.012-.012a.248.248 0 0 1 .024-.09.328.328 0 0 1 .118-.151.014.014 0 0 0 .008-.003c.003-.002.005-.003.009-.003.02-.008.036-.01.05-.006a.086.086 0 0 1 .038.024c.004 0 .007.001.009.003.002.002.005.003.009.003a.173.173 0 0 0 .03.024.073.073 0 0 0 .04.012h.006c.02 0 .04-.004.06-.012a.216.216 0 0 0 .053-.03.075.075 0 0 1 .026-.018.19.19 0 0 0 .026-.013.154.154 0 0 1 .047-.015c.016-.002.032.003.047.015a.29.29 0 0 1 .048.046 2.776 2.776 0 0 1 .079.097 1.367 1.367 0 0 1 .08.118c.02.032.029.052.029.06-.027.066-.05.12-.07.164l-.027.079a.467.467 0 0 0-.02.084.102.102 0 0 0-.012.049 3.183 3.183 0 0 0-.036.242c-.023.185-.04.357-.047.513l-.012.248c.157-.225.32-.613.49-1.16a1.12 1.12 0 0 0 .052-.26.803.803 0 0 0 .006-.097c0-.032.002-.069.006-.11v-.023-.024a1.737 1.737 0 0 1 .236-.179.568.568 0 0 1 .082-.045l.071-.022a.253.253 0 0 1 .065-.009h.026c.01 0 .016.003.02.007.04.007.07.024.092.048.022.024.04.055.056.09.02 0 .037.002.053.003a.155.155 0 0 1 .047.015.081.081 0 0 0 .015.012.083.083 0 0 1 .015.012.155.155 0 0 1 .062.066c.014.029.02.06.02.097a6.471 6.471 0 0 0-.17.598 5.554 5.554 0 0 1-.038.16 8.877 8.877 0 0 0-.038.16 8.046 8.046 0 0 0-.062.33 2.51 2.51 0 0 0-.033.288v.018l.003.06.003.06a.752.752 0 0 0 .068.23c.033.069.08.103.139.103h.029a.258.258 0 0 0 .1-.045.906.906 0 0 0 .117-.094 1.05 1.05 0 0 0 .1-.09 2.597 2.597 0 0 0 .195-.225.091.091 0 0 1 .014-.011c.006-.004.011-.006.015-.006a.02.02 0 0 1 .015-.007h.015c.02 0 .034.005.044.015.01.01.015.03.015.058v.139a.057.057 0 0 0-.006.024v.087a.24.24 0 0 0 .006.051v.012a.118.118 0 0 1-.024.085.631.631 0 0 1-.079.09.067.067 0 0 0-.015.013c-.012.012-.04.045-.082.1a1.526 1.526 0 0 1-.412.36.608.608 0 0 1-.295.09c-.185.004-.325-.053-.421-.17a.627.627 0 0 1-.145-.41v-.635c-.004.004-.034.05-.091.139a2.672 2.672 0 0 0-.203.43 2.374 2.374 0 0 0-.106.302c-.02.076-.032.149-.036.217 0 .02.002.038.006.055l.012.048.012.036a.117.117 0 0 1 .006.037.104.104 0 0 1-.006.03.074.074 0 0 1-.018.03.354.354 0 0 1-.068.064.372.372 0 0 1-.091.051.287.287 0 0 1-.044.018.161.161 0 0 1-.045.006h-.02a.528.528 0 0 1-.215-.097.539.539 0 0 1-.169-.136.304.304 0 0 1-.073-.202h-.006",
    fill: "#284866"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.403 14.793a.313.313 0 0 0 .038-.003.238.238 0 0 1 .039-.003c.016 0 .03-.001.04-.003a2.408 2.408 0 0 0 .121-.015.423.423 0 0 1 .057-.005l.389.223a.112.112 0 0 1-.018.033.609.609 0 0 0-.036.064l-.023.051a.274.274 0 0 0-.018.058.235.235 0 0 0-.011.066l-.003.06a.624.624 0 0 0-.003.067.132.132 0 0 0-.006.04v.045a5.302 5.302 0 0 1-.017.181l.017 1.675V17.412c0 .069 0 .144-.002.227a1.35 1.35 0 0 1-.033.257l-.012.039a1.11 1.11 0 0 0-.011.046.349.349 0 0 1-.036.102 1.26 1.26 0 0 1-.082.215.495.495 0 0 1-.154.172l-.389.297a.515.515 0 0 0-.047.027.417.417 0 0 1-.23.063h-.052a.288.288 0 0 1-.06-.006.542.542 0 0 1-.338-.163.652.652 0 0 1-.144-.272l-.012-.097a.784.784 0 0 1 0-.2l.012-.084a.292.292 0 0 1 .011-.046.078.078 0 0 0 .006-.021l.206-.073c.051.1.098.182.142.242.047.06.103.117.168.169a.32.32 0 0 0 .203.079h.02a.05.05 0 0 0 .022-.006.078.078 0 0 0 .02-.003.06.06 0 0 1 .021-.003c.043-.012.072-.03.086-.055a.169.169 0 0 0 .02-.085.517.517 0 0 0-.008-.087 1.417 1.417 0 0 1-.015-.112 7.115 7.115 0 0 1-.024-.175 1.288 1.288 0 0 1-.006-.121v-.109-.054-.055c0-.044-.002-.09-.006-.136a3.047 3.047 0 0 0-.017-.154.279.279 0 0 1-.05.055 1.844 1.844 0 0 1-.309.218c-.032.012-.06.022-.088.03a.262.262 0 0 1-.077.012h-.017c-.216-.016-.378-.086-.486-.211a.678.678 0 0 1-.168-.441v-.046-.046c0-.068.002-.137.006-.205l.012-.206c.016-.161.04-.32.07-.478.032-.157.065-.3.1-.43.044-.165.085-.3.124-.404.04-.105.063-.162.071-.17.004-.007.024-.021.059-.042.035-.02.076-.04.123-.06l.036-.012a.15.15 0 0 0 .035-.018l.147-.055a.368.368 0 0 1 .095-.024h.006c.027 0 .054.008.082.024.028.017.051.035.071.055l.041.042c.012.012.02.022.024.03a.147.147 0 0 0 .032-.009l.062-.021.05-.012.05-.012a.238.238 0 0 0 .035-.003.194.194 0 0 1 .035-.003l.004.005zm-.083.592c-.003.004-.01-.002-.017-.021a.405.405 0 0 0-.07-.12c-.017-.019-.034-.028-.054-.028-.043 0-.1.077-.168.23-.069.153-.148.473-.238.961l-.015.115a1.02 1.02 0 0 0-.008.139V16.698c.003.084.02.162.047.232.027.071.078.114.153.13h.012c.047.004.083-.043.109-.142.025-.099.046-.206.061-.323a1.37 1.37 0 0 1 .015-.103 1.394 1.394 0 0 0 .02-.145l.153-.962z",
    fill: "#284866"
  })));
};

IcoSmilingHouseCircle.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoPlumGuideCircle = function IcoPlumGuideCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "25",
    height: "25"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.16 16.495a1.17 1.17 0 0 0 .197-.476c.04-.191.06-.483.06-.863v-1.317c0-.295.027-.509.079-.637a.391.391 0 0 1 .265-.238l.016-.005v-.153h-.998v.153l.02.003c.128.02.22.094.28.228.062.138.094.347.094.62v1.34c0 .433-.026.742-.078.919a.813.813 0 0 1-.263.416.97.97 0 0 1-.333.17 1.635 1.635 0 0 1-.453.056c-.374 0-.642-.094-.796-.28-.155-.188-.234-.518-.234-.98v-2.01c0-.178.02-.303.058-.375.037-.068.095-.102.179-.106h.022v-.153H8.126v.152l.022.001a.195.195 0 0 1 .179.11c.038.072.058.197.058.37v1.898c0 .341.02.595.058.755.04.16.105.3.194.414.128.159.302.282.514.366.212.084.459.127.733.127.297 0 .553-.042.761-.124.21-.083.382-.21.515-.38v-.001zM7.779 16.367a.194.194 0 0 1-.159-.087.406.406 0 0 1-.059-.234v-1.218c0-.09.02-.148.06-.204a.173.173 0 0 1 .148-.08h.023v-.154h-2.14v.153s.093.008.174.011c.268.01.824.019.983.094.1.048.154.15.154.266v1.235c0 .192-.086.349-.256.466-.172.119-.404.179-.69.179-.438 0-.776-.166-1.002-.49-.228-.329-.344-.817-.344-1.45 0-.634.112-1.101.332-1.426.218-.321.538-.485.951-.485.276 0 .53.084.756.249.226.165.408.4.54.7l.005.013.13.007.167-.714-.014-.009a3.354 3.354 0 0 0-.722-.353 2.174 2.174 0 0 0-1.469.018c-.245.09-.459.221-.636.387-.233.218-.411.474-.531.76a2.39 2.39 0 0 0-.18.93c0 .269.04.527.122.767.081.241.197.45.345.622.196.23.414.403.65.513.236.11.506.166.803.166.281 0 .58-.043.886-.128.306-.084.637-.215.983-.389l.014-.006-.005-.108h-.02v-.001zM12.099 12.959h.022a.195.195 0 0 1 .178.11c.039.073.058.198.058.37v2.844c0 .17-.019.293-.056.365-.036.069-.095.102-.18.107l-.022.001v.153h1.149v-.153h-.022c-.086-.004-.145-.038-.18-.105-.038-.07-.057-.194-.057-.368V13.44c0-.177.02-.303.058-.374.037-.068.095-.103.179-.106l.022-.001v-.153h-1.149v.153zM16.337 13a1.933 1.933 0 0 0-.522-.173 4.05 4.05 0 0 0-.729-.054 19.292 19.292 0 0 0-.454.005l-.925.027v.153l.023.001c.083.003.142.038.178.106.039.071.058.197.058.374v2.843c0 .17-.02.293-.058.366a.19.19 0 0 1-.177.107h-.023v.153h1.522c.677 0 1.215-.178 1.597-.529.382-.35.576-.844.576-1.466 0-.422-.096-.808-.286-1.148a1.843 1.843 0 0 0-.78-.765zm-1.75 3.349v-2.91c0-.177.045-.297.134-.354.092-.06.293-.09.596-.09.474 0 .832.157 1.064.466.233.312.352.793.352 1.43 0 .637-.125 1.129-.37 1.398-.244.27-.673.405-1.276.405-.214 0-.352-.024-.412-.072-.058-.046-.087-.138-.087-.273zM20.73 15.97l-.013.016a2.277 2.277 0 0 1-.35.402 1.02 1.02 0 0 1-.342.2c-.094.029-.204.05-.328.063-.125.013-.338.02-.633.02-.296 0-.409-.032-.447-.059-.035-.025-.078-.1-.078-.312v-1.583h.643c.299 0 .498.027.593.08a.49.49 0 0 1 .212.284l.006.016h.139v-1.012h-.134l-.005.016a.47.47 0 0 1-.25.29c-.123.056-.338.085-.641.085h-.563v-1.132c0-.168.03-.227.055-.247.026-.021.108-.046.351-.046h.173c.476 0 .8.043.96.129.159.084.281.24.363.463l.007.018.158-.023-.07-.832H17.66v.153h.022c.084.004.142.038.178.107.039.071.058.197.058.373v2.844c0 .17-.02.293-.058.366a.19.19 0 0 1-.178.106h-.022v.153h2.974l.247-.857-.153-.081h.001zM7.762 8.316C7.424 8.106 6.95 8 6.35 8a16.479 16.479 0 0 0-.598.022l-.715.039v.152l.022.001c.084.003.142.038.179.106.038.071.058.197.058.374v2.843c0 .17-.02.293-.058.366a.19.19 0 0 1-.178.107h-.023v.153h1.138v-.153h-.023a.191.191 0 0 1-.178-.104c-.038-.07-.058-.195-.058-.368v-1.219a4.536 4.536 0 0 0 .58.043c.564 0 1.006-.102 1.313-.302a.979.979 0 0 0 .467-.865c0-.37-.173-.667-.514-.879zm-.118.868c0 .322-.106.566-.315.725-.211.16-.537.242-.968.242a2.903 2.903 0 0 1-.444-.035V8.593c0-.158.04-.263.122-.312.085-.051.246-.077.479-.077.36 0 .642.086.836.255.192.169.29.413.29.725zM11.512 11.275l-.16-.053-.01.013a3.136 3.136 0 0 1-.263.328.988.988 0 0 1-.224.185c-.107.061-.23.106-.366.132-.136.026-.352.039-.643.039-.24 0-.33-.031-.366-.058-.033-.025-.073-.098-.073-.307v-2.86c0-.176.02-.302.058-.373.037-.068.095-.103.179-.106l.022-.001V8.06H8.517v.153h.022a.195.195 0 0 1 .179.11c.038.073.058.198.058.371v2.843c0 .17-.02.293-.057.365-.035.069-.094.102-.18.107l-.021.001v.153h2.777l.218-.888v-.001zM14.629 11.749c.091-.121.158-.28.198-.475.04-.192.06-.483.06-.864V9.093c0-.295.026-.509.079-.636a.392.392 0 0 1 .264-.24l.017-.004V8.06h-.998v.153l.02.003c.128.02.22.094.28.229.062.137.093.346.093.62v1.34c0 .432-.026.741-.077.918a.813.813 0 0 1-.263.416.972.972 0 0 1-.333.171 1.636 1.636 0 0 1-.453.056c-.374 0-.642-.095-.796-.28-.155-.188-.234-.518-.234-.981v-2.01c0-.177.02-.303.058-.374.036-.068.095-.103.178-.106l.023-.001V8.06h-1.15v.153h.023a.195.195 0 0 1 .178.11c.039.073.058.197.058.371v1.897c0 .342.02.596.059.755.039.16.104.3.194.415.128.158.301.28.514.365.212.085.459.127.733.127.297 0 .553-.041.76-.124.21-.083.383-.21.515-.38v-.001zM18.944 11.59a1.366 1.366 0 0 1 .011.137c0 .082-.02.15-.062.2a.22.22 0 0 1-.164.082l-.021.001v.153h1.138v-.153l-.018-.004c-.068-.015-.128-.067-.177-.16a1.294 1.294 0 0 1-.116-.408l-.393-2.765a1.101 1.101 0 0 1-.016-.188c0-.079.019-.142.057-.189a.23.23 0 0 1 .159-.08l.02-.003v-.152h-.885l-.863 3.187-.922-3.187h-.937v.152l.015.006c.088.035.15.074.187.13.036.056.054.14.054.249 0 .06-.002.122-.006.184v.016l-.363 2.425c-.034.235-.09.42-.169.551a.459.459 0 0 1-.286.232l-.018.004v.153h1.045v-.153l-.02-.003a.336.336 0 0 1-.24-.153.677.677 0 0 1-.084-.363 2.355 2.355 0 0 1 .027-.3l.357-2.458 1.034 3.474h.318l.932-3.467.408 2.85h-.002z"
  })));
};

IcoPlumGuideCircle.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoGoogleVacationRentalsCircle = function IcoGoogleVacationRentalsCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "25",
    height: "25"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.653 11.136v2.905h4.12c-.182.934-.724 1.725-1.538 2.257l2.483 1.889C19.165 16.877 20 14.954 20 12.67c0-.532-.048-1.044-.139-1.534h-7.208z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.364 13.928l-.56.42-1.983 1.513a7.669 7.669 0 0 0 6.832 4.14c2.066 0 3.799-.67 5.065-1.815l-2.484-1.888c-.681.45-1.551.723-2.58.723-1.99 0-3.681-1.316-4.287-3.09l-.003-.003z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.821 9.139a7.288 7.288 0 0 0 0 6.722c0 .007 2.547-1.936 2.547-1.936a4.413 4.413 0 0 1-.244-1.425c0-.498.09-.975.244-1.425L5.82 9.139z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.653 7.986c1.127 0 2.13.382 2.93 1.119l2.191-2.148C16.445 5.743 14.72 5 12.654 5A7.656 7.656 0 0 0 5.82 9.139l2.547 1.936c.605-1.773 2.296-3.089 4.285-3.089z",
    fill: "#EA4335"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5 5)",
    d: "M0 0h15v15H0z"
  }))));
};

IcoGoogleVacationRentalsCircle.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoHomesVillasByMarriottCircle = function IcoHomesVillasByMarriottCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "25",
    height: "25"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.42 19.42V8.904h-.029l1.024-1.598v12.141h-.995v-.029zM7.585 7.306L8.61 8.905h-.03v10.543h-.994V7.308zm4.096-.726h1.667l-.819 1.307-.848-1.307zm.819 2.41l1.521-2.41h1.229l-2.75 4.357L9.75 6.58h1.229L12.5 8.99zm0 4.968L7.82 6.58h1.228l3.452 5.46 3.452-5.46h1.229L12.5 13.959zm2.34-2.586l.995-1.597v9.643h-.995v-8.046zm-4.095 8.046h3.51v-1.394h-3.51v1.394zm0-5.083v-2.033l1.287 2.033h-1.287zm3.51 0h-1.287l1.287-2.033v2.033zm0 1.569h-3.51v-.988h3.51v.988zm-3.51 1.568h3.51v-.988h-3.51v.988zm-.585-6.1v8.046h-.995V9.805l.995 1.568zM7 20h11V6H7v14z",
    fill: "#F69464"
  })));
};

IcoHomesVillasByMarriottCircle.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoStaySenseCircle = function IcoStaySenseCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.321 8c-1.576 0-2.973.801-3.821 2.026l-.004-.005c-.575.872-.851 1.886-.853 2.75v.01c0 1.67-1.33 3.03-2.964 3.03-1.635 0-2.965-1.36-2.965-3.03 0-1.67 1.33-3.03 2.965-3.03 1.064 0 2 .578 2.522 1.442a5.988 5.988 0 0 1 .843-1.727A4.616 4.616 0 0 0 8.679 8C6.099 8 4 10.145 4 12.781c0 2.637 2.099 4.781 4.679 4.781 1.576 0 2.973-.8 3.821-2.025l.005.006a5.17 5.17 0 0 0 .854-2.7l-.002-.062c0-1.67 1.33-3.03 2.964-3.03 1.635 0 2.965 1.36 2.965 3.03 0 1.67-1.33 3.03-2.965 3.03a2.952 2.952 0 0 1-2.52-1.439 5.986 5.986 0 0 1-.844 1.726 4.616 4.616 0 0 0 3.364 1.465c2.58 0 4.679-2.145 4.679-4.782C21 10.145 18.901 8 16.321 8z",
    fill: "#1D4ED8"
  }));
};

IcoStaySenseCircle.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoGlampingHubCircle = function IcoGlampingHubCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.097 18.575c-.026-.466-.048-.93-.067-1.396l-.01-.318a.125.125 0 0 0-.031-.077.13.13 0 0 0-.074-.041 9.552 9.552 0 0 1-1.61-.405c-.08-.025-.157-.056-.237-.086l-.233-.09c-.153-.07-.309-.132-.456-.21a7.232 7.232 0 0 1-.87-.496c-.07-.047-.14-.09-.207-.141l-.202-.147-.198-.153c-.067-.05-.127-.106-.191-.16a7.762 7.762 0 0 1-.708-.697 7.08 7.08 0 0 1-.428-.528.124.124 0 0 0-.103-.05.129.129 0 0 0-.076.026.124.124 0 0 0-.045.065c-.067.247-.099.397-.099.397-.122.48-.2.97-.236 1.465-.042.491-.002.986.118 1.465.123.484.388.923.763 1.261.365.309.804.522 1.276.619.381.087.772.128 1.164.121h.016c.177 0 .348-.009.523-.025.71-.048 1.417-.14 2.115-.274a.128.128 0 0 0 .073-.043.124.124 0 0 0 .03-.08c.002 0 .002 0 .002-.002z",
    fill: "#00665F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2 5a.133.133 0 0 0-.079.026c-.052.037-.1.075-.152.113-.257.203-.504.417-.74.643a16.884 16.884 0 0 0-1.982 2.252l-.01.009c-.1.13-.19.25-.278.372a.108.108 0 0 0-.023.073c0 .03.012.06.032.082l.003.003.003.003.037.035c.146.146.3.284.449.42.305.27.625.527.96.765a11 11 0 0 0 .509.338c.172.107.347.203.525.296.144.072.29.14.437.203v.002a.132.132 0 0 0 .166-.057.122.122 0 0 0 .015-.06v-.003l.02-.848.031-.932.017-.466.023-.466.045-.933.059-.932.03-.466.025-.34v-.009a.114.114 0 0 0-.033-.088.12.12 0 0 0-.09-.035z",
    fill: "#0EB56A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.871 14.516c.01.209.016.418.025.623l.026.519 1.208-1.144H13.87v.002zm6.167-1.98a4.204 4.204 0 0 0-.59-1.423 6.327 6.327 0 0 0-.896-1.072 41.461 41.461 0 0 1-.648-.68 111.223 111.223 0 0 1-3.69-4.193 3.698 3.698 0 0 0-.107-.123.119.119 0 0 0-.094-.045.124.124 0 0 0-.123.117l-.013.243-.02.465-.037.933-.02.933-.01.465-.006.465-.01.933c0 .218 0 .437.004.655l.946-.794a.312.312 0 0 1 .448 0l2.196 1.837a.313.313 0 0 1 .114.243v2.708a.316.316 0 0 1-.091.221.31.31 0 0 1-.221.091h-.955l-2.24 2.116.021.367c.026.399.054.8.083 1.198v.01a.13.13 0 0 0 .122.117.133.133 0 0 0 .035-.007c.591-.165 1.167-.38 1.723-.643l.009-.003a9.666 9.666 0 0 0 2.543-1.59c.54-.46.98-1.027 1.29-1.666a2.948 2.948 0 0 0 .237-1.878z",
    fill: "#01918D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.46 8.901a.13.13 0 0 1 .164-.051.123.123 0 0 1 .042.031 12.716 12.716 0 0 0 1.304 1.272 9.126 9.126 0 0 0 1.09.79c.143.089.29.171.44.246l-.02.017-.006.006-.007.007a.321.321 0 0 0-.107.242v2.804a.323.323 0 0 0 .322.325h.392c.003.226.007.449.013.675l.01.442a.132.132 0 0 1-.13.132c-.008 0-.014 0-.02-.004a8.469 8.469 0 0 1-1.308-.303c-.075-.023-.147-.049-.222-.075a14.903 14.903 0 0 1-.218-.079c-.144-.059-.29-.114-.428-.183a7.172 7.172 0 0 1-.821-.443c-.065-.043-.134-.082-.196-.128l-.19-.128-.186-.141c-.063-.046-.121-.099-.183-.144A7.049 7.049 0 0 1 7.7 12.509a.135.135 0 0 1-.016-.115c0-.003 0-.003.003-.006.213-.602.475-1.186.783-1.744 0-.003.004-.003.004-.007a25.74 25.74 0 0 1 .877-1.563l.11-.173z",
    fill: "#6BBE45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.56 12h-.674a.37.37 0 0 0-.24.088.3.3 0 0 0-.072.097.272.272 0 0 0-.026.116v1.505h1.355v-1.505a.29.29 0 0 0-.102-.213.366.366 0 0 0-.24-.088z",
    fill: "#01918D"
  }));
};

IcoGlampingHubCircle.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoHomeToGoCircle = function IcoHomeToGoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.613 16.225c0-.245.198-.443.443-.443h1.948a.443.443 0 1 1 0 .885h-1.948a.443.443 0 0 1-.443-.442z",
    fill: "#612ACE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.613 16.225c0-.245.198-.443.443-.443h1.948a.443.443 0 1 1 0 .885h-1.948a.443.443 0 0 1-.443-.442z",
    fill: "url(#a)",
    fillOpacity: ".9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.613 16.225c0-.245.198-.443.443-.443h1.948a.443.443 0 1 1 0 .885h-1.948a.443.443 0 0 1-.443-.442z",
    fill: "url(#b)",
    fillOpacity: ".56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.06 12.656a.059.059 0 0 1-.06-.06V8.265c0-.027.018-.05.044-.057l.77-.205a.059.059 0 0 1 .074.057v1.824c.217-.262.505-.392.864-.392.331 0 .614.112.846.338.23.226.344.507.344.843v1.925a.059.059 0 0 1-.06.059H6.12a.059.059 0 0 1-.06-.06V10.91c0-.17-.056-.31-.17-.422a.551.551 0 0 0-.415-.172.57.57 0 0 0-.42.172.572.572 0 0 0-.166.422v1.687a.059.059 0 0 1-.06.059H4.06zM7.726 12.27a1.576 1.576 0 0 1-.467-1.158c0-.46.156-.844.467-1.152.312-.313.705-.47 1.178-.47.47 0 .86.157 1.172.47.316.308.474.692.474 1.152 0 .455-.158.841-.474 1.158a1.61 1.61 0 0 1-1.172.463c-.473 0-.866-.154-1.178-.463zm1.178-.416a.67.67 0 0 0 .51-.214.732.732 0 0 0 .212-.528.712.712 0 0 0-.213-.523.66.66 0 0 0-.509-.22.688.688 0 0 0-.515.214.743.743 0 0 0-.207.529c0 .206.07.382.207.528.138.143.31.214.515.214zM11.75 12.597a.059.059 0 0 1-.058.059h-.77a.059.059 0 0 1-.06-.06v-2.97c0-.032.027-.058.06-.058h.77c.032 0 .059.026.059.059v.22c.205-.238.471-.357.799-.357.402 0 .714.159.935.476.201-.317.509-.476.923-.476.332 0 .614.111.847.333.228.218.343.489.343.814v1.96a.059.059 0 0 1-.06.059h-.769a.059.059 0 0 1-.059-.06v-1.722a.565.565 0 0 0-.148-.398.48.48 0 0 0-.367-.16.498.498 0 0 0-.373.16.565.565 0 0 0-.148.398v1.723a.059.059 0 0 1-.059.059h-.77a.059.059 0 0 1-.059-.06v-1.722a.564.564 0 0 0-.148-.398.479.479 0 0 0-.367-.16.498.498 0 0 0-.372.16.564.564 0 0 0-.148.398v1.723zM19.139 11.432h-2.29a.758.758 0 0 0 .277.392.776.776 0 0 0 .474.149.76.76 0 0 0 .585-.245.061.061 0 0 1 .06-.018l.744.2c.036.01.054.052.034.084a1.489 1.489 0 0 1-.559.52c-.256.146-.546.219-.87.219-.481 0-.882-.154-1.202-.463a1.544 1.544 0 0 1-.479-1.158c0-.46.156-.844.468-1.152.311-.313.7-.47 1.166-.47.461 0 .848.157 1.16.47.311.308.467.692.467 1.152 0 .11-.011.217-.035.32zm-2.285-.659h1.415a.774.774 0 0 0-.278-.38.734.734 0 0 0-1.137.38zM6.066 12.997c0-.033.027-.06.06-.06h.767c.033 0 .06.027.06.06v.538h.637c.032 0 .059.026.059.059v.65a.059.059 0 0 1-.06.06h-.637v1.152c0 .094.032.173.095.236a.34.34 0 0 0 .242.089h.3c.033 0 .06.026.06.059v.709a.059.059 0 0 1-.06.059h-.448c-.303 0-.559-.093-.768-.278a.919.919 0 0 1-.307-.703v-2.63zM8.308 16.224a1.567 1.567 0 0 1-.466-1.153c0-.457.155-.839.466-1.146.311-.311.703-.467 1.175-.467.469 0 .858.156 1.17.467.314.307.472.69.472 1.146 0 .454-.158.838-.473 1.153a1.608 1.608 0 0 1-1.169.46c-.472 0-.864-.153-1.175-.46zm1.175-.414c.205 0 .374-.07.508-.213a.728.728 0 0 0 .213-.526.708.708 0 0 0-.213-.52.66.66 0 0 0-.508-.218.687.687 0 0 0-.513.212.739.739 0 0 0-.207.526c0 .205.069.38.207.526a.687.687 0 0 0 .513.213zM12.402 15.073c0-.462.138-.844.414-1.146a1.345 1.345 0 0 1 1.042-.458c.316 0 .6.094.853.282v-.147c0-.032.026-.059.059-.059h.764c.033 0 .059.027.059.06v2.932c0 .419-.15.766-.45 1.04-.296.282-.665.423-1.107.423-.355 0-.673-.09-.953-.27-.264-.171-.444-.379-.541-.623a.057.057 0 0 1 .039-.075l.762-.206a.064.064 0 0 1 .07.03c.05.082.129.165.226.215.115.063.241.094.38.094a.72.72 0 0 0 .49-.176.562.562 0 0 0 .202-.44v-.16a1.342 1.342 0 0 1-.853.289c-.418 0-.765-.153-1.042-.459-.276-.31-.414-.691-.414-1.146zm1.61-.734a.652.652 0 0 0-.491.211.75.75 0 0 0-.196.53c0 .203.066.375.196.516a.653.653 0 0 0 .491.212c.19 0 .351-.07.486-.212a.71.71 0 0 0 .201-.517.737.737 0 0 0-.201-.529.646.646 0 0 0-.486-.211zM16.38 16.22a1.551 1.551 0 0 1-.468-1.147c0-.454.156-.834.468-1.14.312-.31.704-.464 1.178-.464.47 0 .86.155 1.172.464.316.306.474.686.474 1.14 0 .45-.158.833-.474 1.146a1.62 1.62 0 0 1-1.172.459c-.474 0-.866-.153-1.178-.459zm1.178-.412c.205 0 .375-.07.51-.212a.72.72 0 0 0 .212-.523.701.701 0 0 0-.213-.517.664.664 0 0 0-.509-.217.692.692 0 0 0-.515.211.731.731 0 0 0-.207.523c0 .204.069.378.207.523.138.141.31.212.515.212z",
    fill: "#262626"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(-.02592 -1.07938 2.21351 -.05315 21.468 16.865)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: ".986",
    stopColor: "#FFD458",
    stopOpacity: "0"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: "0",
    cy: "0",
    r: "1",
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "rotate(-93.242 18.931 -1.902) scale(.72815 1.77273)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB4AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "1",
    stopColor: "#FFB4AE",
    stopOpacity: "0"
  }))));
};

IcoHomeToGoCircle.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoInvenioHomesCircle = function IcoInvenioHomesCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 12.798v-.076c.102 0 .18-.014.236-.047a.276.276 0 0 0 .116-.138.628.628 0 0 0 .041-.194c.005-.071.005-.147.005-.223v-.11c0-.094 0-.208.004-.345 0-.147.005-.294.005-.446v-.332c0-.26-.014-.441-.037-.536a.415.415 0 0 0-.083-.152.269.269 0 0 0-.125-.066.565.565 0 0 0-.162-.02v-.07h1.203v.07a.473.473 0 0 0-.236.053.293.293 0 0 0-.125.161.995.995 0 0 0-.037.29v1.603c0 .118.014.213.037.284a.26.26 0 0 0 .125.161c.06.034.139.053.236.053v.08H2zM4.026 12.812v-.075h.018c.209 0 .338-.242.384-.721.014-.138.019-.309.023-.503l.005-.104c.01.08.014.175.023.289.005.109.014.227.023.346.01.119.033.232.06.332.028.104.074.19.13.251.055.067.134.1.236.105v.076h-.902v.004zm2.4.029l-1.193-1.77a5.545 5.545 0 0 0-.532-.72c-.148-.161-.277-.237-.393-.237h-.023v-.076h.795l1.388 2.072v.73h-.041zm.056-1.684c.005-.109.014-.227.023-.346.01-.119.033-.228.06-.332a.608.608 0 0 1 .13-.251.306.306 0 0 1 .231-.105v-.08H6.03v.076h.018c.213 0 .338.242.384.72.014.138.023.304.023.498l.005.1c.01-.076.018-.17.023-.28zM8.282 10.522a.712.712 0 0 0-.2-.304.38.38 0 0 0-.244-.1h-.084v-.075H9.05v.07h-.12a.279.279 0 0 0-.176.053c-.056.047-.084.1-.084.152 0 .061.014.137.047.223l.666 1.797-.195.465-.06.005-.846-2.286zm1.568.607l.139-.37a.992.992 0 0 0 .064-.27c0-.11-.028-.2-.088-.266a.35.35 0 0 0-.245-.11v-.07h.925v.07a.57.57 0 0 0-.236.091.748.748 0 0 0-.19.209 6.566 6.566 0 0 0-.476.991c.028-.062.06-.152.107-.275zM11.473 12.808v-.072h.046a.332.332 0 0 0 .218-.066.348.348 0 0 0 .106-.185c.019-.076.028-.161.028-.251v-1.627c0-.095-.01-.175-.028-.251a.333.333 0 0 0-.106-.18c-.051-.048-.12-.067-.218-.067h-.046v-.076h.8v2.78h-.8v-.005zm1.864-.67a1.26 1.26 0 0 0-.092-.421.447.447 0 0 0-.218-.218.99.99 0 0 0-.37-.072c.222-.004.393-.056.505-.16.11-.105.17-.29.175-.55h.037v1.422h-.037zm.398-1.237a1.165 1.165 0 0 0-.19-.503.755.755 0 0 0-.337-.256 2.036 2.036 0 0 0-.458-.114h1.031v.873h-.046zm.046 1.034h-.046a1.166 1.166 0 0 1-.19.503.756.756 0 0 1-.337.256c-.134.052-.287.09-.458.114h1.031v-.873zM14.604 12.812v-.075h.019c.208 0 .338-.242.384-.721.014-.138.018-.309.023-.503l.005-.104c.009.08.014.175.023.289.004.109.014.227.023.346.01.119.032.232.06.332.028.104.074.19.13.251.055.067.134.1.236.105v.076h-.902v.004zm2.401.029l-1.193-1.764a5.56 5.56 0 0 0-.532-.721c-.148-.162-.278-.237-.393-.237h-.024v-.081h.796l1.388 2.072v.73h-.042zm.056-1.684c.004-.109.014-.227.023-.346.009-.119.032-.228.06-.332a.609.609 0 0 1 .13-.251.306.306 0 0 1 .23-.105v-.08h-.897v.076h.019c.213 0 .337.242.384.72.014.138.023.304.023.498l.005.1c.009-.076.018-.17.023-.28zM18.333 12.798v-.076c.102 0 .18-.014.236-.047a.276.276 0 0 0 .116-.138.626.626 0 0 0 .041-.194c.005-.071.005-.147.005-.223v-.11c0-.094 0-.208.004-.345 0-.147.005-.294.005-.446v-.332c0-.26-.014-.441-.037-.536a.335.335 0 0 0-.079-.147.268.268 0 0 0-.124-.066.8.8 0 0 0-.162-.02v-.075h1.202v.07a.473.473 0 0 0-.236.053.293.293 0 0 0-.124.161.996.996 0 0 0-.038.29v1.603c0 .118.014.213.038.284a.26.26 0 0 0 .124.161c.06.034.14.053.236.053v.08h-1.207zM21.538 12.817c-.259 0-.472-.066-.643-.194a1.23 1.23 0 0 1-.398-.522 1.788 1.788 0 0 1 0-1.356c.088-.219.222-.39.394-.517a1.06 1.06 0 0 1 .643-.195h.023a.682.682 0 0 0-.384.204.915.915 0 0 0-.236.375 2.608 2.608 0 0 0-.125.81c0 .285.042.556.125.816.05.143.13.266.236.375.11.11.236.176.384.204h-.019zm.851-.194a1.23 1.23 0 0 0 .398-.522 1.771 1.771 0 0 0 0-1.356 1.186 1.186 0 0 0-.393-.517 1.06 1.06 0 0 0-.643-.195h-.023a.682.682 0 0 1 .384.204c.11.11.19.232.236.375.083.256.125.526.125.81 0 .285-.042.556-.125.816a1.02 1.02 0 0 1-.236.375.728.728 0 0 1-.384.204h.018c.255 0 .472-.066.643-.194zM9.679 13.685v1.456h-.111v-.688h-.949v.688h-.11v-1.456h.11v.673h.949v-.673h.11zM11.117 13.666c.208 0 .389.071.532.218a.715.715 0 0 1 .217.531.733.733 0 0 1-.217.532.724.724 0 0 1-.532.218.716.716 0 0 1-.532-.218.733.733 0 0 1-.217-.532c0-.208.074-.384.217-.53a.727.727 0 0 1 .532-.219zm.005 1.39a.627.627 0 0 0 .63-.64.627.627 0 0 0-.63-.64.606.606 0 0 0-.449.184.613.613 0 0 0-.185.455c0 .18.06.332.185.456.12.123.268.185.449.185zM13.204 14.363l.54-.678h.112v1.456h-.111v-1.29l-.541.678-.542-.678v1.29h-.11v-1.456h.11l.541.678zM15.373 13.685v.095h-.666v.583h.647v.095h-.647v.593h.68v.095h-.791v-1.461h.777zM16.7 13.76v.124a.648.648 0 0 0-.319-.114.305.305 0 0 0-.213.081.265.265 0 0 0-.037.35.48.48 0 0 0 .213.129c.107.038.185.076.236.104.05.029.093.067.125.119a.39.39 0 0 1 .05.204.403.403 0 0 1-.412.398.656.656 0 0 1-.364-.128v-.133c.139.105.259.157.356.157a.29.29 0 0 0 .213-.085.267.267 0 0 0 .088-.204.266.266 0 0 0-.056-.167.53.53 0 0 0-.217-.137 1.637 1.637 0 0 1-.236-.104.397.397 0 0 1-.12-.114.339.339 0 0 1-.051-.19c0-.109.041-.199.12-.275a.4.4 0 0 1 .287-.114c.12.005.23.038.337.1z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 10)",
    d: "M0 0h21v5.25H0z"
  }))));
};

IcoInvenioHomesCircle.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoAltoVitaCircle = function IcoAltoVitaCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#162958"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.983 12.2V6.429h-.66l-4.314 5.77h.837l1.37-1.847h2.107V12.2h.66zM7.724 9.694l1.599-2.151v2.15H7.724zM19.5 9.162a3.05 3.05 0 0 0-3.046-3.037 3.05 3.05 0 0 0-3.045 3.037 3.05 3.05 0 0 0 3.045 3.038 3.05 3.05 0 0 0 3.045-3.038zm-3.072 2.354a2.38 2.38 0 0 1-2.385-2.379c0-1.316 1.091-2.354 2.386-2.354 1.294 0 2.385 1.063 2.385 2.38 0 1.316-1.066 2.353-2.386 2.353zM13.13 14.174v5.821h.685v-1.873h2.106l1.37 1.823h.838l-4.314-5.797h-.685v.026zm2.284 3.29h-1.599v-2.151l1.599 2.151zM10.592 12.2h3.146v-.684h-2.461V6.43h-.685v5.77z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.592 5.695h1.243v5.163h.66V5.695h1.244v-.683h-3.147v.683zM10.592 13.541h1.243v5.138h.66v-5.138h1.244v-.683h-3.147v.683z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.277 14.174h-.685v5.82h.685v-5.82zM9.323 18.679h.66v-5.77h-.66v4.656l-3.477-4.657H5.01l4.314 5.771z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(5 5)",
    d: "M0 0h14.505v15H0z"
  }))));
};

IcoAltoVitaCircle.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoTravelStaytionCircle = function IcoTravelStaytionCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.672 11.468v-.557h-.256v.556H2.242v.22h.174v1.368h.258V11.69h.282v-.223h-.284zM4.064 11.494l-.146.229c-.054-.035-.108-.069-.159-.069-.202 0-.301.186-.301.523v.878h-.26v-1.591h.26v.16a.846.846 0 0 1 .156-.152.376.376 0 0 1 .208-.052c.082 0 .164.032.242.074zM5.51 11.46v.255a.694.694 0 0 0-.585-.29.737.737 0 0 0-.564.232.81.81 0 0 0-.218.575c0 .241.068.442.203.6.144.171.337.256.579.256.228 0 .465-.092.591-.289l-.001.256h.256V11.46h-.26zm-.544 1.39c-.31 0-.561-.268-.561-.598 0-.33.251-.598.561-.598.31 0 .562.268.562.598 0 .33-.251.598-.562.598zM7.58 11.465l-.794 1.725-.793-1.725h.262l.531 1.185.526-1.185h.267zM9.264 12.306H7.92c0 .15.05.295.144.397.094.102.259.18.415.18a.53.53 0 0 0 .31-.084.652.652 0 0 0 .199-.222l.234.062c-.164.316-.414.45-.747.45-.252 0-.452-.081-.6-.244a.84.84 0 0 1-.213-.593.84.84 0 0 1 .217-.593c.145-.157.342-.235.591-.235.261 0 .462.088.604.264.128.156.191.362.191.618zm-.244-.2a.671.671 0 0 0-.196-.354.515.515 0 0 0-.355-.129.548.548 0 0 0-.348.137.616.616 0 0 0-.198.346H9.02zM9.875 10.273h-.258v2.782h.258v-2.782zM11.454 11.519l-.178.26s-.136-.124-.3-.124c-.189 0-.23.11-.23.174 0 .065.066.122.196.165.13.044.581.11.581.518 0 .408-.358.592-.684.592-.43 0-.649-.284-.649-.284l.199-.273s.188.229.443.229.263-.2.261-.218c0-.018-.011-.127-.194-.186-.183-.06-.574-.125-.574-.498s.345-.524.628-.524c.283 0 .5.169.5.169zM11.983 10.865h.434v.53h.321v.357h-.32v1.303h-.434v-1.303h-.187V11.4h.186M14.221 11.4v.199c-.082-.147-.313-.259-.509-.259a.853.853 0 0 0-.634.25.838.838 0 0 0-.243.608c0 .252.076.465.225.632a.832.832 0 0 0 .652.275c.207 0 .43-.122.513-.272v.222h.43v-1.656h-.434zm.017.819a.49.49 0 0 1-.484.494.49.49 0 0 1-.483-.494.49.49 0 0 1 .483-.496.49.49 0 0 1 .484.495zM14.827 11.394h.49l.547 1.09.516-1.09h.477L15.6 13.938h-.473l.505-1.013-.806-1.53zM17.484 11.468v-.557h-.256v.556H17.054v.22h.174v1.368h.258V11.69h.282v-.223h-.284zM18.36 10.921a.181.181 0 0 1-.185.177.181.181 0 0 1-.186-.177c0-.097.083-.176.186-.176s.186.079.186.176zM18.302 11.468h-.253v1.587h.253v-1.587zM19.562 11.431c-.477 0-.863.373-.863.834 0 .46.386.833.863.833s.864-.373.864-.833c0-.46-.387-.834-.864-.834zm0 1.444a.607.607 0 0 1-.603-.61c0-.338.27-.611.603-.611.334 0 .604.273.604.61 0 .338-.27.611-.604.611zM22.05 13.058h-.254v-.946c0-.147-.021-.264-.058-.328-.06-.103-.158-.136-.295-.136a.366.366 0 0 0-.342.205c-.044.089-.067.223-.067.404v.801h-.271v-1.602h.271v.22a.567.567 0 0 1 .464-.257c.368 0 .552.214.552.642v.997zM22.737 11.377h-.412v.063h.412v-.063z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.563 11.413H22.5v.483h.063v-.483zM22.889 11.377h-.063v.519h.063v-.519zM23.364 11.377H23.3v.519h.063v-.519z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.863 11.377h.07l.159.375.162-.375h.087l-.04.058-.208.46-.23-.518z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(2 10.178)",
    d: "M0 0h21.605v3.854H0z"
  }))));
};

IcoTravelStaytionCircle.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoWhimstayCircle = function IcoWhimstayCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.235 8.479a.904.904 0 0 0-1.236.32l-2.364 4.009c-.37.628-.7 1.284-1.038 1.932a1.054 1.054 0 0 1-.293.394c-.539.383-.84-.621-1.01-.943l-.661-1.242-.918-1.726a.899.899 0 0 0-.459-.413l-.007-.003a.929.929 0 0 0-.074-.026l-.036-.009c-.016-.004-.032-.008-.048-.01a1.395 1.395 0 0 0-.045-.008l-.041-.006a.913.913 0 0 0-.047-.002l-.041-.002-.046.002-.042.002-.046.007c-.013.002-.027.003-.04.006l-.054.013-.03.008a.898.898 0 0 0-.541.441l-.883 1.661c-.342.644-.64 1.351-1.042 1.96-.472.716-.951-.11-1.176-.563-.435-.875-.956-1.705-1.452-2.547l-1.003-1.702H8.07a1.02 1.02 0 0 0 1.018-1.016A1.015 1.015 0 0 0 8.071 8h-3a1.018 1.018 0 0 0-1.019 1.03c.003.18.054.357.147.51.02.06.047.119.08.173l3.606 6.118c.108.196.668 1.116 1.688 1.211.058.005.116.008.174.008 1.058 0 1.777-.843 2.223-1.701.198-.381.403-.758.604-1.136.037-.068.379-.578.343-.645.691 1.3 1.345 3.482 3.17 3.482.058 0 .116-.002.175-.008 1.02-.095 1.58-1.015 1.688-1.21l3.606-6.118a.898.898 0 0 0-.32-1.235z",
    fill: "#F5CE00"
  }));
};

IcoWhimstayCircle.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoHoliduCircle = function IcoHoliduCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.742 6.002a.41.41 0 0 1 .301.095l4.23 3.55c.095.079.149.195.149.318v4.57a.414.414 0 0 1-.076.24 3.109 3.109 0 0 1-.11.14 4.996 4.996 0 0 1-.3.33c-.35.354-.76.682-1.219.976a8.27 8.27 0 0 1-.592.344l-.443.233.5-.01a10.229 10.229 0 0 0 3.801-.821l.094-.042-.027-.099a1.721 1.721 0 0 1 1.654-2.187 1.721 1.721 0 0 1 0 3.443c-.406 0-.8-.145-1.11-.407l-.057-.05-.07.033a8.875 8.875 0 0 1-1.068.416c-1.19.387-2.418.57-3.65.543a10.952 10.952 0 0 1-1.955-.212l-.024-.005-.023.005c-.62.126-1.277.198-1.954.212a11.018 11.018 0 0 1-4.635-.92 6.965 6.965 0 0 1-.086-.04l-.068-.032-.058.05a1.716 1.716 0 0 1-2.827-1.314c0-.95.77-1.721 1.717-1.721a1.721 1.721 0 0 1 1.654 2.186l-.027.099.094.041c.26.115.543.222.84.319.965.314 1.961.483 2.961.503l.5.01-.442-.233a8.28 8.28 0 0 1-.592-.345 7.088 7.088 0 0 1-1.22-.975 4.985 4.985 0 0 1-.378-.427 1.608 1.608 0 0 1-.031-.043l-.076-.107V9.77l4.316-3.593.01-.008.008-.01a.41.41 0 0 1 .29-.157zm.044.96l-3.84 3.198v4.233l.029.033c.064.075.137.154.216.235.308.31.67.6 1.078.86a7.85 7.85 0 0 0 2.475 1.024l.027.006.026-.006a7.852 7.852 0 0 0 2.475-1.024c.408-.26.77-.55 1.078-.86.079-.08.152-.16.216-.235l.029-.033v-4.234l-3.808-3.196zm-7.95 7.508a.892.892 0 0 0 0 1.782.892.892 0 0 0 0-1.782zm15.868 0a.892.892 0 0 0 0 1.782.892.892 0 0 0 0-1.782z",
    fill: "#0C6EEF"
  }));
};

IcoHoliduCircle.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var IcoAabodeAllogioCircle = function IcoAabodeAllogioCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("circle", {
    cx: "12.5",
    cy: "12.5",
    r: "12.5",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.592 9.449L7.52 14.521c1.668 3.298 5.072 5.515 5.072 5.515s3.404-2.217 5.072-5.515l-5.072-5.072zm-.18 7.51H10.98v-1.438h1.434v1.438zm0-1.777H10.98v-1.438h1.434v1.438zm1.798 1.777h-1.438v-1.438h1.438v1.438zm0-1.777h-1.438v-1.438h1.438v1.438z",
    fill: "#EC2027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.592 5.036a5.972 5.972 0 0 0-5.971 5.97c.006.89.174 1.77.495 2.598l5.476-5.476 2.546 2.546V8.785h1.51v3.399l1.42 1.42a7.334 7.334 0 0 0 .495-2.597 5.971 5.971 0 0 0-5.971-5.971z",
    fill: "#EC2027"
  }));
};

IcoAabodeAllogioCircle.defaultProps = {
  width: "25",
  height: "25",
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var Coins = function Coins(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.5a5 5 0 1 0 10 0 5 5 0 0 0-10 0zM8.25 13.395a.894.894 0 0 0 .562.83l1.376.55a.895.895 0 0 1-.333 1.725H8.5M9.5 17.5v-1M7.521 9.911a5 5 0 1 0 6.569 6.568",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 7.5h-1.355a.894.894 0 0 0-.333 1.725l1.376.55a.894.894 0 0 1-.334 1.725H13.5M14.5 7.5v-1M14.5 12.5v-1",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

Coins.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var Layout = function Layout(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M19.384 11.383h-4.923a.615.615 0 0 0-.615.615v7.385c0 .34.275.615.615.615h4.923c.34 0 .616-.275.616-.615v-7.385a.615.615 0 0 0-.616-.615zM19.385 4h-4.923a.615.615 0 0 0-.616.615V7.09c0 .34.276.616.616.616h4.923c.34 0 .615-.276.615-.616V4.615A.615.615 0 0 0 19.385 4zM9.538 4H4.615A.615.615 0 0 0 4 4.615V12c0 .34.276.616.615.616h4.923c.34 0 .616-.276.616-.616V4.615A.615.615 0 0 0 9.538 4zM9.538 16.293H4.615a.615.615 0 0 0-.615.615v2.474c0 .34.276.616.615.616h4.923c.34 0 .616-.276.616-.616v-2.474a.615.615 0 0 0-.616-.615z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

Layout.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var Towel = function Towel(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M13.998 12.004V18.5a1 1 0 0 1-1 1h-5.5a1 1 0 0 1-1-1v-12a2 2 0 0 1 2-2h7.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.324 5a2 2 0 0 0-3.322 1.5v8.999h3a1 1 0 0 0 1-1v-4.5M14.002 7.499h4",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: "19",
    cy: "7.499",
    rx: "1",
    ry: "1",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 7.499H5M13.998 13.5h-7.5M13.998 15.499h-7.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
};

Towel.defaultProps = {
  width: "25",
  height: "24",
  viewBox: "0 0 25 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var Speaker = function Speaker(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.004H7a2.5 2.5 0 0 1 0-5h1.5v5z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39 14c2.935 0 5.803.869 8.245 2.496l.756.504V6l-.756.504A14.867 14.867 0 0 1 8.39 9v5zM19.5 10v3",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.39 13v6",
    stroke: "currentColor",
    strokeLinecap: "round"
  }));
};

Speaker.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var Automation = function Automation(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    stroke: "currentColor",
    strokeMiterlimit: "10",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.763 13.412v2.825H4.938M16.237 10.588V7.763h2.825"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.426 7.763a6.08 6.08 0 0 1 1.695 4.269 6.162 6.162 0 0 1-6.152 6.152c-.817 0-1.633-.189-2.386-.44M7.574 16.238a6.08 6.08 0 0 1-1.695-4.27 6.162 6.162 0 0 1 6.152-6.152c.816 0 1.632.189 2.386.44M11.968 12.346a.314.314 0 0 1 0-.628M11.969 12.346a.314.314 0 0 0 0-.628"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.534 9.394l.188.628c.063.251.314.377.503.314l.627-.125c.565-.126.942.564.565 1.004l-.439.502c-.188.188-.188.44 0 .628l.44.502c.376.44 0 1.13-.566 1.005l-.627-.126c-.252-.063-.44.063-.503.314l-.188.628a.589.589 0 0 1-1.13 0l-.188-.628c-.063-.251-.314-.377-.502-.314l-.628.126c-.565.125-.942-.565-.565-1.005l.44-.502c.188-.188.188-.44 0-.628l-.44-.502c-.377-.44 0-1.13.565-1.004l.627.125c.252.063.44-.063.503-.314l.188-.628c.188-.565 1.005-.565 1.13 0z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(90 12 12)",
    d: "M0 0h24v24H0z"
  }))));
};

Automation.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ShieldFull = function ShieldFull(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M43.96 4.13A36.095 36.095 0 0 1 22.847.737l-.752-.374-.753.374A36.141 36.141 0 0 1 .268 4.13v23.846c.001 8.732 4.839 16.756 12.592 20.888l9.263 4.923 9.263-4.923c7.753-4.132 12.59-12.156 12.592-20.888V4.131h-.017z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.348 46.096C7.616 42.52 3.416 35.555 3.423 27.978V7.59c.63.028 1.268.046 1.899.046a39.52 39.52 0 0 0 16.79-3.769A39.496 39.496 0 0 0 38.9 7.636c.63 0 1.268 0 1.899-.046v20.388c.007 7.577-4.193 14.542-10.925 18.118l-7.758 4.125-7.77-4.125z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".3",
    d: "M22.846.736l-.752-.374v53.426l9.263-4.923c7.753-4.132 12.59-12.156 12.592-20.888V4.131A36.094 36.094 0 0 1 22.846.736z",
    fill: "#C9CED9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.164 44.585C8.99 41.308 5.14 34.923 5.148 27.977V9.347h.174a41.342 41.342 0 0 0 16.79-3.59A41.336 41.336 0 0 0 38.9 9.347h.173v18.63c.01 6.947-3.841 13.333-10.015 16.608L22.11 48.28l-6.947-3.694z",
    fill: "#0F265C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.22 21.607l-6.106 8.974c-.018.03-.048.045-.071.07-.014.015-.02.035-.036.049-.01.01-.026.013-.038.023a.637.637 0 0 1-.136.082c-.035.016-.068.033-.106.042a.747.747 0 0 1-.265.022.696.696 0 0 1-.114-.028.624.624 0 0 1-.143-.059c-.015-.008-.03-.009-.043-.017-.018-.012-.028-.031-.045-.044-.026-.021-.057-.033-.08-.058l-2.97-3.206a.682.682 0 0 1 .038-.964.691.691 0 0 1 .97.037l2.385 2.576 5.622-8.262c.21-.31.64-.394.954-.184a.68.68 0 0 1 .184.947zm-5.109-7.388c-6.395 0-11.579 5.144-11.579 11.49 0 6.345 5.184 11.488 11.58 11.488 6.394 0 11.578-5.144 11.578-11.489 0-6.345-5.184-11.49-11.579-11.49z",
    fill: "#2EB769"
  }));
};

ShieldFull.defaultProps = {
  width: "44",
  height: "54",
  viewBox: "0 0 44 54",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ShieldNone = function ShieldNone(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M43.827 4.13A36.095 36.095 0 0 1 22.713.737L21.96.362l-.753.374A36.141 36.141 0 0 1 .134 4.13v23.846c.001 8.732 4.84 16.756 12.592 20.888l9.263 4.923 9.263-4.923c7.753-4.132 12.59-12.156 12.592-20.888V4.131h-.017z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.214 46.096C7.482 42.52 3.282 35.555 3.289 27.978V7.59c.631.028 1.268.046 1.899.046a39.52 39.52 0 0 0 16.79-3.769 39.496 39.496 0 0 0 16.789 3.769c.631 0 1.268 0 1.899-.046v20.388c.007 7.577-4.193 14.542-10.925 18.118l-7.758 4.125-7.77-4.125z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".3",
    d: "M22.713.736L21.96.362v53.426l9.263-4.923c7.753-4.132 12.59-12.156 12.592-20.888V4.131A36.094 36.094 0 0 1 22.713.736z",
    fill: "#C9CED9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.03 44.585C8.858 41.308 5.007 34.923 5.014 27.977V9.347h.174a41.342 41.342 0 0 0 16.79-3.59 41.336 41.336 0 0 0 16.789 3.59h.173v18.63c.01 6.947-3.841 13.333-10.015 16.608l-6.948 3.694-6.947-3.694z",
    fill: "#10275B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.99 14.219c-6.396 0-11.58 5.144-11.58 11.489 0 6.345 5.184 11.49 11.58 11.49 6.394 0 11.578-5.145 11.578-11.49 0-6.345-5.184-11.49-11.579-11.49z",
    fill: "#EF3F54"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.573 21.331l.827.82-3.584 3.557 3.584 3.556-.827.82-3.584-3.556-3.584 3.557-.827-.82 3.584-3.557-3.584-3.556.827-.82 3.584 3.555 3.584-3.556z",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: ".3"
  }));
};

ShieldNone.defaultProps = {
  width: "44",
  height: "54",
  viewBox: "0 0 44 54",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ShieldOffHover = function ShieldOffHover(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "#5DAFFF",
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.583 13.039a.606.606 0 0 1 .427 0l11.875 4.456a.645.645 0 0 1 .411.607V28.5c0 4.753-3.155 8.632-6.158 11.262a32.806 32.806 0 0 1-5.925 4.1l-.105.054-.028.014-.008.004-.002.001-.274-.58-.273.58-.003-.001-.007-.004-.028-.014a18.607 18.607 0 0 1-.494-.265 32.806 32.806 0 0 1-5.536-3.889c-3.004-2.63-6.159-6.509-6.159-11.262V18.102c0-.272.165-.514.412-.607l11.875-4.456zm.213 30.315l-.273.581a.608.608 0 0 0 .546 0l-.273-.58zm0-.724l.215-.118a31.564 31.564 0 0 0 5.319-3.736c2.934-2.569 5.716-6.117 5.716-10.276v-9.945l-11.25-4.222-11.25 4.222V28.5c0 4.16 2.783 7.708 5.717 10.277a31.579 31.579 0 0 0 5.533 3.853z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.904 34.19c-1.482 0-2.736-.279-3.762-.836a5.59 5.59 0 0 1-2.318-2.375c-.532-1.026-.798-2.242-.798-3.648 0-1.419.272-2.641.817-3.667a5.652 5.652 0 0 1 2.356-2.394c1.026-.57 2.255-.855 3.686-.855.71 0 1.419.089 2.128.266.722.165 1.4.45 2.033.855.279.165.437.386.475.665.05.266.013.52-.114.76s-.317.412-.57.513c-.253.089-.532.044-.836-.133a5.785 5.785 0 0 0-1.463-.608 6.657 6.657 0 0 0-1.653-.19c-1.419 0-2.495.412-3.23 1.235-.722.823-1.083 2.008-1.083 3.553 0 1.558.374 2.742 1.121 3.553.747.81 1.856 1.216 3.325 1.216.418 0 .842-.032 1.273-.095.443-.076.88-.184 1.311-.323v-3.116h-2.09c-.659 0-.988-.304-.988-.912 0-.595.33-.893.988-.893h3.135c.659 0 .988.33.988.988v4.617c0 .583-.228.956-.684 1.121-.557.203-1.197.374-1.919.513-.722.127-1.431.19-2.128.19z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "38",
    cy: "40",
    r: "6",
    fill: "#5DAFFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.76 36.896a.727.727 0 0 1 1.085.016l1.604 1.787 1.656-1.738a.728.728 0 0 1 1.085.016.878.878 0 0 1-.017 1.174l-1.657 1.738 1.604 1.787a.878.878 0 0 1-.017 1.173.727.727 0 0 1-1.086-.016l-1.603-1.787-1.657 1.739a.727.727 0 0 1-1.085-.016.878.878 0 0 1 .017-1.174l1.657-1.738-1.604-1.787a.878.878 0 0 1 .017-1.174z",
    fill: "#fff"
  }));
};

ShieldOffHover.defaultProps = {
  width: "60",
  height: "60",
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ShieldOff = function ShieldOff(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "#3B9DFF",
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.583 13.039a.606.606 0 0 1 .427 0l11.875 4.456a.645.645 0 0 1 .411.607V28.5c0 4.753-3.155 8.632-6.158 11.262a32.806 32.806 0 0 1-5.925 4.1l-.105.054-.028.014-.008.004-.002.001-.274-.58-.273.58-.003-.001-.007-.004-.028-.014a18.607 18.607 0 0 1-.494-.265 32.806 32.806 0 0 1-5.536-3.889c-3.004-2.63-6.159-6.509-6.159-11.262V18.102c0-.272.165-.514.412-.607l11.875-4.456zm.213 30.315l-.273.581a.608.608 0 0 0 .546 0l-.273-.58zm0-.724l.215-.118a31.564 31.564 0 0 0 5.319-3.736c2.934-2.569 5.716-6.117 5.716-10.276v-9.945l-11.25-4.222-11.25 4.222V28.5c0 4.16 2.783 7.708 5.717 10.277a31.579 31.579 0 0 0 5.533 3.853z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.904 34.19c-1.482 0-2.736-.279-3.762-.836a5.59 5.59 0 0 1-2.318-2.375c-.532-1.026-.798-2.242-.798-3.648 0-1.419.272-2.641.817-3.667a5.652 5.652 0 0 1 2.356-2.394c1.026-.57 2.255-.855 3.686-.855.71 0 1.419.089 2.128.266.722.165 1.4.45 2.033.855.279.165.437.386.475.665.05.266.013.52-.114.76s-.317.412-.57.513c-.253.089-.532.044-.836-.133a5.785 5.785 0 0 0-1.463-.608 6.657 6.657 0 0 0-1.653-.19c-1.419 0-2.495.412-3.23 1.235-.722.823-1.083 2.008-1.083 3.553 0 1.558.374 2.742 1.121 3.553.747.81 1.856 1.216 3.325 1.216.418 0 .842-.032 1.273-.095.443-.076.88-.184 1.311-.323v-3.116h-2.09c-.659 0-.988-.304-.988-.912 0-.595.33-.893.988-.893h3.135c.659 0 .988.33.988.988v4.617c0 .583-.228.956-.684 1.121-.557.203-1.197.374-1.919.513-.722.127-1.431.19-2.128.19z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "38",
    cy: "40",
    r: "6",
    fill: "#3B9DFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.76 36.896a.727.727 0 0 1 1.085.016l1.604 1.787 1.656-1.738a.728.728 0 0 1 1.085.016.878.878 0 0 1-.017 1.174l-1.657 1.738 1.604 1.787a.878.878 0 0 1-.017 1.173.727.727 0 0 1-1.086-.016l-1.603-1.787-1.657 1.739a.727.727 0 0 1-1.085-.016.878.878 0 0 1 .017-1.174l1.657-1.738-1.604-1.787a.878.878 0 0 1 .017-1.174z",
    fill: "#fff"
  }));
};

ShieldOff.defaultProps = {
  width: "60",
  height: "60",
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ShieldOnHover = function ShieldOnHover(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "#4FD98A",
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.583 13.039a.606.606 0 0 1 .427 0l11.875 4.456a.645.645 0 0 1 .411.607V28.5c0 4.753-3.155 8.632-6.158 11.262a32.806 32.806 0 0 1-5.925 4.1l-.105.054-.028.014-.008.004-.002.001-.274-.58-.273.58-.003-.001-.007-.004-.028-.014a18.607 18.607 0 0 1-.494-.265 32.806 32.806 0 0 1-5.536-3.889c-3.004-2.63-6.159-6.509-6.159-11.262V18.102c0-.272.165-.514.412-.607l11.875-4.456zm.213 30.315l-.273.581a.608.608 0 0 0 .546 0l-.273-.58zm0-.724l.215-.118a31.564 31.564 0 0 0 5.319-3.736c2.934-2.569 5.716-6.117 5.716-10.276v-9.945l-11.25-4.222-11.25 4.222V28.5c0 4.16 2.783 7.708 5.717 10.277a31.579 31.579 0 0 0 5.533 3.853z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.904 34.19c-1.482 0-2.736-.279-3.762-.836a5.59 5.59 0 0 1-2.318-2.375c-.532-1.026-.798-2.242-.798-3.648 0-1.419.272-2.641.817-3.667a5.652 5.652 0 0 1 2.356-2.394c1.026-.57 2.255-.855 3.686-.855.71 0 1.419.089 2.128.266.722.165 1.4.45 2.033.855.279.165.437.386.475.665.05.266.013.52-.114.76s-.317.412-.57.513c-.253.089-.532.044-.836-.133a5.785 5.785 0 0 0-1.463-.608 6.657 6.657 0 0 0-1.653-.19c-1.419 0-2.495.412-3.23 1.235-.722.823-1.083 2.008-1.083 3.553 0 1.558.374 2.742 1.121 3.553.747.81 1.856 1.216 3.325 1.216.418 0 .842-.032 1.273-.095.443-.076.88-.184 1.311-.323v-3.116h-2.09c-.659 0-.988-.304-.988-.912 0-.595.33-.893.988-.893h3.135c.659 0 .988.33.988.988v4.617c0 .583-.228.956-.684 1.121-.557.203-1.197.374-1.919.513-.722.127-1.431.19-2.128.19z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "38",
    cy: "40",
    r: "6",
    fill: "#4FD98A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.759 36.722a.767.767 0 0 1-.22 1.038l-5.28 3.55a.712.712 0 0 1-.994-.194l-1.614-2.4a.767.767 0 0 1 .188-1.044.712.712 0 0 1 1.012.181l1.215 1.807 4.687-3.152a.712.712 0 0 1 1.006.214z",
    fill: "#fff"
  }));
};

ShieldOnHover.defaultProps = {
  width: "60",
  height: "60",
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ShieldOn = function ShieldOn(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    fill: "#2EB769",
    d: "M0 0h60v60H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.583 13.039a.606.606 0 0 1 .427 0l11.875 4.456a.645.645 0 0 1 .411.607V28.5c0 4.753-3.155 8.632-6.158 11.262a32.806 32.806 0 0 1-5.925 4.1l-.105.054-.028.014-.008.004-.002.001-.274-.58-.273.58-.003-.001-.007-.004-.028-.014a18.607 18.607 0 0 1-.494-.265 32.806 32.806 0 0 1-5.536-3.889c-3.004-2.63-6.159-6.509-6.159-11.262V18.102c0-.272.165-.514.412-.607l11.875-4.456zm.213 30.315l-.273.581a.608.608 0 0 0 .546 0l-.273-.58zm0-.724l.215-.118a31.564 31.564 0 0 0 5.319-3.736c2.934-2.569 5.716-6.117 5.716-10.276v-9.945l-11.25-4.222-11.25 4.222V28.5c0 4.16 2.783 7.708 5.717 10.277a31.579 31.579 0 0 0 5.533 3.853z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.904 34.19c-1.482 0-2.736-.279-3.762-.836a5.59 5.59 0 0 1-2.318-2.375c-.532-1.026-.798-2.242-.798-3.648 0-1.419.272-2.641.817-3.667a5.652 5.652 0 0 1 2.356-2.394c1.026-.57 2.255-.855 3.686-.855.71 0 1.419.089 2.128.266.722.165 1.4.45 2.033.855.279.165.437.386.475.665.05.266.013.52-.114.76s-.317.412-.57.513c-.253.089-.532.044-.836-.133a5.785 5.785 0 0 0-1.463-.608 6.657 6.657 0 0 0-1.653-.19c-1.419 0-2.495.412-3.23 1.235-.722.823-1.083 2.008-1.083 3.553 0 1.558.374 2.742 1.121 3.553.747.81 1.856 1.216 3.325 1.216.418 0 .842-.032 1.273-.095.443-.076.88-.184 1.311-.323v-3.116h-2.09c-.659 0-.988-.304-.988-.912 0-.595.33-.893.988-.893h3.135c.659 0 .988.33.988.988v4.617c0 .583-.228.956-.684 1.121-.557.203-1.197.374-1.919.513-.722.127-1.431.19-2.128.19z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "38",
    cy: "40",
    r: "6",
    fill: "#2EB769"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.759 36.722a.767.767 0 0 1-.22 1.038l-5.28 3.55a.712.712 0 0 1-.994-.194l-1.614-2.4a.767.767 0 0 1 .188-1.044.712.712 0 0 1 1.012.181l1.215 1.807 4.687-3.152a.712.712 0 0 1 1.006.214z",
    fill: "#fff"
  }));
};

ShieldOn.defaultProps = {
  width: "60",
  height: "60",
  viewBox: "0 0 60 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ShieldPartial = function ShieldPartial(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.827 4.163A35.849 35.849 0 0 1 22.713.742L21.96.365l-.753.377A35.895 35.895 0 0 1 .134 4.163v24.032a23.9 23.9 0 0 0 12.592 21.05l9.263 4.962 9.263-4.961a23.899 23.899 0 0 0 12.592-21.05V4.162h-.017z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.214 46.456a20.692 20.692 0 0 1-10.925-18.26V7.649c.631.029 1.268.046 1.899.046a39.265 39.265 0 0 0 16.79-3.798 39.241 39.241 0 0 0 16.789 3.798c.63 0 1.268 0 1.899-.046v20.547a20.692 20.692 0 0 1-10.925 18.26l-7.758 4.157-7.77-4.157z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: ".3",
    d: "M22.713.742L21.96.365v53.842l9.263-4.961a23.899 23.899 0 0 0 12.592-21.05V4.162A35.848 35.848 0 0 1 22.713.742z",
    fill: "#C9CED9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.03 44.933A18.96 18.96 0 0 1 5.014 28.195V9.42h.174a41.07 41.07 0 0 0 16.79-3.618c5.278 2.376 11 3.609 16.789 3.618h.173v18.775a18.949 18.949 0 0 1-10.015 16.738l-6.948 3.722-6.947-3.722z",
    fill: "#10275B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.989 14.33c-6.395 0-11.579 5.184-11.579 11.578 0 6.395 5.184 11.58 11.579 11.58 6.395 0 11.579-5.185 11.579-11.58 0-6.395-5.184-11.579-11.579-11.579z",
    fill: "#FF8A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.073 28.325c-.377 0-.58-.222-.608-.666l-.435-5.529c-.029-.357.049-.642.232-.854.183-.222.453-.333.81-.333.348 0 .608.111.782.333.183.212.26.497.232.854l-.435 5.53c-.029.443-.221.665-.578.665zm0 3.01c-.329 0-.594-.1-.797-.303-.193-.203-.29-.464-.29-.782 0-.309.097-.56.29-.753.203-.202.468-.304.797-.304.337 0 .598.102.781.304.193.193.29.444.29.753 0 .318-.097.579-.29.782-.183.202-.444.303-.781.303z",
    fill: "#10275B"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h44v54.421H0z"
  }))));
};

ShieldPartial.defaultProps = {
  width: "44",
  height: "55",
  viewBox: "0 0 44 55",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
export { IcoPaymentMethodCheck, IcoPaymentMethodCreditCard, IcoPaymentMethodNoteCoin, IcoPaymentMethodBankTransfer, IcoPaymentMethodCoin, IcoPaymentMethodCash, Doc, Gif, Jpg, Mp4, Pdf, Png, Xls, BtnAutomsg, BtnActions, BtnDownload, BtnImport, BtnExport, BtnAccount, BtnAdd, BtnApprove, BtnArchive, BtnArrowDown, BtnArrowUp, BtnAssign, BtnAttachment, BtnBulkArticles, BtnCabs, BtnCalendar, BtnCheckboxOff, BtnCheckboxOn, BtnCheckboxIndeterminate, BtnColumns, BtnCopy, BtnDelete, BtnDeleteMobile, BtnDetails, BtnDetailsOnOff, BtnDragDrop, BtnEdit, BtnExpand, BtnFilters, BtnGoTo, BtnGuests, BtnGuestyLogo, BtnGuestyName, BtnGuestySymbol, BtnHelp, BtnHelpCenter, BtnInbox, BtnInboxExpand, BtnInboxOpen, BtnLeft, BtnLinks, BtnLogout, BtnMap, BtnMarkRead, BtnMessage, BtnNights, BtnNotifications, BtnNotificationsBadge, BtnParking, BtnPayment, BtnPhone, BtnPrinter, BtnProperty, BtnRadioOff, BtnRadioOn, BtnReservation, BtnReservationMobile, BtnReset, BtnRichAlign, BtnRichBold, BtnRichBullets, BtnRichDirection, BtnRichFont, BtnRichItali, BtnRichLink, BtnRichNumbers, BtnRichRemoveStyle, BtnRichTextColor, BtnRichTextSize, BtnRichUnderline, BtnSavedReply, BtnSearch, BtnSearchMobile, BtnServices, BtnSettings, BtnShare, BtnSnooze, BtnSort, BtnStarOff, BtnStarOn, btnSummary, BtnSupport, BtnTime, BtnToCsv, BtnToggleOff, BtnToggleOn, BtnTrash, BtnUnexpand, BtnWeather, BtnYieldAvailabilty, BtnYieldGaps, BtnYieldHolidays, BtnYieldRecurring, BtnYieldSeasons, BtnYieldAvailability, IcoArrowDown, IcoArrowUp, IcoAddress, IcoAirbnb, IcoWhatsapp, IcoApproved, IcoAvatarAutoMessage, IcoAvatarNoName, IcoAvatarProperty, IcoBackCircle, IcoBedBunk, IcoBedDouble, IcoBedMat, IcoBedSingle, IcoBedSofa, IcoTip, IcoEmptystatePayments, IcoEmptystateAccessAcount, IcoEmptystateArchived, IcoEmptystateColumns, IcoEmptystateFavs, IcoEmptystateInactivePropertoes, IcoEmptystateInbox, IcoEmptystateInboxTickets, IcoEmptystateLinks, IcoEmptystateMaintenance, IcoEmptystateNotifications, IcoEmptystateSearch, IcoEmptystateSearchResults, IcoEmptystateSharedReports, IcoEmptystateSnoozed, IcoEmptystateViews, IcoEmptystateExtraInfo, IcoEmptystateListEmpty, IcoEmptystateListFull, IcoFilterBoolean, IcoFilterDate, IcoFilterNumber, IcoFilterPeople, IcoFilterSelection, IcoFilterString, IcoFilterTime, IcoFinderBoard, IcoMap, IcoMultiRate, IcoNotice, IcoNoticeOutline, IcoPayment, IcoPaymentFailed, IcoPaymentsCash, IcoPaymentsCreditCard, IcoVirtualCreditCard, IcoBankTransfer, IcoPaymentsEcheck, IcoPaymentsExpenses, IcoPaymentsIncome, IcoPaymentsNetIncome, IcoPaymentsOwnersRevenue, IcoPaymentsStripe, IcoCollectPaymentRecord, IcoCollectPaymentAH, IcoCollectPaymentCharge, IcoPaymentCash, IcoPaymentCreditCard, IcoPaymentRefunded, IcoPaymentsAmericanExpress, IcoPaymentsChainaUnionPay, IcoPaymentsDiners, IcoPaymentsDiscover, IcoPaymentsJCB, IcoPaymentsMasterCard, IcoPaymentsVisa, IcoPaymentsIsraCard, IcoPaymentsMaestro, IcoRateStrategy, IcoReservationCompleted, IcoKeychain, IcoHopperCircle, IcoHotelBedsCircle, IcoSmilingHouseCircle, IcoPlumGuideCircle, IcoGoogleVacationRentalsCircle, IcoHomesVillasByMarriottCircle, IcoReservationCurrently, IcoReservationPlanned, IcoReservationSummaryGeneral, IcoReservationSummaryStatusReserved, IcoReservationSummaryStatusV, IcoReservationSummaryStatusX, IcoTasks, BtnInfo, BtnRate, IcoAvatarGSC, IcoEmptystateNoMessages, IcoEmptystateAutoMessages, IcoEditA, IcoNotes, IcoNotificationPaymentApplicationCancelled, IcoNotificationPaymentApplicationSuccess, IcoNotificationPaymentApplicationWarning, IcoNotificationAirbnb, IcoNotificationGuesty, IcoNotificationPayment, IcoNotificationPaymentBan, IcoNotificationPaymentCircleXMark, IcoNotificationPaymentClock, IcoNotificationPaymentFlag, IcoNotificationPaymentPadlock, IcoNotificationPaymentShieldPlus, IcoNotificationPaymentShieldXMark, IcoNotificationPaymentSync, IcoNotificationPaymentRefresh, IcoNotificationProperty, IcoNotificationReservation, IcoNotificationTask, IcoPopupAdd, IcoPopupConnect, IcoPopupImport, IcoPopupSync, IcoAvatarListingMD, IcoAvatarListingSM, BtnConnect, BtnMarketplace, BtnPublish, BtnRefresh, IcoConnectChannels, IcoEmptystateMarketplace, IcoPopupPublish, IcoDeclined, IcoCleaner, IcoGeneralNote, BtnAllAcountsListings, BtnLeftSmall, BtnRight, BtnRightSmall, BtnTimeFill, Accessibility, Aircondition, Baby, Bath, Bbq, Beach, Bed, Breakfast, Buzzer, Cats, Chair, Checkin, Cleaning, Cmdetector, Coffee, Console, Dishes, Dishwasher, Dogs, Doorman, Dryer, Elevator, Essentials, Ev, Events, Familyfriendly, Fireextinguisher, Fireplace, Firstaid, Garden, Guard, Gym, Hairdryer, Hangers, Heating, Hotwater, Hottub, Internet, Iron, Keypad, Kitchen, Laptop, Lockbox, Locker, Longterm, Luggage, Microwave, Otherpets, Oven, Parking, Patio, Petsallowed, Petslive, Pool, Privateentrance, Privatelivingroom, Refrigerator, Rug, Safetycard, Shades, Shampoo, Smartlock, Smokedetector, Smoking, Stove, Table, Tv, Washer, Wheelchair, Wifi, BtnSidebarClose, BtnSidebarOpen, FontSize, FontColor, Bold, Italic, Bullets, Numbers, Underline, BtnShow, BtnHide, IcoCheckinFormSent, IcoCheckinFormView, IcoStatusReports, IcoAgreements, IcoCheckinForm, IcoEmptyStateStatusReports, IcoEmptyStateAgreements, IcoPromotion, IcoBookingcom, IcoDiscount, IcoActionRequired, IcoAgodaCircle, IcoAirbnbCircle, IcoBookingcomCircle, IcoExpediaCircle, IcoPlus, IcoPlusCircle, IcoSiteminderCircle, IcoTipBulb, IcoTripadvisorCircle, IcoTripComCircle, IcoVrboCircle, IcoWebsite, IcoWebsiteCircle, IcoEmail, ShieldFull, ShieldNone, ShieldOffHover, ShieldOff, ShieldOnHover, ShieldOn, ShieldPartial, IcoPadlockFilled, IcoStaySenseCircle, IcoGlampingHubCircle, IcoHomeToGoCircle, IcoInvenioHomesCircle, IcoAltoVitaCircle, IcoTravelStaytionCircle, IcoWhimstayCircle, IcoHoliduCircle, IcoAabodeAllogioCircle, Coins, Layout, Towel, Speaker, Automation };